
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree28c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree28c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j7W2w", function(module, exports) {

$parcel$export(module.exports, "spotByPath", () => spotByPath);
$parcel$export(module.exports, "lookup", () => lookup);
$parcel$export(module.exports, "lookdown", () => lookdown);
$parcel$export(module.exports, "lookdownAll", () => lookdownAll);
$parcel$export(module.exports, "setNodeStyles", () => setNodeStyles);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "setProps", () => setProps);
$parcel$export(module.exports, "getRef", () => getRef);
$parcel$export(module.exports, "getChildren", () => getChildren);
$parcel$export(module.exports, "getPath", () => getPath);
$parcel$export(module.exports, "getRootState", () => getRootState);
$parcel$export(module.exports, "getRoot", () => getRoot);
$parcel$export(module.exports, "getRootData", () => getRootData);
$parcel$export(module.exports, "getRootContext", () => getRootContext);
$parcel$export(module.exports, "getContext", () => getContext);
$parcel$export(module.exports, "defineSetter", () => defineSetter);
$parcel$export(module.exports, "keys", () => keys);
$parcel$export(module.exports, "parse", () => parse);
$parcel$export(module.exports, "parseDeep", () => parseDeep);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
$parcel$export(module.exports, "nextElement", () => nextElement);
$parcel$export(module.exports, "previousElement", () => previousElement);
$parcel$export(module.exports, "variables", () => variables);
$parcel$export(module.exports, "call", () => call);
$parcel$export(module.exports, "isMethod", () => isMethod);

var $b4h11 = parcelRequire("b4h11");

var $1jKby = parcelRequire("1jKby");

var $e7Ezu = parcelRequire("e7Ezu");

var $g1LU2 = parcelRequire("g1LU2");

var $eo3lV = parcelRequire("eo3lV");

var $9RPo7 = parcelRequire("9RPo7");
const ENV = "production";
function spotByPath(path) {
    const element = this;
    const { __ref: ref } = element;
    const arr = [].concat(path);
    let foundelement = ref.root[arr[0]];
    if (!arr || !arr.length) return console.log(arr, "on", element.key, "is undefined");
    while(foundelement.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        foundelement = foundelement[arr[0]];
        if (!foundelement) return;
    }
    return foundelement;
}
function lookup(param) {
    const el = this;
    let { parent } = el;
    if ((0, $e7Ezu.isFunction)(param)) {
        if (parent.state && param(parent, parent.state, parent.context)) return parent;
        else if (parent.parent) return parent.lookup(param);
        else return;
    }
    if (el[param]) return el[param];
    while(parent.param !== param){
        if (parent[param]) return parent[param];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
}
function lookdown(param) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) return childElem;
        else if ((0, $e7Ezu.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) return childElem;
        }
        const lookdown2 = childElem?.lookdown?.(param);
        if (lookdown2) return lookdown2;
    }
}
function lookdownAll(param, results = []) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) results.push(childElem);
        else if ((0, $e7Ezu.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) results.push(childElem);
        }
        childElem?.lookdownAll?.(param, results);
    }
    return results.length ? results : void 0;
}
function setNodeStyles(params = {}) {
    const el = this;
    if (!el.node?.style) return;
    for(const param in params){
        const value = params[param];
        const childElem = el[param];
        if ((0, $e7Ezu.isObject)(value) && childElem) setNodeStyles.call(childElem, value);
        else el.node.style[param] = value;
    }
    return el;
}
function remove(opts) {
    const element = this;
    const beforeRemoveReturns = (0, $b4h11.triggerEventOn)("beforeRemove", element, opts);
    if (beforeRemoveReturns === false) return element;
    if ((0, $e7Ezu.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $eo3lV.isProduction)()) {
        console.warn("This item cant be removed");
        element.log();
    }
    delete element.parent[element.key];
    if (element.parent.__ref) element.parent.__ref.__children = (0, $9RPo7.removeValueFromArray)(element.parent.__ref.__children, element.key);
    (0, $b4h11.triggerEventOn)("remove", element, opts);
}
function get(param) {
    const element = this;
    return element[param];
}
function setProps(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef("__children");
    return __children.map((k)=>this[k]);
}
function getPath() {
    return this.getRef().path;
}
function getRootState(param) {
    let state = null;
    const hasRootState = (obj)=>obj.__element && obj.root?.isRootState;
    if (!this) state = window.platformState || window.smblsApp?.state;
    else if (hasRootState(this)) state = this.root;
    else if (this.__ref && this.__ref.path) {
        const hasPlatformState = this.state && hasRootState(this.state);
        const hasPlatformStateOnParent = (0, $e7Ezu.isFunction)(this.state) && this.parent.state && hasRootState(this.parent.state);
        if (hasPlatformState || hasPlatformStateOnParent) state = this.state.root || this.parent.state.root;
    }
    if (!state) state = window.platformState || window.smblsApp?.state;
    return param ? state?.[param] : state;
}
function getRoot(key) {
    const rootElem = this.getRootState()?.__element;
    return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
}
function getRootData(key) {
    return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && key ? this.getRoot("data")[key] : this.getRoot("data");
}
function getRootContext(key) {
    const ctx = this.getRoot()?.context;
    return key ? ctx[key] : ctx;
}
function getContext(key) {
    const ctx = this.context;
    return key ? ctx[key] : ctx;
}
const defineSetter = (element, key, get2, set)=>Object.defineProperty(element, key, {
        get: get2,
        set: set
    });
function keys() {
    const element = this;
    const keys2 = [];
    for(const param in element){
        if (// (REGISTRY[param] && !DOMQ_PROPERTIES.has(param)) ||
        !Object.prototype.hasOwnProperty.call(element, param) || (0, $1jKby.DOMQ_PROPERTIES).has(param) && !(0, $1jKby.PARSED_DOMQ_PROPERTIES).has(param)) continue;
        keys2.push(param);
    }
    return keys2;
}
function parse(excl = []) {
    const element = this;
    const obj = {};
    const keyList = keys.call(element);
    const hasChildren = keyList.includes("children");
    const exclSet = excl.length ? new Set(excl) : null;
    for(let i = 0; i < keyList.length; i++){
        const v = keyList[i];
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        if (hasChildren && v === "content") continue;
        const val = element[v];
        if (v === "state") {
            if (element.__ref && !element.__ref.__hasRootState) continue;
            const parsedVal = (0, $e7Ezu.isFunction)(val && val.parse) ? val.parse() : val;
            obj[v] = (0, $e7Ezu.isFunction)(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
        } else if (v === "scope") {
            if (element.__ref && !element.__ref.__hasRootScope) continue;
            obj[v] = JSON.parse(JSON.stringify(val || {}));
        } else if (v === "props") {
            const { __element, update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $e7Ezu.isDefined)(val) && Object.prototype.hasOwnProperty.call(element, v)) obj[v] = val;
    }
    return obj;
}
function parseDeep(excl = [], visited = /* @__PURE__ */ new WeakSet()) {
    const element = this;
    if (visited.has(element)) return void 0;
    visited.add(element);
    const obj = parse.call(element, excl);
    const exclSet = excl.length ? new Set(excl) : null;
    for(const v in obj){
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        const val = obj[v];
        if (Array.isArray(val)) obj[v] = val.map((item)=>(0, $e7Ezu.isObjectLike)(item) ? parseDeep.call(item, excl, visited) : item);
        else if ((0, $e7Ezu.isObjectLike)(val)) obj[v] = parseDeep.call(val, excl, visited);
    }
    return obj;
}
function verbose(...args) {
    if (ENV !== "test" && ENV !== "development") return;
    const element = this;
    const { __ref: ref } = element;
    console.groupCollapsed(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:
`, "font-weight: bold", element[v]));
    else {
        console.log(ref.path);
        const keys2 = element.keys();
        keys2.forEach((v)=>console.log(`%c${v}:`, "font-weight: bold", element[v]));
    }
    console.log(element);
    console.groupEnd(element.key);
    return element;
}
function log(...params) {
    if (ENV === "test" || ENV === "development") console.log(...params);
}
function warn(...params) {
    if (ENV === "test" || ENV === "development") console.warn(...params);
}
function error(...params) {
    if (ENV === "test" || ENV === "development") {
        if (params[params.length - 1]?.debugger) debugger;
        if (params[params.length - 1]?.verbose) verbose.call(this);
        throw new Error(...params);
    }
}
function nextElement() {
    const element = this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
}
function previousElement(el) {
    const element = el || this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
}
function variables(obj = {}) {
    const element = this;
    if (!element.data) element.data = {};
    if (!element.data.varCaches) element.data.varCaches = {};
    const varCaches = element.data.varCaches;
    const changes = {};
    let changed;
    for(const key in obj)if (obj[key] !== varCaches[key]) {
        changed = true;
        changes[key] = obj[key];
    }
    return {
        changed: (cb)=>{
            if (!changed) return;
            const returns = cb(changes, (0, $g1LU2.deepClone)(varCaches));
            for(const key in changes)varCaches[key] = changes[key];
            return returns;
        },
        timeout: (cb, timeout)=>{
            if (!changed) return;
            const t = setTimeout(()=>{
                cb(changes);
                clearTimeout(t);
            }, timeout);
        }
    };
}
function call(fnKey, ...args) {
    const context = this.context;
    const fn = context.utils?.[fnKey] || context.functions?.[fnKey] || context.methods?.[fnKey] || context.snippets?.[fnKey];
    if (!fn) return;
    try {
        const result = fn.call(this, ...args);
        if (result && typeof result.then === "function") result.catch((err)=>{
            this.error = err;
        });
        return result;
    } catch (err) {
        this.error = err;
        if (context?.strictMode) throw err;
    }
}
function isMethod(param, element) {
    return Boolean((0, $1jKby.METHODS).has(param) || element?.context?.methods?.[param]);
}

});
parcelRegister("b4h11", function(module, exports) {

$parcel$export(module.exports, "applyEvent", () => $80ed44535875a935$export$27ca81ea148fa005);
$parcel$export(module.exports, "triggerEventOn", () => $80ed44535875a935$export$1bc010482b845252);
$parcel$export(module.exports, "applyEventUpdate", () => $80ed44535875a935$export$906113ec468a9c43);
$parcel$export(module.exports, "triggerEventOnUpdate", () => $80ed44535875a935$export$8fe90418b8a0fc1e);

var $e7Ezu = parcelRequire("e7Ezu");
const $80ed44535875a935$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    if (onEvent) return onEvent;
    const props = element.props;
    if (!props) return;
    const propKey = "on" + param.charAt(0).toUpperCase() + param.slice(1);
    return props[propKey];
};
const $80ed44535875a935$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    if (!(0, $e7Ezu.isFunction)(param)) return;
    try {
        const result = param.call(element, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === "function") result.catch((err)=>{
            element.error = err;
            console.error("[DomQL] Async event error:", err);
        });
        return result;
    } catch (err) {
        element.error = err;
        console.error("[DomQL] Event handler error:", err);
        if (element.context?.strictMode) throw err;
    }
};
const $80ed44535875a935$export$1bc010482b845252 = (param, element, options)=>{
    if (!element) throw new Error("Element is required");
    const appliedFunction = $80ed44535875a935$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $80ed44535875a935$export$27ca81ea148fa005(appliedFunction, element, state, context, options);
    }
};
const $80ed44535875a935$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    if (!(0, $e7Ezu.isFunction)(param)) return;
    try {
        const result = param.call(element, updatedObj, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === "function") result.catch((err)=>{
            element.error = err;
            console.error("[DomQL] Async event update error:", err);
        });
        return result;
    } catch (err) {
        element.error = err;
        console.error("[DomQL] Event update error:", err);
        if (element.context?.strictMode) throw err;
    }
};
const $80ed44535875a935$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    const appliedFunction = $80ed44535875a935$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $80ed44535875a935$export$906113ec468a9c43(appliedFunction, updatedObj, element, state, context, options);
    }
};

});
parcelRegister("e7Ezu", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $a48130ca43bebe34$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $a48130ca43bebe34$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $a48130ca43bebe34$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $a48130ca43bebe34$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $a48130ca43bebe34$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $a48130ca43bebe34$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $a48130ca43bebe34$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $a48130ca43bebe34$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $a48130ca43bebe34$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $a48130ca43bebe34$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $a48130ca43bebe34$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $a48130ca43bebe34$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $a48130ca43bebe34$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $a48130ca43bebe34$export$612ae635ef713eeb);

var $fhYuv = parcelRequire("fhYuv");
const $a48130ca43bebe34$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object" && arg.constructor === Object;
};
const $a48130ca43bebe34$export$844ec244b1367d54 = (arg)=>typeof arg === "string";
const $a48130ca43bebe34$export$7e4aa119212bc614 = (arg)=>typeof arg === "number";
const $a48130ca43bebe34$export$f6e2535fb5126e54 = (arg)=>typeof arg === "function";
const $a48130ca43bebe34$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $a48130ca43bebe34$export$630801d484da15df = (arg)=>arg === null;
const $a48130ca43bebe34$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $a48130ca43bebe34$export$871608497c498473 = (d)=>d instanceof Date;
const $a48130ca43bebe34$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object";
};
const $a48130ca43bebe34$export$4e62c701997796c1 = (arg)=>arg !== void 0;
const $a48130ca43bebe34$export$fce6876652108ab = (arg)=>arg === void 0;
const $a48130ca43bebe34$export$426db7a6155b7a80 = {
    boolean: $a48130ca43bebe34$export$f9ce7b637dfbe238,
    array: $a48130ca43bebe34$export$43bee75e5e14138e,
    object: $a48130ca43bebe34$export$a6cdc56e425d0d0a,
    string: $a48130ca43bebe34$export$844ec244b1367d54,
    date: $a48130ca43bebe34$export$871608497c498473,
    number: $a48130ca43bebe34$export$7e4aa119212bc614,
    null: $a48130ca43bebe34$export$630801d484da15df,
    function: $a48130ca43bebe34$export$f6e2535fb5126e54,
    objectLike: $a48130ca43bebe34$export$c10d0b04eaa80a43,
    node: (0, $fhYuv.isNode),
    htmlElement: (0, $fhYuv.isHtmlElement),
    defined: $a48130ca43bebe34$export$4e62c701997796c1
};
const $a48130ca43bebe34$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>args.some((val)=>$a48130ca43bebe34$export$426db7a6155b7a80[val](arg));
};
const $a48130ca43bebe34$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>!args.some((val)=>$a48130ca43bebe34$export$426db7a6155b7a80[val](arg));
};

});
parcelRegister("fhYuv", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $b2175dccd9fe9ded$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $b2175dccd9fe9ded$export$211442cb55fb93);
$parcel$export(module.exports, "isDOMNode", () => $b2175dccd9fe9ded$export$b8eb4d3b76e486c2);

var $bD06b = parcelRequire("bD06b");
const $b2175dccd9fe9ded$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === "object" ? obj instanceof (0, $bD06b.window).Node : obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string") || false;
};
const $b2175dccd9fe9ded$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === "object" ? obj instanceof (0, $bD06b.window).HTMLElement : obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string") || false;
};
const $b2175dccd9fe9ded$export$b8eb4d3b76e486c2 = (obj)=>{
    return typeof (0, $bD06b.window) !== "undefined" && ((0, $bD06b.window).Node && obj instanceof (0, $bD06b.window).Node || (0, $bD06b.window).Window && obj instanceof (0, $bD06b.window).Window || obj === (0, $bD06b.window) || obj === document);
};

});
parcelRegister("bD06b", function(module, exports) {

$parcel$export(module.exports, "global", () => $877369d8b756df5e$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $877369d8b756df5e$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $877369d8b756df5e$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $877369d8b756df5e$export$5a7bfc01df82fcd1);
const $877369d8b756df5e$export$90b4d2ff6acb88af = globalThis;
const $877369d8b756df5e$export$82c2e460fb230c2a = globalThis;
const $877369d8b756df5e$export$8291e5b88f90ce4 = globalThis;
const $877369d8b756df5e$export$5a7bfc01df82fcd1 = $877369d8b756df5e$export$8291e5b88f90ce4.document;

});




parcelRegister("1jKby", function(module, exports) {

$parcel$export(module.exports, "DOMQ_PROPERTIES", () => $0f5b643f43fb1b86$export$c7d5e7f7bf0dae25);
$parcel$export(module.exports, "PARSED_DOMQ_PROPERTIES", () => $0f5b643f43fb1b86$export$965c4b042127881f);
$parcel$export(module.exports, "STATE_PROPERTIES", () => $0f5b643f43fb1b86$export$a42fe85dc7bbfd49);
$parcel$export(module.exports, "STATE_METHODS", () => $0f5b643f43fb1b86$export$76c843b7166304af);
$parcel$export(module.exports, "PROPS_METHODS", () => $0f5b643f43fb1b86$export$36cad52ffe088573);
$parcel$export(module.exports, "METHODS", () => $0f5b643f43fb1b86$export$f0748ddc99f937c7);
$parcel$export(module.exports, "METHODS_EXL", () => $0f5b643f43fb1b86$export$7f0c3d30e5984c9d);
$parcel$export(module.exports, "DOMQL_EVENTS", () => $0f5b643f43fb1b86$export$194d3d0e15158f0b);
const $0f5b643f43fb1b86$export$c7d5e7f7bf0dae25 = /* @__PURE__ */ new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "classlist",
    "state",
    "scope",
    "root",
    "deps",
    "extend",
    "extends",
    "$router",
    "routes",
    "children",
    "childExtend",
    "childExtends",
    "childExtendRecursive",
    "childExtendsRecursive",
    "props",
    "if",
    "define",
    "__name",
    "__ref",
    "__hash",
    "__text",
    "key",
    "tag",
    "query",
    "parent",
    "node",
    "variables",
    "on",
    "component",
    "context"
]);
const $0f5b643f43fb1b86$export$965c4b042127881f = /* @__PURE__ */ new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "class",
    "state",
    "scope",
    "children",
    "props",
    "if",
    "key",
    "tag",
    "query",
    "on",
    "context"
]);
const $0f5b643f43fb1b86$export$a42fe85dc7bbfd49 = [
    "ref",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root"
];
const $0f5b643f43fb1b86$export$76c843b7166304af = /* @__PURE__ */ new Set([
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "replace",
    "quietReplace",
    "quietUpdate",
    "applyReplace",
    "applyFunction",
    "keys",
    "values",
    "ref",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root",
    "setByPath",
    "setPathCollection",
    "removeByPath",
    "removePathCollection",
    "getByPath"
]);
const $0f5b643f43fb1b86$export$36cad52ffe088573 = /* @__PURE__ */ new Set([
    "update",
    "__element"
]);
const $0f5b643f43fb1b86$export$f0748ddc99f937c7 = /* @__PURE__ */ new Set([
    "set",
    "reset",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "lookdown",
    "lookdownAll",
    "getRef",
    "getPath",
    "setNodeStyles",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "variables",
    "if",
    "log",
    "verbose",
    "warn",
    "error",
    "call",
    "nextElement",
    "previousElement",
    "getRootState",
    "getRoot",
    "getRootData",
    "getRootContext",
    "getContext",
    "getChildren"
]);
const $0f5b643f43fb1b86$export$7f0c3d30e5984c9d = /* @__PURE__ */ new Set([
    "node",
    "context",
    "extends",
    "__element",
    "__ref",
    ...$0f5b643f43fb1b86$export$f0748ddc99f937c7,
    ...$0f5b643f43fb1b86$export$76c843b7166304af,
    ...$0f5b643f43fb1b86$export$36cad52ffe088573
]);
const $0f5b643f43fb1b86$export$194d3d0e15158f0b = /* @__PURE__ */ new Set([
    "init",
    "beforeClassAssign",
    "render",
    "renderRouter",
    "attachNode",
    "stateInit",
    "stateCreated",
    "beforeStateUpdate",
    "stateUpdate",
    "beforeUpdate",
    "done",
    "create",
    "complete",
    "frame",
    "update"
]);

});

parcelRegister("g1LU2", function(module, exports) {

$parcel$export(module.exports, "exec", () => $bab1e5d6bd41edc8$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $bab1e5d6bd41edc8$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $bab1e5d6bd41edc8$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $bab1e5d6bd41edc8$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $bab1e5d6bd41edc8$export$9cd59f9826255e47);
$parcel$export(module.exports, "deepClone", () => $bab1e5d6bd41edc8$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepStringifyFunctions", () => $bab1e5d6bd41edc8$export$a1b87aa71164cd70);
$parcel$export(module.exports, "objectToString", () => $bab1e5d6bd41edc8$export$830c053460e5ddf6);
$parcel$export(module.exports, "hasFunction", () => $bab1e5d6bd41edc8$export$6b15be743c368efa);
$parcel$export(module.exports, "deepDestringifyFunctions", () => $bab1e5d6bd41edc8$export$4db1ad98392a09bb);
$parcel$export(module.exports, "stringToObject", () => $bab1e5d6bd41edc8$export$a6c9a3ccba61521e);
$parcel$export(module.exports, "hasOwnProperty", () => $bab1e5d6bd41edc8$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $bab1e5d6bd41edc8$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $bab1e5d6bd41edc8$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $bab1e5d6bd41edc8$export$d6d64087a1bd2d);
$parcel$export(module.exports, "overwrite", () => $bab1e5d6bd41edc8$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $bab1e5d6bd41edc8$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $bab1e5d6bd41edc8$export$f0b277b530b4fffd);
$parcel$export(module.exports, "isEqualDeep", () => $bab1e5d6bd41edc8$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $bab1e5d6bd41edc8$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $bab1e5d6bd41edc8$export$bdd7fc6cf95d63b);
$parcel$export(module.exports, "createObjectWithoutPrototype", () => $bab1e5d6bd41edc8$export$c2a75c92f46bb782);
$parcel$export(module.exports, "createNestedObject", () => $bab1e5d6bd41edc8$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeNestedKeyByPath", () => $bab1e5d6bd41edc8$export$33f72cab96f733af);
$parcel$export(module.exports, "setInObjectByPath", () => $bab1e5d6bd41edc8$export$9c3074cc3d55a00f);
$parcel$export(module.exports, "getInObjectByPath", () => $bab1e5d6bd41edc8$export$12bc5d09cd221028);
$parcel$export(module.exports, "detectInfiniteLoop", () => $bab1e5d6bd41edc8$export$ad59efee0c629be2);
$parcel$export(module.exports, "isCyclic", () => $bab1e5d6bd41edc8$export$831fcc412582ee80);
$parcel$export(module.exports, "excludeKeysFromObject", () => $bab1e5d6bd41edc8$export$efc42697dda340d9);

var $bD06b = parcelRequire("bD06b");

var $e7Ezu = parcelRequire("e7Ezu");

var $9RPo7 = parcelRequire("9RPo7");

var $3GLOu = parcelRequire("3GLOu");

var $fhYuv = parcelRequire("fhYuv");

var $1jKby = parcelRequire("1jKby");
const $bab1e5d6bd41edc8$var$ENV = "production";
const $bab1e5d6bd41edc8$var$_startsWithDunder = (e)=>e.charCodeAt(0) === 95 && e.charCodeAt(1) === 95;
const $bab1e5d6bd41edc8$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $e7Ezu.isFunction)(param)) {
        if (!element) return;
        const result = param.call(element, element, state || element.state, context || element.context);
        if (result && typeof result.then === "function") {
            let resolved;
            result.then((value)=>{
                resolved = value;
            });
            return resolved;
        }
        return result;
    }
    return param;
};
const $bab1e5d6bd41edc8$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $bab1e5d6bd41edc8$export$78e3044358792147(extention[e], element);
};
const $bab1e5d6bd41edc8$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, e)) continue;
        if ($bab1e5d6bd41edc8$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        if (element[e] === void 0) element[e] = obj[e];
    }
    return element;
};
const $bab1e5d6bd41edc8$export$6969335ea1e4e77c = (element, extend, excludeFrom = (0, $1jKby.METHODS_EXL))=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in extend){
        if (!Object.prototype.hasOwnProperty.call(extend, e)) continue;
        if ($bab1e5d6bd41edc8$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $e7Ezu.isObjectLike)(elementProp) && (0, $e7Ezu.isObjectLike)(extendProp)) $bab1e5d6bd41edc8$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === void 0) element[e] = extendProp;
    }
    return element;
};
const $bab1e5d6bd41edc8$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    const o = {};
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        if ($bab1e5d6bd41edc8$var$_startsWithDunder(prop)) continue;
        if (useSet ? excludeFrom.has(prop) : excludeFrom.includes(prop)) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $bab1e5d6bd41edc8$export$b7d58db314e0ac27 = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = /* @__PURE__ */ new WeakMap(), handleExtends: handleExtends = false } = options;
    const contentWindow = targetWindow || (0, $bD06b.window) || globalThis;
    if (!(0, $e7Ezu.isObjectLike)(obj) || (0, $fhYuv.isDOMNode)(obj)) return obj;
    if (visited.has(obj)) return visited.get(obj);
    const isArr = (0, $e7Ezu.isArray)(obj);
    const clone2 = isArr ? [] : {};
    visited.set(obj, clone2);
    const excludeSet = exclude instanceof Set ? exclude : exclude.length > 3 ? new Set(exclude) : null;
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        if ($bab1e5d6bd41edc8$var$_startsWithDunder(key) || key === "__proto__") continue;
        if (excludeSet ? excludeSet.has(key) : exclude.includes(key)) continue;
        const value = obj[key];
        if (cleanUndefined && value === void 0) continue;
        if (cleanNull && value === null) continue;
        if ((0, $fhYuv.isDOMNode)(value)) {
            clone2[key] = value;
            continue;
        }
        if (handleExtends && key === "extends" && (0, $e7Ezu.isArray)(value)) {
            clone2[key] = (0, $9RPo7.unstackArrayOfObjects)(value, exclude);
            continue;
        }
        if ((0, $e7Ezu.isFunction)(value) && options.window) {
            clone2[key] = contentWindow.eval("(" + value.toString() + ")");
            continue;
        }
        if ((0, $e7Ezu.isObjectLike)(value)) clone2[key] = $bab1e5d6bd41edc8$export$b7d58db314e0ac27(value, {
            ...options,
            visited: visited
        });
        else clone2[key] = value;
    }
    return clone2;
};
const $bab1e5d6bd41edc8$export$a1b87aa71164cd70 = (obj, stringified = {})=>{
    if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
        (obj.__element || obj.parent?.__element).warn("Trying to clone element or state at", obj);
        obj = obj.parse?.();
    }
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $e7Ezu.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $e7Ezu.isObject)(objProp)) {
            stringified[prop] = {};
            $bab1e5d6bd41edc8$export$a1b87aa71164cd70(objProp, stringified[prop]);
        } else if ((0, $e7Ezu.isArray)(objProp)) {
            const arr = stringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const v = objProp[i];
                if ((0, $e7Ezu.isObject)(v)) {
                    arr[i] = {};
                    $bab1e5d6bd41edc8$export$a1b87aa71164cd70(v, arr[i]);
                } else if ((0, $e7Ezu.isFunction)(v)) arr[i] = v.toString();
                else arr[i] = v;
            }
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $bab1e5d6bd41edc8$var$OBJ_TO_STR_SPECIAL_CHARS = /* @__PURE__ */ new Set([
    "&",
    "*",
    "-",
    ":",
    "%",
    "{",
    "}",
    ">",
    "<",
    "@",
    ".",
    "/",
    "!",
    " "
]);
const $bab1e5d6bd41edc8$export$830c053460e5ddf6 = (obj = {}, indent = 0)=>{
    if (obj === null || typeof obj !== "object") return String(obj);
    let hasKeys = false;
    for(const _k in obj){
        hasKeys = true;
        break;
    }
    if (!hasKeys) return "{}";
    const spaces = "  ".repeat(indent);
    let str = "{\n";
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        const value = obj[key];
        let keyNeedsQuotes = false;
        for(let i = 0; i < key.length; i++)if ($bab1e5d6bd41edc8$var$OBJ_TO_STR_SPECIAL_CHARS.has(key[i])) {
            keyNeedsQuotes = true;
            break;
        }
        const stringedKey = keyNeedsQuotes ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $e7Ezu.isArray)(value)) {
            str += "[\n";
            for (const element of value){
                if ((0, $e7Ezu.isObjectLike)(element) && element !== null) str += `${spaces}    ${$bab1e5d6bd41edc8$export$830c053460e5ddf6(element, indent + 2)},
`;
                else if ((0, $e7Ezu.isString)(element)) str += `${spaces}    '${element}',
`;
                else str += `${spaces}    ${element},
`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $e7Ezu.isObjectLike)(value)) str += $bab1e5d6bd41edc8$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $e7Ezu.isString)(value)) str += (0, $3GLOu.stringIncludesAny)(value, [
            "\n",
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ",\n";
    }
    str += `${spaces}}`;
    return str;
};
const $bab1e5d6bd41edc8$var$FN_PATTERNS = [
    /^\(\s*\{[^}]*\}\s*\)\s*=>/,
    /^(\([^)]*\)|[^=]*)\s*=>/,
    /^function[\s(]/,
    /^async\s+/,
    /^\(\s*function/,
    /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
];
const $bab1e5d6bd41edc8$var$RE_JSON_LIKE = /^["[{]/;
const $bab1e5d6bd41edc8$export$6b15be743c368efa = (str)=>{
    if (!str) return false;
    const trimmed = str.trim().replace(/\n\s*/g, " ").trim();
    if (trimmed === "" || trimmed === "{}" || trimmed === "[]") return false;
    const isFn = $bab1e5d6bd41edc8$var$FN_PATTERNS.some((pattern)=>pattern.test(trimmed));
    if (!isFn) return false;
    const firstChar = trimmed.charCodeAt(0);
    const hasArrow = trimmed.includes("=>");
    if (firstChar === 123 && !hasArrow) return false;
    if (firstChar === 91) return false;
    if ($bab1e5d6bd41edc8$var$RE_JSON_LIKE.test(trimmed) && !hasArrow) return false;
    return true;
};
const $bab1e5d6bd41edc8$export$4db1ad98392a09bb = (obj, destringified = {})=>{
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        const objProp = obj[prop];
        if ((0, $e7Ezu.isString)(objProp)) {
            if ($bab1e5d6bd41edc8$export$6b15be743c368efa(objProp)) try {
                destringified[prop] = (0, $bD06b.window).eval(`(${objProp})`);
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $e7Ezu.isArray)(objProp)) {
            const arr = destringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const arrProp = objProp[i];
                if ((0, $e7Ezu.isString)(arrProp)) {
                    if ($bab1e5d6bd41edc8$export$6b15be743c368efa(arrProp)) try {
                        arr.push((0, $bD06b.window).eval(`(${arrProp})`));
                    } catch (e) {
                        if (e) arr.push(arrProp);
                    }
                    else arr.push(arrProp);
                } else if ((0, $e7Ezu.isObject)(arrProp)) arr.push($bab1e5d6bd41edc8$export$4db1ad98392a09bb(arrProp));
                else arr.push(arrProp);
            }
        } else if ((0, $e7Ezu.isObject)(objProp)) destringified[prop] = $bab1e5d6bd41edc8$export$4db1ad98392a09bb(objProp, destringified[prop]);
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $bab1e5d6bd41edc8$export$a6c9a3ccba61521e = (str, opts = {
    verbose: true
})=>{
    try {
        return str ? (0, $bD06b.window).eval("(" + str + ")") : {};
    } catch (e) {
        if (opts.verbose) console.warn(e);
    }
};
const $bab1e5d6bd41edc8$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $bab1e5d6bd41edc8$export$dd1bc94b04021eeb = (o)=>{
    for(const _ in o)return false;
    return true;
};
const $bab1e5d6bd41edc8$export$83b788b1a3698c03 = (o)=>(0, $e7Ezu.isObject)(o) && $bab1e5d6bd41edc8$export$dd1bc94b04021eeb(o);
const $bab1e5d6bd41edc8$export$d6d64087a1bd2d = ()=>/* @__PURE__ */ Object.create(null);
const $bab1e5d6bd41edc8$export$d3305692eb3e9a81 = (element, params, opts = {})=>{
    const excl = opts.exclude || [];
    const allowUnderscore = opts.preventUnderscore;
    for(const e in params){
        if (excl.includes(e) || !allowUnderscore && $bab1e5d6bd41edc8$var$_startsWithDunder(e)) continue;
        if (params[e] !== void 0) element[e] = params[e];
    }
    return element;
};
const $bab1e5d6bd41edc8$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in params){
        if ($bab1e5d6bd41edc8$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $bab1e5d6bd41edc8$export$f0b277b530b4fffd = (obj, params, opts = {}, visited = /* @__PURE__ */ new WeakMap())=>{
    if (!(0, $e7Ezu.isObjectLike)(obj) || !(0, $e7Ezu.isObjectLike)(params) || (0, $fhYuv.isDOMNode)(obj) || (0, $fhYuv.isDOMNode)(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    const excl = opts.exclude;
    const exclSet = excl ? excl instanceof Set ? excl : new Set(excl) : null;
    const forcedExclude = !opts.preventForce;
    for(const e in params){
        if (!Object.prototype.hasOwnProperty.call(params, e)) continue;
        if (exclSet && exclSet.has(e) || forcedExclude && $bab1e5d6bd41edc8$var$_startsWithDunder(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $fhYuv.isDOMNode)(paramsProp)) obj[e] = paramsProp;
        else if ((0, $e7Ezu.isObjectLike)(objProp) && (0, $e7Ezu.isObjectLike)(paramsProp)) obj[e] = $bab1e5d6bd41edc8$export$f0b277b530b4fffd(objProp, paramsProp, opts, visited);
        else if (paramsProp !== void 0) obj[e] = paramsProp;
    }
    return obj;
};
const $bab1e5d6bd41edc8$export$683c7d6569f339f4 = (param, element, visited = /* @__PURE__ */ new Set())=>{
    if (typeof param !== "object" || typeof element !== "object" || param === null || element === null) return param === element;
    if (visited.has(param) || visited.has(element)) return true;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    if (keysParam.length !== keysElement.length) return false;
    for(let i = 0; i < keysParam.length; i++){
        const key = keysParam[i];
        if (!Object.prototype.hasOwnProperty.call(element, key)) return false;
        if (!$bab1e5d6bd41edc8$export$683c7d6569f339f4(param[key], element[key], visited)) return false;
    }
    return true;
};
const $bab1e5d6bd41edc8$var$DEEP_CONTAINS_IGNORED = /* @__PURE__ */ new Set([
    "node",
    "__ref"
]);
const $bab1e5d6bd41edc8$export$273cb3019e2f952c = (obj1, obj2, ignoredKeys = $bab1e5d6bd41edc8$var$DEEP_CONTAINS_IGNORED)=>{
    if (obj1 === obj2) return true;
    if (!(0, $e7Ezu.isObjectLike)(obj1) || !(0, $e7Ezu.isObjectLike)(obj2)) return obj1 === obj2;
    if ((0, $fhYuv.isDOMNode)(obj1) || (0, $fhYuv.isDOMNode)(obj2)) return obj1 === obj2;
    const ignored = ignoredKeys instanceof Set ? ignoredKeys : new Set(ignoredKeys);
    const visited = /* @__PURE__ */ new WeakSet();
    function checkContains(target, source) {
        if (visited.has(source)) return true;
        visited.add(source);
        for(const key in source){
            if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
            if (ignored.has(key)) continue;
            if (!Object.prototype.hasOwnProperty.call(target, key)) return false;
            const sourceValue = source[key];
            const targetValue = target[key];
            if ((0, $fhYuv.isDOMNode)(sourceValue) || (0, $fhYuv.isDOMNode)(targetValue)) {
                if (sourceValue !== targetValue) return false;
            } else if ((0, $e7Ezu.isObjectLike)(sourceValue) && (0, $e7Ezu.isObjectLike)(targetValue)) {
                if (!checkContains(targetValue, sourceValue)) return false;
            } else if (sourceValue !== targetValue) return false;
        }
        return true;
    }
    return checkContains(obj1, obj2);
};
const $bab1e5d6bd41edc8$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === void 0 || props === null) return obj;
    if ((0, $e7Ezu.is)(props)("string", "number")) delete obj[props];
    else if ((0, $e7Ezu.isArray)(props)) for(let i = 0; i < props.length; i++)delete obj[props[i]];
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return obj;
};
const $bab1e5d6bd41edc8$export$c2a75c92f46bb782 = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const newObj = /* @__PURE__ */ Object.create(null);
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $bab1e5d6bd41edc8$export$c2a75c92f46bb782(obj[key]);
    return newObj;
};
const $bab1e5d6bd41edc8$export$a9706fb8026b394a = (arr, lastValue)=>{
    if (arr.length === 0) return lastValue;
    const nestedObject = {};
    let current = nestedObject;
    for(let i = 0; i < arr.length; i++)if (i === arr.length - 1 && lastValue) current[arr[i]] = lastValue;
    else {
        current[arr[i]] = {};
        current = current[arr[i]];
    }
    return nestedObject;
};
const $bab1e5d6bd41edc8$export$33f72cab96f733af = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error("Path must be an array.");
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (current[path[i]] === void 0) return;
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    if (current && Object.prototype.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
};
const $bab1e5d6bd41edc8$export$9c3074cc3d55a00f = (obj, path, value)=>{
    if (!Array.isArray(path)) throw new Error("Path must be an array.");
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (!current[path[i]] || typeof current[path[i]] !== "object") current[path[i]] = {};
        current = current[path[i]];
    }
    current[path[path.length - 1]] = value;
    return obj;
};
const $bab1e5d6bd41edc8$export$12bc5d09cd221028 = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error("Path must be an array.");
    let current = obj;
    for(let i = 0; i < path.length; i++){
        if (current === void 0 || current === null) return void 0;
        current = current[path[i]];
    }
    return current;
};
const $bab1e5d6bd41edc8$export$ad59efee0c629be2 = (arr)=>{
    const maxRepeats = 10;
    let pattern = [];
    let repeatCount = 0;
    for(let i = 0; i < arr.length; i++)if (pattern.length < 2) pattern.push(arr[i]);
    else {
        if (arr[i] === pattern[i % 2]) repeatCount++;
        else {
            pattern = [
                arr[i - 1],
                arr[i]
            ];
            repeatCount = 1;
        }
        if (repeatCount >= maxRepeats * 2) {
            if ($bab1e5d6bd41edc8$var$ENV === "test" || $bab1e5d6bd41edc8$var$ENV === "development") console.warn("Warning: Potential infinite loop detected due to repeated sequence:", pattern);
            return true;
        }
    }
};
const $bab1e5d6bd41edc8$export$831fcc412582ee80 = (obj)=>{
    const seen = /* @__PURE__ */ new WeakSet();
    function detect(obj2) {
        if (obj2 && typeof obj2 === "object") {
            if (seen.has(obj2)) return true;
            seen.add(obj2);
            for(const key in obj2)if (Object.prototype.hasOwnProperty.call(obj2, key) && detect(obj2[key])) {
                console.log(obj2, "cycle at " + key);
                return true;
            }
        }
        return false;
    }
    return detect(obj);
};
const $bab1e5d6bd41edc8$export$efc42697dda340d9 = (obj, excludedKeys)=>{
    const excluded = excludedKeys instanceof Set ? excludedKeys : new Set(excludedKeys);
    const result = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && !excluded.has(key)) result[key] = obj[key];
    return result;
};

});
parcelRegister("9RPo7", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $72f0ece054036747$export$de875babef361e5d);
$parcel$export(module.exports, "getFrequencyInArray", () => $72f0ece054036747$export$2b3f138fefbb2e97);
$parcel$export(module.exports, "removeFromArray", () => $72f0ece054036747$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $72f0ece054036747$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $72f0ece054036747$export$fc359ae9633f7296);
$parcel$export(module.exports, "unstackArrayOfObjects", () => $72f0ece054036747$export$86332fe6637020e6);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $72f0ece054036747$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $72f0ece054036747$export$e9b4b966d876219d);
$parcel$export(module.exports, "removeValueFromArray", () => $72f0ece054036747$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $72f0ece054036747$export$91b305d65813a3f8);
$parcel$export(module.exports, "addItemAfterEveryElement", () => $72f0ece054036747$export$aefdd0c3cb403b10);
$parcel$export(module.exports, "reorderArrayByValues", () => $72f0ece054036747$export$402525ce1e0ae04f);
$parcel$export(module.exports, "arraysEqual", () => $72f0ece054036747$export$234180f8206db11b);
$parcel$export(module.exports, "filterArrays", () => $72f0ece054036747$export$e43a5cd3407a4eed);
$parcel$export(module.exports, "filterArraysFast", () => $72f0ece054036747$export$34fca6752b16443b);
$parcel$export(module.exports, "checkIfStringIsInArray", () => $72f0ece054036747$export$8a158988a0fbe64f);
$parcel$export(module.exports, "removeDuplicatesInArray", () => $72f0ece054036747$export$21c00e23a20acdb3);
$parcel$export(module.exports, "addProtoToArray", () => $72f0ece054036747$export$3369abff3c322c4c);

var $g1LU2 = parcelRequire("g1LU2");

var $e7Ezu = parcelRequire("e7Ezu");
const $72f0ece054036747$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $72f0ece054036747$export$2b3f138fefbb2e97 = (arr, value)=>{
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (arr[i] === value) count++;
    return count;
};
const $72f0ece054036747$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $e7Ezu.isString)(index)) index = parseInt(index);
    if ((0, $e7Ezu.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error("Invalid index");
        arr.splice(index, 1);
    } else throw new Error("Invalid index");
    return arr;
};
const $72f0ece054036747$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $72f0ece054036747$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $72f0ece054036747$export$86332fe6637020e6 = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>(0, $g1LU2.deepMerge)(a, (0, $g1LU2.deepClone)(c, {
            exclude: exclude
        }), exclude), {});
};
const $72f0ece054036747$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $72f0ece054036747$export$e9b4b966d876219d = (arr, value)=>{
    if (!(0, $e7Ezu.isArray)(arr)) return;
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $72f0ece054036747$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr;
};
const $72f0ece054036747$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};
const $72f0ece054036747$export$aefdd0c3cb403b10 = (array, item)=>{
    const result = [];
    for(let i = 0; i < array.length; i++){
        result.push(array[i]);
        if (i < array.length - 1) result.push(item);
    }
    return result;
};
const $72f0ece054036747$export$402525ce1e0ae04f = (array, valueToMove, insertBeforeValue)=>{
    const newArray = [
        ...array
    ];
    const indexToMove = newArray.indexOf(valueToMove);
    const indexToInsertBefore = newArray.indexOf(insertBeforeValue);
    if (indexToMove !== -1 && indexToInsertBefore !== -1) {
        const removedItem = newArray.splice(indexToMove, 1)[0];
        const insertIndex = indexToInsertBefore < indexToMove ? indexToInsertBefore : indexToInsertBefore + 1;
        newArray.splice(insertIndex, 0, removedItem);
    }
    return newArray;
};
const $72f0ece054036747$export$234180f8206db11b = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $72f0ece054036747$export$e43a5cd3407a4eed = (sourceArr, excludeArr)=>{
    return sourceArr.filter((item)=>!excludeArr.includes(item));
};
const $72f0ece054036747$export$34fca6752b16443b = (sourceArr, excludeArr)=>{
    const excludeSet = new Set(excludeArr);
    return sourceArr.filter((item)=>!excludeSet.has(item));
};
const $72f0ece054036747$export$8a158988a0fbe64f = (string, arr)=>{
    if (!string) return 0;
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (string.includes(arr[i])) count++;
    return count;
};
const $72f0ece054036747$export$21c00e23a20acdb3 = (arr)=>{
    if (!(0, $e7Ezu.isArray)(arr)) return arr;
    return [
        ...new Set(arr)
    ];
};
const $72f0ece054036747$export$3369abff3c322c4c = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        // Set this to true if you want the method to appear in for...in loops
        configurable: true,
        // Set this to true if you want to allow redefining/removing the property later
        writable: true
    });
};

});

parcelRegister("3GLOu", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $2afa621a2baa0103$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $2afa621a2baa0103$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $2afa621a2baa0103$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $2afa621a2baa0103$export$f08459d87829d2ee);
$parcel$export(module.exports, "findKeyPosition", () => $2afa621a2baa0103$export$e03c69ff1d8102d5);
$parcel$export(module.exports, "replaceOctalEscapeSequences", () => $2afa621a2baa0103$export$ed5844ba7edb0ac0);
$parcel$export(module.exports, "encodeNewlines", () => $2afa621a2baa0103$export$56079d9b77cc851c);
$parcel$export(module.exports, "decodeNewlines", () => $2afa621a2baa0103$export$d5a58d286266e59c);
$parcel$export(module.exports, "customEncodeURIComponent", () => $2afa621a2baa0103$export$afdf0655b23d957b);
$parcel$export(module.exports, "customDecodeURIComponent", () => $2afa621a2baa0103$export$f0dfcf6020c0b258);
const $2afa621a2baa0103$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $2afa621a2baa0103$export$4cb168a4c77839cc = (str, characters)=>{
    const pattern = new RegExp(`[${characters.join("\\")}]`, "g");
    return str.replace(pattern, "");
};
const $2afa621a2baa0103$var$brackRegex = {
    2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*}}/g,
    3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*}}}/g
};
const $2afa621a2baa0103$var$getNestedValue = (obj, path)=>{
    return path.split(".").reduce((acc, part)=>{
        return acc?.[part];
    }, obj);
};
function $2afa621a2baa0103$export$7cb52b7decbd2220(str, state, options = {}) {
    const { bracketsLength: bracketsLength = 2 } = options;
    const bracketPattern = bracketsLength === 3 ? "{{{" : "{{";
    if (!str.includes(bracketPattern)) return str;
    const reg = $2afa621a2baa0103$var$brackRegex[bracketsLength];
    const obj = state || this.state || {};
    return str.replace(reg, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = (parentPath.match(/\.\.\//g) || []).length;
            let parentState = obj;
            for(let i = 0; i < parentLevels; i++){
                if (!parentState || !parentState.parent) return "";
                parentState = parentState.parent;
            }
            const key = variable.trim();
            if (key === "parent") return String(parentState.value ?? "");
            const value = $2afa621a2baa0103$var$getNestedValue(parentState, key);
            return String(value ?? "");
        } else {
            const value = $2afa621a2baa0103$var$getNestedValue(obj, variable.trim());
            return String(value ?? "");
        }
    });
}
const $2afa621a2baa0103$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};
const $2afa621a2baa0103$export$e03c69ff1d8102d5 = (str, key)=>{
    const lines = str.split("\n");
    let startLineNumber = -1;
    let endLineNumber = -1;
    let startColumn = -1;
    let endColumn = -1;
    const keyPattern = new RegExp(`\\b${key}\\b\\s*:\\s*`);
    let braceCount = 0;
    let foundKey = false;
    for(let i = 0; i < lines.length; i++){
        if (keyPattern.test(lines[i]) && !foundKey) {
            foundKey = true;
            startLineNumber = i + 1;
            startColumn = lines[i].indexOf(key) + 1;
            if (lines[i].includes("{}")) {
                endLineNumber = startLineNumber;
                endColumn = lines[i].indexOf("{}") + 3;
                break;
            }
            const line = lines[i].slice(startColumn + key.length);
            if (line.includes("{") || line.includes("[")) braceCount = 1;
            else {
                endLineNumber = i + 1;
                endColumn = lines[i].length + 1;
                break;
            }
        } else if (foundKey) {
            braceCount += (lines[i].match(/{/g) || []).length;
            braceCount += (lines[i].match(/\[/g) || []).length;
            braceCount -= (lines[i].match(/}/g) || []).length;
            braceCount -= (lines[i].match(/]/g) || []).length;
            if (braceCount === 0) {
                endLineNumber = i + 1;
                endColumn = lines[i].lastIndexOf("}") !== -1 ? lines[i].lastIndexOf("}") + 2 : lines[i].length + 1;
                break;
            }
        }
    }
    return {
        startColumn: startColumn,
        endColumn: endColumn,
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber
    };
};
const $2afa621a2baa0103$var$RE_OCTAL = /\\([0-7]{1,3})/g;
const $2afa621a2baa0103$export$ed5844ba7edb0ac0 = (str)=>{
    return str.replace($2afa621a2baa0103$var$RE_OCTAL, (_, p1)=>String.fromCharCode(parseInt(p1, 8)));
};
const $2afa621a2baa0103$export$56079d9b77cc851c = (str)=>{
    return str.replace(/\n/g, "/////n").replace(/`/g, "/////tilde").replace(/\$/g, "/////dlrsgn");
};
const $2afa621a2baa0103$export$d5a58d286266e59c = (encodedStr)=>{
    return encodedStr.replace(/\/\/\/\/\/n/g, "\n").replace(/\/\/\/\/\/tilde/g, "`").replace(/\/\/\/\/\/dlrsgn/g, "$");
};
const $2afa621a2baa0103$var$RE_NON_ALNUM = /[^a-zA-Z0-9\s]/g;
const $2afa621a2baa0103$export$afdf0655b23d957b = (str)=>{
    return str.replace($2afa621a2baa0103$var$RE_NON_ALNUM, (char)=>"%" + char.charCodeAt(0).toString(16).toUpperCase());
};
const $2afa621a2baa0103$export$f0dfcf6020c0b258 = (encodedStr)=>{
    return encodedStr.replace(/%[0-9A-Fa-f]{2}/g, (match)=>String.fromCharCode(parseInt(match.slice(1), 16)));
};

});


parcelRegister("eo3lV", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $a795e856035023af$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "ENV", () => $a795e856035023af$export$83401e34d5e11bf4);
$parcel$export(module.exports, "isProduction", () => $a795e856035023af$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $a795e856035023af$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isTesting", () => $a795e856035023af$export$9592e006a670b581);
$parcel$export(module.exports, "isStaging", () => $a795e856035023af$export$23da1d24a38b0bde);
$parcel$export(module.exports, "isLocal", () => $a795e856035023af$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDevelopment", () => $a795e856035023af$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $a795e856035023af$export$d84272657cb7c466);
$parcel$export(module.exports, "isNotProduction", () => $a795e856035023af$export$eda5083784a7e709);
// @preserve-env
const $a795e856035023af$export$dd8826725fa2a3d4 = "production";
const $a795e856035023af$export$83401e34d5e11bf4 = $a795e856035023af$export$dd8826725fa2a3d4;
const $a795e856035023af$export$f15d00aa73aafac4 = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>env === "production";
const $a795e856035023af$export$410cbc2864fa25b5 = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>env === "testing" || env === "test";
const $a795e856035023af$export$9592e006a670b581 = $a795e856035023af$export$410cbc2864fa25b5;
const $a795e856035023af$export$23da1d24a38b0bde = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>env === "staging";
const $a795e856035023af$export$6dd1bbd39f571125 = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>env === "local";
const $a795e856035023af$export$df77466336fe5355 = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>env === "development" || env === "dev" || env === "local";
const $a795e856035023af$export$d84272657cb7c466 = (key, env = $a795e856035023af$export$dd8826725fa2a3d4)=>env[key];
const $a795e856035023af$export$eda5083784a7e709 = (env = $a795e856035023af$export$dd8826725fa2a3d4)=>!$a795e856035023af$export$f15d00aa73aafac4(env);

});


parcelRegister("fUAoP", function(module, exports) {

$parcel$export(module.exports, "spotByPath", () => spotByPath);
$parcel$export(module.exports, "lookup", () => lookup);
$parcel$export(module.exports, "lookdown", () => lookdown);
$parcel$export(module.exports, "lookdownAll", () => lookdownAll);
$parcel$export(module.exports, "setNodeStyles", () => setNodeStyles);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "setProps", () => setProps);
$parcel$export(module.exports, "getRef", () => getRef);
$parcel$export(module.exports, "getPath", () => getPath);
$parcel$export(module.exports, "getRootState", () => getRootState);
$parcel$export(module.exports, "getRoot", () => getRoot);
$parcel$export(module.exports, "getRootData", () => getRootData);
$parcel$export(module.exports, "getRootContext", () => getRootContext);
$parcel$export(module.exports, "getContext", () => getContext);
$parcel$export(module.exports, "keys", () => keys);
$parcel$export(module.exports, "parse", () => parse);
$parcel$export(module.exports, "parseDeep", () => parseDeep);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
$parcel$export(module.exports, "nextElement", () => nextElement);
$parcel$export(module.exports, "previousElement", () => previousElement);
$parcel$export(module.exports, "variables", () => variables);
$parcel$export(module.exports, "call", () => call);

var $fU20L = parcelRequire("fU20L");

var $hMWjF = parcelRequire("hMWjF");

var $EqHTq = parcelRequire("EqHTq");

var $8wu6n = parcelRequire("8wu6n");

var $jOLBF = parcelRequire("jOLBF");

var $hSU9O = parcelRequire("hSU9O");
'use strict';
const ENV = "production";
function spotByPath(path) {
    const element = this;
    const { __ref: ref } = element;
    const arr = [].concat(path);
    let foundelement = ref.root[arr[0]];
    if (!arr || !arr.length) return console.log(arr, 'on', element.key, 'is undefined');
    while(foundelement.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        foundelement = foundelement[arr[0]];
        if (!foundelement) return;
    }
    return foundelement;
}
function lookup(param) {
    const el = this;
    let { parent } = el;
    if ((0, $EqHTq.isFunction)(param)) {
        if (parent.state && param(parent, parent.state, parent.context)) return parent;
        else if (parent.parent) return parent.lookup(param);
        else return;
    }
    if (el[param]) return el[param];
    while(parent.param !== param){
        if (parent[param]) return parent[param];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
}
function lookdown(param) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) return childElem;
        else if ((0, $EqHTq.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) return childElem;
        }
        const lookdown = childElem?.lookdown?.(param);
        if (lookdown) return lookdown;
    }
}
function lookdownAll(param, results = []) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) results.push(childElem);
        else if ((0, $EqHTq.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) results.push(childElem);
        }
        childElem?.lookdownAll?.(param, results);
    }
    return results.length ? results : undefined;
}
function setNodeStyles(params = {}) {
    const el = this;
    if (!el.node?.style) return;
    for(const param in params){
        const value = params[param];
        const childElem = el[param];
        if ((0, $EqHTq.isObject)(value) && childElem) setNodeStyles.call(childElem, value);
        else el.node.style[param] = value;
    }
    return el;
}
function remove(opts) {
    const element = this;
    const beforeRemoveReturns = (0, $fU20L.triggerEventOn)('beforeRemove', element, opts);
    if (beforeRemoveReturns === false) return element;
    if ((0, $EqHTq.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $jOLBF.isProduction)()) {
        console.warn('This item cant be removed');
        element.log();
    }
    delete element.parent[element.key];
    if (element.parent.__ref) element.parent.__ref.__children = (0, $hSU9O.removeValueFromArray)(element.parent.__ref.__children, element.key);
    (0, $fU20L.triggerEventOn)('remove', element, opts);
}
function get(param) {
    const element = this;
    return element[param];
}
function setProps(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children.map((k)=>this[k]);
}
function getPath() {
    return this.getRef().path;
}
function getRootState(param) {
    let state = null;
    const hasRootState = (obj)=>obj.__element && obj.root?.isRootState;
    if (!this) state = window.platformState || window.smblsApp?.state;
    else if (hasRootState(this)) state = this.root;
    else if (this.__ref && this.__ref.path) {
        const hasPlatformState = this.state && hasRootState(this.state);
        const hasPlatformStateOnParent = (0, $EqHTq.isFunction)(this.state) && this.parent.state && hasRootState(this.parent.state);
        if (hasPlatformState || hasPlatformStateOnParent) state = this.state.root || this.parent.state.root;
    }
    if (!state) state = window.platformState || window.smblsApp?.state;
    return param ? state?.[param] : state;
}
function getRoot(key) {
    const rootElem = this.getRootState()?.__element;
    return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
}
function getRootData(key) {
    return this.getRoot('data') && Object.keys(this.getRoot('data')).length > 0 && key ? this.getRoot('data')[key] : this.getRoot('data');
}
function getRootContext(key) {
    const ctx = this.getRoot()?.context;
    return key ? ctx[key] : ctx;
}
function getContext(key) {
    const ctx = this.context;
    return key ? ctx[key] : ctx;
}
const defineSetter = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
function keys() {
    const element = this;
    const keys = [];
    for(const param in element){
        if (// (REGISTRY[param] && !DOMQ_PROPERTIES.has(param)) ||
        !Object.prototype.hasOwnProperty.call(element, param) || (0, $hMWjF.DOMQ_PROPERTIES).has(param) && !(0, $hMWjF.PARSED_DOMQ_PROPERTIES).has(param)) continue;
        keys.push(param);
    }
    return keys;
}
function parse(excl = []) {
    const element = this;
    const obj = {};
    const keyList = keys.call(element);
    const hasChildren = keyList.includes('children');
    const exclSet = excl.length ? new Set(excl) : null;
    for(let i = 0; i < keyList.length; i++){
        const v = keyList[i];
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        if (hasChildren && v === 'content') continue;
        const val = element[v];
        if (v === 'state') {
            if (element.__ref && !element.__ref.__hasRootState) continue;
            const parsedVal = (0, $EqHTq.isFunction)(val && val.parse) ? val.parse() : val;
            obj[v] = (0, $EqHTq.isFunction)(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
        } else if (v === 'scope') {
            if (element.__ref && !element.__ref.__hasRootScope) continue;
            obj[v] = JSON.parse(JSON.stringify(val || {}));
        } else if (v === 'props') {
            const { __element, update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $EqHTq.isDefined)(val) && Object.prototype.hasOwnProperty.call(element, v)) obj[v] = val;
    }
    return obj;
}
function parseDeep(excl = [], visited = new WeakSet()) {
    const element = this;
    if (visited.has(element)) return undefined;
    visited.add(element);
    const obj = parse.call(element, excl);
    const exclSet = excl.length ? new Set(excl) : null;
    for(const v in obj){
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        const val = obj[v];
        if (Array.isArray(val)) obj[v] = val.map((item)=>(0, $EqHTq.isObjectLike)(item) ? parseDeep.call(item, excl, visited) : item);
        else if ((0, $EqHTq.isObjectLike)(val)) obj[v] = parseDeep.call(val, excl, visited);
    }
    return obj;
}
function verbose(...args) {
    if (ENV !== 'test' && ENV !== 'development') return;
    const element = this;
    const { __ref: ref } = element;
    console.groupCollapsed(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', element[v]));
    else {
        console.log(ref.path);
        const keys = element.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', element[v]));
    }
    console.log(element);
    console.groupEnd(element.key);
    return element;
}
function log(...params) {
    if (ENV === 'test' || ENV === 'development') console.log(...params);
}
function warn(...params) {
    if (ENV === 'test' || ENV === 'development') console.warn(...params);
}
function error(...params) {
    if (ENV === 'test' || ENV === 'development') {
        if (params[params.length - 1]?.debugger) debugger; // eslint-disable-line
        if (params[params.length - 1]?.verbose) verbose.call(this);
        throw new Error(...params);
    }
}
function nextElement() {
    const element = this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
}
function previousElement(el) {
    const element = el || this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
}
function variables(obj = {}) {
    const element = this;
    if (!element.data) element.data = {};
    if (!element.data.varCaches) element.data.varCaches = {};
    const varCaches = element.data.varCaches;
    const changes = {};
    let changed;
    for(const key in obj)if (obj[key] !== varCaches[key]) {
        changed = true;
        changes[key] = obj[key];
    }
    return {
        changed: (cb)=>{
            if (!changed) return;
            const returns = cb(changes, (0, $8wu6n.deepClone)(varCaches));
            for(const key in changes)varCaches[key] = changes[key];
            return returns;
        },
        timeout: (cb, timeout)=>{
            if (!changed) return;
            const t = setTimeout(()=>{
                cb(changes);
                clearTimeout(t);
            }, timeout);
        }
    };
}
function call(fnKey, ...args) {
    const context = this.context;
    const fn = context.utils?.[fnKey] || context.functions?.[fnKey] || context.methods?.[fnKey] || context.snippets?.[fnKey];
    if (!fn) return;
    try {
        const result = fn.call(this, ...args);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            this.error = err;
        });
        return result;
    } catch (err) {
        this.error = err;
        if (context?.strictMode) throw err;
    }
}
function isMethod(param, element) {
    return Boolean((0, $hMWjF.METHODS).has(param) || element?.context?.methods?.[param]);
}

});
parcelRegister("fU20L", function(module, exports) {

$parcel$export(module.exports, "triggerEventOn", () => $b93da565fc3cb072$export$1bc010482b845252);

var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $b93da565fc3cb072$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    if (onEvent) return onEvent;
    const props = element.props;
    if (!props) return;
    const propKey = 'on' + param.charAt(0).toUpperCase() + param.slice(1);
    return props[propKey];
};
const $b93da565fc3cb072$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    if (!(0, $EqHTq.isFunction)(param)) return;
    try {
        const result = param.call(element, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            element.error = err;
            console.error('[DomQL] Async event error:', err);
        });
        return result;
    } catch (err) {
        element.error = err;
        console.error('[DomQL] Event handler error:', err);
        if (element.context?.strictMode) throw err;
    }
};
const $b93da565fc3cb072$export$1bc010482b845252 = (param, element, options)=>{
    if (!element) throw new Error('Element is required');
    const appliedFunction = $b93da565fc3cb072$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $b93da565fc3cb072$export$27ca81ea148fa005(appliedFunction, element, state, context, options);
    }
};
const $b93da565fc3cb072$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    if (!(0, $EqHTq.isFunction)(param)) return;
    try {
        const result = param.call(element, updatedObj, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            element.error = err;
            console.error('[DomQL] Async event update error:', err);
        });
        return result;
    } catch (err) {
        element.error = err;
        console.error('[DomQL] Event update error:', err);
        if (element.context?.strictMode) throw err;
    }
};
const $b93da565fc3cb072$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    const appliedFunction = $b93da565fc3cb072$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $b93da565fc3cb072$export$906113ec468a9c43(appliedFunction, updatedObj, element, state, context, options);
    }
};

});
parcelRegister("EqHTq", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $079873fc3f2b5f81$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $079873fc3f2b5f81$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $079873fc3f2b5f81$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $079873fc3f2b5f81$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isArray", () => $079873fc3f2b5f81$export$43bee75e5e14138e);
$parcel$export(module.exports, "isObjectLike", () => $079873fc3f2b5f81$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $079873fc3f2b5f81$export$4e62c701997796c1);
$parcel$export(module.exports, "is", () => $079873fc3f2b5f81$export$226b3eccf92c9ed9);

var $cPMIO = parcelRequire("cPMIO");
'use strict';
const $079873fc3f2b5f81$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === 'object' && arg.constructor === Object;
};
const $079873fc3f2b5f81$export$844ec244b1367d54 = (arg)=>typeof arg === 'string';
const $079873fc3f2b5f81$export$7e4aa119212bc614 = (arg)=>typeof arg === 'number';
const $079873fc3f2b5f81$export$f6e2535fb5126e54 = (arg)=>typeof arg === 'function';
const $079873fc3f2b5f81$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $079873fc3f2b5f81$export$630801d484da15df = (arg)=>arg === null;
const $079873fc3f2b5f81$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $079873fc3f2b5f81$export$871608497c498473 = (d)=>d instanceof Date;
const $079873fc3f2b5f81$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === 'object';
};
const $079873fc3f2b5f81$export$4e62c701997796c1 = (arg)=>arg !== undefined;
const $079873fc3f2b5f81$export$fce6876652108ab = (arg)=>arg === undefined;
const $079873fc3f2b5f81$export$426db7a6155b7a80 = {
    boolean: $079873fc3f2b5f81$export$f9ce7b637dfbe238,
    array: $079873fc3f2b5f81$export$43bee75e5e14138e,
    object: $079873fc3f2b5f81$export$a6cdc56e425d0d0a,
    string: $079873fc3f2b5f81$export$844ec244b1367d54,
    date: $079873fc3f2b5f81$export$871608497c498473,
    number: $079873fc3f2b5f81$export$7e4aa119212bc614,
    null: $079873fc3f2b5f81$export$630801d484da15df,
    function: $079873fc3f2b5f81$export$f6e2535fb5126e54,
    objectLike: $079873fc3f2b5f81$export$c10d0b04eaa80a43,
    node: (0, $cPMIO.isNode),
    htmlElement: (0, $cPMIO.isHtmlElement),
    defined: $079873fc3f2b5f81$export$4e62c701997796c1
};
const $079873fc3f2b5f81$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>args.some((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg));
};
const $079873fc3f2b5f81$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>!args.some((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg));
};

});
parcelRegister("cPMIO", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $95800a96be489797$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $95800a96be489797$export$211442cb55fb93);
$parcel$export(module.exports, "isDOMNode", () => $95800a96be489797$export$b8eb4d3b76e486c2);

var $jvD5p = parcelRequire("jvD5p");
'use strict';
const $95800a96be489797$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === 'object' ? obj instanceof (0, $jvD5p.window).Node : obj && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string') || false;
};
const $95800a96be489797$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === 'object' ? obj instanceof (0, $jvD5p.window).HTMLElement // DOM2
     : obj && typeof obj === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string') || false;
};
const $95800a96be489797$export$b8eb4d3b76e486c2 = (obj)=>{
    return typeof (0, $jvD5p.window) !== 'undefined' && ((0, $jvD5p.window).Node && obj instanceof (0, $jvD5p.window).Node || (0, $jvD5p.window).Window && obj instanceof (0, $jvD5p.window).Window || obj === (0, $jvD5p.window) || obj === document);
};

});
parcelRegister("jvD5p", function(module, exports) {

$parcel$export(module.exports, "window", () => $e33f3b456b841cc9$export$8291e5b88f90ce4);
'use strict';
const $e33f3b456b841cc9$export$90b4d2ff6acb88af = globalThis;
const $e33f3b456b841cc9$export$82c2e460fb230c2a = globalThis;
const $e33f3b456b841cc9$export$8291e5b88f90ce4 = globalThis;
const $e33f3b456b841cc9$export$5a7bfc01df82fcd1 = (undefined || $e33f3b456b841cc9$export$8291e5b88f90ce4).document // eslint-disable-line
;

});




parcelRegister("hMWjF", function(module, exports) {

$parcel$export(module.exports, "DOMQ_PROPERTIES", () => $cf3427bacf7fc551$export$c7d5e7f7bf0dae25);
$parcel$export(module.exports, "PARSED_DOMQ_PROPERTIES", () => $cf3427bacf7fc551$export$965c4b042127881f);
$parcel$export(module.exports, "METHODS", () => $cf3427bacf7fc551$export$f0748ddc99f937c7);
$parcel$export(module.exports, "METHODS_EXL", () => $cf3427bacf7fc551$export$7f0c3d30e5984c9d);
'use strict';
const $cf3427bacf7fc551$export$c7d5e7f7bf0dae25 = new Set([
    'attr',
    'style',
    'text',
    'html',
    'content',
    'data',
    'classlist',
    'state',
    'scope',
    'root',
    'deps',
    'extend',
    'extends',
    '$router',
    'routes',
    'children',
    'childExtend',
    'childExtends',
    'childExtendRecursive',
    'childExtendsRecursive',
    'props',
    'if',
    'define',
    '__name',
    '__ref',
    '__hash',
    '__text',
    'key',
    'tag',
    'query',
    'parent',
    'node',
    'variables',
    'on',
    'component',
    'context'
]);
const $cf3427bacf7fc551$export$965c4b042127881f = new Set([
    'attr',
    'style',
    'text',
    'html',
    'content',
    'data',
    'class',
    'state',
    'scope',
    'children',
    'props',
    'if',
    'key',
    'tag',
    'query',
    'on',
    'context'
]);
const $cf3427bacf7fc551$export$a42fe85dc7bbfd49 = [
    'ref',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root'
];
const $cf3427bacf7fc551$export$76c843b7166304af = new Set([
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'keys',
    'values',
    'ref',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
]);
const $cf3427bacf7fc551$export$36cad52ffe088573 = new Set([
    'update',
    '__element'
]);
const $cf3427bacf7fc551$export$f0748ddc99f937c7 = new Set([
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getPath',
    'setNodeStyles',
    'spotByPath',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'verbose',
    'warn',
    'error',
    'call',
    'nextElement',
    'previousElement',
    'getRootState',
    'getRoot',
    'getRootData',
    'getRootContext',
    'getContext',
    'getChildren'
]);
const $cf3427bacf7fc551$export$7f0c3d30e5984c9d = new Set([
    'node',
    'context',
    'extends',
    '__element',
    '__ref',
    ...$cf3427bacf7fc551$export$f0748ddc99f937c7,
    ...$cf3427bacf7fc551$export$76c843b7166304af,
    ...$cf3427bacf7fc551$export$36cad52ffe088573
]);
const $cf3427bacf7fc551$export$194d3d0e15158f0b = new Set([
    'init',
    'beforeClassAssign',
    'render',
    'renderRouter',
    'attachNode',
    'stateInit',
    'stateCreated',
    'beforeStateUpdate',
    'stateUpdate',
    'beforeUpdate',
    'done',
    'create',
    'complete',
    'frame',
    'update'
]);

});

parcelRegister("8wu6n", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $6348a97baa20d8d9$export$6969335ea1e4e77c);
$parcel$export(module.exports, "deepClone", () => $6348a97baa20d8d9$export$b7d58db314e0ac27);

var $jvD5p = parcelRequire("jvD5p");

var $EqHTq = parcelRequire("EqHTq");

var $hSU9O = parcelRequire("hSU9O");

var $5WrxC = parcelRequire("5WrxC");

var $cPMIO = parcelRequire("cPMIO");

var $hMWjF = parcelRequire("hMWjF");
'use strict';
const $6348a97baa20d8d9$var$ENV = "production";
const $6348a97baa20d8d9$var$_startsWithDunder = (e)=>e.charCodeAt(0) === 95 && e.charCodeAt(1) === 95;
const $6348a97baa20d8d9$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $EqHTq.isFunction)(param)) {
        if (!element) return;
        const result = param.call(element, element, state || element.state, context || element.context);
        if (result && typeof result.then === 'function') {
            let resolved;
            result.then((value)=>{
                resolved = value;
            });
            return resolved;
        }
        return result;
    }
    return param;
};
const $6348a97baa20d8d9$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $6348a97baa20d8d9$export$78e3044358792147(extention[e], element);
};
const $6348a97baa20d8d9$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, e)) continue;
        if ($6348a97baa20d8d9$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        if (element[e] === undefined) element[e] = obj[e];
    }
    return element;
};
const $6348a97baa20d8d9$export$6969335ea1e4e77c = (element, extend, excludeFrom = (0, $hMWjF.METHODS_EXL))=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in extend){
        if (!Object.prototype.hasOwnProperty.call(extend, e)) continue;
        if ($6348a97baa20d8d9$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObjectLike)(extendProp)) $6348a97baa20d8d9$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    const o = {};
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        if ($6348a97baa20d8d9$var$_startsWithDunder(prop)) continue;
        if (useSet ? excludeFrom.has(prop) : excludeFrom.includes(prop)) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $6348a97baa20d8d9$export$b7d58db314e0ac27 = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = new WeakMap(), handleExtends: handleExtends = false } = options;
    const contentWindow = targetWindow || (0, $jvD5p.window) || globalThis;
    // Handle non-object types and special cases
    if (!(0, $EqHTq.isObjectLike)(obj) || (0, $cPMIO.isDOMNode)(obj)) return obj;
    // Handle circular references
    if (visited.has(obj)) return visited.get(obj);
    // Create appropriate container based on type and window context
    const isArr = (0, $EqHTq.isArray)(obj);
    const clone = isArr ? [] : {};
    // Store the clone to handle circular references
    visited.set(obj, clone);
    // Convert exclude to Set for O(1) lookups when list is non-trivial
    const excludeSet = exclude instanceof Set ? exclude : exclude.length > 3 ? new Set(exclude) : null;
    // Clone properties
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        // Skip excluded properties
        if ($6348a97baa20d8d9$var$_startsWithDunder(key) || key === '__proto__') continue;
        if (excludeSet ? excludeSet.has(key) : exclude.includes(key)) continue;
        const value = obj[key];
        // Skip based on cleanup options
        if (cleanUndefined && value === undefined) continue;
        if (cleanNull && value === null) continue;
        // Handle special cases
        if ((0, $cPMIO.isDOMNode)(value)) {
            clone[key] = value;
            continue;
        }
        // Handle 'extends' array if enabled
        if (handleExtends && key === 'extends' && (0, $EqHTq.isArray)(value)) {
            clone[key] = (0, $hSU9O.unstackArrayOfObjects)(value, exclude);
            continue;
        }
        // Handle functions in cross-frame scenario
        if ((0, $EqHTq.isFunction)(value) && options.window) {
            clone[key] = contentWindow.eval('(' + value.toString() + ')');
            continue;
        }
        // Recursively clone objects
        if ((0, $EqHTq.isObjectLike)(value)) clone[key] = $6348a97baa20d8d9$export$b7d58db314e0ac27(value, {
            ...options,
            visited: visited
        });
        else clone[key] = value;
    }
    return clone;
};
const $6348a97baa20d8d9$export$a1b87aa71164cd70 = (obj, stringified = {})=>{
    if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
        (obj.__element || obj.parent?.__element).warn('Trying to clone element or state at', obj);
        obj = obj.parse?.();
    }
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $EqHTq.isObject)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$a1b87aa71164cd70(objProp, stringified[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            const arr = stringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const v = objProp[i];
                if ((0, $EqHTq.isObject)(v)) {
                    arr[i] = {};
                    $6348a97baa20d8d9$export$a1b87aa71164cd70(v, arr[i]);
                } else if ((0, $EqHTq.isFunction)(v)) arr[i] = v.toString();
                else arr[i] = v;
            }
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$var$OBJ_TO_STR_SPECIAL_CHARS = new Set([
    '&',
    '*',
    '-',
    ':',
    '%',
    '{',
    '}',
    '>',
    '<',
    '@',
    '.',
    '/',
    '!',
    ' '
]);
const $6348a97baa20d8d9$export$830c053460e5ddf6 = (obj = {}, indent = 0)=>{
    // Handle empty object case
    if (obj === null || typeof obj !== 'object') return String(obj);
    // Handle empty object case - avoid Object.keys allocation
    let hasKeys = false;
    for(const _k in obj){
        hasKeys = true;
        break;
    } // eslint-disable-line
    if (!hasKeys) return '{}';
    const spaces = '  '.repeat(indent);
    let str = '{\n';
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        const value = obj[key];
        let keyNeedsQuotes = false;
        for(let i = 0; i < key.length; i++)if ($6348a97baa20d8d9$var$OBJ_TO_STR_SPECIAL_CHARS.has(key[i])) {
            keyNeedsQuotes = true;
            break;
        }
        const stringedKey = keyNeedsQuotes ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $EqHTq.isArray)(value)) {
            str += '[\n';
            for (const element of value){
                if ((0, $EqHTq.isObjectLike)(element) && element !== null) str += `${spaces}    ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $EqHTq.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $EqHTq.isObjectLike)(value)) str += $6348a97baa20d8d9$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $EqHTq.isString)(value)) str += (0, $5WrxC.stringIncludesAny)(value, [
            '\n',
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ',\n';
    }
    str += `${spaces}}`;
    return str;
};
const $6348a97baa20d8d9$var$FN_PATTERNS = [
    /^\(\s*\{[^}]*\}\s*\)\s*=>/,
    /^(\([^)]*\)|[^=]*)\s*=>/,
    /^function[\s(]/,
    /^async\s+/,
    /^\(\s*function/,
    /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
];
const $6348a97baa20d8d9$var$RE_JSON_LIKE = /^["[{]/;
const $6348a97baa20d8d9$export$6b15be743c368efa = (str)=>{
    if (!str) return false;
    const trimmed = str.trim().replace(/\n\s*/g, ' ').trim();
    if (trimmed === '' || trimmed === '{}' || trimmed === '[]') return false;
    const isFn = $6348a97baa20d8d9$var$FN_PATTERNS.some((pattern)=>pattern.test(trimmed));
    if (!isFn) return false;
    const firstChar = trimmed.charCodeAt(0);
    const hasArrow = trimmed.includes('=>');
    // '{' = 123, '[' = 91
    if (firstChar === 123 && !hasArrow) return false // object literal
    ;
    if (firstChar === 91) return false // array literal
    ;
    if ($6348a97baa20d8d9$var$RE_JSON_LIKE.test(trimmed) && !hasArrow) return false;
    return true;
};
const $6348a97baa20d8d9$export$4db1ad98392a09bb = (obj, destringified = {})=>{
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isString)(objProp)) {
            if ($6348a97baa20d8d9$export$6b15be743c368efa(objProp)) try {
                destringified[prop] = (0, $jvD5p.window).eval(`(${objProp})`);
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $EqHTq.isArray)(objProp)) {
            const arr = destringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const arrProp = objProp[i];
                if ((0, $EqHTq.isString)(arrProp)) {
                    if ($6348a97baa20d8d9$export$6b15be743c368efa(arrProp)) try {
                        arr.push((0, $jvD5p.window).eval(`(${arrProp})`));
                    } catch (e) {
                        if (e) arr.push(arrProp);
                    }
                    else arr.push(arrProp);
                } else if ((0, $EqHTq.isObject)(arrProp)) arr.push($6348a97baa20d8d9$export$4db1ad98392a09bb(arrProp));
                else arr.push(arrProp);
            }
        } else if ((0, $EqHTq.isObject)(objProp)) destringified[prop] = $6348a97baa20d8d9$export$4db1ad98392a09bb(objProp, destringified[prop]);
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $6348a97baa20d8d9$export$a6c9a3ccba61521e = (str, opts = {
    verbose: true
})=>{
    try {
        return str ? (0, $jvD5p.window).eval('(' + str + ')') : {} // eslint-disable-line
        ;
    } catch (e) {
        if (opts.verbose) console.warn(e);
    }
};
const $6348a97baa20d8d9$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $6348a97baa20d8d9$export$dd1bc94b04021eeb = (o)=>{
    for(const _ in o)return false // eslint-disable-line
    ;
    return true;
};
const $6348a97baa20d8d9$export$83b788b1a3698c03 = (o)=>(0, $EqHTq.isObject)(o) && $6348a97baa20d8d9$export$dd1bc94b04021eeb(o);
const $6348a97baa20d8d9$export$d6d64087a1bd2d = ()=>Object.create(null);
const $6348a97baa20d8d9$export$d3305692eb3e9a81 = (element, params, opts = {})=>{
    const excl = opts.exclude || [];
    const allowUnderscore = opts.preventUnderscore;
    for(const e in params){
        if (excl.includes(e) || !allowUnderscore && $6348a97baa20d8d9$var$_startsWithDunder(e)) continue;
        if (params[e] !== undefined) element[e] = params[e];
    }
    return element;
};
const $6348a97baa20d8d9$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in params){
        if ($6348a97baa20d8d9$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $6348a97baa20d8d9$export$f0b277b530b4fffd = (obj, params, opts = {}, visited = new WeakMap())=>{
    if (!(0, $EqHTq.isObjectLike)(obj) || !(0, $EqHTq.isObjectLike)(params) || (0, $cPMIO.isDOMNode)(obj) || (0, $cPMIO.isDOMNode)(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    const excl = opts.exclude;
    const exclSet = excl ? excl instanceof Set ? excl : new Set(excl) : null;
    const forcedExclude = !opts.preventForce;
    for(const e in params){
        if (!Object.prototype.hasOwnProperty.call(params, e)) continue;
        if (exclSet && exclSet.has(e) || forcedExclude && $6348a97baa20d8d9$var$_startsWithDunder(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $cPMIO.isDOMNode)(paramsProp)) obj[e] = paramsProp;
        else if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) obj[e] = $6348a97baa20d8d9$export$f0b277b530b4fffd(objProp, paramsProp, opts, visited);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $6348a97baa20d8d9$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    if (typeof param !== 'object' || typeof element !== 'object' || param === null || element === null) return param === element;
    if (visited.has(param) || visited.has(element)) return true;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    if (keysParam.length !== keysElement.length) return false;
    for(let i = 0; i < keysParam.length; i++){
        const key = keysParam[i];
        if (!Object.prototype.hasOwnProperty.call(element, key)) return false;
        if (!$6348a97baa20d8d9$export$683c7d6569f339f4(param[key], element[key], visited)) return false;
    }
    return true;
};
const $6348a97baa20d8d9$var$DEEP_CONTAINS_IGNORED = new Set([
    'node',
    '__ref'
]);
const $6348a97baa20d8d9$export$273cb3019e2f952c = (obj1, obj2, ignoredKeys = $6348a97baa20d8d9$var$DEEP_CONTAINS_IGNORED)=>{
    if (obj1 === obj2) return true;
    if (!(0, $EqHTq.isObjectLike)(obj1) || !(0, $EqHTq.isObjectLike)(obj2)) return obj1 === obj2;
    if ((0, $cPMIO.isDOMNode)(obj1) || (0, $cPMIO.isDOMNode)(obj2)) return obj1 === obj2;
    const ignored = ignoredKeys instanceof Set ? ignoredKeys : new Set(ignoredKeys);
    const visited = new WeakSet();
    function checkContains(target, source) {
        if (visited.has(source)) return true;
        visited.add(source);
        for(const key in source){
            if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
            if (ignored.has(key)) continue;
            if (!Object.prototype.hasOwnProperty.call(target, key)) return false;
            const sourceValue = source[key];
            const targetValue = target[key];
            if ((0, $cPMIO.isDOMNode)(sourceValue) || (0, $cPMIO.isDOMNode)(targetValue)) {
                if (sourceValue !== targetValue) return false;
            } else if ((0, $EqHTq.isObjectLike)(sourceValue) && (0, $EqHTq.isObjectLike)(targetValue)) {
                if (!checkContains(targetValue, sourceValue)) return false;
            } else if (sourceValue !== targetValue) return false;
        }
        return true;
    }
    return checkContains(obj1, obj2);
};
const $6348a97baa20d8d9$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $EqHTq.is)(props)('string', 'number')) delete obj[props];
    else if ((0, $EqHTq.isArray)(props)) for(let i = 0; i < props.length; i++)delete obj[props[i]];
    else throw new Error('Invalid input: props must be a string or an array of strings');
    return obj;
};
const $6348a97baa20d8d9$export$c2a75c92f46bb782 = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const newObj = Object.create(null);
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $6348a97baa20d8d9$export$c2a75c92f46bb782(obj[key]);
    return newObj;
};
const $6348a97baa20d8d9$export$a9706fb8026b394a = (arr, lastValue)=>{
    if (arr.length === 0) return lastValue;
    const nestedObject = {};
    let current = nestedObject;
    for(let i = 0; i < arr.length; i++)if (i === arr.length - 1 && lastValue) current[arr[i]] = lastValue;
    else {
        current[arr[i]] = {};
        current = current[arr[i]];
    }
    return nestedObject;
};
const $6348a97baa20d8d9$export$33f72cab96f733af = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (current[path[i]] === undefined) return;
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    if (current && Object.prototype.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
};
const $6348a97baa20d8d9$export$9c3074cc3d55a00f = (obj, path, value)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (!current[path[i]] || typeof current[path[i]] !== 'object') current[path[i]] = {};
        current = current[path[i]];
    }
    current[path[path.length - 1]] = value;
    return obj;
};
const $6348a97baa20d8d9$export$12bc5d09cd221028 = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length; i++){
        if (current === undefined || current === null) return undefined;
        current = current[path[i]];
    }
    return current;
};
const $6348a97baa20d8d9$export$ad59efee0c629be2 = (arr)=>{
    const maxRepeats = 10;
    let pattern = [];
    let repeatCount = 0;
    for(let i = 0; i < arr.length; i++)if (pattern.length < 2) pattern.push(arr[i]);
    else {
        if (arr[i] === pattern[i % 2]) repeatCount++;
        else {
            pattern = [
                arr[i - 1],
                arr[i]
            ];
            repeatCount = 1;
        }
        if (repeatCount >= maxRepeats * 2) {
            if ($6348a97baa20d8d9$var$ENV === 'test' || $6348a97baa20d8d9$var$ENV === 'development') console.warn('Warning: Potential infinite loop detected due to repeated sequence:', pattern);
            return true;
        }
    }
};
const $6348a97baa20d8d9$export$831fcc412582ee80 = (obj)=>{
    const seen = new WeakSet();
    function detect(obj) {
        if (obj && typeof obj === 'object') {
            if (seen.has(obj)) return true;
            seen.add(obj);
            for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && detect(obj[key])) {
                console.log(obj, 'cycle at ' + key);
                return true;
            }
        }
        return false;
    }
    return detect(obj);
};
const $6348a97baa20d8d9$export$efc42697dda340d9 = (obj, excludedKeys)=>{
    const excluded = excludedKeys instanceof Set ? excludedKeys : new Set(excludedKeys);
    const result = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && !excluded.has(key)) result[key] = obj[key];
    return result;
};

});
parcelRegister("hSU9O", function(module, exports) {

$parcel$export(module.exports, "unstackArrayOfObjects", () => $d0530a7c3063b815$export$86332fe6637020e6);
$parcel$export(module.exports, "removeValueFromArray", () => $d0530a7c3063b815$export$7268a0a9258a5297);

var $8wu6n = parcelRequire("8wu6n");

var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $d0530a7c3063b815$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $d0530a7c3063b815$export$2b3f138fefbb2e97 = (arr, value)=>{
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (arr[i] === value) count++;
    return count;
};
const $d0530a7c3063b815$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $EqHTq.isString)(index)) index = parseInt(index);
    if ((0, $EqHTq.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error('Invalid index');
        arr.splice(index, 1);
    } else throw new Error('Invalid index');
    return arr;
};
const $d0530a7c3063b815$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $d0530a7c3063b815$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $d0530a7c3063b815$export$86332fe6637020e6 = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>(0, $8wu6n.deepMerge)(a, (0, $8wu6n.deepClone)(c, {
            exclude: exclude
        }), exclude), {});
};
const $d0530a7c3063b815$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $d0530a7c3063b815$export$e9b4b966d876219d = (arr, value)=>{
    if (!(0, $EqHTq.isArray)(arr)) return;
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $d0530a7c3063b815$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr;
};
const $d0530a7c3063b815$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};
const $d0530a7c3063b815$export$aefdd0c3cb403b10 = (array, item)=>{
    // Create a new array to hold the result
    const result = [];
    // Loop through the input array
    for(let i = 0; i < array.length; i++){
        // Add the current element to the result array
        result.push(array[i]);
        // If it's not the last element, add the item
        if (i < array.length - 1) result.push(item);
    }
    return result;
};
const $d0530a7c3063b815$export$402525ce1e0ae04f = (array, valueToMove, insertBeforeValue)=>{
    const newArray = [
        ...array
    ] // Create a copy of the original array
    ;
    const indexToMove = newArray.indexOf(valueToMove) // Find the index of the value to move
    ;
    const indexToInsertBefore = newArray.indexOf(insertBeforeValue) // Find the index to insert before
    ;
    if (indexToMove !== -1 && indexToInsertBefore !== -1) {
        const removedItem = newArray.splice(indexToMove, 1)[0] // Remove the item to move
        ;
        const insertIndex = indexToInsertBefore < indexToMove ? indexToInsertBefore : indexToInsertBefore + 1 // Adjust insert index
        ;
        newArray.splice(insertIndex, 0, removedItem) // Insert the removed item before the specified value
        ;
    }
    return newArray;
};
const $d0530a7c3063b815$export$234180f8206db11b = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $d0530a7c3063b815$export$e43a5cd3407a4eed = (sourceArr, excludeArr)=>{
    return sourceArr.filter((item)=>!excludeArr.includes(item));
};
const $d0530a7c3063b815$export$34fca6752b16443b = (sourceArr, excludeArr)=>{
    const excludeSet = new Set(excludeArr);
    return sourceArr.filter((item)=>!excludeSet.has(item));
};
const $d0530a7c3063b815$export$8a158988a0fbe64f = (string, arr)=>{
    if (!string) return 0;
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (string.includes(arr[i])) count++;
    return count;
};
const $d0530a7c3063b815$export$21c00e23a20acdb3 = (arr)=>{
    if (!(0, $EqHTq.isArray)(arr)) return arr;
    return [
        ...new Set(arr)
    ];
};
const $d0530a7c3063b815$export$3369abff3c322c4c = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};

});

parcelRegister("5WrxC", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $4537bba2bd33729a$export$5e62532c096c05e0);
'use strict';
const $4537bba2bd33729a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $4537bba2bd33729a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join('\\')}]`, 'g');
    // Replace matched symbols with an empty string
    return str.replace(pattern, '');
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $4537bba2bd33729a$var$brackRegex = {
    2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*}}/g,
    3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*}}}/g
};
const $4537bba2bd33729a$var$getNestedValue = (obj, path)=>{
    return path.split('.').reduce((acc, part)=>{
        return acc?.[part];
    }, obj);
};
function $4537bba2bd33729a$export$7cb52b7decbd2220(str, state, options = {}) {
    const { bracketsLength: bracketsLength = 2 } = options;
    const bracketPattern = bracketsLength === 3 ? '{{{' : '{{';
    if (!str.includes(bracketPattern)) return str;
    const reg = $4537bba2bd33729a$var$brackRegex[bracketsLength];
    const obj = state || this.state || {};
    return str.replace(reg, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = (parentPath.match(/\.\.\//g) || []).length;
            let parentState = obj;
            for(let i = 0; i < parentLevels; i++){
                if (!parentState || !parentState.parent) return '';
                parentState = parentState.parent;
            }
            // If the variable is 'parent', return the value property
            const key = variable.trim();
            if (key === 'parent') return String(parentState.value ?? '');
            const value = $4537bba2bd33729a$var$getNestedValue(parentState, key);
            return String(value ?? '');
        } else {
            const value = $4537bba2bd33729a$var$getNestedValue(obj, variable.trim());
            return String(value ?? '');
        }
    });
}
const $4537bba2bd33729a$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};
const $4537bba2bd33729a$export$e03c69ff1d8102d5 = (str, key)=>{
    const lines = str.split('\n');
    let startLineNumber = -1;
    let endLineNumber = -1;
    let startColumn = -1;
    let endColumn = -1;
    const keyPattern = new RegExp(`\\b${key}\\b\\s*:\\s*`);
    let braceCount = 0;
    let foundKey = false;
    for(let i = 0; i < lines.length; i++){
        if (keyPattern.test(lines[i]) && !foundKey) {
            foundKey = true;
            startLineNumber = i + 1;
            startColumn = lines[i].indexOf(key) + 1;
            // Check if the value is an empty object
            if (lines[i].includes('{}')) {
                endLineNumber = startLineNumber;
                endColumn = lines[i].indexOf('{}') + 3;
                break;
            }
            // Check if the value starts with '{' (object) or '[' (array)
            const line = lines[i].slice(startColumn + key.length);
            if (line.includes('{') || line.includes('[')) braceCount = 1;
            else {
                endLineNumber = i + 1;
                endColumn = lines[i].length + 1;
                break;
            }
        } else if (foundKey) {
            braceCount += (lines[i].match(/{/g) || []).length;
            braceCount += (lines[i].match(/\[/g) || []).length;
            braceCount -= (lines[i].match(/}/g) || []).length;
            braceCount -= (lines[i].match(/]/g) || []).length;
            // If braceCount is 0 and we find the end of the object/array
            if (braceCount === 0) {
                endLineNumber = i + 1;
                endColumn = lines[i].lastIndexOf('}') !== -1 ? lines[i].lastIndexOf('}') + 2 : lines[i].length + 1;
                break;
            }
        }
    }
    return {
        startColumn: startColumn,
        endColumn: endColumn,
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber
    };
};
const $4537bba2bd33729a$var$RE_OCTAL = /\\([0-7]{1,3})/g;
const $4537bba2bd33729a$export$ed5844ba7edb0ac0 = (str)=>{
    return str.replace($4537bba2bd33729a$var$RE_OCTAL, (_, p1)=>String.fromCharCode(parseInt(p1, 8)));
};
const $4537bba2bd33729a$export$56079d9b77cc851c = (str)=>{
    return str.replace(/\n/g, '/////n').replace(/`/g, '/////tilde').replace(/\$/g, '/////dlrsgn');
};
const $4537bba2bd33729a$export$d5a58d286266e59c = (encodedStr)=>{
    return encodedStr.replace(/\/\/\/\/\/n/g, '\n').replace(/\/\/\/\/\/tilde/g, '`').replace(/\/\/\/\/\/dlrsgn/g, '$');
};
const $4537bba2bd33729a$var$RE_NON_ALNUM = /[^a-zA-Z0-9\s]/g;
const $4537bba2bd33729a$export$afdf0655b23d957b = (str)=>{
    return str.replace($4537bba2bd33729a$var$RE_NON_ALNUM, (char)=>'%' + char.charCodeAt(0).toString(16).toUpperCase());
};
const $4537bba2bd33729a$export$f0dfcf6020c0b258 = (encodedStr)=>{
    return encodedStr.replace(/%[0-9A-Fa-f]{2}/g, (match)=>String.fromCharCode(parseInt(match.slice(1), 16)));
};

});


parcelRegister("jOLBF", function(module, exports) {

$parcel$export(module.exports, "isProduction", () => $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4);
'use strict';
const $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4 = "production";
const $e6d79d7b0d7b5fe1$export$83401e34d5e11bf4 = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4;
const $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'production';
const $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'testing' || env === 'test';
const $e6d79d7b0d7b5fe1$export$9592e006a670b581 = $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5;
const $e6d79d7b0d7b5fe1$export$23da1d24a38b0bde = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'staging';
const $e6d79d7b0d7b5fe1$export$6dd1bbd39f571125 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'local';
const $e6d79d7b0d7b5fe1$export$df77466336fe5355 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'development' || env === 'dev' || env === 'local';
const $e6d79d7b0d7b5fe1$export$d84272657cb7c466 = (key, env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env[key];
const $e6d79d7b0d7b5fe1$export$eda5083784a7e709 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>!$e6d79d7b0d7b5fe1$export$f15d00aa73aafac4(env);

});


parcelRegister("Lswg4", function(module, exports) {

$parcel$export(module.exports, "send", () => send);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $bD06b = parcelRequire("bD06b");

var $73MNt = parcelRequire("73MNt");
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const getIsDev = (options)=>{
    return options.development || (0, $bD06b.window) && (0, $bD06b.window).location && (0, $bD06b.window).location.host.includes("local") || ENV === "testing" || ENV === "development";
};
const getSocketUrl = (options, isDev)=>{
    const SOCKET_BACKEND_URL = isDev ? "http://localhost:8080/" : "https://api.symbols.app/";
    const socketUrls = (0, $e7Ezu.isArray)(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || "api.symbols.app";
    return {
        primaryUrl: primaryUrl || SOCKET_BACKEND_URL,
        secondaryUrl: secondaryUrl
    };
};
const connect = (key, options = {})=>{
    const isDev = getIsDev(options);
    const { primaryUrl, secondaryUrl } = getSocketUrl(options, isDev);
    const socket = (0, $73MNt.default)(primaryUrl || secondaryUrl, {
    });
    socket.on("connect", ()=>{
        if (isDev) console.warn(`Connected to %c${primaryUrl} %c${key} %c${socket.id}`, "font-weight: bold; color: green;", "font-weight: bold;", "");
        socket.emit("initConnect", {
            key: key,
            ...options
        });
        try {
            if ((0, $e7Ezu.isFunction)(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("connect_error", (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if ((0, $e7Ezu.isFunction)(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if (utils.isNotProduction()) console.log(`Could not connect to %c${primaryUrl}%c, reconnecting to %c${secondaryUrl}`, "font-weight: bold; color: red;", "", "font-weight: bold; color: green;");
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("disconnect", (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if ((0, $e7Ezu.isFunction)(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === "connect") return;
        try {
            if ((0, $e7Ezu.isFunction)(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = "change", changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});
parcelRegister("jgAqB", function(module, exports) {

var $b3i2S = parcelRequire("b3i2S");

var $eo3lV = parcelRequire("eo3lV");

var $e7Ezu = parcelRequire("e7Ezu");

var $g1LU2 = parcelRequire("g1LU2");

var $3Ocr8 = parcelRequire("3Ocr8");

var $9RPo7 = parcelRequire("9RPo7");

var $fhYuv = parcelRequire("fhYuv");

var $bvmdI = parcelRequire("bvmdI");

var $kQGmH = parcelRequire("kQGmH");

var $3GLOu = parcelRequire("3GLOu");

var $bD06b = parcelRequire("bD06b");

var $ajexq = parcelRequire("ajexq");

var $03PwY = parcelRequire("03PwY");

var $iPYI6 = parcelRequire("iPYI6");

var $5zx8x = parcelRequire("5zx8x");

var $7gXxj = parcelRequire("7gXxj");

var $81M4S = parcelRequire("81M4S");

var $lw6SS = parcelRequire("lw6SS");

var $1jKby = parcelRequire("1jKby");

var $5ORwk = parcelRequire("5ORwk");

var $j7W2w = parcelRequire("j7W2w");

var $dzojf = parcelRequire("dzojf");

var $dWAIU = parcelRequire("dWAIU");

var $b4h11 = parcelRequire("b4h11");
$parcel$exportWildcard(module.exports, $b3i2S);
$parcel$exportWildcard(module.exports, $eo3lV);
$parcel$exportWildcard(module.exports, $e7Ezu);
$parcel$exportWildcard(module.exports, $g1LU2);
$parcel$exportWildcard(module.exports, $3Ocr8);
$parcel$exportWildcard(module.exports, $9RPo7);
$parcel$exportWildcard(module.exports, $fhYuv);
$parcel$exportWildcard(module.exports, $bvmdI);
$parcel$exportWildcard(module.exports, $kQGmH);
$parcel$exportWildcard(module.exports, $3GLOu);
$parcel$exportWildcard(module.exports, $bD06b);
$parcel$exportWildcard(module.exports, $ajexq);
$parcel$exportWildcard(module.exports, $03PwY);
$parcel$exportWildcard(module.exports, $iPYI6);
$parcel$exportWildcard(module.exports, $5zx8x);
$parcel$exportWildcard(module.exports, $7gXxj);
$parcel$exportWildcard(module.exports, $81M4S);
$parcel$exportWildcard(module.exports, $lw6SS);
$parcel$exportWildcard(module.exports, $1jKby);
$parcel$exportWildcard(module.exports, $5ORwk);
$parcel$exportWildcard(module.exports, $j7W2w);
$parcel$exportWildcard(module.exports, $dzojf);
$parcel$exportWildcard(module.exports, $dWAIU);
$parcel$exportWildcard(module.exports, $b4h11);

});
parcelRegister("b3i2S", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $80bdf8f9dda795eb$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $80bdf8f9dda795eb$export$6f8fb29fbb5b5b63);
$parcel$export(module.exports, "createKey", () => $80bdf8f9dda795eb$export$e2280c1995141b13);

var $g1LU2 = parcelRequire("g1LU2");
const $80bdf8f9dda795eb$export$3a7728e868aa3ebd = /* @__PURE__ */ function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $80bdf8f9dda795eb$export$6f8fb29fbb5b5b63 = $80bdf8f9dda795eb$export$3a7728e868aa3ebd;
const $80bdf8f9dda795eb$export$e2280c1995141b13 = (element, parent, key)=>{
    return ((0, $g1LU2.exec)(key, element) || key || element.key || $80bdf8f9dda795eb$export$3a7728e868aa3ebd()).toString();
};

});

parcelRegister("3Ocr8", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $2c5fb04049889cd6$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $2c5fb04049889cd6$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $2c5fb04049889cd6$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $2c5fb04049889cd6$export$6f017d9966fe4675);
$parcel$export(module.exports, "cloneFunction", () => $2c5fb04049889cd6$export$5c7d787bf6cea16b);
function $2c5fb04049889cd6$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $2c5fb04049889cd6$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $2c5fb04049889cd6$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $2c5fb04049889cd6$var$RE_STRING_FUNCTION = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
const $2c5fb04049889cd6$export$6f017d9966fe4675 = (inputString)=>{
    return $2c5fb04049889cd6$var$RE_STRING_FUNCTION.test(inputString);
};
function $2c5fb04049889cd6$export$5c7d787bf6cea16b(fn, win = window) {
    const temp = function() {
        return fn.apply(win, arguments);
    };
    for(const key in fn)if (Object.prototype.hasOwnProperty.call(fn, key)) temp[key] = fn[key];
    return temp;
}

});

parcelRegister("bvmdI", function(module, exports) {

$parcel$export(module.exports, "createIfConditionFlag", () => $8603d36fc5de217d$export$62115f5848b33107);

var $e7Ezu = parcelRequire("e7Ezu");
const $8603d36fc5de217d$export$62115f5848b33107 = (element, parent)=>{
    const { __ref: ref } = element;
    if ((0, $e7Ezu.isFunction)(element.if) && !element.if(element, element.state, element.context)) delete ref.__if;
    else ref.__if = true;
};

});

parcelRegister("kQGmH", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $f2d986cb4b3fa031$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $f2d986cb4b3fa031$export$7cea94b68a0c230b);
const $f2d986cb4b3fa031$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $f2d986cb4b3fa031$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("ajexq", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $7816f4b1df5a49c3$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $7816f4b1df5a49c3$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $7816f4b1df5a49c3$export$4be65e66cfa2648a);
$parcel$export(module.exports, "removeCookie", () => $7816f4b1df5a49c3$export$6a874b7a74007875);
$parcel$export(module.exports, "getLocalStorage", () => $7816f4b1df5a49c3$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $7816f4b1df5a49c3$export$1f73f60bdb811cb1);

var $e7Ezu = parcelRequire("e7Ezu");

var $bD06b = parcelRequire("bD06b");
const $7816f4b1df5a49c3$export$d0a8044dce8ff2fc = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
const $7816f4b1df5a49c3$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $e7Ezu.isUndefined)((0, $bD06b.document)) || (0, $e7Ezu.isUndefined)((0, $bD06b.document).cookie)) return;
    const d = /* @__PURE__ */ new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    (0, $bD06b.document).cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $7816f4b1df5a49c3$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $e7Ezu.isUndefined)((0, $bD06b.document)) || (0, $e7Ezu.isUndefined)((0, $bD06b.document).cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent((0, $bD06b.document).cookie);
    const ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
};
const $7816f4b1df5a49c3$export$6a874b7a74007875 = (cname)=>{
    if ((0, $e7Ezu.isUndefined)((0, $bD06b.document)) || (0, $e7Ezu.isUndefined)((0, $bD06b.document).cookie)) return;
    (0, $bD06b.document).cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
function $7816f4b1df5a49c3$export$d3720feff416e85b(key) {
    if (!window.localStorage) return void 0;
    const item = window.localStorage.getItem(key);
    if (item === null) return void 0;
    try {
        return JSON.parse(item);
    } catch (e) {
        return void 0;
    }
}
function $7816f4b1df5a49c3$export$1f73f60bdb811cb1(key, data) {
    if (!window.localStorage || data === void 0 || data === null) return;
    const value = typeof data === "object" ? JSON.stringify(data) : data;
    window.localStorage.setItem(key, value);
}

});

parcelRegister("03PwY", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $00b840e74de94691$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "SVG_TAGS", () => $00b840e74de94691$export$23d5ae6d2560d158);
$parcel$export(module.exports, "isValidHtmlTag", () => $00b840e74de94691$export$52675ca41d41c093);
const $00b840e74de94691$export$4c3fa92ca590c71f = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style",
        "noscript",
        "script"
    ],
    body: /* @__PURE__ */ new Set([
        "string",
        "style",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "search",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "hgroup",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "hgroup",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path",
        "circle",
        "ellipse",
        "line",
        "polygon",
        "polyline",
        "rect",
        "g",
        "defs",
        "symbol",
        "use",
        "text",
        "tspan",
        "image",
        "clipPath",
        "mask",
        "pattern",
        "marker",
        "linearGradient",
        "radialGradient",
        "stop",
        "filter",
        "feGaussianBlur",
        "feOffset",
        "feMerge",
        "feMergeNode",
        "feBlend",
        "feColorMatrix",
        "feFlood",
        "feComposite",
        "foreignObject"
    ])
};
const $00b840e74de94691$export$23d5ae6d2560d158 = /* @__PURE__ */ new Set([
    "svg",
    "path",
    "circle",
    "ellipse",
    "line",
    "polygon",
    "polyline",
    "rect",
    "g",
    "defs",
    "symbol",
    "use",
    "text",
    "tspan",
    "image",
    "clipPath",
    "mask",
    "pattern",
    "marker",
    "linearGradient",
    "radialGradient",
    "stop",
    "filter",
    "feGaussianBlur",
    "feOffset",
    "feMerge",
    "feMergeNode",
    "feBlend",
    "feColorMatrix",
    "feFlood",
    "feComposite",
    "foreignObject"
]);
const $00b840e74de94691$export$52675ca41d41c093 = (arg)=>$00b840e74de94691$export$4c3fa92ca590c71f.body.has(arg);

});

parcelRegister("iPYI6", function(module, exports) {

$parcel$export(module.exports, "matchesComponentNaming", () => $db6c153b9be90b1b$export$7ee0520502076834);
$parcel$export(module.exports, "getCapitalCaseKeys", () => $db6c153b9be90b1b$export$ef62ecae187000fa);
$parcel$export(module.exports, "getSpreadChildren", () => $db6c153b9be90b1b$export$e3565e6b9e497c79);
$parcel$export(module.exports, "isContextComponent", () => $db6c153b9be90b1b$export$5869b4db06e1780c);

var $7gXxj = parcelRequire("7gXxj");

var $e7Ezu = parcelRequire("e7Ezu");
const $db6c153b9be90b1b$export$7ee0520502076834 = (key)=>{
    if (!(0, $e7Ezu.isString)(key) || !key.length) return false;
    const code = key.charCodeAt(0);
    return code >= 65 && code <= 90;
};
function $db6c153b9be90b1b$export$ef62ecae187000fa(obj) {
    return Object.keys(obj).filter((key)=>/^[A-Z]/.test(key));
}
function $db6c153b9be90b1b$export$e3565e6b9e497c79(obj) {
    return Object.keys(obj).filter((key)=>/^\d+$/.test(key));
}
function $db6c153b9be90b1b$export$5869b4db06e1780c(element, parent, passedKey) {
    const { context: context } = parent || {};
    const [extendsKey] = (0, $7gXxj.createExtendsFromKeys)(passedKey);
    const key = passedKey || extendsKey;
    return context?.components?.[key] || context?.pages?.[key];
}

});
parcelRegister("7gXxj", function(module, exports) {

$parcel$export(module.exports, "createExtendsFromKeys", () => $54b835af654e0f7f$export$f99aa3442ed267f1);
$parcel$export(module.exports, "createExtends", () => $54b835af654e0f7f$export$7c6fdf32f38bef77);
$parcel$export(module.exports, "addExtends", () => $54b835af654e0f7f$export$3200adf97fb998d9);
$parcel$export(module.exports, "concatAddExtends", () => $54b835af654e0f7f$export$cfa74393132ebcec);
$parcel$export(module.exports, "generateHash", () => $54b835af654e0f7f$export$daf4c137c5f56404);
$parcel$export(module.exports, "extendStackRegistry", () => $54b835af654e0f7f$export$476cb8ab9adcdb0d);
$parcel$export(module.exports, "extendCachedRegistry", () => $54b835af654e0f7f$export$bc442b6cc8c83971);
$parcel$export(module.exports, "getHashedExtend", () => $54b835af654e0f7f$export$46ce3405574370c6);
$parcel$export(module.exports, "setHashedExtend", () => $54b835af654e0f7f$export$8c8f2806a2edf07f);
$parcel$export(module.exports, "getExtendsStackRegistry", () => $54b835af654e0f7f$export$c4fe3c170ecffa69);
$parcel$export(module.exports, "extractArrayExtend", () => $54b835af654e0f7f$export$2c118161a655606a);
$parcel$export(module.exports, "flattenExtend", () => $54b835af654e0f7f$export$802e3e1ed5ecb3f2);
$parcel$export(module.exports, "deepExtend", () => $54b835af654e0f7f$export$54e9fb29908872fa);
$parcel$export(module.exports, "mapStringsWithContextComponents", () => $54b835af654e0f7f$export$325609fc8b225e02);
$parcel$export(module.exports, "deepMergeExtends", () => $54b835af654e0f7f$export$e0fa903e42ff191c);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => $54b835af654e0f7f$export$e2e460d82983fb19);
$parcel$export(module.exports, "jointStacks", () => $54b835af654e0f7f$export$f9f936cf352c3af2);
$parcel$export(module.exports, "getExtendsStack", () => $54b835af654e0f7f$export$f39bb847e2d05ef6);
$parcel$export(module.exports, "addExtend", () => $54b835af654e0f7f$export$2f41615046006887);
$parcel$export(module.exports, "getExtendsInElement", () => $54b835af654e0f7f$export$a23334bdec459c3a);
$parcel$export(module.exports, "createElementExtends", () => $54b835af654e0f7f$export$5adee993743866c4);
$parcel$export(module.exports, "inheritChildPropsExtends", () => $54b835af654e0f7f$export$330789d8e1f3b311);
$parcel$export(module.exports, "inheritChildExtends", () => $54b835af654e0f7f$export$dde729987f06f311);
$parcel$export(module.exports, "inheritRecursiveChildExtends", () => $54b835af654e0f7f$export$4426caec5c659cae);
$parcel$export(module.exports, "createExtendsStack", () => $54b835af654e0f7f$export$5625cedc68348886);
$parcel$export(module.exports, "finalizeExtends", () => $54b835af654e0f7f$export$eef12a49036578e9);
$parcel$export(module.exports, "applyExtends", () => $54b835af654e0f7f$export$1ac92e2b1d1a0b6d);

var $9RPo7 = parcelRequire("9RPo7");

var $iPYI6 = parcelRequire("iPYI6");

var $g1LU2 = parcelRequire("g1LU2");

var $e7Ezu = parcelRequire("e7Ezu");
const $54b835af654e0f7f$var$ENV = "production";
const $54b835af654e0f7f$var$isSourcemapEnabled = (options)=>options.sourcemap !== false && $54b835af654e0f7f$var$ENV !== "production";
const $54b835af654e0f7f$export$f99aa3442ed267f1 = (key)=>{
    if (key.includes("+")) return key.split("+").filter((0, $iPYI6.matchesComponentNaming));
    if (key.includes("_")) {
        const [first] = key.split("_");
        return [
            first
        ];
    }
    if (key.includes(".") && !(0, $iPYI6.matchesComponentNaming)(key.split(".")[1])) {
        const [first] = key.split(".");
        return [
            first
        ];
    }
    return [
        key
    ];
};
const $54b835af654e0f7f$export$7c6fdf32f38bef77 = (element, parent, key)=>{
    let __extends = [];
    const keyExtends = $54b835af654e0f7f$export$f99aa3442ed267f1(key);
    if (keyExtends) __extends = [
        ...keyExtends
    ];
    const elementExtends = element.extends;
    if (elementExtends) __extends = (0, $e7Ezu.isArray)(elementExtends) ? [
        ...__extends,
        ...elementExtends
    ] : [
        ...__extends,
        elementExtends
    ];
    return __extends;
};
const $54b835af654e0f7f$export$3200adf97fb998d9 = (newExtends, element)=>{
    const { __ref: ref } = element;
    let { __extends: __extends } = ref;
    if (!newExtends) return __extends;
    const variant = element.props?.variant;
    const context = element.context;
    if (variant && context?.components && !Array.isArray(newExtends) && typeof newExtends === "string") {
        const variantKey = `${newExtends}.${variant}`;
        if (context.components[variantKey]) newExtends = variantKey;
    }
    if (!__extends.includes(newExtends)) {
        __extends = Array.isArray(newExtends) ? [
            ...__extends,
            ...newExtends
        ] : [
            ...__extends,
            newExtends
        ];
        ref.__extends = __extends;
    }
    return __extends;
};
const $54b835af654e0f7f$export$cfa74393132ebcec = (newExtend, element)=>{
    if (!newExtend) return element;
    const { extends: elementExtend } = element;
    const originalArray = (0, $e7Ezu.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $e7Ezu.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    return {
        ...element,
        extends: (0, $9RPo7.joinArrays)(receivedArray, originalArray)
    };
};
const $54b835af654e0f7f$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $54b835af654e0f7f$export$476cb8ab9adcdb0d = {};
const $54b835af654e0f7f$export$bc442b6cc8c83971 = {};
const $54b835af654e0f7f$export$46ce3405574370c6 = (extend)=>{
    return $54b835af654e0f7f$export$476cb8ab9adcdb0d[extend.__hash];
};
const $54b835af654e0f7f$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $54b835af654e0f7f$export$daf4c137c5f56404();
    if (!(0, $e7Ezu.isString)(extend)) extend.__hash = hash;
    if (hash !== "__proto__" && hash !== "constructor" && hash !== "prototype") $54b835af654e0f7f$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $54b835af654e0f7f$export$c4fe3c170ecffa69 = (extend, stack)=>{
    if (extend.__hash) return stack.concat($54b835af654e0f7f$export$46ce3405574370c6(extend));
    return $54b835af654e0f7f$export$8c8f2806a2edf07f(extend, stack);
};
const $54b835af654e0f7f$export$2c118161a655606a = (extend, stack, context, processed = /* @__PURE__ */ new Set(), nameStack, componentNameMap)=>{
    for (const each of extend)if ((0, $e7Ezu.isArray)(each)) $54b835af654e0f7f$export$2c118161a655606a(each, stack, context, processed, nameStack, componentNameMap);
    else $54b835af654e0f7f$export$802e3e1ed5ecb3f2(each, stack, context, processed, nameStack, void 0, componentNameMap);
    return stack;
};
const $54b835af654e0f7f$export$54e9fb29908872fa = (extend, stack, context, processed = /* @__PURE__ */ new Set(), nameStack, currentName, componentNameMap)=>{
    const extendOflattenExtend = extend.extends || extend.extend;
    const cleanExtend = {
        ...extend
    };
    delete cleanExtend.extends;
    delete cleanExtend.extend;
    let hasKeys = false;
    for(const _k in cleanExtend){
        hasKeys = true;
        break;
    }
    if (hasKeys) {
        stack.push(cleanExtend);
        if (nameStack) nameStack.push(currentName);
    }
    if (extendOflattenExtend) $54b835af654e0f7f$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context, processed, nameStack, currentName, componentNameMap);
    return stack;
};
const $54b835af654e0f7f$export$802e3e1ed5ecb3f2 = (extend, stack, context, processed = /* @__PURE__ */ new Set(), nameStack, parentName, componentNameMap)=>{
    if (!extend) return stack;
    if (processed.has(extend)) return stack;
    if ((0, $e7Ezu.isArray)(extend)) return $54b835af654e0f7f$export$2c118161a655606a(extend, stack, context, processed, nameStack, componentNameMap);
    let currentName = parentName;
    if ((0, $e7Ezu.isString)(extend)) {
        currentName = extend;
        extend = $54b835af654e0f7f$export$325609fc8b225e02(extend, context);
    } else if (componentNameMap && (0, $e7Ezu.isObject)(extend) && componentNameMap.has(extend)) currentName = componentNameMap.get(extend);
    processed.add(extend);
    if (extend?.extends || extend?.extend) $54b835af654e0f7f$export$54e9fb29908872fa(extend, stack, context, processed, nameStack, currentName, componentNameMap);
    else if (extend) {
        stack.push(extend);
        if (nameStack) nameStack.push(currentName);
    }
    return stack;
};
const $54b835af654e0f7f$var$MERGE_EXTENDS_SKIP = /* @__PURE__ */ new Set([
    "parent",
    "node",
    "__ref",
    "__proto__",
    "extend",
    "childExtend",
    "childExtendRecursive"
]);
const $54b835af654e0f7f$export$e0fa903e42ff191c = (element, extend, sourcemap, sourceName, preBuiltSourcemap)=>{
    extend = (0, $g1LU2.deepClone)(extend);
    for(const e in extend){
        if ($54b835af654e0f7f$var$MERGE_EXTENDS_SKIP.has(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (extendProp === void 0) continue;
        if (Object.prototype.hasOwnProperty.call(extend, e) && e !== "__proto__" && e !== "constructor" && e !== "prototype") {
            if (elementProp === void 0) {
                element[e] = extendProp;
                if (sourcemap && sourceName) {
                    if ((0, $e7Ezu.isObject)(extendProp) && !(0, $e7Ezu.isArray)(extendProp)) {
                        sourcemap[e] = sourcemap[e] || {};
                        $54b835af654e0f7f$var$trackSourcemapDeep(sourcemap[e], extendProp, sourceName);
                    } else sourcemap[e] = sourceName;
                } else if (sourcemap && preBuiltSourcemap?.[e]) sourcemap[e] = preBuiltSourcemap[e];
            } else if ((0, $e7Ezu.isObject)(elementProp) && (0, $e7Ezu.isObject)(extendProp)) {
                const nestedSourcemap = sourcemap ? sourcemap[e] = sourcemap[e] || {} : void 0;
                const nestedPreBuilt = preBuiltSourcemap?.[e];
                if ((0, $iPYI6.matchesComponentNaming)(e)) element[e] = $54b835af654e0f7f$export$e0fa903e42ff191c(elementProp, extendProp, nestedSourcemap, sourceName, nestedPreBuilt);
                else $54b835af654e0f7f$export$e0fa903e42ff191c(elementProp, extendProp, nestedSourcemap, sourceName, nestedPreBuilt);
            }
            if (e === "extends" || e === "childExtends" || e === "childExtendsRecursive") {
                if ((0, $e7Ezu.isArray)(elementProp) && (0, $e7Ezu.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
                else if ((0, $e7Ezu.isArray)(elementProp) && (0, $e7Ezu.isObject)(extendProp)) {
                    const obj = $54b835af654e0f7f$export$e0fa903e42ff191c({}, elementProp);
                    element[e] = $54b835af654e0f7f$export$e0fa903e42ff191c(obj, extendProp);
                }
            }
        }
    }
    return element;
};
const $54b835af654e0f7f$var$trackSourcemapDeep = (sourcemap, obj, sourceName)=>{
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        if (key === "__proto__" || key === "constructor" || key === "prototype") continue;
        const val = obj[key];
        if ((0, $e7Ezu.isObject)(val) && !(0, $e7Ezu.isArray)(val)) {
            sourcemap[key] = sourcemap[key] || {};
            $54b835af654e0f7f$var$trackSourcemapDeep(sourcemap[key], val, sourceName);
        } else sourcemap[key] = sourceName;
    }
};
const $54b835af654e0f7f$export$e2e460d82983fb19 = (stack, sourcemap, extendNames)=>{
    return stack.reduce((acc, current, i)=>{
        const cloned = (0, $g1LU2.deepClone)(current);
        const sourceName = extendNames ? extendNames[i] : void 0;
        return $54b835af654e0f7f$export$e0fa903e42ff191c(acc, cloned, sourcemap, sourceName);
    }, {});
};
const $54b835af654e0f7f$export$325609fc8b225e02 = (extend, context, options = {}, variant)=>{
    const COMPONENTS = context?.components || options.components;
    const PAGES = context?.pages || options.pages;
    if ((0, $e7Ezu.isString)(extend)) {
        const componentExists = COMPONENTS && (COMPONENTS[extend + "." + variant] || COMPONENTS[extend] || COMPONENTS["smbls." + extend]);
        const pageExists = PAGES && extend.charCodeAt(0) === 47 && PAGES[extend];
        if (componentExists) return componentExists;
        else if (pageExists) return pageExists;
        else {
            if (options.verbose && ($54b835af654e0f7f$var$ENV === "test" || $54b835af654e0f7f$var$ENV === "development")) console.warn("Extend is string but component was not found:", extend);
            return;
        }
    }
    return extend;
};
const $54b835af654e0f7f$export$f9f936cf352c3af2 = (extendStack, childExtendsStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendsStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendsStack.slice(1));
};
const $54b835af654e0f7f$export$f39bb847e2d05ef6 = (extend, context, nameStack, componentNameMap)=>{
    if (!extend) return [];
    if (extend.__hash) return $54b835af654e0f7f$export$46ce3405574370c6(extend) || [];
    const processed = /* @__PURE__ */ new Set();
    const stack = $54b835af654e0f7f$export$802e3e1ed5ecb3f2(extend, [], context, processed, nameStack, void 0, componentNameMap);
    if (nameStack) return stack;
    return $54b835af654e0f7f$export$c4fe3c170ecffa69(extend, stack);
};
const $54b835af654e0f7f$export$2f41615046006887 = (newExtends, elementExtends)=>{
    if (!newExtends) return elementExtends;
    const receivedArray = (0, $e7Ezu.isArray)(newExtends) ? newExtends : [
        newExtends
    ];
    return (0, $9RPo7.joinArrays)(receivedArray, elementExtends);
};
const $54b835af654e0f7f$export$a23334bdec459c3a = (obj)=>{
    let result = [];
    function traverse(o) {
        for(const key in o)if (Object.prototype.hasOwnProperty.call(o, key)) {
            if ((0, $iPYI6.matchesComponentNaming)(key)) result.push(key);
            if (key === "extends") {
                if (typeof o[key] === "string") result.push(o[key]);
                else if (Array.isArray(o[key])) result = result.concat(o[key]);
            }
            if (typeof o[key] === "object" && o[key] !== null) traverse(o[key]);
        }
    }
    traverse(obj);
    return result;
};
const $54b835af654e0f7f$export$5adee993743866c4 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const context = element.context || parent.context;
    const variant = element.props?.variant;
    if (element.extend && !element.extends) element.extends = element.extend;
    delete element.extend;
    if (!element.extends && element.props?.extends) element.extends = element.props.extends;
    if (element.extends) {
        if (Array.isArray(element.extends) && element.extends.length > 0) {
            const [firstExtend, ...restExtends] = element.extends;
            if (typeof firstExtend === "string" && variant && context?.components) {
                const variantKey = `${firstExtend}.${variant}`;
                if (context.components[variantKey]) $54b835af654e0f7f$export$3200adf97fb998d9([
                    variantKey,
                    ...restExtends
                ], element);
                else $54b835af654e0f7f$export$3200adf97fb998d9(element.extends, element);
            } else $54b835af654e0f7f$export$3200adf97fb998d9(element.extends, element);
        } else if (typeof element.extends === "string" && variant && context?.components) {
            const variantKey = `${element.extends}.${variant}`;
            if (context.components[variantKey]) $54b835af654e0f7f$export$3200adf97fb998d9(variantKey, element);
            else $54b835af654e0f7f$export$3200adf97fb998d9(element.extends, element);
        } else $54b835af654e0f7f$export$3200adf97fb998d9(element.extends, element);
    }
    $54b835af654e0f7f$export$330789d8e1f3b311(element, parent, options);
    $54b835af654e0f7f$export$dde729987f06f311(element, parent, options);
    $54b835af654e0f7f$export$4426caec5c659cae(element, parent, options);
    if (element.component) $54b835af654e0f7f$export$3200adf97fb998d9((0, $g1LU2.exec)(element.component, element), element);
    if (context.defaultExtends) $54b835af654e0f7f$export$3200adf97fb998d9(context.defaultExtends, element);
    return (0, $9RPo7.removeDuplicatesInArray)(ref.__extends);
};
const $54b835af654e0f7f$export$330789d8e1f3b311 = (element, parent, options = {})=>{
    const { props: props, __ref: ref } = element;
    const ignoreChildExtends = options.ignoreChildExtends || props?.ignoreChildExtends;
    if (!ignoreChildExtends) {
        if (parent.props?.childProps?.extends) $54b835af654e0f7f$export$3200adf97fb998d9(parent.props?.childProps.extends, element);
    }
    return ref.__extends;
};
const $54b835af654e0f7f$export$dde729987f06f311 = (element, parent, options = {})=>{
    const { props: props, __ref: ref } = element;
    const ignoreChildExtends = options.ignoreChildExtends || props?.ignoreChildExtends;
    const childExtends = parent.childExtends || parent.childExtend;
    if (!ignoreChildExtends && childExtends) $54b835af654e0f7f$export$3200adf97fb998d9(childExtends, element);
    return ref.__extends;
};
const $54b835af654e0f7f$export$4426caec5c659cae = (element, parent, options = {})=>{
    const { props: props, __ref: ref } = element;
    const childExtendsRecursive = parent.childExtendsRecursive || parent.childExtendRecursive;
    const ignoreChildExtendsRecursive = options.ignoreChildExtendsRecursive || props?.ignoreChildExtendsRecursive;
    const isText = element.key === "__text";
    if (childExtendsRecursive && !isText && !ignoreChildExtendsRecursive) $54b835af654e0f7f$export$3200adf97fb998d9(childExtendsRecursive, element);
    return ref.__extends;
};
const $54b835af654e0f7f$export$5625cedc68348886 = (element, parent, options = {})=>{
    const { props: props, __ref: ref } = element;
    const context = element.context || parent.context;
    const variant = element.variant || props?.variant;
    const sourcemap = $54b835af654e0f7f$var$isSourcemapEnabled(options);
    const originalExtendNames = sourcemap ? [
        ...ref.__extends
    ] : null;
    const __extends = (0, $9RPo7.removeDuplicatesInArray)(ref.__extends.map((val, i)=>{
        return $54b835af654e0f7f$export$325609fc8b225e02(val, context, options, i === 0 && variant);
    }));
    if (sourcemap) {
        const componentNameMap = /* @__PURE__ */ new WeakMap();
        for(let i = 0; i < __extends.length; i++){
            const resolved = __extends[i];
            const originalName = originalExtendNames[i];
            if (resolved && (0, $e7Ezu.isObject)(resolved) && (0, $e7Ezu.isString)(originalName)) componentNameMap.set(resolved, originalName);
        }
        const nameStack = [];
        const stack = $54b835af654e0f7f$export$f39bb847e2d05ef6(__extends, context, nameStack, componentNameMap);
        ref.__extendsStack = stack;
        ref.__extendsNames = nameStack;
    } else {
        const stack = $54b835af654e0f7f$export$f39bb847e2d05ef6(__extends, context);
        ref.__extendsStack = stack;
    }
    return ref.__extendsStack;
};
const $54b835af654e0f7f$export$eef12a49036578e9 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const { __extendsStack: __extendsStack } = ref;
    if ($54b835af654e0f7f$var$isSourcemapEnabled(options)) {
        const sourcemapAcc = {};
        const extendNames = ref.__extendsNames || [];
        const flattenExtends = $54b835af654e0f7f$export$e2e460d82983fb19(__extendsStack, sourcemapAcc, extendNames);
        const appliedSourcemap = {};
        $54b835af654e0f7f$export$e0fa903e42ff191c(element, flattenExtends, appliedSourcemap, void 0, sourcemapAcc);
        ref.__sourcemap = appliedSourcemap;
    } else {
        const flattenExtends = $54b835af654e0f7f$export$e2e460d82983fb19(__extendsStack);
        $54b835af654e0f7f$export$e0fa903e42ff191c(element, flattenExtends);
    }
    return element;
};
const $54b835af654e0f7f$export$1ac92e2b1d1a0b6d = (element, parent, options = {})=>{
    $54b835af654e0f7f$export$5adee993743866c4(element, parent, options);
    $54b835af654e0f7f$export$5625cedc68348886(element, parent, options);
    $54b835af654e0f7f$export$eef12a49036578e9(element, parent, options);
    return element;
};

});


parcelRegister("5zx8x", function(module, exports) {

$parcel$export(module.exports, "createProps", () => $40e9ece60fec1cbd$export$c94ea207b45fef3a);
$parcel$export(module.exports, "pickupPropsFromElement", () => $40e9ece60fec1cbd$export$411043fa9345828f);
$parcel$export(module.exports, "pickupElementFromProps", () => $40e9ece60fec1cbd$export$fa8664b35a0bcdc9);
$parcel$export(module.exports, "propertizeElement", () => $40e9ece60fec1cbd$export$4ff756f42aa6b6a4);
$parcel$export(module.exports, "propertizeUpdate", () => $40e9ece60fec1cbd$export$2bbd9d589d78c8ea);
$parcel$export(module.exports, "objectizeStringProperty", () => $40e9ece60fec1cbd$export$5e9fe7243e559e3c);
$parcel$export(module.exports, "propExists", () => $40e9ece60fec1cbd$export$fd415051acfc22d4);
$parcel$export(module.exports, "inheritParentProps", () => $40e9ece60fec1cbd$export$d25057a75c14aff7);
$parcel$export(module.exports, "update", () => $40e9ece60fec1cbd$export$722fbec263ad908a);
$parcel$export(module.exports, "setPropsPrototype", () => $40e9ece60fec1cbd$export$e290b82348b6726c);
$parcel$export(module.exports, "removeDuplicateProps", () => $40e9ece60fec1cbd$export$44466878677fcc43);
$parcel$export(module.exports, "syncProps", () => $40e9ece60fec1cbd$export$b23ca50362483f82);
$parcel$export(module.exports, "createPropsStack", () => $40e9ece60fec1cbd$export$1327128ea5b9a1e8);
$parcel$export(module.exports, "applyProps", () => $40e9ece60fec1cbd$export$d76b848a0167f48b);
$parcel$export(module.exports, "initProps", () => $40e9ece60fec1cbd$export$a121566aadcfe021);
$parcel$export(module.exports, "updateProps", () => $40e9ece60fec1cbd$export$c8dce3c08436e91e);

var $1jKby = parcelRequire("1jKby");

var $5JBoC = parcelRequire("5JBoC");

var $g1LU2 = parcelRequire("g1LU2");

var $e7Ezu = parcelRequire("e7Ezu");

var $3GLOu = parcelRequire("3GLOu");
const $40e9ece60fec1cbd$var$RE_UPPER = /^[A-Z]/;
const $40e9ece60fec1cbd$var$RE_DIGITS = /^\d+$/;
const $40e9ece60fec1cbd$var$CSS_SELECTOR_PREFIXES = /* @__PURE__ */ new Set([
    ":",
    "@",
    "[",
    "*",
    "+",
    "~",
    "&",
    ">",
    "$",
    "-",
    ".",
    "!"
]);
const $40e9ece60fec1cbd$var$ELEMENT_INDICATOR_KEYS = /* @__PURE__ */ new Set([
    "extend",
    "props",
    "text",
    "tag",
    "on",
    "if",
    "childExtend",
    "children",
    "childrenAs",
    "state",
    "html",
    "attr",
    "define",
    "content"
]);
const $40e9ece60fec1cbd$var$looksLikeElement = (value)=>{
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    for(const k in value){
        if ($40e9ece60fec1cbd$var$ELEMENT_INDICATOR_KEYS.has(k)) return true;
        if ($40e9ece60fec1cbd$var$RE_UPPER.test(k)) return true;
    }
    return false;
};
const $40e9ece60fec1cbd$export$c94ea207b45fef3a = (element, parent, key)=>{
    const { props: props, __ref: ref } = element;
    ref.__propsStack = [];
    if (props) ref.__initialProps = props;
    else return {};
    if (!(0, $e7Ezu.isObjectLike)(props)) {
        ref.__propsStack.push(props);
        return {};
    }
    return {
        ...props
    };
};
function $40e9ece60fec1cbd$export$411043fa9345828f(obj, opts = {}) {
    const cachedKeys = opts.cachedKeys || [];
    for(const key in obj){
        const value = obj[key];
        const isEventHandler = key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && key[2] === key[2].toUpperCase() && (0, $e7Ezu.isFunction)(value);
        if (isEventHandler) {
            const eventName = (0, $3GLOu.lowercaseFirstLetter)(key.slice(2));
            if (obj.on) obj.on[eventName] = value;
            delete obj[key];
            continue;
        }
        if (key === "childProps") {
            obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
            continue;
        }
        const defineValue = this.define?.[key];
        const globalDefineValue = this.context?.define?.[key];
        const hasDefine = (0, $e7Ezu.isObject)(defineValue) || (0, $e7Ezu.isFunction)(defineValue);
        const hasGlobalDefine = (0, $e7Ezu.isObject)(globalDefineValue) || (0, $e7Ezu.isFunction)(globalDefineValue);
        if (hasDefine || hasGlobalDefine) continue;
        const firstChar = key.charAt(0);
        if ($40e9ece60fec1cbd$var$CSS_SELECTOR_PREFIXES.has(firstChar)) {
            obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
            continue;
        }
        const isElement = $40e9ece60fec1cbd$var$RE_UPPER.test(key) || $40e9ece60fec1cbd$var$RE_DIGITS.test(key) || $40e9ece60fec1cbd$var$looksLikeElement(value);
        const isBuiltin = (0, $1jKby.DOMQ_PROPERTIES).has(key);
        if (!isElement && !isBuiltin) {
            obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
        }
    }
    return obj;
}
function $40e9ece60fec1cbd$export$fa8664b35a0bcdc9(obj = this, opts) {
    const cachedKeys = opts.cachedKeys || [];
    for(const key in obj.props){
        const value = obj.props[key];
        const isEvent = key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110;
        const isFn = (0, $e7Ezu.isFunction)(value);
        if (isEvent && isFn) {
            (0, $5JBoC.addEventFromProps)(key, obj);
            delete obj.props[key];
            continue;
        }
        if (cachedKeys.includes(key)) continue;
        if (key === "childProps") continue;
        const firstChar = key.charAt(0);
        if ($40e9ece60fec1cbd$var$CSS_SELECTOR_PREFIXES.has(firstChar)) continue;
        const defineValue = this.define?.[key];
        const globalDefineValue = this.context?.define?.[key];
        const hasDefine = (0, $e7Ezu.isObject)(defineValue) || (0, $e7Ezu.isFunction)(defineValue);
        const hasGlobalDefine = (0, $e7Ezu.isObject)(globalDefineValue) || (0, $e7Ezu.isFunction)(globalDefineValue);
        const isElement = $40e9ece60fec1cbd$var$RE_UPPER.test(key) || $40e9ece60fec1cbd$var$RE_DIGITS.test(key);
        const isBuiltin = (0, $1jKby.DOMQ_PROPERTIES).has(key);
        if (isElement || isBuiltin || hasDefine || hasGlobalDefine) {
            if (obj[key] === void 0 || value === null) {
                obj[key] = value;
                if (obj.props) delete obj.props[key];
            }
        }
    }
    return obj;
}
function $40e9ece60fec1cbd$export$4ff756f42aa6b6a4(element = this) {
    const cachedKeys = [];
    $40e9ece60fec1cbd$export$411043fa9345828f.call(this, element, {
        cachedKeys: cachedKeys
    });
    $40e9ece60fec1cbd$export$fa8664b35a0bcdc9.call(this, element, {
        cachedKeys: cachedKeys
    });
    return element;
}
function $40e9ece60fec1cbd$export$2bbd9d589d78c8ea(params = {}) {
    if (!params.on) params.on = {};
    if (!params.props) params.props = {};
    return $40e9ece60fec1cbd$export$4ff756f42aa6b6a4.call(this, params);
}
const $40e9ece60fec1cbd$export$5e9fe7243e559e3c = (propValue)=>{
    if ((0, $e7Ezu.is)(propValue)("string", "number")) return {
        inheritedString: propValue
    };
    return propValue;
};
const $40e9ece60fec1cbd$export$fd415051acfc22d4 = (prop, stack)=>{
    if (!prop || !stack.length) return false;
    return stack.includes(prop);
};
const $40e9ece60fec1cbd$export$d25057a75c14aff7 = (element, parent)=>{
    const { __ref: ref } = element;
    const propsStack = ref.__propsStack || [];
    const parentProps = parent.props;
    if (!parentProps) return propsStack;
    const matchParentKeyProps = parentProps[element.key];
    const matchParentChildProps = parentProps.childProps || parent.childProps;
    const ignoreChildProps = element.props?.ignoreChildProps;
    if (matchParentChildProps && !ignoreChildProps) {
        const childProps = $40e9ece60fec1cbd$export$5e9fe7243e559e3c(matchParentChildProps);
        propsStack.unshift(childProps);
    }
    if (matchParentKeyProps) {
        const keyProps = $40e9ece60fec1cbd$export$5e9fe7243e559e3c(matchParentKeyProps);
        propsStack.unshift(keyProps);
    }
    return propsStack;
};
function $40e9ece60fec1cbd$export$722fbec263ad908a(props, options) {
    const element = this.__element;
    element.update({
        props: props
    }, options);
}
function $40e9ece60fec1cbd$export$e290b82348b6726c(element) {
    const methods = {
        update: $40e9ece60fec1cbd$export$722fbec263ad908a.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
}
const $40e9ece60fec1cbd$export$44466878677fcc43 = (propsStack)=>{
    const seen = /* @__PURE__ */ new Set();
    return propsStack.filter((prop)=>{
        if (!prop || (0, $1jKby.PROPS_METHODS).has(prop)) return false;
        if (seen.has(prop)) return false;
        seen.add(prop);
        return true;
    });
};
const $40e9ece60fec1cbd$export$b23ca50362483f82 = (propsStack, element, opts)=>{
    element.props = propsStack.reduce((mergedProps, v)=>{
        if ((0, $1jKby.PROPS_METHODS).has(v)) return mergedProps;
        while((0, $e7Ezu.isFunction)(v))v = (0, $g1LU2.exec)(v, element);
        return (0, $g1LU2.deepMerge)(mergedProps, (0, $g1LU2.deepClone)(v, {
            exclude: (0, $1jKby.PROPS_METHODS)
        }));
    }, {});
    $40e9ece60fec1cbd$export$e290b82348b6726c(element);
    return element.props;
};
const $40e9ece60fec1cbd$export$1327128ea5b9a1e8 = (element, parent)=>{
    const { props: props, __ref: ref } = element;
    let propsStack = ref.__propsStack || [];
    if (parent?.props) {
        const parentStack = $40e9ece60fec1cbd$export$d25057a75c14aff7(element, parent);
        propsStack = [
            ...parentStack
        ];
    }
    if ((0, $e7Ezu.isObject)(props)) propsStack.push(props);
    else if (props === "inherit" && parent?.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $e7Ezu.isArray)(ref.__extendsStack)) for(let i = 0; i < ref.__extendsStack.length; i++){
        const _extends = ref.__extendsStack[i];
        if (_extends.props && _extends.props !== props) propsStack.push(_extends.props);
    }
    ref.__propsStack = $40e9ece60fec1cbd$export$44466878677fcc43(propsStack);
    return ref.__propsStack;
};
const $40e9ece60fec1cbd$export$d76b848a0167f48b = (element, parent)=>{
    const { __ref: ref } = element;
    const propsStack = $40e9ece60fec1cbd$export$1327128ea5b9a1e8(element, parent);
    if (propsStack.length) $40e9ece60fec1cbd$export$b23ca50362483f82(propsStack, element);
    else {
        ref.__propsStack = [];
        element.props = {};
    }
};
const $40e9ece60fec1cbd$export$a121566aadcfe021 = function(element, parent, options) {
    const { __ref: ref } = element;
    if (ref.__if) $40e9ece60fec1cbd$export$d76b848a0167f48b(element, parent);
    else try {
        $40e9ece60fec1cbd$export$d76b848a0167f48b(element, parent);
    } catch (e) {
        if (element.context?.designSystem?.verbose) console.warn("initProps error at", ref.path?.join("."), e);
        element.props = {};
        ref.__propsStack = [];
    }
    $40e9ece60fec1cbd$export$e290b82348b6726c(element);
    return element;
};
const $40e9ece60fec1cbd$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: ref } = element;
    const propsStack = ref.__propsStack || [];
    let newStack = [
        ...propsStack
    ];
    const parentProps = $40e9ece60fec1cbd$export$d25057a75c14aff7(element, parent);
    if (parentProps.length) newStack = [
        ...parentProps,
        ...newStack
    ];
    if (newProps) newStack = [
        newProps,
        ...newStack
    ];
    ref.__propsStack = $40e9ece60fec1cbd$export$44466878677fcc43(newStack);
    if (ref.__propsStack.length) $40e9ece60fec1cbd$export$b23ca50362483f82(ref.__propsStack, element);
    return element;
};

});
parcelRegister("5JBoC", function(module, exports) {

$parcel$export(module.exports, "addEventFromProps", () => $42ce29caeeb0921d$export$4c071752ff9c2992);

var $3GLOu = parcelRequire("3GLOu");

var $e7Ezu = parcelRequire("e7Ezu");
function $42ce29caeeb0921d$export$4c071752ff9c2992(key, obj) {
    const { props: props, on: on } = obj;
    const eventName = (0, $3GLOu.lowercaseFirstLetter)(key.split("on")[1]);
    const origEvent = on[eventName];
    const funcFromProps = props[key];
    if ((0, $e7Ezu.isFunction)(origEvent)) on[eventName] = (...args)=>{
        const originalEventRetunrs = origEvent(...args);
        if (originalEventRetunrs !== false) funcFromProps(...args);
    };
    else on[eventName] = funcFromProps;
}

});


parcelRegister("81M4S", function(module, exports) {

$parcel$export(module.exports, "returnValueAsText", () => $5d83b5f5cdacccb7$export$dfa23c5e4a54ab0c);
$parcel$export(module.exports, "createBasedOnType", () => $5d83b5f5cdacccb7$export$927f99b3b8be13bc);
$parcel$export(module.exports, "addRef", () => $5d83b5f5cdacccb7$export$67a43d775655c9fa);
$parcel$export(module.exports, "createParent", () => $5d83b5f5cdacccb7$export$afa4f66aa2aa78ad);
$parcel$export(module.exports, "createRoot", () => $5d83b5f5cdacccb7$export$882461b6382ed46c);
$parcel$export(module.exports, "createPath", () => $5d83b5f5cdacccb7$export$fe53371bee54353d);
$parcel$export(module.exports, "addContext", () => $5d83b5f5cdacccb7$export$f02680d0c92070c1);
$parcel$export(module.exports, "addCaching", () => $5d83b5f5cdacccb7$export$ffc78f972bfbae8a);
$parcel$export(module.exports, "createElement", () => $5d83b5f5cdacccb7$export$c8a8987d4410bf2d);

var $7gXxj = parcelRequire("7gXxj");

var $b3i2S = parcelRequire("b3i2S");

var $fhYuv = parcelRequire("fhYuv");

var $5zx8x = parcelRequire("5zx8x");

var $03PwY = parcelRequire("03PwY");

var $e7Ezu = parcelRequire("e7Ezu");
const $5d83b5f5cdacccb7$var$ENV = "production";
const $5d83b5f5cdacccb7$export$dfa23c5e4a54ab0c = (element, parent, key)=>{
    const childExtendsTag = parent.childExtends && parent.childExtends.tag;
    const childPropsTag = parent.props.childProps && parent.props.childProps.tag;
    const isKeyValidHTMLTag = (0, $03PwY.HTML_TAGS).body.has(key) && key;
    return {
        text: element,
        tag: childExtendsTag || childPropsTag || isKeyValidHTMLTag || "string"
    };
};
const $5d83b5f5cdacccb7$export$927f99b3b8be13bc = (element, parent, key)=>{
    if (element === void 0) {
        if ($5d83b5f5cdacccb7$var$ENV === "test" || $5d83b5f5cdacccb7$var$ENV === "development") console.warn(key, "element is undefined in", parent?.__ref?.path);
        return {};
    }
    if (element === null) return;
    if (element === true) return {};
    if ((0, $e7Ezu.is)(element)("string", "number")) return $5d83b5f5cdacccb7$export$dfa23c5e4a54ab0c(element, parent, key);
    if ((0, $e7Ezu.isFunction)(element)) return {
        props: element
    };
    return element;
};
const $5d83b5f5cdacccb7$export$67a43d775655c9fa = (element, parent)=>{
    const ref = {};
    ref.origin = element;
    ref.parent = parent;
    return ref;
};
const $5d83b5f5cdacccb7$export$afa4f66aa2aa78ad = (element, parent, key, options, root)=>{
    if (!parent) return root;
    if ((0, $fhYuv.isNode)(parent)) {
        const parentNodeWrapper = {
            key: ":root",
            node: parent
        };
        root[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $5d83b5f5cdacccb7$export$882461b6382ed46c = (element, parent)=>{
    const { __ref: ref } = element;
    const { __ref: parentRef } = parent;
    const hasRoot = parent && parent.key === ":root";
    if (!ref?.root) ref.root = hasRoot ? element : parentRef?.root;
};
const $5d83b5f5cdacccb7$export$fe53371bee54353d = (element, parent, key)=>{
    let { __ref: parentRef } = parent;
    if (!parentRef) parentRef = parent.ref = {};
    if (!parentRef.path) parentRef.path = [];
    return parentRef.path.concat(key);
};
const $5d83b5f5cdacccb7$export$f02680d0c92070c1 = (element, parent, key, options, root)=>{
    const forcedOptionsContext = options.context && !root.context && !element.context;
    if (forcedOptionsContext) root.context = options.context;
    return options.context || parent.context || root.context || element.context;
};
const $5d83b5f5cdacccb7$export$ffc78f972bfbae8a = (element, parent, key)=>{
    const ref = $5d83b5f5cdacccb7$export$67a43d775655c9fa(element, parent);
    element.__ref = ref;
    if (!ref.__defineCache) ref.__defineCache = {};
    if (!ref.__exec) ref.__exec = {};
    if (!ref.__execProps) ref.__execProps = {};
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    if (!ref.__attr) ref.__attr = {};
    if (!ref.__changes) ref.__changes = [];
    if (!ref.__children) ref.__children = [];
    ref.__extends = (0, $7gXxj.createExtends)(element, parent, key);
    ref.path = $5d83b5f5cdacccb7$export$fe53371bee54353d(element, parent, key);
    return ref;
};
const $5d83b5f5cdacccb7$export$c8a8987d4410bf2d = (passedProps, parentEl, passedKey, opts, root)=>{
    const hashed = passedProps?.__hash;
    const element = hashed ? {
        extends: [
            passedProps
        ]
    } : $5d83b5f5cdacccb7$export$927f99b3b8be13bc(passedProps, parentEl, passedKey);
    if (!element) return;
    const parent = $5d83b5f5cdacccb7$export$afa4f66aa2aa78ad(element, parentEl, passedKey, opts, root);
    const key = (0, $b3i2S.createKey)(element, parent, passedKey);
    $5d83b5f5cdacccb7$export$ffc78f972bfbae8a(element, parent, key);
    const props = (0, $5zx8x.createProps)(element, parent, key);
    const context = $5d83b5f5cdacccb7$export$f02680d0c92070c1(element, parent, key, opts, root);
    const on = element.on || {};
    return {
        ...element,
        key: key,
        props: props,
        parent: parent,
        context: context,
        on: on
    };
};

});

parcelRegister("lw6SS", function(module, exports) {

$parcel$export(module.exports, "checkForStateTypes", () => $faa1ed26e13381d2$export$1a615c2b5db1076e);
$parcel$export(module.exports, "getRootStateInKey", () => $faa1ed26e13381d2$export$c138e045c9d99c0);
$parcel$export(module.exports, "getParentStateInKey", () => $faa1ed26e13381d2$export$f7dd4f6f6830b29d);
$parcel$export(module.exports, "getChildStateInKey", () => $faa1ed26e13381d2$export$e6d108f71cc7e736);
$parcel$export(module.exports, "findInheritedState", () => $faa1ed26e13381d2$export$487549069bb5d2a9);
$parcel$export(module.exports, "checkIfInherits", () => $faa1ed26e13381d2$export$e187d7e20e9fd8fa);
$parcel$export(module.exports, "createInheritedState", () => $faa1ed26e13381d2$export$c546cc738d4564ba);
$parcel$export(module.exports, "isState", () => $faa1ed26e13381d2$export$e5d60a6bbabd36f);
$parcel$export(module.exports, "createNestedObjectByKeyPath", () => $faa1ed26e13381d2$export$a1831dd7b6191ba4);
$parcel$export(module.exports, "applyDependentState", () => $faa1ed26e13381d2$export$af8fd5cebbe79a02);
$parcel$export(module.exports, "overwriteState", () => $faa1ed26e13381d2$export$dd6f28ea13b47393);

var $9RPo7 = parcelRequire("9RPo7");

var $1jKby = parcelRequire("1jKby");

var $g1LU2 = parcelRequire("g1LU2");

var $e7Ezu = parcelRequire("e7Ezu");
const $faa1ed26e13381d2$export$1a615c2b5db1076e = (element)=>{
    const { state: orig, props: props, __ref: ref } = element;
    const state = props?.state || orig;
    if ((0, $e7Ezu.isFunction)(state)) {
        ref.__state = state;
        return (0, $g1LU2.exec)(state, element);
    } else if ((0, $e7Ezu.is)(state)("string", "number")) {
        ref.__state = state;
        return {
            value: state
        };
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $faa1ed26e13381d2$export$c138e045c9d99c0 = (stateKey, parentState)=>{
    if (!stateKey.includes("~/")) return;
    const arr = stateKey.split("~/");
    if (arr.length > 1) return parentState.root;
};
const $faa1ed26e13381d2$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes("../")) return;
    const arr = stateKey.split("../");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $faa1ed26e13381d2$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = (0, $e7Ezu.isString)(stateKey) ? stateKey.split("/") : [
        stateKey
    ];
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === "__proto__" || grandChildKey === "__proto__") return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {};
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {};
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $faa1ed26e13381d2$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$faa1ed26e13381d2$export$e187d7e20e9fd8fa(element)) return;
    const rootState = $faa1ed26e13381d2$export$c138e045c9d99c0(stateKey, parent.state);
    let parentState = parent.state;
    if (rootState) {
        parentState = rootState;
        stateKey = stateKey.replaceAll("~/", "");
    } else {
        const findGrandParentState = $faa1ed26e13381d2$export$f7dd4f6f6830b29d(stateKey, parent.state);
        if (findGrandParentState) {
            parentState = findGrandParentState;
            stateKey = stateKey.replaceAll("../", "");
        }
    }
    if (!parentState) return;
    return $faa1ed26e13381d2$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $faa1ed26e13381d2$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $faa1ed26e13381d2$export$487549069bb5d2a9(element, parent);
    if (inheritedState === void 0) return element.state;
    if ((0, $e7Ezu.is)(inheritedState)("object", "array")) return (0, $g1LU2.deepClone)(inheritedState);
    else if ((0, $e7Ezu.is)(inheritedState)("string", "number", "boolean")) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, "is not present. Replacing with", {});
};
const $faa1ed26e13381d2$export$e187d7e20e9fd8fa = (element)=>{
    const { __ref: ref } = element;
    const stateKey = ref?.__state;
    if (stateKey && (0, $e7Ezu.is)(stateKey)("number", "string", "boolean")) return true;
    return false;
};
const $faa1ed26e13381d2$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $e7Ezu.isObjectLike)(state)) return false;
    return Boolean(state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.keys && state.values && state.toggle && state.replace && state.quietUpdate && state.quietReplace && state.add && state.apply && state.applyReplace && state.setByPath && state.setPathCollection && state.removeByPath && state.removePathCollection && state.getByPath && state.applyFunction && state.__element && state.__children);
};
const $faa1ed26e13381d2$export$a1831dd7b6191ba4 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split("/");
    const obj = {};
    let ref = obj;
    const lastIdx = keys.length - 1;
    for(let i = 0; i <= lastIdx; i++){
        ref[keys[i]] = i === lastIdx ? value || {} : {};
        ref = ref[keys[i]];
    }
    return obj;
};
const $faa1ed26e13381d2$export$af8fd5cebbe79a02 = (element, state)=>{
    const { __element: __element } = state;
    const origState = (0, $g1LU2.exec)(__element?.state, element);
    if (!origState) return;
    const dependentState = (0, $g1LU2.deepClone)(origState, (0, $1jKby.STATE_METHODS));
    const newDepends = {
        [element.key]: dependentState
    };
    const __depends = (0, $e7Ezu.isObject)(origState.__depends) ? {
        ...origState.__depends,
        ...newDepends
    } : newDepends;
    if (Array.isArray(origState)) (0, $9RPo7.addProtoToArray)(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    else Object.setPrototypeOf(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    return dependentState;
};
const $faa1ed26e13381d2$export$dd6f28ea13b47393 = (state, obj, options = {})=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === "shallow";
    const merge = overwrite === "merge";
    if (merge) {
        (0, $g1LU2.deepMerge)(state, obj, (0, $1jKby.STATE_METHODS));
        return;
    }
    const overwriteFunc = shallow ? (0, $g1LU2.overwriteShallow) : (0, $g1LU2.overwriteDeep);
    overwriteFunc(state, obj, (0, $1jKby.STATE_METHODS));
};

});

parcelRegister("5ORwk", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $43cb23542500e5d2$export$41a9651decfe2bde);
const $43cb23542500e5d2$export$41a9651decfe2bde = (element, parent)=>{
    const { __ref: ref } = element;
    if (!element.scope) element.scope = parent.scope || ref.root?.scope || {};
};

});

parcelRegister("dzojf", function(module, exports) {

$parcel$export(module.exports, "cache", () => $9e1166994afba572$export$69a3209f1a06c04d);
$parcel$export(module.exports, "OPTIONS", () => $9e1166994afba572$export$8eb3892b442747bd);
const $9e1166994afba572$export$69a3209f1a06c04d = {};
const $9e1166994afba572$export$8eb3892b442747bd = {};

});

parcelRegister("dWAIU", function(module, exports) {

$parcel$export(module.exports, "captureSnapshot", () => $a26d2da667802bae$export$537d05c9e22d9551);

var $b3i2S = parcelRequire("b3i2S");
const $a26d2da667802bae$var$snapshot = {
    snapshotId: (0, $b3i2S.createSnapshotId)
};
const $a26d2da667802bae$export$537d05c9e22d9551 = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $a26d2da667802bae$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = calleeElement.__ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};

});


parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "io", () => $523eaa49d3f99bf8$export$841407ceb083bd74);
$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
parcelRequire("1XKMK");
var $i3KZp = parcelRequire("i3KZp");
var $3W81j = parcelRequire("3W81j");
var $dhyBt = parcelRequire("dhyBt");
var $hJTtX = parcelRequire("hJTtX");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("bN72v")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $bN72v = parcelRequire("bN72v");

var $i3KZp = parcelRequire("i3KZp");

var $3W81j = parcelRequire("3W81j");

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $5hHAH = parcelRequire("5hHAH");

var $CnWUo = parcelRequire("CnWUo");

var $bN72v = parcelRequire("bN72v");
const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $5hHAH.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $bN72v.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $l7wSz.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $bN72v.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $bN72v.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $CnWUo.protocol);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $gEtm1.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $3W81j.XHR)
};

});
parcelRegister("3W81j", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $2ddd02863faa1587$export$a2d42eb087c10497);

var $7pvuz = parcelRequire("7pvuz");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $bN72v = parcelRequire("bN72v");

var $kxvpX = parcelRequire("kxvpX");
function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $7pvuz.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $5hHAH.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $bN72v.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $bN72v.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");

var $CnWUo = parcelRequire("CnWUo");
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $5hHAH.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("5hHAH", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $3d905a8ca243a015$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);
$parcel$export(module.exports, "randomString", () => $4028d5a20a4526d1$export$7fa8378418b4411e);

var $bN72v = parcelRequire("bN72v");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $bN72v.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $bN72v.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $bN72v.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $bN72v.globalThisShim).setTimeout.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = (0, $bN72v.globalThisShim).clearTimeout.bind((0, $bN72v.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("bN72v", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $8959bb304e43f43f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "globalThisShim", () => $8959bb304e43f43f$export$394f9358f6231289);
$parcel$export(module.exports, "defaultBinaryType", () => $8959bb304e43f43f$export$790dcbc41e2d75d5);
$parcel$export(module.exports, "createCookieJar", () => $8959bb304e43f43f$export$19413efcf2fac759);
const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});


parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $bN72v = parcelRequire("bN72v");
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $6opKi.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $bN72v.globalThisShim).WebSocket || (0, $bN72v.globalThisShim).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $bN72v = parcelRequire("bN72v");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("i3KZp", function(module, exports) {

var $7pvuz = parcelRequire("7pvuz");
class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $7pvuz.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $bN72v = parcelRequire("bN72v");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $5hHAH = parcelRequire("5hHAH");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $5hHAH.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $bN72v.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5hHAH = parcelRequire("5hHAH");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $5hHAH.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);
$parcel$export(module.exports, "isPacketValid", () => $1e4e6e6cc3958162$export$1a38ed17dcb5458e);

var $5hHAH = parcelRequire("5hHAH");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $5hHAH.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $1e4e6e6cc3958162$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $1e4e6e6cc3958162$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $1e4e6e6cc3958162$var$isAckIdValid(id) {
    return id === undefined || $1e4e6e6cc3958162$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $1e4e6e6cc3958162$var$isDataValid(type, payload) {
    switch(type){
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $1e4e6e6cc3958162$var$isObject(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
        default:
            return false;
    }
}
function $1e4e6e6cc3958162$export$1a38ed17dcb5458e(packet) {
    return $1e4e6e6cc3958162$var$isNamespaceValid(packet.nsp) && $1e4e6e6cc3958162$var$isAckIdValid(packet.id) && $1e4e6e6cc3958162$var$isDataValid(packet.type, packet.data);
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




var $92955cf4caddf682$exports = {};
$parcel$export($92955cf4caddf682$exports, "create", () => $d34fff7d4687ff54$export$185802fd694ee1f5);
$parcel$export($92955cf4caddf682$exports, "init", () => $7d124ec5af804dac$export$2cd8252107eb640b);

var $j7W2w = parcelRequire("j7W2w");


const $52458ec890d0efdd$export$6be23892b3f5233 = {
    symbols: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    logo: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    arrowDownCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-circle"><circle cx="12" cy="12" r="10"/><path d="M8 12l4 4 4-4M12 8v8"/></svg>',
    arrowDownLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-left"><path d="M17 7L7 17M17 17H7V7"/></svg>',
    arrowDownRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-right"><path d="M7 7l10 10M17 7v10H7"/></svg>',
    arrowDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>',
    arrowLeftCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left-circle"><circle cx="12" cy="12" r="10"/><path d="M12 8l-4 4 4 4M16 12H8"/></svg>',
    arrowLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    arrowRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    arrowRightCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"/><path d="M12 16l4-4-4-4M8 12h8"/></svg>',
    arrowUpCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-circle"><circle cx="12" cy="12" r="10"/><path d="M16 12l-4-4-4 4M12 16V8"/></svg>',
    arrowUpLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-left"><path d="M17 17L7 7M7 17V7h10"/></svg>',
    arrowUpRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-right"><path d="M7 17L17 7M7 7h10v10"/></svg>',
    arrowUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    checkCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>',
    check: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><path d="M20 6L9 17l-5-5"/></svg>',
    chevronDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><path d="M6 9l6 6 6-6"/></svg>',
    chevronLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><path d="M15 18l-6-6 6-6"/></svg>',
    chevronRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><path d="M9 18l6-6-6-6"/></svg>',
    chevronUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><path d="M18 15l-6-6-6 6"/></svg>',
    copy: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>',
    eyeOff: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></svg>',
    eye: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    info: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
    lock: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
    minus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><path d="M5 12h14"/></svg>',
    sun: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>',
    moon: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>',
    moreHorizontal: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>',
    moreVertical: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
    send: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    smile: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-smile"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>',
    search: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>',
    upload: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>',
    video: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
    x: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    star: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>',
    plus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><path d="M12 5v14M5 12h14"/></svg>'
};


'use strict';
const $d9d3cb30dba31610$export$9b982809044276a6 = {
    transparent: 'rgba(0, 0, 0, 0)',
    black: 'black',
    white: 'white',
    title: [
        '--gray 1 -168',
        '--gray 1 +168'
    ],
    caption: [
        '--gray 1 -68',
        '--gray 1 +68'
    ],
    paragraph: [
        '--gray 1 -42',
        '--gray 1 +42'
    ],
    disabled: [
        '--gray 1 -26',
        '--gray 1 +26'
    ],
    line: [
        '--gray 1 -16',
        '--gray 1 +16'
    ]
};
const $d9d3cb30dba31610$export$3d856cf049c09ba8 = {};


'use strict';
const $bd9aaa3080f586ac$var$PRIORITIES = {
    primary: {
        '@dark': {
            color: 'white',
            background: 'blue'
        },
        '@light': {
            color: 'white',
            background: 'gradient-blue'
        }
    },
    secondary: {
        '@dark': {
            color: 'white',
            background: 'gray'
        },
        '@light': {
            color: 'white',
            background: 'gray'
        }
    },
    tertiary: {
        '@dark': {
            color: 'white',
            background: 'gray.92+8'
        },
        '@light': {
            background: 'gray.1'
        }
    },
    quaternary: {
        '@light': {
            color: 'white',
            background: 'gradient-light'
        },
        '@dark': {
            color: 'white',
            background: 'gradient-dark-active'
        }
    },
    quinary: {
        '@dark': {
            color: 'gray=90',
            background: 'gradient-light'
        },
        '@light': {
            color: 'gray3',
            background: 'gradient-dark'
        }
    }
};
const $bd9aaa3080f586ac$var$STATES = {
    alert: {
        '@dark': {
            color: 'white',
            background: 'red'
        }
    },
    warning: {
        '@dark': {
            color: 'black',
            background: 'yellow'
        }
    },
    success: {
        '@dark': {
            color: 'black',
            background: 'green'
        }
    }
};
const $bd9aaa3080f586ac$var$UI = {
    field: {
        '@light': {
            color: 'black',
            background: 'gray.975+144',
            borderColor: 'gray.975+144',
            '::placeholder': {
                color: 'gray-68'
            }
        },
        '@dark': {
            color: 'white',
            background: 'gray.975-52',
            borderColor: 'gray.975-52',
            '::placeholder': {
                color: 'gray+68'
            }
        }
    },
    label: {
        '@dark': {
            color: 'white',
            background: 'gray.92+8'
        },
        '@light': {
            background: 'gray.1'
        }
    },
    dialog: {
        '@dark': {
            color: 'white',
            background: 'gray.92'
        },
        '@light': {
            color: 'currentColor',
            background: 'gray.1'
        }
    }
};
const $bd9aaa3080f586ac$export$5714e40777c1bcc2 = {
    document: {
        '@light': {
            color: 'black',
            background: 'white'
        },
        '@dark': {
            color: 'white',
            background: 'black'
        }
    },
    ...$bd9aaa3080f586ac$var$PRIORITIES,
    ...$bd9aaa3080f586ac$var$STATES,
    ...$bd9aaa3080f586ac$var$UI,
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    }
};


'use strict';
const $299cc65848d03d49$export$75d3998385cc196f = {};
const $299cc65848d03d49$export$530097e879f93363 = {
    system: {
        value: [
            '"Helvetica Neue"',
            'Helvetica',
            'Arial'
        ],
        type: 'sans-serif'
    }
};


'use strict';
const $87fe34b74ee20786$export$500415a86c544f73 = {
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024px)',
    mobileL: '(max-width: 768px)',
    'mobileL<': '(min-width: 768px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};


'use strict';
const $496af4c86e8e4209$export$3c9e9dc0cdfaa753 = {
    base: 150,
    ratio: 1.333,
    unit: 'ms',
    subSequence: true
};


'use strict';
const $72d70d264f1ca449$export$c2f8e0cc249a8d8f = {
    version: '0.0.1',
    COLOR: $d9d3cb30dba31610$export$9b982809044276a6,
    GRADIENT: $d9d3cb30dba31610$export$3d856cf049c09ba8,
    THEME: $bd9aaa3080f586ac$export$5714e40777c1bcc2,
    TYPOGRAPHY: {
        base: 16,
        ratio: 1.25,
        subSequence: true,
        templates: {}
    },
    SPACING: {
        base: 16,
        ratio: 1.618,
        subSequence: true
    },
    FONT: $299cc65848d03d49$export$75d3998385cc196f,
    FONT_FAMILY: $299cc65848d03d49$export$530097e879f93363,
    TIMING: $496af4c86e8e4209$export$3c9e9dc0cdfaa753,
    ICONS: (0, $52458ec890d0efdd$export$6be23892b3f5233),
    MEDIA: $87fe34b74ee20786$export$500415a86c544f73,
    RESET: {
        html: {},
        body: {}
    },
    ANIMATION: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    DEVICES: {},
    CASES: {},
    CLASS: {},
    SVG: {},
    GRID: {},
    SHAPE: {},
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false
};
var $72d70d264f1ca449$export$2e2bcd8739ae039 = $72d70d264f1ca449$export$c2f8e0cc249a8d8f;


var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($76500f1a9bc57c92$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function() {
    return (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}


var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $5f1e384d41b6dbd9$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
const $68a163d53ebd5b81$var$RE_MULTI_SPACE = /\s+/g;
const $68a163d53ebd5b81$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.classlist === true) element.classlist = key;
    else if (!element.classlist && typeof key === 'string' && key.charCodeAt(0) === 95 && key.charCodeAt(1) !== 95) element.classlist = key.slice(1);
};
const $68a163d53ebd5b81$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $g1LU2.exec)(param, element)}`;
    }
    return className;
};
const $68a163d53ebd5b81$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.classlist = {
        key: key
    };
    if ((0, $e7Ezu.isString)(params)) params = element.classlist = {
        default: params
    };
    if ((0, $e7Ezu.isObject)(params)) params = $68a163d53ebd5b81$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace($68a163d53ebd5b81$var$RE_MULTI_SPACE, ' ').trim();
    return className;
};
const $68a163d53ebd5b81$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $68a163d53ebd5b81$export$11c615ce16f87241(params, element);
    // Use setAttribute for universal SVG/HTML compatibility
    if (node && typeof node.setAttribute === 'function') node.setAttribute('class', className);
    else if (node) try {
        node.className = className;
    } catch (e) {}
    return className;
};
function $68a163d53ebd5b81$export$f1a8a7f322d4587c(params, element, node) {
    $68a163d53ebd5b81$export$e8f750c9f10c0a7b(params, element, node);
}
var $68a163d53ebd5b81$export$2e2bcd8739ae039 = $68a163d53ebd5b81$export$f1a8a7f322d4587c;


'use strict';
const $b3468425a35a59c8$export$100c3af055d141e0 = (key = 'smbls', container)=>{
    const cleanKey = key.replaceAll(/\./g, '-');
    return (0, $f80ae5e019588f18$export$2e2bcd8739ae039)({
        key: cleanKey,
        container: container
    });
};
const $b3468425a35a59c8$export$51d693b3d243fd90 = $b3468425a35a59c8$export$100c3af055d141e0();
const $b3468425a35a59c8$export$c79b0dc85ccca679 = (emotion)=>{
    return (params, element, state)=>{
        const execParams = (0, $g1LU2.exec)(params, element);
        if (params) {
            const { __ref: ref } = element;
            ref.__class.style = execParams;
        }
        $b3468425a35a59c8$export$62b33bcc98e42249(emotion)(element.classlist, element, element.state, true);
    };
};
const $b3468425a35a59c8$export$62b33bcc98e42249 = (emotion)=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (!(0, $e7Ezu.isObjectLike)(params)) return;
        if (element.props.class) __classNames.classProps = element.props.class;
        if (element.attr?.class) __classNames.class = element.attr.class;
        for(const key in __class){
            const prop = __class[key];
            if (!prop) {
                delete __classNames[key];
                continue;
            }
            let className;
            if ((0, $e7Ezu.isString)(prop) || (0, $e7Ezu.isNumber)(prop)) className = prop;
            else if ((0, $e7Ezu.isBoolean)(prop)) className = element.key;
            else className = emotion.css(prop);
            __classNames[key] = className;
        }
        // Remove stale classNames that no longer exist in __class
        for(const key in __classNames){
            if (key === 'classProps' || key === 'class') continue;
            if (__class[key] === undefined) delete __classNames[key];
        }
        if (element.node) (0, $68a163d53ebd5b81$export$e8f750c9f10c0a7b)(__classNames, element, element.node);
    };
};
const $b3468425a35a59c8$export$23627aa597d6e60c = (emotion, options)=>{
    if (!emotion) emotion = (0, $f80ae5e019588f18$export$2e2bcd8739ae039)(options || {
        key: 'smbls'
    });
    return {
        style: $b3468425a35a59c8$export$c79b0dc85ccca679(emotion),
        classlist: $b3468425a35a59c8$export$62b33bcc98e42249(emotion)
    };
} // initEmotion is imported directly from '@symbo.ls/emotion/initEmotion.js' to avoid circular dependency
;



var $be006f1a0fabd945$exports = {};
var $73d59c6c3fce378b$exports = {};
var $40d382f435ee1fdb$exports = {};

$parcel$export($40d382f435ee1fdb$exports, "Block", () => $40d382f435ee1fdb$export$d96a8827a60d6b69);
$parcel$export($40d382f435ee1fdb$exports, "Inline", () => $40d382f435ee1fdb$export$fbae5b5ffd8af05e);
$parcel$export($40d382f435ee1fdb$exports, "Flex", () => $40d382f435ee1fdb$export$f51f4c4ede09e011);
$parcel$export($40d382f435ee1fdb$exports, "InlineFlex", () => $40d382f435ee1fdb$export$5d643ad162c021dc);
$parcel$export($40d382f435ee1fdb$exports, "Grid", () => $40d382f435ee1fdb$export$ef2184bd89960b14);
$parcel$export($40d382f435ee1fdb$exports, "InlineGrid", () => $40d382f435ee1fdb$export$1e7ecf8382e655ff);
$parcel$export($40d382f435ee1fdb$exports, "Gutter", () => $40d382f435ee1fdb$export$b710539649c46ff);
'use strict';
const $40d382f435ee1fdb$export$d96a8827a60d6b69 = {
    display: 'block'
};
const $40d382f435ee1fdb$export$fbae5b5ffd8af05e = {
    display: 'inline'
};
const $40d382f435ee1fdb$export$f51f4c4ede09e011 = {
    display: 'flex'
};
const $40d382f435ee1fdb$export$5d643ad162c021dc = {
    display: 'inline-flex'
};
const $40d382f435ee1fdb$export$ef2184bd89960b14 = {
    display: 'grid'
};
const $40d382f435ee1fdb$export$1e7ecf8382e655ff = {
    display: 'inline-grid'
};
const $40d382f435ee1fdb$export$b710539649c46ff = {
    boxSize: 'C1'
};


var $c95002999fe11fd8$exports = {};

$parcel$export($c95002999fe11fd8$exports, "Img", () => $c95002999fe11fd8$export$cc7b5f925acc71d3);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $235425de3553395f$export$147ca7d289c2f7de = [
    "alert",
    "alertdialog",
    "application",
    "article",
    "banner",
    "button",
    "cell",
    "checkbox",
    "columnheader",
    "combobox",
    "complementary",
    "contentinfo",
    "definition",
    "dialog",
    "directory",
    "document",
    "feed",
    "figure",
    "form",
    "grid",
    "gridcell",
    "group",
    "heading",
    "img",
    "link",
    "list",
    "listbox",
    "listitem",
    "log",
    "main",
    "marquee",
    "math",
    "menu",
    "menubar",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "navigation",
    "none",
    "note",
    "option",
    "presentation",
    "progressbar",
    "radio",
    "radiogroup",
    "region",
    "row",
    "rowgroup",
    "rowheader",
    "scrollbar",
    "search",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "status",
    "switch",
    "tab",
    "table",
    "tablist",
    "tabpanel",
    "term",
    "textbox",
    "timer",
    "toolbar",
    "tooltip",
    "tree",
    "treegrid",
    "treeitem"
];
const $235425de3553395f$export$a073516cf3506ae6 = {
    default: [
        "accesskey",
        "autofocus",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "hidden",
        "id",
        "lang",
        "part",
        "placeholder",
        "slot",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate",
        "inert",
        "radiogroup",
        "role",
        "about",
        "datatype",
        "inlist",
        "prefix",
        "property",
        "resource",
        "typeof",
        "vocab",
        "autocapitalize",
        "autocorrect",
        "autosave",
        "color",
        "itemprop",
        "itemscope",
        "itemtype",
        "itemid",
        "itemref",
        "results",
        "security",
        "unselectable",
        "is"
    ],
    a: [
        "accesskey",
        "charset",
        "coords",
        "download",
        "href",
        "hreflang",
        "name",
        "rel",
        "rev",
        "shape",
        "target",
        "type"
    ],
    aria: [
        "aria-activedescendant",
        "aria-atomic",
        "aria-autocomplete",
        "aria-checked",
        "aria-colcount",
        "aria-colindex",
        "aria-colspan",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-errormessage",
        "aria-expanded",
        "aria-flowto",
        "aria-grabbed",
        "aria-haspopup",
        "aria-hidden",
        "aria-invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-level",
        "aria-live",
        "aria-modal",
        "aria-multiline",
        "aria-multiselectable",
        "aria-orientation",
        "aria-owns",
        "aria-placeholder",
        "aria-posinset",
        "aria-pressed",
        "aria-readonly",
        "aria-relevant",
        "aria-required",
        "aria-roledescription",
        "aria-rowcount",
        "aria-rowindex",
        "aria-rowspan",
        "aria-selected",
        "aria-setsize",
        "aria-sort",
        "aria-valuemax",
        "aria-valuemin",
        "aria-valuenow",
        "aria-valuetext"
    ],
    anchor: [
        "download",
        "href",
        "hreflang",
        "media",
        "ping",
        "rel",
        "target",
        "type",
        "referrerpolicy"
    ],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    area: [
        "alt",
        "coords",
        "download",
        "href",
        "hreflang",
        "media",
        "referrerpolicy",
        "rel",
        "shape",
        "target",
        "ping"
    ],
    base: [
        "href",
        "target"
    ],
    blockquote: [
        "cite"
    ],
    button: [
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "name",
        "type",
        "value"
    ],
    canvas: [
        "height",
        "width"
    ],
    col: [
        "span",
        "width"
    ],
    colgroup: [
        "span"
    ],
    data: [
        "value"
    ],
    details: [
        "open"
    ],
    del: [
        "cite",
        "datetime"
    ],
    dialog: [
        "open"
    ],
    embed: [
        "height",
        "src",
        "type",
        "width"
    ],
    fieldset: [
        "disabled",
        "form",
        "name"
    ],
    form: [
        "acceptcharset",
        "action",
        "autocomplete",
        "enctype",
        "method",
        "name",
        "novalidate",
        "target",
        "rel"
    ],
    html: [
        "manifest"
    ],
    iframe: [
        "allow",
        "allowfullscreen",
        "allowtransparency",
        "frameborder",
        "height",
        "loading",
        "marginheight",
        "marginwidth",
        "mozallowfullscreen",
        "name",
        "referrerpolicy",
        "sandbox",
        "scrolling",
        "seamless",
        "src",
        "srcdoc",
        "webkitallowfullscreen",
        "width"
    ],
    img: [
        "alt",
        "crossorigin",
        "decoding",
        "height",
        "ismap",
        "loading",
        "referrerpolicy",
        "sizes",
        "src",
        "srcset",
        "usemap",
        "width"
    ],
    ins: [
        "cite",
        "datetime"
    ],
    input: [
        "accept",
        "alt",
        "autocomplete",
        "capture",
        "checked",
        "crossorigin",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "height",
        "indeterminate",
        "list",
        "max",
        "maxlength",
        "min",
        "minlength",
        "multiple",
        "name",
        "pattern",
        "placeholder",
        "readonly",
        "required",
        "size",
        "src",
        "step",
        "type",
        "value",
        "width"
    ],
    keygen: [
        "challenge",
        "disabled",
        "form",
        "keytype",
        "keyparams",
        "name"
    ],
    label: [
        "form",
        "for"
    ],
    li: [
        "value"
    ],
    link: [
        "as",
        "crossorigin",
        "href",
        "hreflang",
        "integrity",
        "media",
        "imagesrcset",
        "imagesizes",
        "referrerpolicy",
        "rel",
        "sizes",
        "type",
        "charset"
    ],
    map: [
        "name"
    ],
    menu: [
        "type"
    ],
    media: [
        "autoplay",
        "controls",
        "currenttime",
        "defaultmuted",
        "defaultplaybackrate",
        "loop",
        "mediagroup",
        "muted",
        "playsinline",
        "preload",
        "src",
        "volume"
    ],
    meta: [
        "charset",
        "content",
        "http-equiv",
        "name",
        "media"
    ],
    meter: [
        "form",
        "high",
        "low",
        "max",
        "min",
        "optimum",
        "value"
    ],
    quote: [
        "cite"
    ],
    object: [
        "classid",
        "data",
        "form",
        "height",
        "name",
        "type",
        "usemap",
        "width",
        "wmode"
    ],
    ol: [
        "reversed",
        "start",
        "type"
    ],
    optgroup: [
        "disabled",
        "label"
    ],
    option: [
        "disabled",
        "label",
        "selected",
        "value"
    ],
    output: [
        "form",
        "for",
        "name"
    ],
    param: [
        "name",
        "value"
    ],
    progress: [
        "max",
        "value"
    ],
    slot: [
        "name"
    ],
    script: [
        "async",
        "charset",
        "crossorigin",
        "defer",
        "integrity",
        "nomodule",
        "nonce",
        "referrerpolicy",
        "src",
        "type"
    ],
    select: [
        "autocomplete",
        "disabled",
        "form",
        "multiple",
        "name",
        "required",
        "size",
        "value",
        "onchange"
    ],
    source: [
        "height",
        "media",
        "sizes",
        "src",
        "srcset",
        "type",
        "width"
    ],
    style: [
        "media",
        "nonce",
        "scoped",
        "type"
    ],
    table: [
        "align",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "rules",
        "summary",
        "width"
    ],
    textarea: [
        "autocomplete",
        "cols",
        "dirname",
        "disabled",
        "form",
        "maxlength",
        "minlength",
        "name",
        "placeholder",
        "readonly",
        "required",
        "rows",
        "value",
        "wrap"
    ],
    td: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr",
        "height",
        "width",
        "valign"
    ],
    th: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr"
    ],
    time: [
        "datetime"
    ],
    track: [
        "default",
        "kind",
        "label",
        "src",
        "srclang"
    ],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "disablepictureinpicture",
        "disableremoteplayback",
        "height",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "width"
    ],
    svg: [
        "className",
        "class",
        "color",
        "height",
        "id",
        "lang",
        "max",
        "media",
        "method",
        "min",
        "name",
        "style",
        "target",
        "type",
        "width",
        // Other HTML properties supported by SVG elements in browsers
        "role",
        "tabindex",
        "crossorigin",
        // SVG Specific attributes
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "allowReorder",
        "alphabetic",
        "amplitude",
        "arabic-form",
        "ascent",
        "attributeName",
        "attributeType",
        "autoReverse",
        "azimuth",
        "baseFrequency",
        "baseline-shift",
        "baseProfile",
        "bbox",
        "begin",
        "bias",
        "by",
        "calcMode",
        "cap-height",
        "clip",
        "clip-path",
        "clipPathUnits",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "contentScriptType",
        "contentStyleType",
        "cursor",
        "cx",
        "cy",
        "d",
        "decelerate",
        "descent",
        "diffuseConstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "dx",
        "dy",
        "edgeMode",
        "elevation",
        "enable-background",
        "end",
        "exponent",
        "externalResourcesRequired",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterRes",
        "filterUnits",
        "flood-color",
        "flood-opacity",
        "focusable",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "format",
        "from",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "glyphRef",
        "gradientTransform",
        "gradientUnits",
        "hanging",
        "href",
        "horiz-adv-x",
        "horiz-origin-x",
        "ideographic",
        "image-rendering",
        "in2",
        "in",
        "intercept",
        "k1",
        "k2",
        "k3",
        "k4",
        "k",
        "kernelMatrix",
        "kernelUnitLength",
        "kerning",
        "keyPoints",
        "keySplines",
        "keyTimes",
        "lengthAdjust",
        "letter-spacing",
        "lighting-color",
        "limitingConeAngle",
        "local",
        "marker-end",
        "markerHeight",
        "marker-mid",
        "marker-start",
        "markerUnits",
        "markerWidth",
        "mask",
        "maskContentUnits",
        "maskUnits",
        "mathematical",
        "mode",
        "numOctaves",
        "offset",
        "opacity",
        "operator",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "path",
        "pathLength",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "pointer-events",
        "points",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "preserveAlpha",
        "preserveAspectRatio",
        "primitiveUnits",
        "r",
        "radius",
        "refX",
        "refY",
        "rendering-intent",
        "repeatCount",
        "repeatDur",
        "requiredExtensions",
        "requiredFeatures",
        "restart",
        "result",
        "rotate",
        "rx",
        "ry",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "spacing",
        "specularConstant",
        "specularExponent",
        "speed",
        "spreadMethod",
        "startOffset",
        "stdDeviation",
        "stemh",
        "stemv",
        "stitchTiles",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "string",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "surfaceScale",
        "systemLanguage",
        "tableValues",
        "targetX",
        "targetY",
        "text-anchor",
        "text-decoration",
        "textLength",
        "text-rendering",
        "to",
        "transform",
        "u1",
        "u2",
        "underline-position",
        "underline-thickness",
        "unicode",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "values",
        "vector-effect",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "v-hanging",
        "v-ideographic",
        "viewBox",
        "viewTarget",
        "visibility",
        "v-mathematical",
        "widths",
        "word-spacing",
        "writing-mode",
        "x1",
        "x2",
        "x",
        "xChannelSelector",
        "x-height",
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:href",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type",
        "xml:base",
        "xml:lang",
        "xmlns",
        "xmlns:xlink",
        "xml:space",
        "y1",
        "y2",
        "y",
        "yChannelSelector",
        "z",
        "zoomAndPan"
    ]
};
const $235425de3553395f$export$f552dbb36ef6b3dd = [
    // Clipboard Events
    "oncopy",
    "oncut",
    "onpaste",
    // Composition Events
    "oncompositionend",
    "oncompositionstart",
    "oncompositionupdate",
    // Focus Events
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onblur",
    // Form Events
    "onchange",
    "onbeforeinput",
    "oninput",
    "onreset",
    "onsubmit",
    "oninvalid",
    "onformdata",
    // Image Events
    "onload",
    "onerror",
    // also a Media Event
    // Detail Events
    "ontoggle",
    // Keyboard Events
    "onkeydown",
    "onkeypress",
    "onkeyup",
    // Media Events
    "onabort",
    "oncanplay",
    "oncanplaythrough",
    "oncuechange",
    "ondurationchange",
    "onemptied",
    "onencrypted",
    "onended",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onseeked",
    "onseeking",
    "onstalled",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting",
    // MouseEvents
    "onauxclick",
    "onclick",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    // Selection Events
    "onselect",
    "onselectionchange",
    "onselectstart",
    // Touch Events
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    // Pointer Events
    "ongotpointercapture",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerup",
    "onlostpointercapture",
    // UI Events
    "onscroll",
    "onresize",
    // Wheel Events
    "onwheel",
    // Animation Events
    "onanimationstart",
    "onanimationend",
    "onanimationiteration",
    // Transition Events
    "ontransitionstart",
    "ontransitionrun",
    "ontransitionend",
    "ontransitioncancel",
    // Svelte Transition Events
    "onoutrostart",
    "onoutroend",
    "onintrostart",
    "onintroend",
    // Message Events
    "onmessage",
    "onmessageerror",
    // Document Events
    "onvisibilitychange",
    // Global Events
    "oncancel",
    "onclose",
    "onfullscreenchange",
    "onfullscreenerror"
];
const $235425de3553395f$export$3c670b34323f5417 = (tag, attribute)=>{
    if (Object.prototype.hasOwnProperty.call($235425de3553395f$export$a073516cf3506ae6, tag)) {
        const attributes = $235425de3553395f$export$a073516cf3506ae6[tag];
        return attributes.includes(attribute) || attributes.includes("default");
    } else {
        const defaultAttributes = $235425de3553395f$export$a073516cf3506ae6.default;
        return defaultAttributes.includes(attribute);
    }
};
const $235425de3553395f$export$12ab4f1a89970119 = (key)=>{
    if (!(0, $e7Ezu.isString)(key)) return false;
    const normalizedKey = key.toLowerCase();
    return $235425de3553395f$export$f552dbb36ef6b3dd.includes(normalizedKey);
};
const $235425de3553395f$export$a3d5d5e1a17535c6 = (tag, props, cssProps)=>{
    const filteredObject = {};
    for(const key in props)if (Object.prototype.hasOwnProperty.call(props, key)) {
        if (cssProps && key in cssProps) continue;
        const isAttribute = $235425de3553395f$export$3c670b34323f5417(tag, key);
        const isEvent = $235425de3553395f$export$12ab4f1a89970119(key);
        if ((0, $e7Ezu.isDefined)(props[key]) && (isAttribute || isEvent)) filteredObject[key] = props[key];
    }
    return filteredObject;
};
const $235425de3553395f$export$a420285f97b772db = (elem, element)=>{
    const attrObj = {};
    if (elem.attr) for(const attrProp in elem.attr)attrObj[attrProp] = elem.attr[attrProp](element, element.state, element.context);
    return attrObj;
};
const $235425de3553395f$export$ba06f8f07b4aa3a7 = (el, value)=>{
    let resolved = el.call("exec", value, el);
    if (!resolved) return;
    if ((0, $e7Ezu.isString)(resolved) && resolved.includes("{{")) resolved = el.call("replaceLiteralsWithObjectFields", resolved);
    return resolved;
};
const $235425de3553395f$export$a73e91daa9bedc56 = {
    src: (el)=>$235425de3553395f$export$ba06f8f07b4aa3a7(el, el.props.src),
    href: (el)=>$235425de3553395f$export$ba06f8f07b4aa3a7(el, el.props.href),
    action: (el)=>$235425de3553395f$export$ba06f8f07b4aa3a7(el, el.props.action),
    poster: (el)=>$235425de3553395f$export$ba06f8f07b4aa3a7(el, el.props.poster),
    data: (el)=>$235425de3553395f$export$ba06f8f07b4aa3a7(el, el.props.data)
};
const $235425de3553395f$export$5ff0ab856938124a = (element)=>{
    const tag = element.tag || "div";
    const { props: props } = element;
    const result = {};
    for(const attr in $235425de3553395f$export$a73e91daa9bedc56)if (props[attr] !== void 0 && $235425de3553395f$export$3c670b34323f5417(tag, attr)) {
        const val = $235425de3553395f$export$a73e91daa9bedc56[attr](element);
        if (val !== void 0) result[attr] = val;
    }
    return result;
};


'use strict';
const $c95002999fe11fd8$export$cc7b5f925acc71d3 = {
    tag: 'img',
    attr: {
        src: (el)=>{
            const { props: props, context: context } = el;
            let src = (props.preSrc || '') + (0, $235425de3553395f$export$ba06f8f07b4aa3a7)(el, props.src);
            let isUrl;
            try {
                isUrl = new URL(src);
            } catch (e) {}
            if (isUrl) return src;
            const file = context.files && context.files[src];
            if (file) return file.content && file.content.src;
        },
        title: ({ props: props })=>props.title || props.alt
    }
};


var $f085155ee8a416c4$exports = {};

$parcel$export($f085155ee8a416c4$exports, "Form", () => $f085155ee8a416c4$export$a7fed597f4b8afd8);
'use strict';
const $f085155ee8a416c4$export$a7fed597f4b8afd8 = {
    tag: 'form'
};


var $0b0e26e2a21aab54$exports = {};

$parcel$export($0b0e26e2a21aab54$exports, "Iframe", () => $0b0e26e2a21aab54$export$5137ec99f248330b);
'use strict';
const $0b0e26e2a21aab54$export$5137ec99f248330b = {
    tag: 'iframe',
    position: 'relative',
    minWidth: 'H',
    minHeight: 'H'
};


var $c3656ade3a6fd1e0$exports = {};

$parcel$export($c3656ade3a6fd1e0$exports, "Hoverable", () => $c3656ade3a6fd1e0$export$8cf654b375a16d2d);
$parcel$export($c3656ade3a6fd1e0$exports, "Clickable", () => $c3656ade3a6fd1e0$export$2f51d37476d4c437);
$parcel$export($c3656ade3a6fd1e0$exports, "Focusable", () => $c3656ade3a6fd1e0$export$35a3bebf7ef2d934);
$parcel$export($c3656ade3a6fd1e0$exports, "FocusableComponent", () => $c3656ade3a6fd1e0$export$b177f82f5511f000);
'use strict';
const $c3656ade3a6fd1e0$var$style = {
    appearance: 'none',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit'
};
const $c3656ade3a6fd1e0$export$8cf654b375a16d2d = {
    transition: 'C defaultBezier',
    transitionProperty: 'opacity, transform',
    opacity: 0.85,
    ':hover': {
        opacity: 0.9,
        transform: 'scale(1.015)'
    },
    ':active': {
        opacity: 1,
        transform: 'scale(1.015)'
    },
    '.active': {
        opacity: 1,
        transform: 'scale(1.015)',
        ':hover': {
            opacity: 1
        }
    }
};
const $c3656ade3a6fd1e0$export$2f51d37476d4c437 = {
    extends: 'Hoverable',
    ':active': {
        opacity: 1,
        transform: 'scale(1.015)'
    },
    '.active': {
        opacity: 1
    }
};
const $c3656ade3a6fd1e0$export$35a3bebf7ef2d934 = {
    border: 'none',
    outline: 'solid 0 blue.3',
    ':focus-visible': {
        opacity: 1,
        outline: 'solid X blue.3'
    },
    attr: {
        tabIndex: ({ props: props })=>props.tabIndex
    }
};
const $c3656ade3a6fd1e0$export$b177f82f5511f000 = {
    extends: 'Focusable',
    tag: 'button',
    fontSize: 'A',
    type: 'button',
    border: 'none',
    textDecoration: 'none',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    style: $c3656ade3a6fd1e0$var$style
};


var $80736e04e60e3fa1$exports = {};

$parcel$export($80736e04e60e3fa1$exports, "Picture", () => $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f);
var $2ae1edf582b77174$exports = {};

$parcel$export($2ae1edf582b77174$exports, "getSystemGlobalTheme", () => $2ae1edf582b77174$export$f12bbb197a836138);
$parcel$export($2ae1edf582b77174$exports, "Theme", () => $2ae1edf582b77174$export$14faa19a0f3bbeb2);
var $c031e540a33546ea$exports = {};

$parcel$export($c031e540a33546ea$exports, "depth", () => $c031e540a33546ea$export$b202ba015b5882cd);
$parcel$export($c031e540a33546ea$exports, "SHAPES", () => $c031e540a33546ea$export$511e1d54a4a8684e);
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $58da49287d386dc1$exports = {};

$parcel$export($58da49287d386dc1$exports, "RESET", () => $58da49287d386dc1$export$4a991c87e640ef77);
var $d9cd80b79b005e10$exports = {};

$parcel$export($d9cd80b79b005e10$exports, "SEQUENCE", () => $d9cd80b79b005e10$export$34694f8d8b23ee2a);
const $d9cd80b79b005e10$export$34694f8d8b23ee2a = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    // golden-ratio
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    // theodorus
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    // pythagoras
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    // archimedes
    "double-octave": 4
};


var $61e14b335d61c3a7$exports = {};

$parcel$export($61e14b335d61c3a7$exports, "UNIT", () => $61e14b335d61c3a7$export$97361b7a0c542045);
const $61e14b335d61c3a7$export$97361b7a0c542045 = {
    default: "em"
};


var $76aa46f41f43bddd$exports = {};

$parcel$export($76aa46f41f43bddd$exports, "TYPOGRAPHY", () => $76aa46f41f43bddd$export$d36796ab73e728d9);

const $76aa46f41f43bddd$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: (0, $d9cd80b79b005e10$export$34694f8d8b23ee2a)["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $76aa46f41f43bddd$export$d36796ab73e728d9 = $76aa46f41f43bddd$var$defaultProps;


var $0716edafe9323d70$exports = {};

$parcel$export($0716edafe9323d70$exports, "FONT", () => $0716edafe9323d70$export$75d3998385cc196f);
var $0716edafe9323d70$var$defFont = {
    // eslint-disable-line
    name: "",
    url: "",
    fontStyle: "",
    fontWeight: 500,
    fontStretch: "normal",
    fontOpticalSizing: "auto"
};
const $0716edafe9323d70$export$75d3998385cc196f = {};


var $891a5dbbc92540bf$exports = {};

$parcel$export($891a5dbbc92540bf$exports, "FONT_FAMILY", () => $891a5dbbc92540bf$export$530097e879f93363);
$parcel$export($891a5dbbc92540bf$exports, "FONT_FAMILY_TYPES", () => $891a5dbbc92540bf$export$756e583a6734f96e);
$parcel$export($891a5dbbc92540bf$exports, "FONT_FACE", () => $891a5dbbc92540bf$export$2c16de31893252e6);
var $891a5dbbc92540bf$var$defaultFont = {
    // eslint-disable-line
    name: "",
    family: "",
    type: ""
};
const $891a5dbbc92540bf$export$530097e879f93363 = {};
const $891a5dbbc92540bf$export$756e583a6734f96e = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
};
const $891a5dbbc92540bf$export$2c16de31893252e6 = {};


var $47f3349b77f19697$exports = {};

$parcel$export($47f3349b77f19697$exports, "MEDIA", () => $47f3349b77f19697$export$500415a86c544f73);
const $47f3349b77f19697$export$500415a86c544f73 = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};


var $25fc3a373030fbd8$exports = {};

$parcel$export($25fc3a373030fbd8$exports, "SPACING", () => $25fc3a373030fbd8$export$82ea42e772d49e5b);


const $25fc3a373030fbd8$var$defaultProps = {
    base: (0, $76aa46f41f43bddd$export$d36796ab73e728d9).base,
    type: "spacing",
    ratio: (0, $d9cd80b79b005e10$export$34694f8d8b23ee2a).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
};
const $25fc3a373030fbd8$export$82ea42e772d49e5b = $25fc3a373030fbd8$var$defaultProps;


var $a07d7dfbc0ab68d8$exports = {};

$parcel$export($a07d7dfbc0ab68d8$exports, "COLOR", () => $a07d7dfbc0ab68d8$export$9b982809044276a6);
$parcel$export($a07d7dfbc0ab68d8$exports, "GRADIENT", () => $a07d7dfbc0ab68d8$export$3d856cf049c09ba8);
var $a07d7dfbc0ab68d8$var$proto = {
    // eslint-disable-line
    name: "",
    value: ""
};
const $a07d7dfbc0ab68d8$export$9b982809044276a6 = {};
const $a07d7dfbc0ab68d8$export$3d856cf049c09ba8 = {};


var $6a6766843ac0e31a$exports = {};

$parcel$export($6a6766843ac0e31a$exports, "THEME", () => $6a6766843ac0e31a$export$5714e40777c1bcc2);
const $6a6766843ac0e31a$var$themeA = {
    // eslint-disable-line no-unused-vars
    text: "blue",
    background: "white",
    border: "black",
    // .opacity(0.2),
    active: {},
    helpers: [],
    themes: {},
    inverse: {}
};
const $6a6766843ac0e31a$export$5714e40777c1bcc2 = {};


var $26be2041f1427518$exports = {};

$parcel$export($26be2041f1427518$exports, "SHADOW", () => $26be2041f1427518$export$98b6069deb71e13e);
const $26be2041f1427518$var$shadow = {
    // eslint-disable-line
    name: "primaryShadow",
    boxShadow: "gray12, 0 0px 50px 50px"
};
const $26be2041f1427518$export$98b6069deb71e13e = {};


var $689aaf5c32f73b80$exports = {};

$parcel$export($689aaf5c32f73b80$exports, "ICONS", () => $689aaf5c32f73b80$export$fde44257752a9f60);
$parcel$export($689aaf5c32f73b80$exports, "SEMANTIC_ICONS", () => $689aaf5c32f73b80$export$e63edd959d6ceec9);
const $689aaf5c32f73b80$export$fde44257752a9f60 = {};
const $689aaf5c32f73b80$export$e63edd959d6ceec9 = {};


var $d6d0f2253229450d$exports = {};

$parcel$export($d6d0f2253229450d$exports, "TIMING", () => $d6d0f2253229450d$export$3c9e9dc0cdfaa753);

const $d6d0f2253229450d$var$defaultProps = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: (0, $d9cd80b79b005e10$export$34694f8d8b23ee2a)["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
};
const $d6d0f2253229450d$export$3c9e9dc0cdfaa753 = $d6d0f2253229450d$var$defaultProps;


var $f272d4a5e591ce7e$exports = {};

$parcel$export($f272d4a5e591ce7e$exports, "DOCUMENT", () => $f272d4a5e591ce7e$export$ef011b4e114b1fba);
const $f272d4a5e591ce7e$export$ef011b4e114b1fba = {};


var $96ce15ca3abe0ec7$exports = {};

$parcel$export($96ce15ca3abe0ec7$exports, "BREAKPOINTS", () => $96ce15ca3abe0ec7$export$426e07cd0772984d);
$parcel$export($96ce15ca3abe0ec7$exports, "DEVICES", () => $96ce15ca3abe0ec7$export$7e1b78538df536d8);
const $96ce15ca3abe0ec7$export$426e07cd0772984d = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $96ce15ca3abe0ec7$export$7e1b78538df536d8 = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};


var $42c13b0f9f546748$exports = {};

$parcel$export($42c13b0f9f546748$exports, "CASES", () => $42c13b0f9f546748$export$ddbef7dfaa374d2d);
const $42c13b0f9f546748$export$ddbef7dfaa374d2d = {};


var $3c07d190ee38a929$exports = {};

$parcel$export($3c07d190ee38a929$exports, "ANIMATION", () => $3c07d190ee38a929$export$a8fef325e42f6db3);
const $3c07d190ee38a929$export$a8fef325e42f6db3 = {};


var $2448e57676b13d20$exports = {};

$parcel$export($2448e57676b13d20$exports, "SVG", () => $2448e57676b13d20$export$13f4b12aafeba5d6);
$parcel$export($2448e57676b13d20$exports, "SVG_DATA", () => $2448e57676b13d20$export$9738e40199601663);
const $2448e57676b13d20$export$13f4b12aafeba5d6 = {};
const $2448e57676b13d20$export$9738e40199601663 = {};


var $db1909334565260a$exports = {};

$parcel$export($db1909334565260a$exports, "TEMPLATES", () => $db1909334565260a$export$b8020e85ad90bfe5);
const $db1909334565260a$export$b8020e85ad90bfe5 = {};


var $f64b3264fb4e0a50$exports = {};

$parcel$export($f64b3264fb4e0a50$exports, "GRID", () => $f64b3264fb4e0a50$export$e2b0b9a5e613f348);
const $f64b3264fb4e0a50$var$defaultProps = {};
const $f64b3264fb4e0a50$export$e2b0b9a5e613f348 = $f64b3264fb4e0a50$var$defaultProps;


var $79927f8512a3d489$exports = {};

$parcel$export($79927f8512a3d489$exports, "CLASS", () => $79927f8512a3d489$export$6120d77db9a8f6cb);
const $79927f8512a3d489$var$defaultProps = {};
const $79927f8512a3d489$export$6120d77db9a8f6cb = $79927f8512a3d489$var$defaultProps;


const $58da49287d386dc1$export$4a991c87e640ef77 = {};
$parcel$exportWildcard($58da49287d386dc1$exports, $d9cd80b79b005e10$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $61e14b335d61c3a7$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $76aa46f41f43bddd$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $0716edafe9323d70$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $891a5dbbc92540bf$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $47f3349b77f19697$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $25fc3a373030fbd8$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $a07d7dfbc0ab68d8$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $6a6766843ac0e31a$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $26be2041f1427518$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $689aaf5c32f73b80$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $d6d0f2253229450d$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $f272d4a5e591ce7e$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $96ce15ca3abe0ec7$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $42c13b0f9f546748$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $3c07d190ee38a929$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $2448e57676b13d20$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $db1909334565260a$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $f64b3264fb4e0a50$exports);
$parcel$exportWildcard($58da49287d386dc1$exports, $79927f8512a3d489$exports);


const $e2cb0be23d169790$export$220f2e5d84ced4cb = {};
const $e2cb0be23d169790$export$b7fe9b3ddb6b99bb = {};
const $e2cb0be23d169790$var$_CONF = $58da49287d386dc1$exports;
const $e2cb0be23d169790$var$_confLower = {};
for(const key in $e2cb0be23d169790$var$_CONF){
    const lower = key.toLowerCase();
    $e2cb0be23d169790$var$_confLower[lower] = $e2cb0be23d169790$var$_CONF[key];
    if (lower !== key) $e2cb0be23d169790$var$_confLower[key] = $e2cb0be23d169790$var$_CONF[key];
}
const $e2cb0be23d169790$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    globalTheme: "auto",
    CSS_VARS: $e2cb0be23d169790$export$220f2e5d84ced4cb,
    CSS_MEDIA_VARS: $e2cb0be23d169790$export$b7fe9b3ddb6b99bb,
    ...$e2cb0be23d169790$var$_confLower
};
const $e2cb0be23d169790$var$cachedConfig = (0, $g1LU2.deepClone)($e2cb0be23d169790$export$1630b5343357e8b5);
const $e2cb0be23d169790$export$ee513c29aad6cc62 = {
    active: "0",
    0: $e2cb0be23d169790$export$1630b5343357e8b5
};
const $e2cb0be23d169790$export$8a278b801d0668ff = (def)=>{
    if ((0, $e7Ezu.isDefined)(def)) $e2cb0be23d169790$export$ee513c29aad6cc62.active = def;
    return $e2cb0be23d169790$export$ee513c29aad6cc62[def || $e2cb0be23d169790$export$ee513c29aad6cc62.active];
};
const $e2cb0be23d169790$export$e23c3d522afb24cd = (def)=>{
    return $e2cb0be23d169790$export$ee513c29aad6cc62[def || $e2cb0be23d169790$export$ee513c29aad6cc62.active] || $e2cb0be23d169790$export$1630b5343357e8b5;
};
const $e2cb0be23d169790$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $e7Ezu.isObject)(newConfig)) return;
    $e2cb0be23d169790$export$ee513c29aad6cc62.active = "1";
    $e2cb0be23d169790$export$ee513c29aad6cc62["1"] = (0, $g1LU2.deepMerge)(newConfig, (0, $g1LU2.deepClone)($e2cb0be23d169790$var$cachedConfig));
    return newConfig;
};

var $232c9281a8f7b24b$exports = {};

$parcel$export($232c9281a8f7b24b$exports, "getColor", () => $232c9281a8f7b24b$export$5551a2d24ff40153);
$parcel$export($232c9281a8f7b24b$exports, "getMediaColor", () => $232c9281a8f7b24b$export$dd72f6d9deea7207);
$parcel$export($232c9281a8f7b24b$exports, "setColor", () => $232c9281a8f7b24b$export$130a5dc1bc9cd8e1);
$parcel$export($232c9281a8f7b24b$exports, "setGradient", () => $232c9281a8f7b24b$export$afaa8352c6a43a44);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");

var $d49bd28b97ddb649$exports = {};

$parcel$export($d49bd28b97ddb649$exports, "colorStringToRgbaArray", () => $d49bd28b97ddb649$export$fa32e9c99a43479e);
$parcel$export($d49bd28b97ddb649$exports, "mixTwoColors", () => $d49bd28b97ddb649$export$fc81362b978df912);
$parcel$export($d49bd28b97ddb649$exports, "mixTwoRgba", () => $d49bd28b97ddb649$export$7aaa71d8fa03e6fa);
$parcel$export($d49bd28b97ddb649$exports, "hexToRgb", () => $d49bd28b97ddb649$export$5a544e13ad4e1fa5);
$parcel$export($d49bd28b97ddb649$exports, "hexToRgbArray", () => $d49bd28b97ddb649$export$fc66327a54d8eee6);
$parcel$export($d49bd28b97ddb649$exports, "rgbToHex", () => $d49bd28b97ddb649$export$34d09c4a771c46ef);
$parcel$export($d49bd28b97ddb649$exports, "rgbArrayToHex", () => $d49bd28b97ddb649$export$becee3e8de1b8d23);
$parcel$export($d49bd28b97ddb649$exports, "hexToRgba", () => $d49bd28b97ddb649$export$9665a07d9187b414);
$parcel$export($d49bd28b97ddb649$exports, "mixTwoRgb", () => $d49bd28b97ddb649$export$7d1bd62512294b2f);
$parcel$export($d49bd28b97ddb649$exports, "changeLightness", () => $d49bd28b97ddb649$export$784aaa753604ca97);
$parcel$export($d49bd28b97ddb649$exports, "rgbToHSL", () => $d49bd28b97ddb649$export$ac60e367bcb68b);
$parcel$export($d49bd28b97ddb649$exports, "hslToRgb", () => $d49bd28b97ddb649$export$29fb7152bd3f781a);
$parcel$export($d49bd28b97ddb649$exports, "getColorShade", () => $d49bd28b97ddb649$export$e1d0a0f5f1f4ce36);
$parcel$export($d49bd28b97ddb649$exports, "opacify", () => $d49bd28b97ddb649$export$f4f50e3877dd0530);
$parcel$export($d49bd28b97ddb649$exports, "isCSSVar", () => $d49bd28b97ddb649$export$c9f584638d388483);
$parcel$export($d49bd28b97ddb649$exports, "CSS_NATIVE_COLOR_REGEX", () => $d49bd28b97ddb649$export$cc26ca941513e971);
$parcel$export($d49bd28b97ddb649$exports, "parseColorToken", () => $d49bd28b97ddb649$export$4ea2ee5b33c12815);
$parcel$export($d49bd28b97ddb649$exports, "isResolvedColor", () => $d49bd28b97ddb649$export$962b4432982d3252);
$parcel$export($d49bd28b97ddb649$exports, "splitTopLevelCommas", () => $d49bd28b97ddb649$export$ef7a598b406793c);
$parcel$export($d49bd28b97ddb649$exports, "getRgbTone", () => $d49bd28b97ddb649$export$2d78fefdcfb7f222);
parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");
var $eo3lV = parcelRequire("eo3lV");
var $e7Ezu = parcelRequire("e7Ezu");
const $d49bd28b97ddb649$export$fa32e9c99a43479e = (color)=>{
    if (color === "") return [
        0,
        0,
        0,
        0
    ];
    if (color.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    if (color[0] === "#") {
        if (color.length < 7) color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : "");
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    if (color.indexOf("rgb") === -1) {
        if ((0, $bD06b.document) && (0, $bD06b.window)) {
            const elem = (0, $bD06b.document).body.appendChild((0, $bD06b.document).createElement("fictum"));
            const flag = "rgb(1, 2, 3)";
            elem.style.color = flag;
            if (elem.style.color !== flag) {
                (0, $bD06b.document).body.removeChild(elem);
                return;
            }
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === "") {
                (0, $bD06b.document).body.removeChild(elem);
                return [
                    0,
                    0,
                    0,
                    0
                ];
            }
            color = (0, $bD06b.window).getComputedStyle(elem).color;
            (0, $bD06b.document).body.removeChild(elem);
        }
    }
    if (color.indexOf("rgb") === 0) {
        if (color.indexOf("rgba") === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a);
    }
    return [
        0,
        0,
        0,
        0
    ];
};
const $d49bd28b97ddb649$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $d49bd28b97ddb649$export$fa32e9c99a43479e(colorA);
    colorB = $d49bd28b97ddb649$export$fa32e9c99a43479e(colorB);
    return $d49bd28b97ddb649$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $d49bd28b97ddb649$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $d49bd28b97ddb649$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $d49bd28b97ddb649$export$34d09c4a771c46ef = (r, g, b)=>{
    return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $d49bd28b97ddb649$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $d49bd28b97ddb649$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $d49bd28b97ddb649$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $d49bd28b97ddb649$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $d49bd28b97ddb649$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n);
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $d49bd28b97ddb649$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $d49bd28b97ddb649$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 255) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 255) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 16777216).toString(16).slice(1);
};
const $d49bd28b97ddb649$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $d49bd28b97ddb649$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $d49bd28b97ddb649$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ((0, $eo3lV.isNotProduction)()) console.warn(color + " color is not rgba");
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $d49bd28b97ddb649$export$c9f584638d388483 = (v)=>v.charCodeAt(0) === 45 && v.charCodeAt(1) === 45;
const $d49bd28b97ddb649$export$cc26ca941513e971 = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/;
const $d49bd28b97ddb649$var$COLOR_TOKEN_REGEX = /^([a-zA-Z]\w*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/;
const $d49bd28b97ddb649$export$4ea2ee5b33c12815 = (value)=>{
    if (!(0, $e7Ezu.isString)(value)) return null;
    if ($d49bd28b97ddb649$export$cc26ca941513e971.test(value)) return {
        passthrough: value
    };
    if ($d49bd28b97ddb649$export$c9f584638d388483(value)) return {
        cssVar: value
    };
    const match = value.match($d49bd28b97ddb649$var$COLOR_TOKEN_REGEX);
    if (!match) return null;
    const [, name, alphaDigits, rawTone] = match;
    const alpha = alphaDigits !== void 0 ? `0.${alphaDigits}` : void 0;
    const tone = rawTone && rawTone[0] === "=" ? rawTone.slice(1) : rawTone;
    return {
        name: name,
        alpha: alpha,
        tone: tone
    };
};
const $d49bd28b97ddb649$export$962b4432982d3252 = (result)=>{
    return (0, $e7Ezu.isString)(result) && (result.includes("rgb") || result.includes("var(") || result.includes("#"));
};
const $d49bd28b97ddb649$export$ef7a598b406793c = (value)=>{
    const result = [];
    let current = "";
    let depth = 0;
    for (const char of value){
        if (char === "(") depth += 1;
        else if (char === ")" && depth > 0) depth -= 1;
        if (char === "," && depth === 0) {
            result.push(current);
            current = "";
            continue;
        }
        current += char;
    }
    if (current.length || !result.length) result.push(current);
    return result;
};
const $d49bd28b97ddb649$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $e7Ezu.isString)(rgb) && rgb.includes("rgb")) rgb = $d49bd28b97ddb649$export$fa32e9c99a43479e(rgb).join(", ");
    if ((0, $e7Ezu.isString)(rgb)) rgb = rgb.split(",").map((v)=>parseFloat(v.trim()));
    if ((0, $e7Ezu.isNumber)(tone)) tone += "";
    const toHex = $d49bd28b97ddb649$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === "-" || abs === "+") {
        const colorShade = $d49bd28b97ddb649$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $d49bd28b97ddb649$export$fc66327a54d8eee6(colorShade).join(", ");
    } else {
        const [r, g, b] = rgb;
        const hsl = $d49bd28b97ddb649$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl;
        const newRgb = $d49bd28b97ddb649$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};


const $232c9281a8f7b24b$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (!(0, $e7Ezu.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(value)) return `var(${value})`;
    if (key && value[key]) value = value[key];
    let name, alpha, tone;
    if ((0, $e7Ezu.isArray)(value)) [name, alpha, tone] = value;
    else {
        const parsed = (0, $d49bd28b97ddb649$export$4ea2ee5b33c12815)(value);
        if (!parsed) return value;
        if (parsed.passthrough) return parsed.passthrough;
        if (parsed.cssVar) return `var(${parsed.cssVar})`;
        name = parsed.name;
        alpha = parsed.alpha;
        tone = parsed.tone;
    }
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, " - does not have ", key);
    }
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $d49bd28b97ddb649$export$2d78fefdcfb7f222)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    if (tone) return `rgba(${rgb}, 1)`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $232c9281a8f7b24b$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme === "auto" ? null : CONFIG.globalTheme;
    if (!(0, $e7Ezu.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(value)) return `var(${value})`;
    let name;
    if ((0, $e7Ezu.isArray)(value)) name = value[0];
    else {
        const parsed = (0, $d49bd28b97ddb649$export$4ea2ee5b33c12815)(value);
        if (!parsed) return value;
        if (parsed.passthrough) return parsed.passthrough;
        if (parsed.cssVar) return `var(${parsed.cssVar})`;
        name = parsed.name;
    }
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $e7Ezu.isObject)(val);
    if (isObj && val.value) return $232c9281a8f7b24b$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $232c9281a8f7b24b$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG.MEDIA[mediaName.slice(1)];
                const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
                obj[media] = $232c9281a8f7b24b$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn("Can't find color", value);
        return value;
    }
};
const $232c9281a8f7b24b$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if ((0, $e7Ezu.isString)(val) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(val)) {
        const rawRef = val.slice(2);
        val = $232c9281a8f7b24b$export$5551a2d24ff40153(rawRef);
        if (!(val.includes("rgb") || val.includes("var") || val.includes("#"))) {
            const parts = rawRef.split(" ");
            const refColor = CONFIG.COLOR[parts[0]];
            if (refColor && refColor.value) {
                let rgb2 = refColor.rgb;
                const alpha2 = parts[1] !== void 0 ? parts[1] : "1";
                const tone = parts[2];
                if (tone) rgb2 = (0, $d49bd28b97ddb649$export$2d78fefdcfb7f222)(rgb2, tone);
                val = `rgba(${rgb2}, ${alpha2})`;
            } else {
                const tone = parts[2];
                const alpha2 = parts[1] !== void 0 ? parts[1] : "1";
                if (tone) try {
                    const rgb2 = (0, $d49bd28b97ddb649$export$fa32e9c99a43479e)(parts[0]);
                    if (rgb2 && rgb2.length >= 3) {
                        const tonedRgb = (0, $d49bd28b97ddb649$export$2d78fefdcfb7f222)(rgb2.slice(0, 3).join(", "), tone);
                        val = `rgba(${tonedRgb}, ${alpha2})`;
                    } else val = parts[0];
                } catch (e) {
                    val = parts[0];
                }
                else val = parts[0];
            }
        }
    }
    if ((0, $e7Ezu.isArray)(val)) return {
        "@light": $232c9281a8f7b24b$export$130a5dc1bc9cd8e1(val[0], key, "light"),
        "@dark": $232c9281a8f7b24b$export$130a5dc1bc9cd8e1(val[1], key, "dark")
    };
    if ((0, $e7Ezu.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $232c9281a8f7b24b$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : "");
    const colorArr = (0, $d49bd28b97ddb649$export$fa32e9c99a43479e)(val.value || val);
    const [r, g, b, a = 1] = colorArr;
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $232c9281a8f7b24b$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if ((0, $e7Ezu.isString)(val) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(val)) val = $232c9281a8f7b24b$export$5551a2d24ff40153(val.slice(2));
    if ((0, $e7Ezu.isArray)(val)) return {
        "@light": $232c9281a8f7b24b$export$afaa8352c6a43a44(val[0], key, "light"),
        "@dark": $232c9281a8f7b24b$export$afaa8352c6a43a44(val[0], key, "dark")
    };
    if ((0, $e7Ezu.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $232c9281a8f7b24b$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};


var $ad7739c5bf717870$exports = {};

$parcel$export($ad7739c5bf717870$exports, "applyTimingSequence", () => $ad7739c5bf717870$export$a5be618f63a441ac);
$parcel$export($ad7739c5bf717870$exports, "getTimingFunction", () => $ad7739c5bf717870$export$23ba66c7c3e2e613);
$parcel$export($ad7739c5bf717870$exports, "getTimingByKey", () => $ad7739c5bf717870$export$3fa311edc5edd22f);
var $18086de584b972dd$exports = {};

$parcel$export($18086de584b972dd$exports, "copyStringToClipboard", () => $18086de584b972dd$export$4cdfed7d7fed21b8);
$parcel$export($18086de584b972dd$exports, "copyJavaScriptToClipboard", () => $18086de584b972dd$export$62b326c3a2efe2fb);
$parcel$export($18086de584b972dd$exports, "removeChars", () => $18086de584b972dd$export$3cc82ee301fb0516);
$parcel$export($18086de584b972dd$exports, "toCamelCase", () => $18086de584b972dd$export$86f54f62aa7a7514);
$parcel$export($18086de584b972dd$exports, "toTitleCase", () => $18086de584b972dd$export$f06f8b3003f18927);
$parcel$export($18086de584b972dd$exports, "toDashCase", () => $18086de584b972dd$export$6401d9e8afa09755);
$parcel$export($18086de584b972dd$exports, "toDescriptionCase", () => $18086de584b972dd$export$c82070d8669cc24e);
$parcel$export($18086de584b972dd$exports, "arrayzeValue", () => $18086de584b972dd$export$d1ef4b1a340dec10);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $8d18b01144f658b0$exports = {};

$parcel$export($8d18b01144f658b0$exports, "toggleFullscreen", () => $8d18b01144f658b0$export$1aba1ee5e6dc1474);
async function $8d18b01144f658b0$export$1aba1ee5e6dc1474(opts) {
    if (!document.fullscreenElement) try {
        await (this.node || document).requestFullscreen();
    } catch (err) {
        console.warn(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
    }
    else await document.exitFullscreen();
}


var $6dfa08da6f36726f$exports = {};

$parcel$export($6dfa08da6f36726f$exports, "findClosestNumber", () => $6dfa08da6f36726f$export$97a41db892f2d4c);
$parcel$export($6dfa08da6f36726f$exports, "findClosestNumberInFactory", () => $6dfa08da6f36726f$export$63c606e1170dd201);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $6dfa08da6f36726f$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $e7Ezu.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $6dfa08da6f36726f$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $e7Ezu.isObject)(factory)) factory = Object.values(factory);
    return $6dfa08da6f36726f$export$97a41db892f2d4c(val, factory);
};


var $1e9e7119fc562565$exports = {};

$parcel$export($1e9e7119fc562565$exports, "formatDate", () => $1e9e7119fc562565$export$3ae94a2503e890a1);
const $1e9e7119fc562565$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return "";
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(d);
    const mo = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(d);
    const da = new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};


var $03ea8a8df4cbad45$exports = {};

$parcel$export($03ea8a8df4cbad45$exports, "fibonacciNumberByIndex", () => $03ea8a8df4cbad45$export$6d35f41941932cbd);
const $03ea8a8df4cbad45$export$6d35f41941932cbd = function fibonacciNumberByIndex2(n) {
    const fib = [
        0,
        1
    ];
    for(let i = 2; i <= n; i++)fib[i] = fib[i - 1] + fib[i - 2];
    return fib[n];
};


var $a0f72614798eb1de$exports = {};

$parcel$export($a0f72614798eb1de$exports, "loadJavascriptFile", () => $a0f72614798eb1de$export$f5254c626a3f7f04);
$parcel$export($a0f72614798eb1de$exports, "loadJavascriptFileSync", () => $a0f72614798eb1de$export$f846581269718859);
$parcel$export($a0f72614798eb1de$exports, "loadJavascriptFileEmbedSync", () => $a0f72614798eb1de$export$2e2cf34468b4616);
$parcel$export($a0f72614798eb1de$exports, "loadCssFile", () => $a0f72614798eb1de$export$adc703d835881894);
$parcel$export($a0f72614798eb1de$exports, "loadJavascript", () => $a0f72614798eb1de$export$8b7778d7ecfcc995);
$parcel$export($a0f72614798eb1de$exports, "loadRemoteScript", () => $a0f72614798eb1de$export$c432db100969a36b);
$parcel$export($a0f72614798eb1de$exports, "loadRemoteCSS", () => $a0f72614798eb1de$export$d146908f5d25486);
const $a0f72614798eb1de$export$f5254c626a3f7f04 = (FILE_URL, async = false, doc = document, type = "text/javascript")=>{
    return new Promise((resolve, reject)=>{
        try {
            const scriptEle = doc.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;
            scriptEle.addEventListener("load", (ev)=>{
                resolve({
                    status: true
                });
            });
            scriptEle.addEventListener("error", (ev)=>{
                reject(new Error({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                }));
            });
            doc.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};
const $a0f72614798eb1de$export$f846581269718859 = (fileUrl, doc = document, type = "text/javascript")=>{
    return new Promise((resolve, reject)=>{
        const scriptEle = doc.createElement("script");
        scriptEle.type = type;
        scriptEle.src = fileUrl;
        const blocker = doc.createElement("div");
        blocker.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;";
        doc.body.appendChild(blocker);
        scriptEle.onload = ()=>{
            console.log(`Successfully loaded: ${fileUrl}`);
            doc.body.removeChild(blocker);
            resolve();
        };
        scriptEle.onerror = ()=>{
            doc.body.removeChild(blocker);
            reject(new Error(`Failed to load: ${fileUrl}`));
        };
        doc.body.appendChild(scriptEle);
    });
};
const $a0f72614798eb1de$export$2e2cf34468b4616 = (FILE_URL, doc = document, fallback, type = "text/javascript")=>{
    const xhr = new window.XMLHttpRequest();
    xhr.open("GET", FILE_URL, false);
    xhr.send();
    if (xhr.status === 200) {
        const scriptEle = doc.createElement("script");
        scriptEle.type = type;
        scriptEle.text = xhr.responseText;
        doc.body.appendChild(scriptEle);
        if (typeof fallback === "function") fallback();
    } else throw new Error(`Failed to load the script ${FILE_URL}`);
};
const $a0f72614798eb1de$export$adc703d835881894 = (FILE_URL, async = false, doc = document, type = "text/javascript")=>{
    return new Promise((resolve, reject)=>{
        try {
            const linkElem = doc.createElement("link");
            linkElem.rel = "stylesheet";
            linkElem.href = FILE_URL;
            linkElem.addEventListener("load", (ev)=>{
                resolve({
                    status: true
                });
            });
            doc.head.appendChild(linkElem);
        } catch (error) {
            reject(error);
        }
    });
};
const $a0f72614798eb1de$export$8b7778d7ecfcc995 = (body, async = false, doc = document, type = "text/javascript", id = "smbls-script")=>{
    try {
        const scriptEle = doc.createElement("script");
        scriptEle.type = type;
        scriptEle.async = async;
        scriptEle.id = id;
        scriptEle.innerHTML = body;
        doc.body.appendChild(scriptEle);
    } catch (error) {
        console.warn(error);
    }
};
function $a0f72614798eb1de$export$c432db100969a36b(url, options = {}) {
    const { window: window2 = globalThis } = options;
    const { document: document2 = window2.document } = options;
    return new Promise((resolve, reject)=>{
        const existingScript = document2.querySelector(`script[src="${url}"]`);
        if (existingScript) return resolve(existingScript);
        const script = document2.createElement("script");
        script.src = url;
        script.async = options.async === true;
        script.type = options.type || "text/javascript";
        if (options.id) script.id = options.id;
        if (options.integrity) script.integrity = options.integrity;
        if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
        script.onload = ()=>{
            script.onerror = script.onload = null;
            resolve(script);
        };
        script.onerror = ()=>{
            script.onerror = script.onload = null;
            reject(new Error(`Failed to load script: ${url}`));
        };
        document2.head.appendChild(script);
    });
}
async function $a0f72614798eb1de$export$d146908f5d25486(url, options = {}) {
    const { window: window2 = globalThis } = options;
    const { document: document2 = window2.document } = options;
    return new Promise((resolve, reject)=>{
        const existingLink = document2.querySelector(`link[href="${url}"]`);
        if (existingLink) return resolve(existingLink);
        const link = document2.createElement("link");
        link.href = url;
        link.rel = options.rel || "stylesheet";
        link.type = "text/css";
        link.media = options.media || "all";
        if (options.id) link.id = options.id;
        if (options.integrity) link.integrity = options.integrity;
        if (options.crossOrigin) link.crossOrigin = options.crossOrigin;
        link.onload = ()=>{
            link.onerror = link.onload = null;
            resolve(link);
        };
        link.onerror = ()=>{
            link.onerror = link.onload = null;
            reject(new Error(`Failed to load stylesheet: ${url}`));
        };
        document2.head.appendChild(link);
    });
}


var $9de252c208dab6ca$exports = {};

$parcel$export($9de252c208dab6ca$exports, "isPhoto", () => $9de252c208dab6ca$export$722f9ea87a439ca4);
const $9de252c208dab6ca$export$722f9ea87a439ca4 = (format)=>[
        "jpeg",
        "gif",
        "jpg",
        "png",
        "tiff",
        "woff"
    ].includes(format);


var $6aceb777da373426$exports = {};

$parcel$export($6aceb777da373426$exports, "CDN_PROVIDERS", () => $6aceb777da373426$export$14b025088496860c);
$parcel$export($6aceb777da373426$exports, "PACKAGE_MANAGER_TO_CDN", () => $6aceb777da373426$export$1a8b9f70f9282ea1);
$parcel$export($6aceb777da373426$exports, "getCdnProviderFromConfig", () => $6aceb777da373426$export$b5e67ffeac229970);
$parcel$export($6aceb777da373426$exports, "getCDNUrl", () => $6aceb777da373426$export$8407093f131dcef1);
$parcel$export($6aceb777da373426$exports, "getImportMapScript", () => $6aceb777da373426$export$fe7cd7f7aa440aad);
function $6aceb777da373426$var$onlyDotsAndNumbers(str) {
    return /^[0-9.]+$/.test(str) && str !== "";
}
const $6aceb777da373426$export$14b025088496860c = {
    skypack: {
        url: "https://cdn.skypack.dev",
        formatUrl: (pkg, version)=>`${$6aceb777da373426$export$14b025088496860c.skypack.url}/${pkg}${version !== "latest" ? `@${version}` : ""}`
    },
    esmsh: {
        url: "https://esm.sh",
        formatUrl: (pkg, version)=>`${$6aceb777da373426$export$14b025088496860c.esmsh.url}/${pkg}${version !== "latest" ? `@${version}` : ""}`
    },
    unpkg: {
        url: "https://unpkg.com",
        formatUrl: (pkg, version)=>`${$6aceb777da373426$export$14b025088496860c.unpkg.url}/${pkg}${version !== "latest" ? `@${version}` : ""}?module`
    },
    jsdelivr: {
        url: "https://cdn.jsdelivr.net/npm",
        formatUrl: (pkg, version)=>`${$6aceb777da373426$export$14b025088496860c.jsdelivr.url}/${pkg}${version !== "latest" ? `@${version}` : ""}/+esm`
    },
    symbols: {
        url: "https://pkg.symbo.ls",
        formatUrl: (pkg, version)=>{
            if (pkg.split("/").length > 2 || !$6aceb777da373426$var$onlyDotsAndNumbers(version)) return `${$6aceb777da373426$export$14b025088496860c.symbols.url}/${pkg}`;
            return `${$6aceb777da373426$export$14b025088496860c.symbols.url}/${pkg}/${version}.js`;
        }
    }
};
const $6aceb777da373426$export$1a8b9f70f9282ea1 = {
    "esm.sh": "esmsh",
    "unpkg": "unpkg",
    "skypack": "skypack",
    "jsdelivr": "jsdelivr",
    "pkg.symbo.ls": "symbols"
};
const $6aceb777da373426$export$b5e67ffeac229970 = (symbolsConfig = {})=>{
    const { packageManager: packageManager } = symbolsConfig;
    return $6aceb777da373426$export$1a8b9f70f9282ea1[packageManager] || null;
};
const $6aceb777da373426$export$8407093f131dcef1 = (packageName, version = "latest", provider = "esmsh")=>{
    const cdnConfig = $6aceb777da373426$export$14b025088496860c[provider] || $6aceb777da373426$export$14b025088496860c.esmsh;
    return cdnConfig.formatUrl(packageName, version);
};
const $6aceb777da373426$export$fe7cd7f7aa440aad = (data, defaultProvider = "skypack")=>{
    const dependencies = data.dependencies || {};
    const keys = Object.keys(dependencies);
    if (!keys.length) return "";
    const imports = {};
    for (const pkgName of keys){
        const version = dependencies[pkgName] || "latest";
        imports[pkgName] = $6aceb777da373426$export$8407093f131dcef1(pkgName, version, defaultProvider);
    }
    return `<script type="importmap">{
    "imports": ${JSON.stringify(imports, null, 2)}
  }<\/script>`;
};


var $2a6039d8d9da1773$exports = {};

$parcel$export($2a6039d8d9da1773$exports, "generateMetaTags", () => $2a6039d8d9da1773$export$1beeb737204e5202);
$parcel$export($2a6039d8d9da1773$exports, "getPageMetadata", () => $2a6039d8d9da1773$export$d6de83dbd93927be);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $2a6039d8d9da1773$var$escapeHtml = (text)=>{
    if (text === null || text === void 0) return "";
    const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return text.toString().replace(/[&<>"']/g, (m)=>map[m]);
};
const $2a6039d8d9da1773$var$buildAttrs = (obj)=>Object.entries(obj || {}).filter(([_, v])=>v !== void 0).map(([k, v])=>`${k}="${$2a6039d8d9da1773$var$escapeHtml(v)}"`).join(" ");
const $2a6039d8d9da1773$export$1beeb737204e5202 = (metadata, isProduction)=>{
    if (!isProduction) {
        const faviconTag = (()=>{
            const fv = metadata?.favicon || metadata?.favicons;
            if (!fv) return '<link rel="icon" href="/favicon.ico">';
            if (typeof fv === "string") return `<link rel="icon" href="${$2a6039d8d9da1773$var$escapeHtml(fv)}">`;
            if (Array.isArray(fv)) return fv.map((item)=>typeof item === "string" ? `<link rel="icon" href="${$2a6039d8d9da1773$var$escapeHtml(item)}">` : `<link ${$2a6039d8d9da1773$var$buildAttrs({
                    rel: "icon",
                    ...item
                })}>`).join("\n");
            return `<link ${$2a6039d8d9da1773$var$buildAttrs({
                rel: "icon",
                ...fv
            })}>`;
        })();
        return [
            '<meta charset="UTF-8">',
            `<title>${$2a6039d8d9da1773$var$escapeHtml(metadata.title || "Test")}</title>`,
            '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">',
            '<meta name="robots" content="noindex">',
            '<meta name="apple-mobile-web-app-capable" content="yes">',
            faviconTag
        ].join("\n");
    }
    const tags = Object.entries(metadata).reduce((acc, [key, value])=>{
        if (!value && value !== 0 && value !== false) return acc;
        if (key === "title") {
            acc.push(`<title>${$2a6039d8d9da1773$var$escapeHtml(value)}</title>`);
            return acc;
        }
        if (key === "canonical") {
            acc.push(`<link rel="canonical" href="${$2a6039d8d9da1773$var$escapeHtml(value)}">`);
            return acc;
        }
        if (key === "manifest") {
            acc.push(`<link rel="manifest" href="${$2a6039d8d9da1773$var$escapeHtml(value)}">`);
            return acc;
        }
        if (key === "favicon" || key === "favicons" || key === "icon" || key === "icons") {
            const items = Array.isArray(value) ? value : [
                value
            ];
            items.forEach((item)=>{
                if (typeof item === "string") acc.push(`<link rel="icon" href="${$2a6039d8d9da1773$var$escapeHtml(item)}">`);
                else if (typeof item === "object") {
                    const attrs = $2a6039d8d9da1773$var$buildAttrs(item);
                    if (!/rel=/.test(attrs)) acc.push(`<link rel="icon" ${attrs}>`);
                    else acc.push(`<link ${attrs}>`);
                }
            });
            return acc;
        }
        if (key === "alternate") {
            const alternates = Array.isArray(value) ? value : [
                value
            ];
            alternates.forEach((alt)=>{
                if (typeof alt === "object") {
                    const attrs = Object.entries(alt).filter(([_, attrValue])=>attrValue !== void 0).map(([attrKey, attrValue])=>`${attrKey}="${$2a6039d8d9da1773$var$escapeHtml(attrValue)}"`).join(" ");
                    acc.push(`<link rel="alternate" ${attrs}>`);
                }
            });
            return acc;
        }
        const processMetaTag = (tagKey, tagValue, attrType = "name")=>{
            if (typeof tagValue === "string" || typeof tagValue === "number" || typeof tagValue === "boolean") acc.push(`<meta ${attrType}="${$2a6039d8d9da1773$var$escapeHtml(tagKey)}" content="${$2a6039d8d9da1773$var$escapeHtml(tagValue)}">`);
            else if (Array.isArray(tagValue)) tagValue.forEach((item)=>{
                if (typeof item === "string" || typeof item === "number" || typeof item === "boolean") acc.push(`<meta ${attrType}="${$2a6039d8d9da1773$var$escapeHtml(tagKey)}" content="${$2a6039d8d9da1773$var$escapeHtml(item)}">`);
                else if (typeof item === "object") {
                    const attrs = Object.entries(item).filter(([_, attrValue])=>attrValue !== void 0).map(([attrKey, attrValue])=>`${attrKey}="${$2a6039d8d9da1773$var$escapeHtml(attrValue)}"`).join(" ");
                    acc.push(`<meta ${attrs}>`);
                }
            });
            else if (typeof tagValue === "object") {
                const attrs = Object.entries(tagValue).filter(([_, attrValue])=>attrValue !== void 0).map(([attrKey, attrValue])=>`${attrKey}="${$2a6039d8d9da1773$var$escapeHtml(attrValue)}"`).join(" ");
                acc.push(`<meta ${attrs}>`);
            }
        };
        if (key.startsWith("http-equiv:")) {
            const httpEquivKey = key.replace("http-equiv:", "");
            processMetaTag(httpEquivKey, value, "http-equiv");
            return acc;
        }
        if (key.startsWith("itemprop:")) {
            const itempropKey = key.replace("itemprop:", "");
            processMetaTag(itempropKey, value, "itemprop");
            return acc;
        }
        const prefixes = [
            "og:",
            "twitter:",
            "fb:",
            "article:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "product:",
            "video:",
            "DC:",
            "DCTERMS:"
        ];
        const prefix = prefixes.find((p)=>key.startsWith(p));
        if (prefix) {
            const tagKey = key.replace(prefix, "");
            processMetaTag(`${prefix.replace(":", "")}:${tagKey}`, value, prefix === "twitter:" || prefix === "DC:" || prefix === "DCTERMS:" ? "name" : "property");
            return acc;
        }
        if (key.startsWith("apple:") || key.startsWith("msapplication:")) {
            const pfx = key.startsWith("apple:") ? "apple-" : "msapplication-";
            const tagKey = key.replace(/^apple:|^msapplication:/, "");
            processMetaTag(`${pfx}${tagKey}`, value, "name");
            return acc;
        }
        processMetaTag(key, value);
        return acc;
    }, [
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">'
    ]);
    return tags.join("\n");
};
const $2a6039d8d9da1773$var$isBareFilename = (val)=>typeof val === "string" && val.length > 0 && !val.startsWith("/") && !val.startsWith("http");
function $2a6039d8d9da1773$var$resolveFileReferences(metadata, files) {
    if (!files || typeof files !== "object") return metadata;
    const resolve = (val)=>{
        if (!$2a6039d8d9da1773$var$isBareFilename(val)) return val;
        const fileEntry = files[val];
        if (fileEntry?.src) return fileEntry.src;
        return val;
    };
    const result = {
        ...metadata
    };
    for (const [key, value] of Object.entries(result)){
        if (typeof value === "string") result[key] = resolve(value);
        else if (Array.isArray(value)) result[key] = value.map((item)=>typeof item === "string" ? resolve(item) : item);
    }
    return result;
}
function $2a6039d8d9da1773$export$d6de83dbd93927be(data, pathname) {
    const currentPage = data.pages?.[pathname];
    const stateObject = (0, $e7Ezu.isObject)(currentPage?.state) && currentPage?.state;
    let pageMetadata = currentPage?.metadata || currentPage?.helmet || stateObject || {};
    const appMetadata = data.app?.metadata || {};
    if (data.integrations?.seo) pageMetadata = {
        ...data.integrations.seo,
        ...appMetadata,
        ...pageMetadata
    };
    else if (Object.keys(appMetadata).length) pageMetadata = {
        ...appMetadata,
        ...pageMetadata
    };
    if (!pageMetadata.title) pageMetadata.title = data.name + " / symbo.ls";
    pageMetadata = $2a6039d8d9da1773$var$resolveFileReferences(pageMetadata, data.files);
    return pageMetadata;
}


const $18086de584b972dd$export$4cdfed7d7fed21b8 = async (str)=>{
    try {
        await navigator.clipboard.writeText(str);
    } catch (err) {
        console.warn("Failed to copy text: ", err);
    }
};
const $18086de584b972dd$export$62b326c3a2efe2fb = async (jsCode)=>{
    try {
        const blob = new Blob([
            jsCode
        ], {
            type: "text/javascript"
        });
        const clipboardItem = new window.ClipboardItem({
            "text/plain": blob
        });
        await navigator.clipboard.write([
            clipboardItem
        ]);
        console.log("JavaScript code copied to clipboard as text/javascript");
    } catch (err) {
        console.error("Failed to copy JavaScript code: ", err);
    }
};
const $18086de584b972dd$export$3cc82ee301fb0516 = (str)=>{
    return str.replace(/[^a-zA-Z0-9_]/g, "");
};
const $18086de584b972dd$export$86f54f62aa7a7514 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, "");
};
const $18086de584b972dd$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $18086de584b972dd$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
const $18086de584b972dd$export$c82070d8669cc24e = (str = "")=>{
    if (typeof str !== "string") return;
    const result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $18086de584b972dd$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $e7Ezu.isArray)(val)) return val;
    if ((0, $e7Ezu.isString)(val)) return val.split(" ");
    if ((0, $e7Ezu.isObject)(val)) return Object.values(val);
    if ((0, $e7Ezu.isNumber)(val)) return [
        val
    ];
};
$parcel$exportWildcard($18086de584b972dd$exports, $8d18b01144f658b0$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $6dfa08da6f36726f$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $1e9e7119fc562565$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $03ea8a8df4cbad45$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $a0f72614798eb1de$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $9de252c208dab6ca$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $6aceb777da373426$exports);
$parcel$exportWildcard($18086de584b972dd$exports, $2a6039d8d9da1773$exports);



var $4e7bc1998c817803$exports = {};

$parcel$export($4e7bc1998c817803$exports, "setVariables", () => $4e7bc1998c817803$export$7c38483ff47439d8);
$parcel$export($4e7bc1998c817803$exports, "applySequenceGlobalVars", () => $4e7bc1998c817803$export$eba6b21fdce78bcd);
$parcel$export($4e7bc1998c817803$exports, "applySequenceVars", () => $4e7bc1998c817803$export$97ab4e7d8ade5018);
$parcel$export($4e7bc1998c817803$exports, "applyMediaSequenceVars", () => $4e7bc1998c817803$export$768e417cbfe71417);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");

var $48a67b64ca668600$exports = {};

$parcel$export($48a67b64ca668600$exports, "numToLetterMap", () => $48a67b64ca668600$export$81ab9dc24d52c4ba);
$parcel$export($48a67b64ca668600$exports, "getFnPrefixAndValue", () => $48a67b64ca668600$export$30fba622059784de);
$parcel$export($48a67b64ca668600$exports, "setScalingVar", () => $48a67b64ca668600$export$68dfa61d698afbde);
$parcel$export($48a67b64ca668600$exports, "setSubScalingVar", () => $48a67b64ca668600$export$c9d5ef57eeb83fa);
$parcel$export($48a67b64ca668600$exports, "getSubratioDifference", () => $48a67b64ca668600$export$12adf55fdaa50348);
$parcel$export($48a67b64ca668600$exports, "getSubratio", () => $48a67b64ca668600$export$50db87b17b1557b4);
$parcel$export($48a67b64ca668600$exports, "generateSubSequence", () => $48a67b64ca668600$export$622ae6209895c34e);
$parcel$export($48a67b64ca668600$exports, "generateSequence", () => $48a67b64ca668600$export$29708af739d9b0fc);
$parcel$export($48a67b64ca668600$exports, "generateSequencePosition", () => $48a67b64ca668600$export$7b7c0090b74e1e64);
$parcel$export($48a67b64ca668600$exports, "getSequenceValue", () => $48a67b64ca668600$export$efde09b5692f9bd0);
$parcel$export($48a67b64ca668600$exports, "getSequenceValueBySymbols", () => $48a67b64ca668600$export$69f332a3be1b2f36);
$parcel$export($48a67b64ca668600$exports, "getSequenceValuePropertyPair", () => $48a67b64ca668600$export$86c0052f25dacc45);
$parcel$export($48a67b64ca668600$exports, "findHeadingLetter", () => $48a67b64ca668600$export$14c834a042d41297);
$parcel$export($48a67b64ca668600$exports, "findHeadings", () => $48a67b64ca668600$export$8dc77c00fe04c40a);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");


var $a1be1bae5b4015a7$exports = {};

$parcel$export($a1be1bae5b4015a7$exports, "isScalingUnit", () => $a1be1bae5b4015a7$export$6a836bb704f10b75);
$parcel$export($a1be1bae5b4015a7$exports, "CSS_UNITS", () => $a1be1bae5b4015a7$export$7263016d8c64b932);
const $a1be1bae5b4015a7$export$6a836bb704f10b75 = (unit)=>{
    return unit === "em" || unit === "rem" || unit === "vw" || unit === "vh" || unit === "vmax" || unit === "vmin";
};
const $a1be1bae5b4015a7$export$7263016d8c64b932 = [
    // Absolute
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    // Font-relative
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    // Viewport-relative
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    // Container query units
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    // Angle
    "deg",
    "rad",
    "grad",
    "turn",
    // Time
    "s",
    "ms",
    // Resolution
    "dpi",
    "dpcm",
    "dppx",
    // Grid fractional
    "fr",
    "auto"
];



const $48a67b64ca668600$export$81ab9dc24d52c4ba = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
};
const $48a67b64ca668600$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
const $48a67b64ca668600$export$30fba622059784de = (val)=>{
    if (!val.includes("(")) return val;
    const prefix = val.split("(")[0];
    const value = val.slice(val.indexOf("(") + 1, val.lastIndexOf(")"));
    return [
        prefix,
        value
    ];
};
const $48a67b64ca668600$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ((0, $a1be1bae5b4015a7$export$6a836bb704f10b75)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = "--" + (type && type.replace(".", "-"));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $48a67b64ca668600$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $48a67b64ca668600$export$81ab9dc24d52c4ba[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $48a67b64ca668600$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = "--" + (type && type.replace(".", "-"));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $48a67b64ca668600$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $48a67b64ca668600$export$50db87b17b1557b4 = (base, ratio)=>{
    return $48a67b64ca668600$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $48a67b64ca668600$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $48a67b64ca668600$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1e3) / 1e3;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $48a67b64ca668600$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props2 = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $48a67b64ca668600$var$setSequenceValue(props2, sequenceProps);
    });
};
const $48a67b64ca668600$var$switchSequenceOnNegative = (key, base, ratio)=>{
    return base * Math.pow(ratio, key);
};
const $48a67b64ca668600$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $48a67b64ca668600$export$81ab9dc24d52c4ba[key];
        const value = $48a67b64ca668600$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $48a67b64ca668600$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $48a67b64ca668600$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $48a67b64ca668600$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $48a67b64ca668600$export$7b7c0090b74e1e64 = (sequenceProps, position = 0)=>{
    const { type: type, base: base, ratio: ratio, subSequence: subSequence } = sequenceProps;
    const letterKey = (0, $e7Ezu.isString)(position) ? position : $48a67b64ca668600$export$81ab9dc24d52c4ba[position];
    const index = (0, $e7Ezu.isString)(position) ? Object.entries($48a67b64ca668600$export$81ab9dc24d52c4ba).find(([, value2])=>value2 === position)?.[0] : position;
    if (!letterKey) {
        console.warn(`Position ${position} is out of range in numToLetterMap`);
        return null;
    }
    const result = {
        sequence: {},
        scales: {},
        vars: {},
        ...sequenceProps
    };
    const value = base * Math.pow(ratio, index);
    const scaling = ~~(value / base * 100) / 100;
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    const variable = prefix + letterKey;
    const scalingVariable = $48a67b64ca668600$export$68dfa61d698afbde(index, sequenceProps);
    const props = {
        key: letterKey,
        variable: variable,
        value: value,
        base: base,
        scaling: scaling,
        scalingVariable: scalingVariable,
        ratio: ratio,
        index: index
    };
    $48a67b64ca668600$var$setSequenceValue(props, result);
    if (subSequence) $48a67b64ca668600$export$622ae6209895c34e(props, result);
    return result;
};
const $48a67b64ca668600$export$efde09b5692f9bd0 = (value = "A", sequenceProps)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    if ((0, $e7Ezu.isString)(value) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(value)) return `var(${value})`;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    const hasUnits = (0, $a1be1bae5b4015a7$export$7263016d8c64b932).some((unit2)=>value.includes(unit2));
    if (hasUnits || !startsWithDashOrLetter) return value;
    const skipArr = [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ];
    if (skipArr.includes(value)) return value;
    const prefix = `--${(0, $18086de584b972dd$export$6401d9e8afa09755)(sequenceProps.type.replace(".", "-"))}-`;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === "-" ? "-" : "";
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = "";
    if (absValue.includes("_")) {
        mediaName = "_" + absValue.split("_")[1].toLowerCase();
        absValue = absValue.split("_")[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes("+")) {
        const [first, second] = absValue.split("+");
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("*")) {
        const [first, second] = absValue.split("*");
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("-")) {
        const [first, second] = absValue.split("-");
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, "- value is not found because `subSequence` is set to false");
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue2 = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue2} * -1)` : varValue2;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === "ms" || unit === "s") return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $48a67b64ca668600$export$69f332a3be1b2f36 = (value, sequenceProps)=>{
    const mathArr = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((v)=>value.includes(v + " "));
    if (!mathArr.length) return value;
    return mathArr.map((symbol)=>{
        const valuesArr = value.split(symbol + " ").map((v)=>v.trim());
        const transformedValues = valuesArr.map((v)=>{
            return $48a67b64ca668600$export$efde09b5692f9bd0(v, sequenceProps);
        });
        return transformedValues.join(" " + symbol + " ");
    }).join("");
};
const $48a67b64ca668600$export$86c0052f25dacc45 = (value, propertyName, sequenceProps, fnPrefix)=>{
    if (typeof value !== "string") {
        const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
        if (CONFIG.verbose) console.warn(propertyName, value, "is not a string");
        return {
            [propertyName]: value
        };
    }
    if (value === "-" || value === "") return {};
    if (!fnPrefix && value.includes("(")) {
        const fnArr = $48a67b64ca668600$export$30fba622059784de(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    const mathArr = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((v)=>value.includes(v + " "));
    if (mathArr.length) value = $48a67b64ca668600$export$69f332a3be1b2f36(value, sequenceProps);
    else value = $48a67b64ca668600$export$efde09b5692f9bd0(value, sequenceProps);
    return {
        [propertyName]: fnPrefix ? `${fnPrefix}(${value})` : value
    };
};
const $48a67b64ca668600$export$14c834a042d41297 = (h1Matches, index)=>$48a67b64ca668600$export$81ab9dc24d52c4ba[h1Matches - index];
const $48a67b64ca668600$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $48a67b64ca668600$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};



const $4e7bc1998c817803$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if ((0, $e7Ezu.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $4e7bc1998c817803$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = "--" + (type && type.replace(".", "-"));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $48a67b64ca668600$export$50db87b17b1557b4)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
};
const $4e7bc1998c817803$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, TIMING: TIMING, CSS_VARS: CSS_VARS } = CONFIG;
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $4e7bc1998c817803$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = `var(${item.variable + "_default"})`;
        }
    }
};
const $4e7bc1998c817803$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, MEDIA: MEDIA, CSS_VARS: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = FACTORY[media];
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn("Can't find media query ", query);
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $4e7bc1998c817803$export$eba6b21fdce78bcd(underMediaQuery, FACTORY[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $a1be1bae5b4015a7$export$6a836bb704f10b75)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn("Can't find query ", query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + "_" + mediaName})`;
        CSS_VARS[item.variable + "_" + mediaName] = value;
    }
};


const $ad7739c5bf717870$export$a5be618f63a441ac = ()=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    (0, $48a67b64ca668600$export$29708af739d9b0fc)(TIMING);
    (0, $4e7bc1998c817803$export$97ab4e7d8ade5018)(TIMING);
};
const $ad7739c5bf717870$export$23ba66c7c3e2e613 = (value)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return TIMING[value] || TIMING[(0, $18086de584b972dd$export$86f54f62aa7a7514)(value)] || value;
};
const $ad7739c5bf717870$export$3fa311edc5edd22f = (value, property = "timing")=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return (0, $48a67b64ca668600$export$86c0052f25dacc45)(value, property, TIMING);
};

parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

var $82d690e9f70ef2c9$exports = {};

$parcel$export($82d690e9f70ef2c9$exports, "checkIfBoxSize", () => $82d690e9f70ef2c9$export$80eafc63c0bb6c49);
$parcel$export($82d690e9f70ef2c9$exports, "applySpacingSequence", () => $82d690e9f70ef2c9$export$9bfe8384addafa7c);
$parcel$export($82d690e9f70ef2c9$exports, "getSpacingByKey", () => $82d690e9f70ef2c9$export$4f949d23b5dbefe6);
$parcel$export($82d690e9f70ef2c9$exports, "getSpacingBasedOnRatio", () => $82d690e9f70ef2c9$export$94679ba49f16fc2e);
$parcel$export($82d690e9f70ef2c9$exports, "splitSpacedValue", () => $82d690e9f70ef2c9$export$b5c85645d77180b6);

parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $g1LU2 = parcelRequire("g1LU2");


const $82d690e9f70ef2c9$var$runThroughMedia = (FACTORY)=>{
    for(const prop in FACTORY){
        const mediaProps = FACTORY[prop];
        const isMediaName = prop.slice(0, 1) === "@";
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $g1LU2.merge)(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $48a67b64ca668600$export$29708af739d9b0fc)(mediaProps);
        (0, $4e7bc1998c817803$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $82d690e9f70ef2c9$export$80eafc63c0bb6c49 = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    const includesWidth = prop.includes("width") || prop.includes("height");
    const includesBorder = prop.includes("border") || prop.includes("outline");
    return includesWidth && !includesBorder;
};
const $82d690e9f70ef2c9$export$9bfe8384addafa7c = ()=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    (0, $48a67b64ca668600$export$29708af739d9b0fc)(SPACING);
    (0, $4e7bc1998c817803$export$97ab4e7d8ade5018)(SPACING);
    $82d690e9f70ef2c9$var$runThroughMedia(SPACING);
};
const $82d690e9f70ef2c9$var$getSequence = (sequenceProps)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    if (!sequenceProps || !sequenceProps.sequence) return SPACING;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : (0, $48a67b64ca668600$export$29708af739d9b0fc)(sequenceProps);
};
const $82d690e9f70ef2c9$export$4f949d23b5dbefe6 = (value, propertyName = "padding", sequenceProps, fnPrefix)=>{
    const sequence = $82d690e9f70ef2c9$var$getSequence(sequenceProps);
    if ((0, $e7Ezu.isString)(value)) {
        if (!fnPrefix && value.includes("(")) {
            const fnArray = (0, $48a67b64ca668600$export$30fba622059784de)(value);
            fnPrefix = fnArray[0];
            value = fnArray[1];
        }
    }
    const stack = fnPrefix ? [
        value
    ] : (0, $18086de584b972dd$export$d1ef4b1a340dec10)(value);
    if (!(0, $e7Ezu.isArray)(stack)) return;
    if (stack.length > 1) {
        let suffix = "";
        if (propertyName === "borderWidth") {
            propertyName = "border";
            suffix = "Width";
        }
        const directions = {
            2: [
                "Block",
                "Inline"
            ],
            3: [
                "BlockStart",
                "Inline",
                "BlockEnd"
            ],
            4: [
                "BlockStart",
                "InlineEnd",
                "BlockEnd",
                "InlineStart"
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>(0, $48a67b64ca668600$export$86c0052f25dacc45)(stack[i], propertyName + direction + suffix, sequence, fnPrefix);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return (0, $48a67b64ca668600$export$86c0052f25dacc45)(value, propertyName, sequence, fnPrefix);
};
const $82d690e9f70ef2c9$export$94679ba49f16fc2e = (props, propertyName, val, fnPrefix)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    let value = val || props[propertyName];
    if (!fnPrefix && (0, $e7Ezu.isString)(value) && value.includes("(")) {
        const fnArr = (0, $48a67b64ca668600$export$30fba622059784de)(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    if (props.spacingRatio) {
        const sequenceProps = applyCustomSequence(props);
        return $82d690e9f70ef2c9$export$4f949d23b5dbefe6(value, propertyName, sequenceProps, fnPrefix);
    }
    return $82d690e9f70ef2c9$export$4f949d23b5dbefe6(value, propertyName, SPACING, fnPrefix);
};
const $82d690e9f70ef2c9$export$b5c85645d77180b6 = (val)=>{
    const addDefault = (v)=>{
        const isSymbol = [
            "+",
            "-",
            "*",
            "/"
        ].includes(v);
        const hasUnits = (0, $a1be1bae5b4015a7$export$7263016d8c64b932).some((unit)=>val.includes(unit));
        if (isSymbol || hasUnits) return v;
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        if (isSingleLetter) return v + "_default";
        return v;
    };
    return val.split(",").map((v)=>v.trim()).map(addDefault).join(",").split(" ").map(addDefault).join(" ");
};

var $964ba5cf20bdbfc1$exports = {};

$parcel$export($964ba5cf20bdbfc1$exports, "setShadow", () => $964ba5cf20bdbfc1$export$9cd3672191b5a46f);
$parcel$export($964ba5cf20bdbfc1$exports, "getShadow", () => $964ba5cf20bdbfc1$export$db93b77dbb14f011);




parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $964ba5cf20bdbfc1$export$9cd3672191b5a46f = (value, key, suffix, prefers)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if ((0, $e7Ezu.isArray)(value)) return {
        "@light": $964ba5cf20bdbfc1$export$9cd3672191b5a46f(value[0], key, "light"),
        "@dark": $964ba5cf20bdbfc1$export$9cd3672191b5a46f(value[1], key, "dark")
    };
    if ((0, $e7Ezu.isObject)(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $964ba5cf20bdbfc1$export$9cd3672191b5a46f(value[variant], key, variant.startsWith("@") ? variant.slice(1) : variant);
        return obj;
    }
    if ((0, $e7Ezu.isString)(value) && !(0, $d49bd28b97ddb649$export$cc26ca941513e971).test(value)) value = (0, $d49bd28b97ddb649$export$ef7a598b406793c)(value).map((shadow)=>{
        shadow = shadow.trim();
        return shadow.split(/\s+/).map((v)=>{
            v = v.trim();
            if (!v) return "";
            if (v.startsWith("--")) return `var(${v})`;
            const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(v);
            if ((0, $d49bd28b97ddb649$export$962b4432982d3252)(color)) return color;
            if (/^\d/.test(v) || v === "0" || v.includes("px") || v.slice(-2) === "em") return v;
            if (v === "inset" || v === "none") return v;
            const spacing = (0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "shadow");
            if (spacing && spacing.shadow) return spacing.shadow;
            return v;
        }).join(" ");
    }).join(", ");
    const CSSVar = `--shadow-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
const $964ba5cf20bdbfc1$export$db93b77dbb14f011 = (value, globalTheme)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $e7Ezu.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(value)) return `var(${value})`;
    const [name] = (0, $e7Ezu.isArray)(value) ? value : value.split(" ");
    const { SHADOW: SHADOW } = CONFIG;
    const val = SHADOW[name];
    const isObj = (0, $e7Ezu.isObject)(val);
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG.verbose) console.warn(value, " - does not have ", globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG.MEDIA[mediaName.slice(1)];
            const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG.verbose) console.warn("Can't find color", value);
    return value;
};



const $9e43a615778fa908$var$BORDER_STYLES = /* @__PURE__ */ new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "initial"
]);
const $9e43a615778fa908$var$GRADIENT_KEYWORDS = /* @__PURE__ */ new Set([
    "to",
    "top",
    "bottom",
    "left",
    "right",
    "center",
    "at",
    "circle",
    "ellipse",
    "closest-side",
    "farthest-side",
    "closest-corner",
    "farthest-corner"
]);
const $9e43a615778fa908$var$isBorderStyle = (str)=>$9e43a615778fa908$var$BORDER_STYLES.has(str);
const $9e43a615778fa908$export$ca4ef6ca6dc743f2 = (border)=>{
    const str = border + "";
    if ((0, $d49bd28b97ddb649$export$cc26ca941513e971).test(str)) return str;
    const trimmed = str.trim();
    if (trimmed === "none" || trimmed === "0" || trimmed === "initial" || trimmed === "inherit" || trimmed === "unset") return str;
    const tokens = str.split(/\s+/);
    return tokens.map((v)=>{
        v = v.trim();
        if (!v) return "";
        if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(v)) return `var(${v})`;
        if ($9e43a615778fa908$var$isBorderStyle(v)) return v;
        if (/^\d/.test(v) || v === "0") return v;
        const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(v);
        if ((0, $d49bd28b97ddb649$export$962b4432982d3252)(color)) return color;
        const spacing = (0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "border");
        if (spacing && spacing.border) return spacing.border;
        return v;
    }).join(" ");
};
const $9e43a615778fa908$export$8bcd50b221b13db = (stroke)=>{
    if ((0, $d49bd28b97ddb649$export$cc26ca941513e971).test(stroke)) return stroke;
    return stroke.split(/\s+/).map((v)=>{
        v = v.trim();
        if (!v) return "";
        if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(v)) return `var(${v})`;
        if (/^\d/.test(v) || v.includes("px") || v === "0") return v;
        const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(v);
        if ((0, $d49bd28b97ddb649$export$962b4432982d3252)(color)) return color;
        return v;
    }).join(" ");
};
const $9e43a615778fa908$export$837e4beeff9ff924 = (sh, globalTheme)=>(0, $964ba5cf20bdbfc1$export$db93b77dbb14f011)(sh, globalTheme);
const $9e43a615778fa908$export$9c296746f296a70 = (shadows, globalTheme)=>{
    if ((0, $d49bd28b97ddb649$export$cc26ca941513e971).test(shadows)) return shadows;
    return (0, $d49bd28b97ddb649$export$ef7a598b406793c)(shadows).map((shadow)=>{
        shadow = shadow.trim();
        if (!shadow) return "";
        return shadow.split(/\s+/).map((v)=>{
            v = v.trim();
            if (!v) return "";
            if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(v)) return `var(${v})`;
            if (v === "inset" || v === "none") return v;
            const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(v);
            if ((0, $d49bd28b97ddb649$export$962b4432982d3252)(color)) {
                const mediaColor = (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(v, globalTheme);
                if ((0, $e7Ezu.isObject)(mediaColor)) return Object.values(mediaColor).filter((c)=>c.includes(": " + globalTheme))[0];
                return mediaColor;
            }
            if (/^\d/.test(v) || v === "0" || v.includes("px") || v.slice(-2) === "em") return v;
            const spacing = (0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "shadow");
            if (spacing && spacing.shadow) return spacing.shadow;
            return v;
        }).join(" ");
    }).join(", ");
};
const $9e43a615778fa908$export$74ec263a34bf386a = (gradient, globalTheme)=>{
    const parenStart = gradient.indexOf("(");
    if (parenStart === -1) return gradient;
    const prefix = gradient.slice(0, parenStart + 1);
    const inner = gradient.slice(parenStart + 1, gradient.lastIndexOf(")"));
    const suffix = ")";
    const segments = (0, $d49bd28b97ddb649$export$ef7a598b406793c)(inner);
    const resolved = segments.map((segment)=>{
        segment = segment.trim();
        const tokens = segment.split(/\s+/);
        return tokens.map((token)=>{
            if (!token) return token;
            if (/^\d/.test(token) || token === "0") return token;
            if ($9e43a615778fa908$var$GRADIENT_KEYWORDS.has(token)) return token;
            if (token === "transparent") return token;
            if ((0, $d49bd28b97ddb649$export$cc26ca941513e971).test(token)) return token;
            const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(token);
            if ((0, $d49bd28b97ddb649$export$962b4432982d3252)(color)) return color;
            return token;
        }).join(" ");
    });
    return prefix + resolved.join(", ") + suffix;
};
const $9e43a615778fa908$export$15f2b9b64835b137 = (backgroundImage, globalTheme)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    return backgroundImage.split(", ").map((v)=>{
        if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(v)) return `var(${v})`;
        if (v.includes("url")) return v;
        if (v.includes("gradient")) return $9e43a615778fa908$export$74ec263a34bf386a(v, globalTheme);
        else if (CONFIG.GRADIENT[backgroundImage]) return {
            backgroundImage: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(backgroundImage, globalTheme || CONFIG.globalTheme)
        };
        else if (v.includes("/") || v.startsWith("http") || v.includes(".") && !(0, $d49bd28b97ddb649$export$4ea2ee5b33c12815)(v)) return `url(${v})`;
        return v;
    }).join(" ");
};
const $9e43a615778fa908$export$1e420ad2d0d06436 = (gap)=>(0, $e7Ezu.isString)(gap) && gap.split(" ").map((v)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "gap").gap).join(" ");
const $9e43a615778fa908$export$df2b736a06860be7 = (transition)=>{
    const arr = transition.split(" ");
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if ((0, $d49bd28b97ddb649$export$c9f584638d388483)(v)) return `var(${v})`;
        if (v.length < 3 || v.includes("ms")) {
            const mapWithSequence = (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(v);
            return mapWithSequence.timing || v;
        }
        if ((0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(v)) return (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(v);
        return v;
    }).join(" ");
};
const $9e43a615778fa908$export$d87c1c5f4a8ec3d9 = (duration, props, propertyName)=>{
    if (!(0, $e7Ezu.isString)(duration)) return;
    return duration.split(",").map((v)=>(0, $ad7739c5bf717870$export$3fa311edc5edd22f)(v).timing || v).join(",");
};
const $9e43a615778fa908$export$d9f7ff0c2b32d4b5 = (transition)=>{
    const arr = transition.split(",");
    if (!arr.length) return;
    return arr.map($9e43a615778fa908$export$df2b736a06860be7).join(",");
};
function $9e43a615778fa908$export$f09d9444954afeda(propertyName, val, props = {}, opts = {}) {
    let value = (0, $g1LU2.exec).call(this, val || props[propertyName]);
    if (value === void 0 || value === null) return;
    let fnPrefix;
    if ((0, $e7Ezu.isString)(value)) {
        if (value.includes("(")) {
            const fnArr = (0, $48a67b64ca668600$export$30fba622059784de)(value);
            fnPrefix = fnArr[0];
            value = fnArr[1];
        }
        const shouldScaleBoxSize = props.scaleBoxSize;
        const isBoxSize = (0, $82d690e9f70ef2c9$export$80eafc63c0bb6c49)(propertyName);
        if (!shouldScaleBoxSize && isBoxSize && !opts.ratio) value = (0, $82d690e9f70ef2c9$export$b5c85645d77180b6)(value);
    }
    return opts.ratio ? (0, $82d690e9f70ef2c9$export$94679ba49f16fc2e)(props, propertyName, value, fnPrefix) : (0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(value, propertyName, void 0, fnPrefix);
}
const $9e43a615778fa908$export$b6e34d20a288a08c = (propertyName, val = null, props)=>{
    return $9e43a615778fa908$export$f09d9444954afeda(propertyName, val, props, {
        ratio: true
    });
};
const $9e43a615778fa908$export$7150732276d3a7a2 = (radius, props, propertyName)=>{
    if (!(0, $e7Ezu.isString)(radius)) return;
    return {
        borderRadius: radius.split(" ").map((v, k)=>(0, $82d690e9f70ef2c9$export$94679ba49f16fc2e)(props, propertyName, v)[propertyName]).join(" ")
    };
};


'use strict';
const $39f812117129238d$export$801d104720a35e80 = {
    transition: (val)=>({
            transition: (0, $9e43a615778fa908$export$d9f7ff0c2b32d4b5)(val)
        }),
    transitionDuration: (val)=>({
            transitionDuration: (0, $9e43a615778fa908$export$d87c1c5f4a8ec3d9)(val)
        }),
    transitionDelay: (val)=>({
            transitionDelay: (0, $9e43a615778fa908$export$d87c1c5f4a8ec3d9)(val)
        }),
    transitionTimingFunction: (val)=>({
            transitionTimingFunction: (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(val)
        }),
    transitionProperty: (val)=>({
            transitionProperty: val,
            willChange: val
        })
};


'use strict';
const $c031e540a33546ea$var$CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
const $c031e540a33546ea$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$c031e540a33546ea$var$CONFIG.UNIT.default} 4${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$c031e540a33546ea$var$CONFIG.UNIT.default} 6${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$c031e540a33546ea$var$CONFIG.UNIT.default} 10${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$c031e540a33546ea$var$CONFIG.UNIT.default} 16${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$c031e540a33546ea$var$CONFIG.UNIT.default} 26${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$c031e540a33546ea$var$CONFIG.UNIT.default} 42${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    }
};
const $c031e540a33546ea$var$getComputedBackgroundColor = ({ props: props })=>{
    return (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(props.shapeDirectionColor) || (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(props.borderColor) || (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(props.backgroundColor) || (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(props.background);
};
const $c031e540a33546ea$var$inheritTransition = ({ props: props, deps: deps })=>{
    const exec = (0, $39f812117129238d$export$801d104720a35e80).transition(props.transition, {
        props: props,
        deps: deps
    });
    return exec && exec.transition;
};
const $c031e540a33546ea$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: '100%'
    },
    bubble: {},
    tv: {
        borderRadius: '1.15em/2.5em'
    },
    tooltip: ({ props: props, deps: deps })=>({
            position: props.position || 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
                border: '.35em solid',
                borderColor: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'border-color',
                position: 'absolute',
                borderRadius: '.15em'
            }
        }),
    tooltipDirection: {
        top: {
            '&:before': {
                top: '0',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                right: '0',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                bottom: '0',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                left: '0',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        }
    },
    tag: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background',
                borderRadius: '.25em',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%'
            }
        }),
    tagDirection: {
        top: {
            '&:before': {
                bottom: '100%',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                left: '100%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                top: '100%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                right: '100%',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        }
    },
    hexagon: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                borderRadius: '.25em',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%',
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            },
            '&:after': {
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }),
    chevron: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                background: `linear-gradient(225deg, ${$c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%), linear-gradient(315deg, ${$c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%)`
            },
            '&:after': {
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                borderRadius: '.25em'
            }
        }),
    chevronDirection: {
        left: {
            '&:before': {
                height: '100%',
                left: '100%',
                transform: 'translate3d(-1%, -50%, 1px) scale(-1, 1)'
            },
            '&:after': {
                height: '73%',
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                height: '100%',
                left: '0',
                transform: 'translate3d(-99%, -50%, 1px)'
            },
            '&:after': {
                height: '73%',
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }
    }
};


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
const $2ae1edf582b77174$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    const theme = rootState && rootState.globalTheme || context.designSystem && context.designSystem.globalTheme;
    return theme === 'auto' ? null : theme;
};
const $2ae1edf582b77174$export$14faa19a0f3bbeb2 = {
    deps: {
        depth: $c031e540a33546ea$export$b202ba015b5882cd
    },
    classlist: {
        depth: ({ props: props, deps: deps })=>!(0, $e7Ezu.isUndefined)(props.depth) && deps.depth[props.depth]
    }
};


'use strict';
const $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemGlobalTheme: $2ae1edf582b77174$export$f12bbb197a836138
    },
    tag: 'picture',
    childExtends: {
        deps: {
            getSystemGlobalTheme: $2ae1edf582b77174$export$f12bbb197a836138
        },
        tag: 'source',
        attr: {
            media: (element)=>{
                const { props: props, key: key, context: context, deps: deps } = element;
                const { MEDIA: MEDIA } = context.designSystem;
                const globalTheme = deps.getSystemGlobalTheme(element);
                const mediaName = (props.media || key).slice(1);
                if (mediaName === globalTheme) return '(min-width: 0px)';
                else if (mediaName === 'dark' || mediaName === 'light') return '(max-width: 0px)';
                return MEDIA[mediaName];
            }
        }
    },
    Img: {
        width: 'inherit',
        ignoreChildExtends: true,
        height: 'inherit',
        src: (element, state)=>element.parent.src || state.src
    }
};


var $7d36ad90912ad279$exports = {};

$parcel$export($7d36ad90912ad279$exports, "Svg", () => $7d36ad90912ad279$export$e17b9c1182212c96);
'use strict';
const $7d36ad90912ad279$export$e17b9c1182212c96 = {
    tag: 'svg',
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        'xmlns:xlink': 'http://www.w3.org/1999/xlink'
    },
    html: (el)=>{
        const { props: props, context: context } = el;
        if (props.semantic_symbols) return;
        if (props.html) return el.call('exec', props.html, el);
        const { designSystem: designSystem, utils: utils } = context;
        const SVG = designSystem && designSystem.SVG;
        const useSvgSprite = props.spriteId || context.designSystem && context.designSystem.useSvgSprite;
        const src = el.call('exec', props.src, el);
        if (!useSvgSprite && src) return src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = props.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        const symbolId = Symbol.for(src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (src) utils.init({
            svg: {
                [SVGKey]: src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};



var $23a4770c72ef76cc$exports = {};

$parcel$export($23a4770c72ef76cc$exports, "Video", () => $23a4770c72ef76cc$export$ae01dedf5c052bb);
'use strict';
const $23a4770c72ef76cc$export$ae01dedf5c052bb = {
    tag: 'video',
    controls: true,
    childExtends: {
        tag: 'source'
    }
};



var $b448a4a1f1311a88$exports = {};

$parcel$export($b448a4a1f1311a88$exports, "Text", () => $b448a4a1f1311a88$export$5f1af8db9871e1d6);
$parcel$export($b448a4a1f1311a88$exports, "H1", () => $b448a4a1f1311a88$export$5523b16adee8048);
$parcel$export($b448a4a1f1311a88$exports, "H2", () => $b448a4a1f1311a88$export$cb94397127ac9363);
$parcel$export($b448a4a1f1311a88$exports, "H3", () => $b448a4a1f1311a88$export$746be9e3a3dfff1f);
$parcel$export($b448a4a1f1311a88$exports, "H4", () => $b448a4a1f1311a88$export$cc5e069d64fda823);
$parcel$export($b448a4a1f1311a88$exports, "H5", () => $b448a4a1f1311a88$export$88ef9fdaf11f7a1f);
$parcel$export($b448a4a1f1311a88$exports, "H6", () => $b448a4a1f1311a88$export$a559fb8039b06400);
$parcel$export($b448a4a1f1311a88$exports, "P", () => $b448a4a1f1311a88$export$56c0d5a1e737357d);
$parcel$export($b448a4a1f1311a88$exports, "Caption", () => $b448a4a1f1311a88$export$32fbfacc5d962e0c);
$parcel$export($b448a4a1f1311a88$exports, "Strong", () => $b448a4a1f1311a88$export$f301627d437cff88);
$parcel$export($b448a4a1f1311a88$exports, "U", () => $b448a4a1f1311a88$export$3a6d5c9ae78a2c08);
$parcel$export($b448a4a1f1311a88$exports, "Underline", () => $b448a4a1f1311a88$export$741ee5bff4f2bc22);
$parcel$export($b448a4a1f1311a88$exports, "Italic", () => $b448a4a1f1311a88$export$1cfcf4275506b1c6);
$parcel$export($b448a4a1f1311a88$exports, "Title", () => $b448a4a1f1311a88$export$f99233281efd08a0);
$parcel$export($b448a4a1f1311a88$exports, "Headline", () => $b448a4a1f1311a88$export$e1faab0803786bcf);
$parcel$export($b448a4a1f1311a88$exports, "Subhead", () => $b448a4a1f1311a88$export$17e07beff4cf82a6);
$parcel$export($b448a4a1f1311a88$exports, "Footnote", () => $b448a4a1f1311a88$export$54539b446c9863da);
$parcel$export($b448a4a1f1311a88$exports, "B", () => $b448a4a1f1311a88$export$ef35774e6d314e91);
$parcel$export($b448a4a1f1311a88$exports, "I", () => $b448a4a1f1311a88$export$9bb611d729802a56);
$parcel$export($b448a4a1f1311a88$exports, "Data", () => $b448a4a1f1311a88$export$2d0294657ab35f1b);
'use strict';
const $b448a4a1f1311a88$export$5f1af8db9871e1d6 = {};
const $b448a4a1f1311a88$export$5523b16adee8048 = {
    tag: 'h1'
};
const $b448a4a1f1311a88$export$cb94397127ac9363 = {
    tag: 'h2'
};
const $b448a4a1f1311a88$export$746be9e3a3dfff1f = {
    tag: 'h3'
};
const $b448a4a1f1311a88$export$cc5e069d64fda823 = {
    tag: 'h4'
};
const $b448a4a1f1311a88$export$88ef9fdaf11f7a1f = {
    tag: 'h5'
};
const $b448a4a1f1311a88$export$a559fb8039b06400 = {
    tag: 'h6'
};
const $b448a4a1f1311a88$export$56c0d5a1e737357d = {
    tag: 'p'
};
const $b448a4a1f1311a88$export$32fbfacc5d962e0c = {
    tag: 'caption'
};
const $b448a4a1f1311a88$export$f301627d437cff88 = {
    tag: 'strong',
    fontWeight: '700'
};
const $b448a4a1f1311a88$export$3a6d5c9ae78a2c08 = {
    tag: 'u'
};
const $b448a4a1f1311a88$export$741ee5bff4f2bc22 = {
    tag: 'u'
};
const $b448a4a1f1311a88$export$1cfcf4275506b1c6 = {
    tag: 'i'
};
const $b448a4a1f1311a88$export$f99233281efd08a0 = {};
const $b448a4a1f1311a88$export$e1faab0803786bcf = {
    tag: 'h6',
    fontSize: 'B',
    fontWeight: 500
};
const $b448a4a1f1311a88$export$17e07beff4cf82a6 = {
    tag: 'span',
    fontSize: 'Z1'
};
const $b448a4a1f1311a88$export$54539b446c9863da = {
    tag: 'span',
    fontSize: 'Z'
};
const $b448a4a1f1311a88$export$ef35774e6d314e91 = {
    tag: 'b'
};
const $b448a4a1f1311a88$export$9bb611d729802a56 = {
    tag: 'i'
};
const $b448a4a1f1311a88$export$2d0294657ab35f1b = {
    tag: 'data'
};


var $c4098057d78edae9$exports = {};

$parcel$export($c4098057d78edae9$exports, "Box", () => $c4098057d78edae9$export$e71c4d32a2263218);
$parcel$export($c4098057d78edae9$exports, "Hr", () => $c4098057d78edae9$export$c65504044f62f430);
$parcel$export($c4098057d78edae9$exports, "Br", () => $c4098057d78edae9$export$9130f216d904f5ea);
$parcel$export($c4098057d78edae9$exports, "Li", () => $c4098057d78edae9$export$4de39c9f3329bb96);
$parcel$export($c4098057d78edae9$exports, "Ul", () => $c4098057d78edae9$export$d4f99c77eeffeaea);
$parcel$export($c4098057d78edae9$exports, "Ol", () => $c4098057d78edae9$export$60180a808b215c38);
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $eo3lV = parcelRequire("eo3lV");
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");


const $90827fd008d7752a$var$TIMING_FUNCTIONS = [
    "ease",
    "linear",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
];
const $90827fd008d7752a$var$FILL_MODES = [
    "none",
    "forwards",
    "backwards",
    "both"
];
const $90827fd008d7752a$var$DIRECTIONS = [
    "normal",
    "reverse",
    "alternate",
    "alternate-reverse"
];
const $90827fd008d7752a$var$PLAY_STATES = [
    "running",
    "paused"
];
const $90827fd008d7752a$var$isDuration = (v)=>/^[\d.]+m?s$/.test(v);
const $90827fd008d7752a$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    if ((0, $e7Ezu.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $90827fd008d7752a$var$parseAnimationShorthand = (val, el)=>{
    const { ANIMATION: ANIMATION } = el.context && el.context.designSystem || {};
    const tokens = val.split(/\s+/);
    let name = null;
    const durations = [];
    let timingFunction = null;
    let iterationCount = null;
    let direction = null;
    let fillMode = null;
    let playState = null;
    for (const token of tokens){
        if (ANIMATION && ANIMATION[token]) name = token;
        else if ($90827fd008d7752a$var$isDuration(token)) durations.push(token);
        else if ($90827fd008d7752a$var$TIMING_FUNCTIONS.includes(token) || token.startsWith("cubic-bezier") || token.startsWith("steps(")) timingFunction = token;
        else if (token === "infinite" || /^\d+$/.test(token)) iterationCount = token === "infinite" ? token : Number(token);
        else if ($90827fd008d7752a$var$DIRECTIONS.includes(token)) direction = token;
        else if ($90827fd008d7752a$var$FILL_MODES.includes(token)) fillMode = token;
        else if ($90827fd008d7752a$var$PLAY_STATES.includes(token)) playState = token;
        else if (!name) name = token;
    }
    return {
        name: name,
        durations: durations,
        timingFunction: timingFunction,
        iterationCount: iterationCount,
        direction: direction,
        fillMode: fillMode,
        playState: playState
    };
};
const $90827fd008d7752a$export$29173f57c6f2005 = {
    animation: (val, el)=>{
        if ((0, $e7Ezu.isString)(val) && val.includes(" ")) {
            const parsed = $90827fd008d7752a$var$parseAnimationShorthand(val, el);
            return {
                animationName: $90827fd008d7752a$var$applyAnimationProps(parsed.name || val, el),
                animationDuration: parsed.durations[0] || (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(el.props.animationDuration || "A").timing,
                animationDelay: parsed.durations[1] || (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(el.props.animationDelay || "0s").timing,
                animationTimingFunction: parsed.timingFunction || (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(el.props.animationTimingFunction || "ease"),
                animationFillMode: parsed.fillMode || el.props.animationFillMode || "both",
                animationIterationCount: parsed.iterationCount != null ? parsed.iterationCount : el.props.animationIterationCount || 1,
                animationPlayState: parsed.playState || el.props.animationPlayState,
                animationDirection: parsed.direction || el.props.animationDirection
            };
        }
        return {
            animationName: $90827fd008d7752a$var$applyAnimationProps(val, el),
            animationDuration: (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(el.props.animationDuration || "A").timing,
            animationDelay: (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(el.props.animationDelay || "0s").timing,
            animationTimingFunction: (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(el.props.animationTimingFunction || "ease"),
            animationFillMode: el.props.animationFillMode || "both",
            animationIterationCount: el.props.animationIterationCount || 1,
            animationPlayState: el.props.animationPlayState,
            animationDirection: el.props.animationDirection
        };
    },
    animationName: (val, el)=>({
            animationName: $90827fd008d7752a$var$applyAnimationProps(val, el)
        }),
    animationDuration: (val)=>({
            animationDuration: (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(val).timing
        }),
    animationDelay: (val)=>({
            animationDelay: (0, $ad7739c5bf717870$export$3fa311edc5edd22f)(val).timing
        }),
    animationTimingFunction: (val)=>({
            animationTimingFunction: (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(val)
        }),
    animationIterationCount: (val)=>({
            animationIterationCount: val
        }),
    animationFillMode: (val)=>({
            animationFillMode: val
        }),
    animationPlayState: (val)=>({
            animationPlayState: val
        }),
    animationDirection: (val)=>({
            animationDirection: val
        })
};


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");

const $f7d319db4e60e5d5$export$d8a4821b5338da9d = {
    show: (val, el, s, ctx)=>!!(ctx.utils.exec(val, el, s) === false) && {
            display: "none !important"
        },
    hide: (val, el, s, ctx)=>!!ctx.utils.exec(val, el, s) && {
            display: "none !important"
        },
    height: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("height", val, props),
    width: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("width", val, props),
    boxSizing: (val)=>!(0, $e7Ezu.isUndefined)(val) ? {
            boxSizing: val
        } : {
            boxSizing: "border-box"
        },
    boxSize: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [height, width] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("height", height),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("width", width || height)
        };
    },
    inlineSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("inlineSize", val, props),
    blockSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("blockSize", val, props),
    minWidth: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("minWidth", val, props),
    maxWidth: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("maxWidth", val, props),
    widthRange: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [minWidth, maxWidth] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("minWidth", minWidth),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("maxWidth", maxWidth || minWidth)
        };
    },
    minHeight: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("minHeight", val, props),
    maxHeight: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("maxHeight", val, props),
    heightRange: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [minHeight, maxHeight] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("minHeight", minHeight),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("maxHeight", maxHeight || minHeight)
        };
    },
    size: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [inlineSize, blockSize] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$b6e34d20a288a08c)("inlineSize", inlineSize),
            ...(0, $9e43a615778fa908$export$b6e34d20a288a08c)("blockSize", blockSize || inlineSize)
        };
    },
    minBlockSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("minBlockSize", val, props),
    minInlineSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("minInlineSize", val, props),
    maxBlockSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("maxBlockSize", val, props),
    maxInlineSize: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("maxInlineSize", val, props),
    minSize: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [minInlineSize, minBlockSize] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("minInlineSize", minInlineSize),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("minBlockSize", minBlockSize || minInlineSize)
        };
    },
    maxSize: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [maxInlineSize, maxBlockSize] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("maxInlineSize", maxInlineSize),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("maxBlockSize", maxBlockSize || maxInlineSize)
        };
    },
    borderWidth: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("borderWidth", val, props),
    padding: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("padding", val, props),
    scrollPadding: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("scrollPadding", val, props),
    paddingInline: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [paddingInlineStart, paddingInlineEnd] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("paddingInlineStart", paddingInlineStart),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("paddingInlineEnd", paddingInlineEnd || paddingInlineStart)
        };
    },
    paddingBlock: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [paddingBlockStart, paddingBlockEnd] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("paddingBlockStart", paddingBlockStart),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("paddingBlockEnd", paddingBlockEnd || paddingBlockStart)
        };
    },
    // Traditional directional padding
    paddingTop: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingBlockStart", val, props),
    paddingBottom: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingBlockEnd", val, props),
    paddingLeft: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingInlineStart", val, props),
    paddingRight: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingInlineEnd", val, props),
    // Logical properties (for reference)
    paddingBlockStart: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingBlockStart", val, props),
    // maps to top
    paddingBlockEnd: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingBlockEnd", val, props),
    // maps to bottom
    paddingInlineStart: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingInlineStart", val, props),
    // maps to left
    paddingInlineEnd: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("paddingInlineEnd", val, props),
    // maps to right
    margin: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("margin", val, props),
    marginInline: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [marginInlineStart, marginInlineEnd] = val.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("marginInlineStart", marginInlineStart),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("marginInlineEnd", marginInlineEnd || marginInlineStart)
        };
    },
    marginBlock: (val, { props: props })=>{
        if (!(0, $e7Ezu.isString)(props.marginBlock)) return;
        const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(" ");
        return {
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("marginBlockStart", marginBlockStart),
            ...(0, $9e43a615778fa908$export$f09d9444954afeda)("marginBlockEnd", marginBlockEnd || marginBlockStart)
        };
    },
    marginInlineStart: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("marginInlineStart", val, props),
    marginInlineEnd: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("marginInlineEnd", val, props),
    marginBlockStart: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("marginBlockStart", val, props),
    marginBlockEnd: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("marginBlockEnd", val, props),
    gap: (val)=>({
            gap: (0, $9e43a615778fa908$export$1e420ad2d0d06436)(val)
        }),
    columnGap: (val, { props: props })=>(0, $82d690e9f70ef2c9$export$94679ba49f16fc2e)(props, "columnGap", val),
    rowGap: (val, { props: props })=>(0, $82d690e9f70ef2c9$export$94679ba49f16fc2e)(props, "rowGap", val),
    flexWrap: (val, { props: props })=>({
            display: "flex",
            flexFlow: (val || "row").split(" ")[0] + " " + props.flexWrap
        }),
    flexFlow: (val, { props: props })=>{
        const { reverse: reverse } = props;
        if (!(0, $e7Ezu.isString)(val)) return;
        let [direction, wrap] = (val || "row").split(" ");
        if (val.startsWith("x") || val === "row") direction = "row";
        if (val.startsWith("y") || val === "column") direction = "column";
        return {
            display: "flex",
            flexFlow: (direction || "") + (!direction.includes("-reverse") && reverse ? "-reverse" : "") + " " + (wrap || "")
        };
    },
    flexAlign: (val)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [alignItems, justifyContent] = val.split(" ");
        return {
            display: "flex",
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    },
    round: (val, { props: props })=>(0, $9e43a615778fa908$export$7150732276d3a7a2)(val || props.borderRadius, props, "round"),
    borderRadius: (val, { props: props })=>(0, $9e43a615778fa908$export$7150732276d3a7a2)(val || props.round, props, "borderRadius")
};


var $6c2784ef9a7b4251$exports = {};

$parcel$export($6c2784ef9a7b4251$exports, "setFont", () => $6c2784ef9a7b4251$export$69e9bdef456a9c46);
$parcel$export($6c2784ef9a7b4251$exports, "getFontFamily", () => $6c2784ef9a7b4251$export$c4930fc256cef44f);
$parcel$export($6c2784ef9a7b4251$exports, "setFontFamily", () => $6c2784ef9a7b4251$export$5fae120d779aafec);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");


var $69026df1e768b48e$exports = {};

$parcel$export($69026df1e768b48e$exports, "resolveFileUrl", () => $69026df1e768b48e$export$61174294d0ed0cf1);
$parcel$export($69026df1e768b48e$exports, "getDefaultOrFirstKey", () => $69026df1e768b48e$export$73aa7d12a2d2fb83);
$parcel$export($69026df1e768b48e$exports, "getFontFormat", () => $69026df1e768b48e$export$6c7bbed5530e9474);
$parcel$export($69026df1e768b48e$exports, "isGoogleFontsUrl", () => $69026df1e768b48e$export$460f73444f66199c);
$parcel$export($69026df1e768b48e$exports, "setFontImport", () => $69026df1e768b48e$export$3a1ea4c2338850e0);
$parcel$export($69026df1e768b48e$exports, "setInCustomFontMedia", () => $69026df1e768b48e$export$e84fe2812840a337);
$parcel$export($69026df1e768b48e$exports, "setCustomFont", () => $69026df1e768b48e$export$27bb82ae7d3ac02b);
$parcel$export($69026df1e768b48e$exports, "setCustomFontMedia", () => $69026df1e768b48e$export$2593ac3417be5ed7);
$parcel$export($69026df1e768b48e$exports, "getFontFaceEach", () => $69026df1e768b48e$export$198e04e3616f042a);
$parcel$export($69026df1e768b48e$exports, "getFontFace", () => $69026df1e768b48e$export$e9d70cd3a9044b8e);
$parcel$export($69026df1e768b48e$exports, "getFontFaceEachString", () => $69026df1e768b48e$export$c26ef91aac8931ec);
$parcel$export($69026df1e768b48e$exports, "getFontFaceString", () => $69026df1e768b48e$export$8b73d71a1d936bc);
const $69026df1e768b48e$export$61174294d0ed0cf1 = (url, files)=>{
    if (!url || !files) return null;
    try {
        new URL(url);
        return null;
    } catch (e) {}
    const file = files[url];
    if (file) return file.content && file.content.src;
    return null;
};
const $69026df1e768b48e$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $69026df1e768b48e$export$6c7bbed5530e9474 = (url)=>{
    const ext = url.split(/[#?]/)[0].split(".").pop().trim();
    if ([
        "woff2",
        "woff",
        "ttf",
        "otf",
        "eot"
    ].includes(ext)) return ext;
    return null;
};
const $69026df1e768b48e$export$460f73444f66199c = (url)=>url && (url.includes("fonts.googleapis.com") || url.includes("fonts.gstatic.com"));
const $69026df1e768b48e$export$3a1ea4c2338850e0 = (url)=>`@import url('${url}');`;
const $69026df1e768b48e$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $69026df1e768b48e$export$27bb82ae7d3ac02b = (name, url, weight, options = {})=>{
    const format = $69026df1e768b48e$export$6c7bbed5530e9474(url);
    const formatStr = format ? ` format('${format}')` : "";
    return `
  font-family: '${name}';
  font-style: normal;${weight ? `
  font-weight: ${weight};` : ""}${options.fontStretch ? `
  font-stretch: ${options.fontStretch};` : ""}${options.fontDisplay ? `
  font-display: ${options.fontDisplay};` : ""}
  src: url('${url}')${formatStr};`;
};
const $69026df1e768b48e$export$2593ac3417be5ed7 = (name, url, weight, options)=>`@font-face {${$69026df1e768b48e$export$27bb82ae7d3ac02b(name, url, weight, options)}
}`;
const $69026df1e768b48e$export$198e04e3616f042a = (name, weights, files)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        const resolvedUrl = $69026df1e768b48e$export$61174294d0ed0cf1(url, files) || url;
        return $69026df1e768b48e$export$27bb82ae7d3ac02b(name, resolvedUrl, fontWeight);
    });
};
const $69026df1e768b48e$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$69026df1e768b48e$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $69026df1e768b48e$export$c26ef91aac8931ec = (name, weights, files)=>{
    if (weights && weights.isVariable) {
        const url2 = $69026df1e768b48e$export$61174294d0ed0cf1(weights.url, files) || weights.url;
        if ($69026df1e768b48e$export$460f73444f66199c(url2)) return $69026df1e768b48e$export$3a1ea4c2338850e0(url2);
        return $69026df1e768b48e$export$2593ac3417be5ed7(name, url2, weights.fontWeight, {
            fontStretch: weights.fontStretch,
            fontDisplay: weights.fontDisplay || "swap"
        });
    }
    const isArr = weights[0];
    if (isArr) return $69026df1e768b48e$export$198e04e3616f042a(name, weights, files).map($69026df1e768b48e$export$e84fe2812840a337);
    const url = $69026df1e768b48e$export$61174294d0ed0cf1(weights.url, files) || weights.url;
    return $69026df1e768b48e$export$2593ac3417be5ed7(name, url);
};
const $69026df1e768b48e$export$8b73d71a1d936bc = (LIBRARY, files)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$69026df1e768b48e$export$c26ef91aac8931ec(key, LIBRARY[key].value, files));
};


const $6c2784ef9a7b4251$export$69e9bdef456a9c46 = (val, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const CSSvar = `--font-${key}`;
    if (!val || (0, $e7Ezu.isArray)(val) && !val[0]) return;
    let fontFace;
    if (val.isVariable) {
        const url = (0, $69026df1e768b48e$export$61174294d0ed0cf1)(val.url, CONFIG.files) || val.url;
        if ((0, $69026df1e768b48e$export$460f73444f66199c)(url)) fontFace = (0, $69026df1e768b48e$export$3a1ea4c2338850e0)(url);
        else fontFace = (0, $69026df1e768b48e$export$2593ac3417be5ed7)(key, url, val.fontWeight, {
            fontStretch: val.fontStretch,
            fontDisplay: val.fontDisplay || "swap"
        });
    } else if (val[0]) fontFace = (0, $69026df1e768b48e$export$198e04e3616f042a)(key, val, CONFIG.files);
    else {
        const url = (0, $69026df1e768b48e$export$61174294d0ed0cf1)(val.url, CONFIG.files) || val.url;
        fontFace = (0, $69026df1e768b48e$export$2593ac3417be5ed7)(key, url);
    }
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
const $6c2784ef9a7b4251$export$c4930fc256cef44f = (key, factory)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY } = CONFIG;
    return (0, $69026df1e768b48e$export$73aa7d12a2d2fb83)(factory || FONT_FAMILY, key);
};
const $6c2784ef9a7b4251$export$5fae120d779aafec = (val, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY, FONT_FAMILY_TYPES: FONT_FAMILY_TYPES } = CONFIG;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY.default = key;
    if ((0, $e7Ezu.isObject)(value)) value = (0, $18086de584b972dd$export$d1ef4b1a340dec10)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(", ")}, ${FONT_FAMILY_TYPES[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};

var $c0cda698d68ed165$exports = {};

$parcel$export($c0cda698d68ed165$exports, "runThroughMedia", () => $c0cda698d68ed165$export$ee622839cb6e2b5d);
$parcel$export($c0cda698d68ed165$exports, "applyHeadings", () => $c0cda698d68ed165$export$7fc39a69c6299a60);
$parcel$export($c0cda698d68ed165$exports, "applyTypographySequence", () => $c0cda698d68ed165$export$7c7d7b0d076fe8b5);
$parcel$export($c0cda698d68ed165$exports, "getFontSizeByKey", () => $c0cda698d68ed165$export$ea9b2cd64205746b);
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");


const $c0cda698d68ed165$export$ee622839cb6e2b5d = (FACTORY)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY, MEDIA: MEDIA } = CONFIG;
    for(const prop in FACTORY){
        const isPropMedia = prop.slice(0, 1) === "@";
        const mediaValue = FACTORY[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $g1LU2.merge)(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const query = MEDIA[mediaName];
        const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
        TYPOGRAPHY.templates[media] = {
            fontSize: mediaValue.base / TYPOGRAPHY.browserDefault + unit
        };
        if (!mediaRegenerate) {
            (0, $4e7bc1998c817803$export$768e417cbfe71417)(FACTORY, prop);
            continue;
        }
        (0, $g1LU2.merge)(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $48a67b64ca668600$export$29708af739d9b0fc)(mediaValue);
        (0, $4e7bc1998c817803$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $c0cda698d68ed165$export$7fc39a69c6299a60 = (props)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = (0, $48a67b64ca668600$export$8dc77c00fe04c40a)(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG.useVariable ? `var(${HEADINGS[k]?.variable})` : `${HEADINGS[k]?.scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
const $c0cda698d68ed165$export$7c7d7b0d076fe8b5 = ()=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    (0, $48a67b64ca668600$export$29708af739d9b0fc)(TYPOGRAPHY);
    $c0cda698d68ed165$export$7fc39a69c6299a60(TYPOGRAPHY);
    (0, $4e7bc1998c817803$export$97ab4e7d8ade5018)(TYPOGRAPHY);
    $c0cda698d68ed165$export$ee622839cb6e2b5d(TYPOGRAPHY);
};
const $c0cda698d68ed165$export$ea9b2cd64205746b = (value)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $48a67b64ca668600$export$86c0052f25dacc45)(value, "fontSize", TYPOGRAPHY);
};


const $37fbe345a1ad4e5d$export$e6c8c930b1cd765 = {
    fontSize: (value)=>{
        return (0, $c0cda698d68ed165$export$ea9b2cd64205746b)(value) || value;
    },
    fontFamily: (value)=>({
            fontFamily: (0, $6c2784ef9a7b4251$export$c4930fc256cef44f)(value) || value
        }),
    fontWeight: (value)=>({
            fontWeight: value,
            fontVariationSettings: '"wght" ' + value
        })
};


const $7bb76108021b4411$export$24dfac4a0da20903 = {
    overflow: (value)=>({
            overflow: value,
            scrollBehavior: "smooth"
        }),
    cursor: (value, el, s, ctx)=>{
        if (!value) return;
        const file = ctx.files && ctx.files[value];
        if (file && file.content) value = `url(${file.content.src})`;
        return {
            cursor: value
        };
    }
};



const $7927404dc0105ea0$export$c0036cbb5416e2bc = {
    inset: (val, el)=>{
        if (el.call("isNumber", val)) return {
            inset: val
        };
        if (!el.call("isString", val)) return;
        return {
            inset: val.split(" ").map((v)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "k").k).join(" ")
        };
    },
    left: (val)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(val, "left"),
    top: (val)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(val, "top"),
    right: (val)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(val, "right"),
    bottom: (val)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(val, "bottom"),
    verticalInset: (val)=>{
        if (typeof val !== "string") return;
        const vi = val.split(" ").map((v)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "k").k);
        return {
            top: vi[0],
            bottom: vi[1] || vi[0]
        };
    },
    horizontalInset: (val)=>{
        if (typeof val !== "string") return;
        const vi = val.split(" ").map((v)=>(0, $82d690e9f70ef2c9$export$4f949d23b5dbefe6)(v, "k").k);
        return {
            left: vi[0],
            right: vi[1] || vi[0]
        };
    }
};


var $faa3e5b310b9cc9c$exports = {};

$parcel$export($faa3e5b310b9cc9c$exports, "getTheme", () => $faa3e5b310b9cc9c$export$89cbf1a0881c8b9c);
$parcel$export($faa3e5b310b9cc9c$exports, "getMediaTheme", () => $faa3e5b310b9cc9c$export$b3cf7317de2f2233);
$parcel$export($faa3e5b310b9cc9c$exports, "setTheme", () => $faa3e5b310b9cc9c$export$2e49b867b7a0847c);
$parcel$export($faa3e5b310b9cc9c$exports, "setMediaTheme", () => $faa3e5b310b9cc9c$export$c57b11cd015ce162);



parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $faa3e5b310b9cc9c$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            "color",
            "Color",
            "background",
            "border"
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(theme[key]) : theme[key];
    });
    return value;
};
const $faa3e5b310b9cc9c$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $faa3e5b310b9cc9c$var$setThemeValue(theme);
    return theme.value;
};
const $faa3e5b310b9cc9c$export$89cbf1a0881c8b9c = (value, modifier)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $faa3e5b310b9cc9c$export$b3cf7317de2f2233(value, modifier);
    const { THEME: THEME } = CONFIG;
    if ((0, $e7Ezu.isString)(value)) {
        const [theme, subtheme] = value.split(" ");
        const isOurTheme = THEME[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $faa3e5b310b9cc9c$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ((0, $e7Ezu.isObjectLike)(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME[themeName];
        if (media && media[subThemeName]) return $faa3e5b310b9cc9c$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $faa3e5b310b9cc9c$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $faa3e5b310b9cc9c$var$getThemeValue(state[subThemeName]);
    } else if ((0, $e7Ezu.isObject)(value)) return $faa3e5b310b9cc9c$var$setThemeValue(value);
};
const $faa3e5b310b9cc9c$var$setInverseTheme = (theme, variant, value)=>{
    if ((0, $e7Ezu.isObject)(variant)) theme.variants.inverse.value = $faa3e5b310b9cc9c$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
const $faa3e5b310b9cc9c$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $faa3e5b310b9cc9c$export$89cbf1a0881c8b9c(variant);
    themeValue[`&:${key}`] = result;
    if ((0, $e7Ezu.isObject)(variant) && !variant.value) variant.value = result;
};
const $faa3e5b310b9cc9c$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $faa3e5b310b9cc9c$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
const $faa3e5b310b9cc9c$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $faa3e5b310b9cc9c$export$89cbf1a0881c8b9c(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ((0, $e7Ezu.isObject)(variant) && !variant.value) variant.value = result;
};
const $faa3e5b310b9cc9c$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === "dark" || key === "light") $faa3e5b310b9cc9c$var$setPrefersScheme(theme, key, variant, value);
        if (key === "inverse") $faa3e5b310b9cc9c$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
const $faa3e5b310b9cc9c$var$setHelpers = (theme, value)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ((0, $e7Ezu.isString)(helper)) helpers[key] = CONFIG.THEME[helper];
        else $faa3e5b310b9cc9c$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
const $faa3e5b310b9cc9c$export$2e49b867b7a0847c = (val, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $faa3e5b310b9cc9c$export$c57b11cd015ce162(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $faa3e5b310b9cc9c$var$setThemeValue(val, key);
    const CSSvar = `--theme-${key}`;
    $faa3e5b310b9cc9c$var$setSelectors(val, value);
    $faa3e5b310b9cc9c$var$setMedia(val, value);
    $faa3e5b310b9cc9c$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
const $faa3e5b310b9cc9c$var$keySetters = {
    // eslint-disable-line
    "@": (theme, value)=>$faa3e5b310b9cc9c$var$setMedia(theme, value),
    ":": (theme, value)=>$faa3e5b310b9cc9c$var$setSelectors(theme, value),
    ".": (theme, value)=>$faa3e5b310b9cc9c$var$setHelpers(theme, value)
};
const $faa3e5b310b9cc9c$var$generateAutoVars = (schemes, varPrefix, CONFIG)=>{
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if (!CONFIG.CSS_MEDIA_VARS) CONFIG.CSS_MEDIA_VARS = {};
    const MEDIA_VARS = CONFIG.CSS_MEDIA_VARS;
    const globalTheme = CONFIG.globalTheme !== void 0 ? CONFIG.globalTheme : "auto";
    const result = {};
    const allKeys = /* @__PURE__ */ new Set();
    for(const scheme in schemes){
        if (schemes[scheme]) for (const k of Object.keys(schemes[scheme]))allKeys.add(k);
    }
    for (const param of allKeys){
        const symb = param.slice(0, 1);
        const hasObject = Object.values(schemes).some((s)=>(0, $e7Ezu.isObjectLike)(s?.[param]));
        if (symb === "." && hasObject) {
            const helperName = param.slice(1);
            const subSchemes = {};
            for(const scheme in schemes)if ((0, $e7Ezu.isObjectLike)(schemes[scheme]?.[param])) subSchemes[scheme] = schemes[scheme][param];
            result[param] = $faa3e5b310b9cc9c$var$generateAutoVars(subSchemes, `${varPrefix}-${helperName}`, CONFIG);
        } else if (symb === ":" && hasObject) {
            const pseudoName = param.replace(/^:+/, "");
            const subSchemes = {};
            for(const scheme in schemes)if ((0, $e7Ezu.isObjectLike)(schemes[scheme]?.[param])) subSchemes[scheme] = schemes[scheme][param];
            result[param] = $faa3e5b310b9cc9c$var$generateAutoVars(subSchemes, `${varPrefix}-${pseudoName}`, CONFIG);
        } else if (symb !== "@" && symb !== "." && symb !== ":") {
            const autoVar = `--theme-${varPrefix}-${param}`;
            if (globalTheme === "auto") for(const scheme in schemes){
                const val = schemes[scheme]?.[param];
                if (val === void 0) continue;
                const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(val, `@${scheme}`);
                if (color === void 0) continue;
                const selector = `[data-theme="${scheme}"]`;
                if (!MEDIA_VARS[selector]) MEDIA_VARS[selector] = {};
                MEDIA_VARS[selector][autoVar] = color;
                if (scheme === "dark" || scheme === "light") {
                    const mq = `@media (prefers-color-scheme: ${scheme})`;
                    if (!MEDIA_VARS[mq]) MEDIA_VARS[mq] = {};
                    MEDIA_VARS[mq][autoVar] = color;
                }
            }
            else {
                const forced = String(globalTheme).replace(/^'|'$/g, "");
                const source = schemes[forced]?.[param];
                if (source !== void 0) {
                    const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(source, `@${forced}`);
                    if (color !== void 0) CSS_VARS[autoVar] = color;
                }
            }
            result[param] = `var(${autoVar})`;
            result[`.${param}`] = {
                [param]: result[param]
            };
        }
    }
    if (result.background || result.color || result.backgroundColor) result[".inversed"] = {
        color: result.background || result.backgroundColor,
        background: result.color
    };
    return result;
};
const $faa3e5b310b9cc9c$export$c57b11cd015ce162 = (val, key, suffix, prefers)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    const theme = {
        value: val
    };
    const isTopLevel = !suffix && !prefers;
    if ((0, $e7Ezu.isObjectLike)(val)) {
        if (isTopLevel && CONFIG.useVariable) {
            const schemes = {};
            for(const param in val)if (param.startsWith("@") && (0, $e7Ezu.isObjectLike)(val[param])) schemes[param.slice(1)] = val[param];
            if (Object.keys(schemes).length) {
                const autoResult = $faa3e5b310b9cc9c$var$generateAutoVars(schemes, key, CONFIG);
                Object.assign(theme, autoResult);
            }
        }
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === "@" || symb === ":" || symb === ".") {
                const hasPrefers = symb === "@" && param;
                theme[param] = $faa3e5b310b9cc9c$export$c57b11cd015ce162(value, key, param, prefers || hasPrefers);
            } else if (!isTopLevel) {
                const color = (0, $232c9281a8f7b24b$export$5551a2d24ff40153)(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? "-" + metaSuffixes.join("-") : "";
                const CSSVar = `--theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG.useVariable) {
                    if (CONFIG.useThemeSuffixedVars) CSS_VARS[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        if (!theme[".inversed"] && (theme.background || theme.color || theme.backgroundColor)) theme[".inversed"] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ((0, $e7Ezu.isString)(val) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(val)) {
        const { THEME: THEME } = CONFIG;
        const value = THEME[val.slice(2)];
        const getReferenced = $faa3e5b310b9cc9c$export$b3cf7317de2f2233(value, prefers);
        return getReferenced;
    }
    return theme;
};
const $faa3e5b310b9cc9c$var$recursiveTheme = (val)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ((0, $e7Ezu.isObjectLike)(val[param])) {
            if (symb === "@") continue;
            else if (symb === ":") obj[`&${param}`] = $faa3e5b310b9cc9c$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
const $faa3e5b310b9cc9c$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $faa3e5b310b9cc9c$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
const $faa3e5b310b9cc9c$var$findModifier = (val, modifier)=>{
    if ((0, $e7Ezu.isArray)(modifier)) return $faa3e5b310b9cc9c$var$findModifierFromArray(val, modifier);
    else if ((0, $e7Ezu.isString)(modifier) && val[modifier]) return val[modifier];
    else return val;
};
const $faa3e5b310b9cc9c$var$checkForReference = (val, callback)=>{
    if ((0, $e7Ezu.isString)(val) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(val)) return $faa3e5b310b9cc9c$export$b3cf7317de2f2233(val.slice(2));
    return val;
};
const $faa3e5b310b9cc9c$var$checkThemeReference = (val)=>$faa3e5b310b9cc9c$var$checkForReference(val, $faa3e5b310b9cc9c$var$checkThemeReference);
const $faa3e5b310b9cc9c$export$b3cf7317de2f2233 = (value, modifier)=>{
    const activeConfig = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if ((0, $e7Ezu.isString)(value) && (0, $d49bd28b97ddb649$export$c9f584638d388483)(value)) value = $faa3e5b310b9cc9c$export$b3cf7317de2f2233(value.slice(2));
    if (!value || !(0, $e7Ezu.isString)(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = (0, $e7Ezu.isArray)(value) ? value : value.split(" ");
    let themeValue = activeConfig.THEME[themeName];
    if (themeValue && themeModifiers.length) themeValue = $faa3e5b310b9cc9c$var$findModifier(themeValue, themeModifiers);
    else if (themeValue && modifier) themeValue = $faa3e5b310b9cc9c$var$findModifier(themeValue, modifier);
    const resolvedTheme = $faa3e5b310b9cc9c$var$recursiveTheme(themeValue);
    return resolvedTheme;
};


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $ef9ef64214b73f57$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const theme = state?.root?.globalTheme || context.designSystem?.globalTheme;
    return theme === "auto" ? null : theme;
};
const $ef9ef64214b73f57$export$11ce017e3ee09814 = {
    theme: (val, element)=>{
        const { props: props } = element;
        if (!val) return;
        if (props.themeModifier) return (0, $faa3e5b310b9cc9c$export$b3cf7317de2f2233)(val, `@${props.themeModifier}`);
        return (0, $faa3e5b310b9cc9c$export$b3cf7317de2f2233)(val);
    },
    color: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            color: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    background: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        if ((0, $e7Ezu.isString)(val) && val.includes("gradient")) return {
            background: (0, $9e43a615778fa908$export$74ec263a34bf386a)(val, globalTheme)
        };
        return {
            background: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    backgroundColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            backgroundColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    backgroundImage: (val, element, s, ctx)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        const file = ctx.files && ctx.files[val];
        if (file && file.content) val = file.content.src;
        return {
            backgroundImage: (0, $9e43a615778fa908$export$15f2b9b64835b137)(val, globalTheme)
        };
    },
    textStroke: (val)=>({
            WebkitTextStroke: (0, $9e43a615778fa908$export$8bcd50b221b13db)(val)
        }),
    outline: (val)=>({
            outline: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    outlineOffset: (val, { props: props })=>(0, $9e43a615778fa908$export$b6e34d20a288a08c)("outlineOffset", val, props),
    border: (val)=>({
            border: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    borderColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    borderTopColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderTopColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    borderBottomColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderBottomColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    borderLeftColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderLeftColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    borderRightColor: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderRightColor: (0, $232c9281a8f7b24b$export$dd72f6d9deea7207)(val, globalTheme)
        };
    },
    borderLeft: (val)=>({
            borderLeft: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    borderTop: (val)=>({
            borderTop: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    borderRight: (val)=>({
            borderRight: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    borderBottom: (val)=>({
            borderBottom: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        }),
    shadow: (val, element)=>{
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            boxShadow: (0, $9e43a615778fa908$export$837e4beeff9ff924)(val, globalTheme)
        };
    },
    boxShadow: (val, element)=>{
        if (!(0, $e7Ezu.isString)(val)) return;
        const [value, hasImportant] = val.split("!importan");
        const globalTheme = $ef9ef64214b73f57$export$f12bbb197a836138(element);
        const important = hasImportant ? " !important" : "";
        return {
            boxShadow: (0, $9e43a615778fa908$export$9c296746f296a70)(value.trim(), globalTheme) + important
        };
    },
    textShadow: (val, { context: context })=>({
            textShadow: (0, $9e43a615778fa908$export$9c296746f296a70)(val, context.designSystem.globalTheme)
        }),
    columnRule: (val)=>({
            columnRule: (0, $9e43a615778fa908$export$ca4ef6ca6dc743f2)(val)
        })
};



const $37602c582618d8b8$export$801d104720a35e80 = {
    transition: (val)=>({
            transition: (0, $9e43a615778fa908$export$d9f7ff0c2b32d4b5)(val)
        }),
    transitionDuration: (val)=>({
            transitionDuration: (0, $9e43a615778fa908$export$d87c1c5f4a8ec3d9)(val)
        }),
    transitionDelay: (val)=>({
            transitionDelay: (0, $9e43a615778fa908$export$d87c1c5f4a8ec3d9)(val)
        }),
    transitionTimingFunction: (val)=>({
            transitionTimingFunction: (0, $ad7739c5bf717870$export$23ba66c7c3e2e613)(val)
        }),
    transitionProperty: (val)=>({
            transitionProperty: val,
            willChange: val
        })
};


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
const $103c250e984ca5f7$export$736b75ae6a344b36 = {
    flow: (value, el)=>{
        const { props: props } = el;
        const { reverse: reverse } = props;
        if (!(0, $e7Ezu.isString)(value)) return;
        let [direction, wrap] = (value || "row").split(" ");
        if (value.startsWith("x") || value === "row") direction = "row";
        if (value.startsWith("y") || value === "column") direction = "column";
        return {
            display: "flex",
            flexFlow: (direction || "") + (!direction.includes("-reverse") && reverse ? "-reverse" : "") + " " + (wrap || "")
        };
    },
    wrap: (value, { props: props })=>{
        return {
            display: "flex",
            flexWrap: value
        };
    },
    align: (value, { props: props })=>{
        const [alignItems, justifyContent] = value.split(" ");
        return {
            display: "flex",
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    }
};


const $4e7c7be26316cc35$export$e33f615210a2138f = {
    area: (value)=>({
            gridArea: value
        }),
    template: (value)=>({
            gridTemplate: value
        }),
    templateAreas: (value)=>({
            gridTemplateAreas: value
        }),
    column: (value)=>({
            gridColumn: value
        }),
    columns: (value)=>({
            gridTemplateColumns: value
        }),
    templateColumns: (value)=>({
            gridTemplateColumns: value
        }),
    autoColumns: (value)=>({
            gridAutoColumns: value
        }),
    columnStart: (value)=>({
            gridColumnStart: value
        }),
    row: (value)=>({
            gridRow: value
        }),
    rows: (value)=>({
            gridTemplateRows: value
        }),
    templateRows: (value)=>({
            gridTemplateRows: value
        }),
    autoRows: (value)=>({
            gridAutoRows: value
        }),
    rowStart: (value)=>({
            gridRowStart: value
        }),
    autoFlow: (value)=>({
            gridAutoFlow: value
        })
};


const $ba2ea636a01886dc$export$b474245a861fc144 = {
    ...(0, $90827fd008d7752a$export$29173f57c6f2005),
    ...(0, $f7d319db4e60e5d5$export$d8a4821b5338da9d),
    ...(0, $37fbe345a1ad4e5d$export$e6c8c930b1cd765),
    ...(0, $7bb76108021b4411$export$24dfac4a0da20903),
    ...(0, $7bb76108021b4411$export$24dfac4a0da20903),
    ...(0, $7927404dc0105ea0$export$c0036cbb5416e2bc),
    ...(0, $ef9ef64214b73f57$export$11ce017e3ee09814),
    ...(0, $37602c582618d8b8$export$801d104720a35e80),
    ...(0, $103c250e984ca5f7$export$736b75ae6a344b36),
    ...(0, $4e7c7be26316cc35$export$e33f615210a2138f)
};
var $ba2ea636a01886dc$export$2e2bcd8739ae039 = $ba2ea636a01886dc$export$b474245a861fc144;


const $a9820eb8a8bd60cf$export$33f20e95f48422c = /* @__PURE__ */ new Set([
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignmentBaseline",
    "all",
    "animation",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "background",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "backgroundImage",
    "backgroundOrigin",
    "backgroundPosition",
    "backgroundPositionX",
    "backgroundPositionY",
    "backgroundRepeat",
    "backgroundRepeatX",
    "backgroundRepeatY",
    "backgroundSize",
    "baselineShift",
    "blockSize",
    "border",
    "borderBlock",
    "borderBlockColor",
    "borderBlockEnd",
    "borderBlockEndColor",
    "borderBlockEndStyle",
    "borderBlockEndWidth",
    "borderBlockStart",
    "borderBlockStartColor",
    "borderBlockStartStyle",
    "borderBlockStartWidth",
    "borderBlockStyle",
    "borderBlockWidth",
    "borderBottom",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderCollapse",
    "borderColor",
    "borderImage",
    "borderImageOutset",
    "borderImageRepeat",
    "borderImageSlice",
    "borderImageSource",
    "borderImageWidth",
    "borderLeft",
    "borderLeftColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderRadius",
    "borderRight",
    "borderRightColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderSpacing",
    "borderStyle",
    "borderTop",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopStyle",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "boxDecorationBreak",
    "boxShadow",
    "boxSizing",
    "breakAfter",
    "breakBefore",
    "breakInside",
    "captionSide",
    "caretColor",
    "clear",
    "clip",
    "clipPath",
    "color",
    "colorAdjust",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorRendering",
    "columnCount",
    "columnFill",
    "columnGap",
    "columnRule",
    "columnRuleColor",
    "columnRuleStyle",
    "columnRuleWidth",
    "columnSpan",
    "columnWidth",
    "columns",
    "contain",
    "content",
    "counterIncrement",
    "counterReset",
    "cursor",
    "direction",
    "display",
    "emptyCells",
    "filter",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexFlow",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "float",
    "font",
    "fontFamily",
    "fontFeatureSettings",
    "fontKerning",
    "fontLanguageOverride",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontVariantAlternates",
    "fontVariantCaps",
    "fontVariantEastAsian",
    "fontVariantNumeric",
    "fontVariantPosition",
    "fontWeight",
    "fontVariationSettings",
    "fontSynthesis",
    "forcedColorAdjust",
    "gap",
    "grid",
    "gridArea",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridColumn",
    "gridColumnEnd",
    "gridColumnGap",
    "gridColumnStart",
    "gridGap",
    "gridRow",
    "gridRowEnd",
    "gridRowGap",
    "gridRowStart",
    "gridTemplate",
    "gridTemplateAreas",
    "gridTemplateColumns",
    "gridTemplateRows",
    "height",
    "hyphens",
    "imageOrientation",
    "imageRendering",
    "imeMode",
    "inset",
    "insetBlock",
    "insetBlockEnd",
    "insetBlockStart",
    "insetInline",
    "insetInlineEnd",
    "insetInlineStart",
    "initialLetter",
    "isolation",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "left",
    "letterSpacing",
    "lineBreak",
    "lineClamp",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBlock",
    "marginBlockEnd",
    "marginBlockStart",
    "marginInline",
    "marginInlineEnd",
    "marginInlineStart",
    "mask",
    "maskBorder",
    "maskBorderImage",
    "maskBorderOutset",
    "maskBorderRepeat",
    "maskBorderSlice",
    "maskBorderSource",
    "maskBorderWidth",
    "maskClip",
    "maskComposite",
    "maskImage",
    "maskOrigin",
    "maskPosition",
    "maskRepeat",
    "maskSize",
    "maskType",
    "maxBlockSize",
    "maxHeight",
    "maxInlineSize",
    "maxWidth",
    "minBlockSize",
    "minHeight",
    "minInlineSize",
    "minWidth",
    "mixBlendMode",
    "objectFit",
    "objectPosition",
    "objectViewBox",
    "offset",
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "opacity",
    "order",
    "orientation",
    "outline",
    "outlineColor",
    "outlineOffset",
    "outlineStyle",
    "outlineWidth",
    "overflow",
    "overflowAnchor",
    "overflowClip",
    "overflowScrolling",
    "overflowWrap",
    "overflowX",
    "overflowY",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "pageBreakAfter",
    "pageBreakBefore",
    "pageBreakInside",
    "paintOrder",
    "perspective",
    "perspectiveOrigin",
    "placeContent",
    "placeItems",
    "placeSelf",
    "pointerEvents",
    "position",
    "resize",
    "right",
    "rotate",
    "rowGap",
    "scrollBehavior",
    "scrollPadding",
    "scrollSnapAlign",
    "scrollSnapType",
    "scrollbarColor",
    "scrollbarWidth",
    "shapeImageThreshold",
    "shapeMargin",
    "shapeOutside",
    "tabSize",
    "tableLayout",
    "textAlign",
    "textAlignLast",
    "textDecoration",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationSkipInk",
    "textDecorationStyle",
    "textDecorationThickness",
    "textIndent",
    "textOverflow",
    "textShadow",
    "textTransform",
    "textUnderlineOffset",
    "top",
    "transform",
    "transformOrigin",
    "transformStyle",
    "transition",
    "transitionDelay",
    "transitionDuration",
    "transitionProperty",
    "transitionTimingFunction",
    "translate",
    "translateX",
    "translateY",
    "translateZ",
    "unicodeBidi",
    "userSelect",
    "verticalAlign",
    "visibility",
    "whiteSpace",
    "widows",
    "width",
    "willChange",
    "wordBreak",
    "wordSpacing",
    "wordWrap",
    "writingMode",
    "zIndex"
]);



const $1bac589ee8a0f167$var$applyMediaProps = (key, selectorProps, element)=>{
    const { context: context } = element;
    if (!context.designSystem?.MEDIA) return;
    const mediaValue = context.designSystem.MEDIA[key.slice(1)];
    const generatedClass = (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element);
    const mediaKey = mediaValue ? "@media " + (mediaValue === "print" ? mediaValue : `screen and ${mediaValue}`) : key;
    return {
        [mediaKey]: generatedClass
    };
};
const $1bac589ee8a0f167$var$applyAndProps = (key, selectorProps, element)=>{
    return {
        [key]: (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element)
    };
};
const $1bac589ee8a0f167$var$applySelectorProps = (key, selectorProps, element)=>{
    const selectorKey = `&${key}`;
    return {
        [selectorKey]: (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element)
    };
};
const $1bac589ee8a0f167$var$applyCaseProps = (key, selectorProps, element)=>{
    const { CASES: CASES } = element.context?.designSystem || {};
    const caseKey = key.slice(1);
    const isCaseTrue = !CASES?.[caseKey] && !element.props[caseKey];
    if (!isCaseTrue) return;
    return (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element);
};
const $1bac589ee8a0f167$var$applyVariableProps = (key, selectorVal, element)=>{
    return {
        [key]: selectorVal
    };
};
const $1bac589ee8a0f167$var$applyConditionalCaseProps = (key, selectorProps, element)=>{
    const caseKey = key.slice(1);
    const isCaseTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (!isCaseTrue) return;
    return (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element);
};
const $1bac589ee8a0f167$var$applyConditionalFalsyProps = (key, selectorProps, element)=>{
    const caseKey = key.slice(1);
    const isCaseTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (isCaseTrue) return;
    return (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element);
};
const $1bac589ee8a0f167$export$c25acf0b55f6ed94 = (selectorProps, element)=>{
    return (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(selectorProps, element);
};
const $1bac589ee8a0f167$export$f635b795713db31b = {
    "@": $1bac589ee8a0f167$var$applyMediaProps,
    // Selector handlers
    ":": $1bac589ee8a0f167$var$applySelectorProps,
    "[": $1bac589ee8a0f167$var$applySelectorProps,
    "*": $1bac589ee8a0f167$var$applySelectorProps,
    "+": $1bac589ee8a0f167$var$applySelectorProps,
    "~": $1bac589ee8a0f167$var$applySelectorProps,
    "&": $1bac589ee8a0f167$var$applyAndProps,
    ">": $1bac589ee8a0f167$var$applyAndProps,
    // Conditional and variable handlers
    $: $1bac589ee8a0f167$var$applyCaseProps,
    "-": $1bac589ee8a0f167$var$applyVariableProps,
    ".": $1bac589ee8a0f167$var$applyConditionalCaseProps,
    "!": $1bac589ee8a0f167$var$applyConditionalFalsyProps
};


const $8205bd27fbc22bee$var$isProd = (0, $eo3lV.isProduction)();
const $8205bd27fbc22bee$export$e3ea26d70189bf39 = (sourceObj, element, opts)=>{
    let obj = {};
    const rest = {};
    const setToObj = (key, val)=>{
        if (opts.unpack) {
            obj = {
                ...obj,
                ...val
            };
            return;
        }
        obj[key] = val;
    };
    for(const key in sourceObj){
        const value = sourceObj[key];
        if (key === "class" && element.call("isString", sourceObj.class)) {
            const val = value.split(" ");
            if (val.length) {
                const CLASS = element.context.designSystem.CLASS;
                const result = val.reduce((acc, curr)=>(0, $g1LU2.merge)(acc, CLASS[curr]), {});
                obj.designSystemClass = result;
            }
        } else if (key === "true") {
            const val = (0, $g1LU2.exec)(value, element);
            (0, $g1LU2.merge)(obj, (0, $1bac589ee8a0f167$export$c25acf0b55f6ed94)(val, element));
        } else if (element.classlist[key]) {
            const originalFromClass = element.classlist[key];
            const result = (0, $e7Ezu.isFunction)(originalFromClass) ? originalFromClass(element, element.state, element.context) : originalFromClass;
            if (result) setToObj(key, result);
            if (!$8205bd27fbc22bee$var$isProd && (0, $e7Ezu.isObject)(obj[key])) obj[key].label = key;
        } else if ((0, $ba2ea636a01886dc$export$b474245a861fc144)[key]) {
            let val = (0, $g1LU2.exec)(value, element);
            if ((0, $e7Ezu.isArray)(val)) val = val.reduce((a, c)=>(0, $g1LU2.merge)(a, c), {});
            let result = (0, $ba2ea636a01886dc$export$b474245a861fc144)[key](val, element, element.state, element.context);
            if ((0, $e7Ezu.isArray)(result)) result = result.reduce((a, c)=>(0, $g1LU2.merge)(a, c), {});
            if (result) setToObj(key, result);
            if (!$8205bd27fbc22bee$var$isProd && (0, $e7Ezu.isObject)(obj[key])) obj[key].label = key;
        } else if ((0, $a9820eb8a8bd60cf$export$33f20e95f48422c).has(key)) {
            const result = (0, $g1LU2.exec)(value, element);
            setToObj(key, {
                [key]: result
            });
            if (!$8205bd27fbc22bee$var$isProd && (0, $e7Ezu.isObject)(obj[key])) obj[key].label = key;
        } else rest[key] = value;
    }
    return [
        obj,
        rest
    ];
};
const $8205bd27fbc22bee$export$274ca54883f83b56 = (sourceObj, element)=>{
    const obj = {};
    for(const key in sourceObj){
        const selectroSetter = (0, $1bac589ee8a0f167$export$f635b795713db31b)[key.slice(0, 1)];
        if (selectroSetter) {
            const result = selectroSetter(key, sourceObj[key], element);
            if (result) (0, $g1LU2.overwriteDeep)(obj, result);
        }
    }
    return obj;
};
const $8205bd27fbc22bee$export$42e1543b9cdeac7c = (selectorProps, element, opts = {
    unpack: true
})=>{
    const [cssObj, restProps] = $8205bd27fbc22bee$export$e3ea26d70189bf39(selectorProps, element, opts);
    const selectorsObj = $8205bd27fbc22bee$export$274ca54883f83b56(restProps, element);
    let hasSelectors = false;
    for(const _k in selectorsObj){
        hasSelectors = true;
        break;
    }
    if (hasSelectors) {
        if (opts.unpack) return (0, $g1LU2.overwrite)(cssObj, selectorsObj);
        cssObj._selectors = selectorsObj;
    }
    return cssObj;
};
const $8205bd27fbc22bee$export$2d3867789701917d = (component, element)=>{
    const classObj = {};
    if (component.class) for(const classProp in component.class)classObj[classProp] = component.class[classProp](element);
    return classObj;
};


'use strict';
// Main class assignment handler
const $c4098057d78edae9$var$onBeforeClassAssign = (element)=>{
    if (!element.context) return;
    const { props: props, __ref: ref } = element;
    ref.__class = (0, $8205bd27fbc22bee$export$42e1543b9cdeac7c)(props, element, {
        unpack: false
    });
};
const $c4098057d78edae9$export$e71c4d32a2263218 = {
    extends: [
        'Shape',
        'Theme'
    ],
    boxSizing: 'border-box',
    onBeforeClassAssign: $c4098057d78edae9$var$onBeforeClassAssign
};
const $c4098057d78edae9$export$c65504044f62f430 = {
    tag: 'hr',
    margin: 'C1 0'
};
const $c4098057d78edae9$export$9130f216d904f5ea = {
    tag: 'br'
};
const $c4098057d78edae9$export$4de39c9f3329bb96 = {
    tag: 'li'
};
const $c4098057d78edae9$export$d4f99c77eeffeaea = {
    tag: 'ul',
    childExtends: {
        extends: 'Li'
    }
};
const $c4098057d78edae9$export$60180a808b215c38 = {
    tag: 'ol',
    childExtends: {
        extends: 'Li'
    }
};


var $70c6d81ead918d7f$exports = {};

$parcel$export($70c6d81ead918d7f$exports, "Hgroup", () => $70c6d81ead918d7f$export$bd5b3f7ef3b94a4a);
$parcel$export($70c6d81ead918d7f$exports, "HgroupRows", () => $70c6d81ead918d7f$export$4c6ac4526c395f50);
$parcel$export($70c6d81ead918d7f$exports, "HgroupButton", () => $70c6d81ead918d7f$export$7fa5389f12735f1f);
'use strict';
const $70c6d81ead918d7f$export$bd5b3f7ef3b94a4a = {
    display: 'flex',
    tag: 'hgroup',
    flow: 'y',
    gap: 'Y2',
    H: {
        color: 'title',
        tag: 'h3',
        lineHeight: '1em',
        margin: '0'
    },
    P: {
        margin: '0',
        color: 'paragraph'
    }
};
const $70c6d81ead918d7f$export$4c6ac4526c395f50 = {
    extends: 'Hgroup',
    H: {
        display: 'flex',
        color: 'title',
        align: 'center space-between'
    },
    P: {
        color: 'paragraph',
        align: 'center space-between'
    }
};
const $70c6d81ead918d7f$export$7fa5389f12735f1f = {
    extends: 'HgroupRows',
    H: {
        justifyContent: 'space-between',
        Span: {},
        Button: {
            background: 'transparent',
            color: 'currentColor',
            padding: '0',
            Icon: {
                name: 'x',
                fontSize: 'C'
            }
        }
    },
    P: {}
};


'use strict';
$parcel$exportWildcard($73d59c6c3fce378b$exports, $40d382f435ee1fdb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c95002999fe11fd8$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f085155ee8a416c4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $0b0e26e2a21aab54$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c3656ade3a6fd1e0$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $80736e04e60e3fa1$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $7d36ad90912ad279$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c031e540a33546ea$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $23a4770c72ef76cc$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2ae1edf582b77174$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b448a4a1f1311a88$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c4098057d78edae9$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $70c6d81ead918d7f$exports);


var $f8a17223267b0208$exports = {};

$parcel$export($f8a17223267b0208$exports, "Icon", () => $f8a17223267b0208$export$f04a61298a47a40f);
$parcel$export($f8a17223267b0208$exports, "IconText", () => $f8a17223267b0208$export$fe7c634bfc18e397);
$parcel$export($f8a17223267b0208$exports, "FileIcon", () => $f8a17223267b0208$export$8c1a3d13e85d78b7);
'use strict';
const $f8a17223267b0208$var$inheritFromIsActive = (el)=>{
    const { props: props } = el;
    const propsActive = props['.isActive'];
    if (!propsActive) return;
    return el.call('exec', propsActive.name || propsActive.icon);
};
const $f8a17223267b0208$var$getIconName = (el, s)=>{
    const { key: key, props: props } = el;
    let icon = el.call('exec', props.name || props.icon || key, el);
    if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
    return el.call('isString', icon) ? icon : key;
};
const $f8a17223267b0208$export$f04a61298a47a40f = {
    extends: 'Svg',
    width: 'A',
    height: 'A',
    display: 'inline-block',
    style: {
        fill: 'currentColor',
        '*': {
            fill: 'currentColor'
        }
    },
    props: (el, s, ctx)=>{
        const { props: props, parent: parent } = el;
        const { ICONS: ICONS, useIconSprite: useIconSprite, verbose: verbose } = ctx && ctx.designSystem;
        const { toCamelCase: toCamelCase } = ctx && ctx.utils;
        const inheritFromIsActive = (el)=>{
            const { props: props } = el;
            const propsActive = props['.isActive'];
            if (!propsActive) return;
            return el.call('exec', propsActive.name || propsActive.icon);
        };
        const getSemanticIcon = (el, s, ctx)=>{
            const { SEMANTIC_ICONS: SEMANTIC_ICONS } = ctx && ctx.designSystem;
            const { toCamelCase: toCamelCase } = ctx && ctx.utils;
            let iconName = getIconName(el, s);
            const camelCase = toCamelCase(iconName);
            const isArray = camelCase.split(/([a-z])([A-Z])/g);
            const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
            const semanticIcon = SEMANTIC_ICONS && SEMANTIC_ICONS[semanticIconRootName];
            if (semanticIcon) {
                const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
                iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
                return {
                    tag: 'span',
                    semantic_symbols: true,
                    width: 'A',
                    height: 'A',
                    lineHeight: '1em',
                    ':after': {
                        fontSize: 'Z',
                        fontWeight: '300',
                        content: `"${iconName}"`,
                        textAlign: 'center',
                        display: 'inline-block',
                        style: {
                            color: 'currentColor',
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        };
        const getIconName = (el, s)=>{
            const { key: key, props: props } = el;
            let icon = el.call('exec', props.name || props.icon || key, el);
            if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
            return el.call('isString', icon) ? icon : key;
        };
        const iconName = getIconName(el, s);
        const camelCase = toCamelCase(iconName);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        const semanticIcon = getSemanticIcon(el, s, ctx);
        if (semanticIcon) return semanticIcon;
        let activeIconName;
        if (props.isActive) activeIconName = inheritFromIsActive(el);
        const parentProps = parent.props;
        const parentPropsActive = parentProps['.isActive'];
        if (parent && parentProps && parentProps.isActive && parentPropsActive && parentPropsActive.icon) activeIconName = el.call('exec', parentPropsActive.icon || parentPropsActive.Icon.name || parentPropsActive.Icon.icon, el);
        if (el.call('isString', activeIconName) && activeIconName.includes('{{')) activeIconName = el.call('replaceLiteralsWithObjectFields', activeIconName);
        let iconInContext;
        if (ICONS[activeIconName]) iconInContext = activeIconName;
        if (ICONS[camelCase]) iconInContext = camelCase;
        else if (ICONS[isArray[0] + isArray[1]]) iconInContext = isArray[0] + isArray[1];
        else if (ICONS[isArray[0]]) iconInContext = isArray[0];
        else if (verbose) el.warn("Can't find icon:", iconName, iconInContext);
        const iconFromLibrary = ICONS[iconInContext];
        const directSrc = parent && parent.props && parent.props.src || props.src;
        return {
            spriteId: useIconSprite && iconInContext,
            src: iconFromLibrary || directSrc || ICONS.noIcon
        };
    },
    attr: {
        viewBox: '0 0 24 24'
    }
};
const $f8a17223267b0208$export$fe7c634bfc18e397 = {
    display: 'flex',
    align: 'center center',
    lineHeight: 1,
    '.reversed': {
        flow: 'row-reverse'
    },
    '.vertical': {
        flow: 'column'
    },
    Icon: {
        if: (el)=>{
            const { parent: parent, props: props } = el;
            return el.call('exec', parent.props.icon || props.name || props.sfSymbols || parent.props.sfSymbols, el);
        },
        icon: (el)=>el.call('exec', el.parent.props.icon, el.parent)
    },
    text: ({ props: props })=>props.text
};
const $f8a17223267b0208$export$8c1a3d13e85d78b7 = {
    display: 'flex',
    theme: 'tertiary',
    boxSize: 'C1',
    align: 'center center',
    round: 'Z',
    Icon: {
        fontSize: 'B',
        margin: 'auto',
        icon: 'file'
    }
};
const $f8a17223267b0208$var$getSemanticIcon = (el, s, ctx)=>{
    const { SEMANTIC_ICONS: SEMANTIC_ICONS } = ctx && ctx.designSystem;
    const { toCamelCase: toCamelCase } = ctx && ctx.utils;
    let iconName = $f8a17223267b0208$var$getIconName(el, s);
    const camelCase = toCamelCase(iconName);
    const isArray = camelCase.split(/([a-z])([A-Z])/g);
    const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
    const semanticIcon = SEMANTIC_ICONS && SEMANTIC_ICONS[semanticIconRootName];
    if (semanticIcon) {
        const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
        iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
        return {
            tag: 'span',
            semantic_symbols: true,
            width: 'A',
            height: 'A',
            lineHeight: '1em',
            ':after': {
                fontSize: 'Z',
                fontWeight: '300',
                content: `"${iconName}"`,
                textAlign: 'center',
                display: 'inline-block',
                style: {
                    color: 'currentColor',
                    fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                }
            }
        };
    }
};


var $59e9b7f5a8955db9$exports = {};

$parcel$export($59e9b7f5a8955db9$exports, "Link", () => $59e9b7f5a8955db9$export$a6c7ac8248d6e38a);
$parcel$export($59e9b7f5a8955db9$exports, "A", () => $59e9b7f5a8955db9$export$ebd11618f299a286);
$parcel$export($59e9b7f5a8955db9$exports, "RouterLink", () => $59e9b7f5a8955db9$export$fce709ebdac448ed);
$parcel$export($59e9b7f5a8955db9$exports, "RouteLink", () => $59e9b7f5a8955db9$export$9a6dc2d0fce7da79);
var $32a808518113ee1c$exports = {};

$parcel$defineInteropFlag($32a808518113ee1c$exports);

$parcel$export($32a808518113ee1c$exports, "parseRoutePattern", () => $32a808518113ee1c$export$c1d2f753e345bfd);
$parcel$export($32a808518113ee1c$exports, "matchRoute", () => $32a808518113ee1c$export$b4ee0d6794375c82);
$parcel$export($32a808518113ee1c$exports, "parseQuery", () => $32a808518113ee1c$export$1e8473eaf75b0d10);
$parcel$export($32a808518113ee1c$exports, "runGuards", () => $32a808518113ee1c$export$6b398ed5c45e580b);
$parcel$export($32a808518113ee1c$exports, "getActiveRoute", () => $32a808518113ee1c$export$e7a685f330e7752);
$parcel$export($32a808518113ee1c$exports, "lastPathname", () => $32a808518113ee1c$export$7a9e7a91cdf4fce1);
$parcel$export($32a808518113ee1c$exports, "lastLevel", () => $32a808518113ee1c$export$ed098f724085d263);
$parcel$export($32a808518113ee1c$exports, "router", () => $32a808518113ee1c$export$5375cda95f0b0eb4);
$parcel$export($32a808518113ee1c$exports, "default", () => $32a808518113ee1c$export$2e2bcd8739ae039);
parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");
var $b4h11 = parcelRequire("b4h11");
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $j7W2w = parcelRequire("j7W2w");
parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
var $1jKby = parcelRequire("1jKby");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
const $b9c13c206b64d15a$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    if (onEvent) return onEvent;
    const props = element.props;
    if (!props) return;
    const propKey = 'on' + param.charAt(0).toUpperCase() + param.slice(1);
    return props[propKey];
};
const $b9c13c206b64d15a$var$registerNodeEvent = (param, element, node, options)=>{
    const appliedFunction = $b9c13c206b64d15a$var$getOnOrPropsEvent(param, element);
    if ((0, $e7Ezu.isFunction)(appliedFunction)) {
        const { __ref: ref } = element;
        if (!ref.__eventListeners) ref.__eventListeners = {};
        // Remove previous listener for this event to avoid duplicates
        if (ref.__eventListeners[param]) node.removeEventListener(param, ref.__eventListeners[param]);
        const handler = (event)=>{
            const { state: state, context: context } = element;
            try {
                const result = appliedFunction.call(element, event, element, state, context, options);
                if (result && typeof result.then === 'function') result.catch((err)=>{
                    element.error = err;
                    console.error('[DomQL] Async DOM event error:', err);
                });
            } catch (err) {
                element.error = err;
                console.error('[DomQL] DOM event error:', err);
                if (context?.strictMode) throw err;
            }
        };
        ref.__eventListeners[param] = handler;
        node.addEventListener(param, handler);
    }
};
const $b9c13c206b64d15a$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on, props: props } = element;
    const handled = new Set();
    // Register events from on: { click: ..., input: ... }
    for(const param in on){
        if ((0, $1jKby.DOMQL_EVENTS).has(param)) continue;
        handled.add(param);
        $b9c13c206b64d15a$var$registerNodeEvent(param, element, node, options);
    }
    // Also pick up props.onClick, props.onInput, etc.
    if (props) {
        for(const key in props)if (key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && (0, $e7Ezu.isFunction)(props[key])) {
            const thirdChar = key[2];
            if (thirdChar !== thirdChar.toUpperCase()) continue;
            const eventName = thirdChar.toLowerCase() + key.slice(3);
            if (handled.has(eventName) || (0, $1jKby.DOMQL_EVENTS).has(eventName)) continue;
            $b9c13c206b64d15a$var$registerNodeEvent(eventName, element, node, options);
        }
    }
};

parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $3GLOu = parcelRequire("3GLOu");
'use strict';
const $11a8b378b730acc1$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    for(const v in props){
        if (v.charCodeAt(0) !== 111 || v.charCodeAt(1) !== 110) continue; // 'on'
        const eventName = (0, $3GLOu.lowercaseFirstLetter)(v.slice(2));
        const origEvent = on[eventName];
        const funcFromProps = props[v];
        if ((0, $e7Ezu.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const originalEventRetunrs = origEvent(...args);
            if (originalEventRetunrs !== false) return funcFromProps(...args);
        };
        else on[eventName] = funcFromProps;
    }
};
const $11a8b378b730acc1$export$703a2b3ea711c09d = (element)=>{
    const { on: on } = element;
    for(const param in element){
        if (param.charCodeAt(0) !== 111 || param.charCodeAt(1) !== 110 || !Object.prototype.hasOwnProperty.call(element, param)) continue;
        const fn = element[param];
        if (!(0, $e7Ezu.isFunction)(fn)) continue;
        const eventName = (0, $3GLOu.lowercaseFirstLetter)(param.slice(2));
        const origEvent = on[eventName];
        if ((0, $e7Ezu.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const ret = origEvent(...args);
            if (ret !== false) return fn(...args);
        };
        else on[eventName] = fn;
    }
};


var $06908963bda72849$exports = {};

$parcel$export($06908963bda72849$exports, "ERRORS_REGISTRY", () => $06908963bda72849$export$fc4da02de2c0bd43);
$parcel$export($06908963bda72849$exports, "report", () => $06908963bda72849$export$f18d5b0af29128b7);
'use strict';
const $06908963bda72849$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: 'Document is undefined',
            description: 'To tweak with DOM, you should use browser.'
        },
        OverwriteToBuiltin: {
            title: 'Overwriting to builtin method',
            description: 'Overwriting a builtin method in the window define is not possible, please choose different name'
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: 'Environment should be browser application, that can run Javascript'
        },
        SetQuickPreferancesIsNotObject: {
            title: 'Quick preferances object is required',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: 'Params are invalid',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: 'You must provide node',
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: 'Element tag name (or DOM nodeName) is invalid',
            description: 'To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/'
        },
        HTMLInvalidAttr: {
            title: 'Attibutes object is invalid',
            description: 'Please pass a valid plain object to apply as an attributes for a DOM node'
        },
        HTMLInvalidData: {
            title: 'Data object is invalid',
            description: 'Please pass a valid plain object to apply as an dataset for a DOM node'
        },
        HTMLInvalidStyles: {
            title: 'Styles object is invalid',
            description: 'Please pass a valid plain object to apply as an style for a DOM node'
        },
        HTMLInvalidText: {
            title: 'Text string is invalid',
            description: 'Please pass a valid string to apply text to DOM node'
        },
        ElementOnStateIsNotDefined: {
            title: 'Element on state is not defined',
            description: 'Please check the element object'
        }
    }
};
const $06908963bda72849$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = 'en';
    let errObj;
    if (err && typeof err === 'string') errObj = $06908963bda72849$export$fc4da02de2c0bd43[currentLang][err];
    const description = errObj ? `\n\n${errObj.description}` : '';
    const context = element ? `\n\n${element}` : '';
    return new Error(`"${err}", "${arg}"${description}${context}`);
};



parcelRequire("jgAqB");
var $03PwY = parcelRequire("03PwY");
'use strict';
const $4b71555204315368$export$342a7615681b7118 = (tag)=>{
    return (0, $03PwY.isValidHtmlTag)(tag || 'div') || (0, $06908963bda72849$export$f18d5b0af29128b7)('HTMLInvalidTag');
};


parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $03PwY = parcelRequire("03PwY");
'use strict';
const $adbe6f4c6817c2d2$var$SVG_NS = 'http://www.w3.org/2000/svg';
const $adbe6f4c6817c2d2$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag, context: context } = element;
    const doc = context.document || (0, $bD06b.document);
    if (tag) {
        if (tag === 'string') return doc.createTextNode(element.text);
        else if (tag === 'fragment') return doc.createDocumentFragment();
        else if ((0, $03PwY.SVG_TAGS).has(tag)) {
            if (tag === 'svg' || element.parent?.node?.namespaceURI === $adbe6f4c6817c2d2$var$SVG_NS) return doc.createElementNS($adbe6f4c6817c2d2$var$SVG_NS, tag);
            return doc.createElement(tag);
        } else return doc.createElement(tag);
    } else return doc.createElement('div');
};
const $adbe6f4c6817c2d2$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $g1LU2.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $e7Ezu.isObject)(props) && (0, $e7Ezu.isString)(props.tag)) {
        const tagExists = (0, $03PwY.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $e7Ezu.isString)(tag)) {
        if ((0, $03PwY.isValidHtmlTag)(tag)) return tag;
    } else {
        let keyAsTag = key.toLowerCase();
        if (keyAsTag.includes('.')) keyAsTag = keyAsTag.split('.')[0];
        if (keyAsTag.includes('_')) keyAsTag = keyAsTag.split('_')[0];
        if ((0, $03PwY.isValidHtmlTag)(keyAsTag)) return keyAsTag;
    }
    return 'div';
};
const $adbe6f4c6817c2d2$export$257247f9c0329159 = (element)=>{
    const { context: context } = element;
    const win = context.window || window;
    const tag = element.tag = $adbe6f4c6817c2d2$export$5075bd4eae016d2c(element);
    if (!(0, $4b71555204315368$export$342a7615681b7118)(tag)) return (0, $06908963bda72849$export$f18d5b0af29128b7)('HTMLInvalidTag', element.tag, element);
    if (!win.nodeCaches) win.nodeCaches = {};
    const isSvgContext = (0, $03PwY.SVG_TAGS).has(tag) && (tag === 'svg' || element.parent?.node?.namespaceURI === $adbe6f4c6817c2d2$var$SVG_NS);
    const cacheKey = isSvgContext ? 'svg:' + tag : tag;
    let cachedTag = win.nodeCaches[cacheKey];
    if (!cachedTag) cachedTag = win.nodeCaches[cacheKey] = $adbe6f4c6817c2d2$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === 'string') clonedNode.nodeValue = element.text;
    return clonedNode;
};



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $iPYI6 = parcelRequire("iPYI6");
var $e7Ezu = parcelRequire("e7Ezu");
var $j7W2w = parcelRequire("j7W2w");
'use strict';
const $0513b3ed7d5404ec$export$3223a9877c540db8 = (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $e7Ezu.isFunction)(prop) && !(0, $j7W2w.isMethod)(param, element)) {
            ref.__exec[param] = prop;
            const result = prop(element, element.state, element.context);
            if (result && typeof result.then === 'function') result.then((resolved)=>{
                element[param] = resolved;
            });
            else element[param] = result;
        }
    }
};
const $0513b3ed7d5404ec$export$2ad800d85590910f = (element, options = {})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = ref.__exec[param](element, element.state, element.context);
        if (newExec && typeof newExec.then === 'function') {
            newExec.then((resolved)=>{
                element[param] = resolved;
            });
            continue;
        }
        const execReturnsString = (0, $e7Ezu.isString)(newExec) || (0, $e7Ezu.isNumber)(newExec);
        if (prop?.node && execReturnsString) (0, $g1LU2.overwrite)(prop, {
            text: newExec
        });
        else if (newExec !== prop) {
            if ((0, $iPYI6.matchesComponentNaming)(param)) {
                const { extends: extend, ...newElem } = (0, $iPYI6.isContextComponent)(newExec, element, param);
                (0, $g1LU2.overwrite)(prop, newElem);
            } else {
                changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $0513b3ed7d5404ec$export$23077649cd9ebd4b = (element)=>{
    const { __ref: ref } = element;
    const { props: props } = element;
    for(const k in props){
        // Check for 'is', 'has', 'use' prefixes using charCodeAt
        const c0 = k.charCodeAt(0);
        const c1 = k.charCodeAt(1);
        const isDefine = c0 === 105 && c1 === 115 || // 'is'
        c0 === 104 && c1 === 97 && k.charCodeAt(2) === 115 || // 'has'
        c0 === 117 && c1 === 115 && k.charCodeAt(2) === 101 // 'use'
        ;
        const cachedExecProp = ref.__execProps[k];
        if ((0, $e7Ezu.isFunction)(cachedExecProp)) {
            const result = (0, $g1LU2.exec)(cachedExecProp, element);
            if (result && typeof result.then === 'function') result.then((resolved)=>{
                props[k] = resolved;
            });
            else props[k] = result;
        } else if (isDefine && (0, $e7Ezu.isFunction)(props[k])) {
            ref.__execProps[k] = props[k];
            const result = (0, $g1LU2.exec)(props[k], element);
            if (result && typeof result.then === 'function') result.then((resolved)=>{
                props[k] = resolved;
            });
            else props[k] = result;
        }
    }
};
const $0513b3ed7d5404ec$export$b4c781127351659b = (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    const hasLocalDefine = (0, $e7Ezu.isObject)(define);
    const hasGlobalDefine = context && (0, $e7Ezu.isObject)(context.define);
    if (!hasLocalDefine && !hasGlobalDefine) return element;
    const defineObj = hasLocalDefine && hasGlobalDefine ? {
        ...define,
        ...context.define
    } : hasLocalDefine ? define : context.define;
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $e7Ezu.isFunction)(elementProp) && !(0, $j7W2w.isMethod)(param, element)) {
            ref.__exec[param] = elementProp;
            let execParam = (0, $g1LU2.exec)(elementProp, element);
            if (execParam && typeof execParam.then === 'function') execParam.then((resolved)=>{
                elementProp = element[param] = resolved && resolved.parse ? resolved.parse() : resolved;
                if (resolved) ref.__defineCache[param] = elementProp;
            });
            else {
                elementProp = element[param] = execParam && execParam.parse ? execParam.parse() : execParam;
                if (execParam) ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = defineObj[param](elementProp, element, element.state, element.context);
        if (execParam && typeof execParam.then === 'function') execParam.then((resolved)=>{
            if (resolved) element[param] = resolved;
        });
        else if (execParam) element[param] = execParam;
    }
    return element;
};
const $0513b3ed7d5404ec$export$88eda8a7eb5c5eff = (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const hasLocalDefine = (0, $e7Ezu.isObject)(define);
    const hasGlobalDefine = (0, $e7Ezu.isObject)(context?.define);
    if (!hasLocalDefine && !hasGlobalDefine) return;
    const obj = hasLocalDefine && hasGlobalDefine ? {
        ...define,
        ...context.define
    } : hasLocalDefine ? define : context.define;
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) {
            const result = execParam(element, element.state, element.context);
            if (result && typeof result.then === 'function') result.then((resolved)=>{
                ref.__defineCache[param] = resolved;
            });
            else ref.__defineCache[param] = result;
        }
        const cached = (0, $g1LU2.exec)(ref.__defineCache[param], element);
        if (cached && typeof cached.then === 'function') {
            cached.then((resolved)=>{
            // Optionally assign or use resolved value if needed
            });
            continue;
        }
        const newExecParam = typeof obj[param] === 'function' ? obj[param](cached, element, element.state, element.context) : undefined;
        if (newExecParam && typeof newExecParam.then === 'function') newExecParam.then((resolved)=>{
            element[param] = resolved;
        });
        else if (newExecParam) element[param] = newExecParam;
    }
};


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

'use strict';
function $781ba30c522cf3e7$export$7aabe8b3a840d2fd(params, element, node) {
    const { __ref: ref, props: props } = element;
    const { __attr: __attr } = ref;
    if ((0, $e7Ezu.isNot)(params)('object')) (0, $06908963bda72849$export$f18d5b0af29128b7)('HTMLInvalidAttr', params);
    if (params) {
        const attrs = (0, $g1LU2.exec)(params, element);
        if (props.attr) (0, $g1LU2.deepMerge)(attrs, props.attr);
        for(const attr in attrs){
            const val = (0, $g1LU2.exec)(attrs[attr], element);
            if (val === __attr[attr]) continue;
            if (val !== false && val !== undefined && val !== null && node.setAttribute) node.setAttribute(attr, val);
            else if (node.removeAttribute) node.removeAttribute(attr);
            __attr[attr] = val;
        }
    }
}
var $781ba30c522cf3e7$export$2e2bcd8739ae039 = $781ba30c522cf3e7$export$7aabe8b3a840d2fd;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
const $6a43953e96d89b45$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.classlist === true) element.classlist = key;
    else if (!element.classlist && typeof key === 'string' && key.charAt(0) === '_' && key.charAt(1) !== '_') element.classlist = key.slice(1);
};
const $6a43953e96d89b45$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $g1LU2.exec)(param, element)}`;
    }
    return className;
};
const $6a43953e96d89b45$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.classlist = {
        key: key
    };
    if ((0, $e7Ezu.isString)(params)) params = element.classlist = {
        default: params
    };
    if ((0, $e7Ezu.isObject)(params)) params = $6a43953e96d89b45$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, ' ').trim();
    return className;
};
const $6a43953e96d89b45$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $6a43953e96d89b45$export$11c615ce16f87241(params, element);
    const { __ref: __ref } = element;
    if (className === __ref.__className) return className;
    __ref.__className = className;
    // Use setAttribute for universal SVG/HTML compatibility
    if (node && typeof node.setAttribute === 'function') node.setAttribute('class', className);
    else if (node) try {
        node.className = className;
    } catch (e) {}
    return className;
};
function $6a43953e96d89b45$export$f1a8a7f322d4587c(params, element, node) {
    $6a43953e96d89b45$export$e8f750c9f10c0a7b(params, element, node);
}
var $6a43953e96d89b45$export$2e2bcd8739ae039 = $6a43953e96d89b45$export$f1a8a7f322d4587c;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

'use strict';
function $e4aeb17327021212$export$4051a07651545597(params, element, node) {
    if (params) {
        if (element.props.data) (0, $g1LU2.deepMerge)(params, element.props.data);
        if (params.showOnNode) {
            if (!(0, $e7Ezu.isObject)(params)) (0, $06908963bda72849$export$f18d5b0af29128b7)('HTMLInvalidData', params);
            // Apply data params on node
            for(const dataset in params)if (dataset !== 'showOnNode') node.dataset[dataset] = (0, $g1LU2.exec)(params[dataset], element);
        }
    }
}
var $e4aeb17327021212$export$2e2bcd8739ae039 = $e4aeb17327021212$export$4051a07651545597;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
'use strict';
function $1591488d379f80a7$export$c0bb0b647f701bb5(param, element, node) {
    const prop = (0, $g1LU2.exec)(param ?? element?.props?.html, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        if (node.nodeName === 'SVG') node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
}
var $1591488d379f80a7$export$2e2bcd8739ae039 = $1591488d379f80a7$export$c0bb0b647f701bb5;


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
function $d1bc0a58271a837c$export$5cff813ca8e50db9(params, element, node) {
    if (!(0, $e7Ezu.isObject)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $e7Ezu.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
}
var $d1bc0a58271a837c$export$2e2bcd8739ae039 = $d1bc0a58271a837c$export$5cff813ca8e50db9;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $1jKby = parcelRequire("1jKby");
'use strict';
function $4a610b4ab9f6f506$export$ca000e230c0caa3e(params, element, node) {
    const state = (0, $g1LU2.exec)(params, element);
    if ((0, $e7Ezu.isObject)(state)) for(const param in state){
        if ((0, $1jKby.STATE_METHODS).has(param)) continue;
        if (!Object.prototype.hasOwnProperty.call(state, param)) continue;
    }
    return element;
}
var $4a610b4ab9f6f506$export$2e2bcd8739ae039 = $4a610b4ab9f6f506$export$ca000e230c0caa3e;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

'use strict';
function $479abf9e8c0e6739$export$1d567c320f4763bc(params, element, node) {
    if (params) {
        if ((0, $e7Ezu.isObject)(params)) {
            const { __ref: __ref } = element;
            if (!__ref.__style) __ref.__style = {};
            const cache = __ref.__style;
            for(const prop in params){
                const val = (0, $g1LU2.exec)(params[prop], element);
                if (val === cache[prop]) continue;
                cache[prop] = val;
                node.style[prop] = val;
            }
        } else (0, $06908963bda72849$export$f18d5b0af29128b7)('HTMLInvalidStyles', params);
    }
}
var $479abf9e8c0e6739$export$2e2bcd8739ae039 = $479abf9e8c0e6739$export$1d567c320f4763bc;



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $03PwY = parcelRequire("03PwY");
'use strict';
function $19f4b3c5f241581d$export$6f093cfa640b7166(param, element, node) {
    let prop = (0, $g1LU2.exec)(element.props.text || param, element);
    if ((0, $e7Ezu.isString)(prop) && prop.includes('{{')) prop = element.call('replaceLiteralsWithObjectFields', prop, element.state);
    if (element.tag === 'string') node.nodeValue = prop;
    else if (param !== undefined && param !== null) {
        // SVG elements don't support appending text nodes as children
        if ((0, $03PwY.SVG_TAGS).has(element.tag)) {
            if (node) node.textContent = prop;
            return;
        }
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $947d5c063e68e91c$export$185802fd694ee1f5)({
            tag: 'string',
            text: prop
        }, element, '__text');
    }
}
var $19f4b3c5f241581d$export$2e2bcd8739ae039 = $19f4b3c5f241581d$export$6f093cfa640b7166;


'use strict';
const $782cf63e523d0885$export$21cc2ed387caee94 = {
    attr: $781ba30c522cf3e7$export$7aabe8b3a840d2fd,
    style: $479abf9e8c0e6739$export$2e2bcd8739ae039,
    text: $19f4b3c5f241581d$export$2e2bcd8739ae039,
    html: $1591488d379f80a7$export$2e2bcd8739ae039,
    data: $e4aeb17327021212$export$2e2bcd8739ae039,
    classlist: (0, $6a43953e96d89b45$export$11c615ce16f87241),
    state: $4a610b4ab9f6f506$export$2e2bcd8739ae039,
    scope: $d1bc0a58271a837c$export$2e2bcd8739ae039,
    deps: (param, el)=>param || el.parent.deps,
    extends: {},
    children: {},
    content: {},
    childExtend: {},
    childExtends: {},
    childExtendRecursive: {},
    childExtendsRecursive: {},
    props: {},
    if: {},
    define: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    variables: {},
    on: {},
    component: {},
    context: {}
};
var $782cf63e523d0885$export$2e2bcd8739ae039 = $782cf63e523d0885$export$21cc2ed387caee94;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

'use strict';
const $88e1be01eff6bc07$export$535107f3c159da5d = (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = (0, $g1LU2.exec)(element[param], element);
    const { onlyUpdate: onlyUpdate } = options;
    const DOMQLProperty = (0, $782cf63e523d0885$export$21cc2ed387caee94)[param];
    const DOMQLPropertyFromContext = context?.registry?.[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define?.[param];
    const hasContextDefine = context?.define?.[param];
    if (!ref.__if) return;
    const hasOnlyUpdate = onlyUpdate ? onlyUpdate === param || element.lookup(onlyUpdate) : true;
    if (isGlobalTransformer && !hasContextDefine && hasOnlyUpdate) {
        if ((0, $e7Ezu.isFunction)(isGlobalTransformer)) isGlobalTransformer(prop, element, node, options);
        return;
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};


parcelRequire("jgAqB");
var $7gXxj = parcelRequire("7gXxj");
var $g1LU2 = parcelRequire("g1LU2");
var $lw6SS = parcelRequire("lw6SS");
var $e7Ezu = parcelRequire("e7Ezu");
var $iPYI6 = parcelRequire("iPYI6");
'use strict';
const $98828bcde53bce97$var$deepChildrenEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const typeA = typeof a;
    const typeB = typeof b;
    // Functions in children data are structural definitions (event handlers,
    // conditions) that get new references each call but are logically equal
    if (typeA === 'function' && typeB === 'function') return true;
    if (typeA !== typeB) return false;
    if ((0, $e7Ezu.isArray)(a) && (0, $e7Ezu.isArray)(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$98828bcde53bce97$var$deepChildrenEqual(a[i], b[i])) return false;
        }
        return true;
    }
    if ((0, $e7Ezu.isObject)(a) && (0, $e7Ezu.isObject)(b)) {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        for(let i = 0; i < keysA.length; i++){
            const key = keysA[i];
            if (!$98828bcde53bce97$var$deepChildrenEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
};
function $98828bcde53bce97$export$d4cb3dfdb7a8fc7d(param, element, opts) {
    let { children: children, __ref: ref, state: state } = element;
    let { childrenAs: childrenAs } = element.props || {};
    let execParam = (0, $g1LU2.exec)(param, element, state);
    let execChildren = (0, $g1LU2.exec)(children, element, state);
    children = execParam || execChildren;
    if (children) {
        if ((0, $lw6SS.isState)(children)) children = children.parse();
        if ((0, $e7Ezu.isString)(children) || (0, $e7Ezu.isNumber)(children)) {
            if (children === 'state') children = state.parse();
            else {
                const pathInState = (0, $lw6SS.getChildStateInKey)(children, state);
                if (pathInState) {
                    childrenAs = 'state';
                    children = (0, $lw6SS.getChildStateInKey)(children, state) || {
                        value: children
                    };
                } else children = {
                    text: children
                };
            }
        }
        if ((0, $e7Ezu.isObject)(children)) {
            if (children.$$typeof) return element.call('renderReact', children, element);
            children = Object.keys(children).map((v)=>{
                const val = children[v];
                if ((0, $iPYI6.matchesComponentNaming)(v)) return (0, $7gXxj.concatAddExtends)(v, val);
                return val;
            });
        }
    }
    if (!children || (0, $e7Ezu.isNot)(children)('array', 'object')) return;
    if ((0, $e7Ezu.isArray)(children) && children.some((v)=>v?.$$typeof)) {
        const filterReact = [];
        const reactComponents = [];
        for(let i = 0; i < children.length; i++)if (children[i]?.$$typeof) reactComponents.push(children[i]);
        else filterReact.push(children[i]);
        if (reactComponents.length) element.call('renderReact', reactComponents, element);
        children = filterReact;
    }
    let cloned;
    if (ref.__childrenCache) {
        if ($98828bcde53bce97$var$deepChildrenEqual(children, ref.__childrenCache)) ref.__noChildrenDifference = true;
        else {
            cloned = (0, $g1LU2.deepClone)(children);
            ref.__childrenCache = cloned;
            delete ref.__noChildrenDifference;
        }
    } else {
        cloned = (0, $g1LU2.deepClone)(children);
        ref.__childrenCache = cloned;
    // First evaluation during update - no cache to compare against, so don't
    // assume children match. State-dependent children may have changed since creation.
    }
    if ((0, $e7Ezu.isObject)(children) || (0, $e7Ezu.isArray)(children)) children = cloned || (0, $g1LU2.deepClone)(children);
    const content = {
        tag: 'fragment'
    };
    for(const key in children){
        const value = Object.prototype.hasOwnProperty.call(children, key) && children[key];
        if ((0, $e7Ezu.isDefined)(value) && value !== null && value !== false) content[key] = (0, $e7Ezu.isObjectLike)(value) ? childrenAs ? {
            [childrenAs]: value
        } : value : childrenAs ? {
            [childrenAs]: childrenAs === 'state' ? {
                value: value
            } : {
                text: value
            }
        } : {
            text: value
        };
    }
    return content;
}
var $98828bcde53bce97$export$2e2bcd8739ae039 = $98828bcde53bce97$export$d4cb3dfdb7a8fc7d;



'use strict';
const $4e214d02be0ddce7$var$ENV = "production";
const $4e214d02be0ddce7$export$270e7ba5936d3c48 = (element, opts)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    if (!ref.__if) return element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (tag === 'shadow') node = element.node = element.parent.node.attachShadow({
            mode: 'open'
        });
        else node = element.node = (0, $adbe6f4c6817c2d2$export$257247f9c0329159)(element);
        // trigger `on.attachNode`
        (0, $b4h11.triggerEventOn)('attachNode', element, opts);
    }
    // node.dataset // .key = element.key
    if ($4e214d02be0ddce7$var$ENV === 'test' || $4e214d02be0ddce7$var$ENV === 'development' || opts.alowRefReference) {
        node.ref = element;
        if ((0, $e7Ezu.isFunction)(node.setAttribute)) node.setAttribute('key', element.key);
    }
    // iterate through exec props
    (0, $0513b3ed7d5404ec$export$23077649cd9ebd4b)(element);
    // iterate through define
    (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
    // iterate through exec
    (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
    (0, $11a8b378b730acc1$export$e43138af17da316d)(element);
    (0, $11a8b378b730acc1$export$703a2b3ea711c09d)(element);
    (0, $b9c13c206b64d15a$export$1f7cb486ba1f8a10)(element, {
        isNewNode: isNewNode,
        ...opts
    });
    for(const param in element){
        const value = element[param];
        if (!Object.prototype.hasOwnProperty.call(element, param) || value === undefined || (0, $j7W2w.isMethod)(param, element) || (0, $e7Ezu.isObject)((0, $782cf63e523d0885$export$21cc2ed387caee94)[param]) || param.length > 2 && param.charCodeAt(0) === 111 && param.charCodeAt(1) === 110 && param.charCodeAt(2) >= 65 && param.charCodeAt(2) <= 90) continue;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, opts);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            if (element[param] && !hasDefine && !hasContextDefine) {
                const createAsync = ()=>{
                    (0, $947d5c063e68e91c$export$185802fd694ee1f5)(value, element, param, opts);
                };
                // TODO: test this with promise
                // handle lazy load
                if (element.props && element.props.lazyLoad || opts.lazyLoad) window.requestAnimationFrame(()=>{
                    createAsync();
                    if (!opts.preventUpdateListener) (0, $b4h11.triggerEventOn)('lazyLoad', element, opts);
                });
                else createAsync();
            }
        }
    }
    const content = element.children ? (0, $98828bcde53bce97$export$2e2bcd8739ae039)(element.children, element, opts) : element.children || element.content;
    if (content) (0, $bf937aebc888d68f$export$431313f2afd011e2)(content, element, opts);
    // node.dataset.key = key
    return element;
};
var $4e214d02be0ddce7$export$2e2bcd8739ae039 = $4e214d02be0ddce7$export$270e7ba5936d3c48;


parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");

'use strict';
const $80563b8eaf6ba844$export$fbea82a1c0574ef4 = {
    key: ':root',
    node: (0, $bD06b.document) ? (0, $bD06b.document).body : (0, $06908963bda72849$export$f18d5b0af29128b7)('DocumentNotDefined', (0, $bD06b.document))
};
const $80563b8eaf6ba844$export$33ecaa422889cd80 = $80563b8eaf6ba844$export$fbea82a1c0574ef4;


parcelRequire("jgAqB");
var $7gXxj = parcelRequire("7gXxj");
var $81M4S = parcelRequire("81M4S");
var $bvmdI = parcelRequire("bvmdI");
var $5ORwk = parcelRequire("5ORwk");
var $g1LU2 = parcelRequire("g1LU2");
var $5zx8x = parcelRequire("5zx8x");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");
var $j7W2w = parcelRequire("j7W2w");
'use strict';
const $53eb18049026e4da$export$a9e0446239e28a61 = (el)=>{
    if (!el || !el.__ref) throw new Error('Element reference is invalid');
    const { __ref: ref } = el;
    if (!ref.root) throw new Error('Root reference is invalid');
    if (!ref.root.data) throw new Error('Data are undefined');
    const { frameListeners: frameListeners } = ref.root.data;
    // Check if frameListeners exists and the element is not already in the Set
    if (frameListeners && !frameListeners.has(el)) frameListeners.add(el) // Add the element to the Set
    ;
};
const $53eb18049026e4da$var$processFrameListeners = (frameListeners)=>{
    for (const element of frameListeners){
        // Cache the handler on first use to avoid repeated property lookups per frame
        if (!element.__ref.__frameHandler) {
            const handler = element.on?.frame || element.onFrame || element.props?.onFrame;
            if (handler) element.__ref.__frameHandler = handler;
            else {
                frameListeners.delete(element);
                continue;
            }
        }
        if (!element.node?.parentNode) {
            frameListeners.delete(element);
            delete element.__ref.__frameHandler;
        } else try {
            element.__ref.__frameHandler(element, element.state, element.context);
        } catch (e) {
            console.warn(e);
            frameListeners.delete(element);
            delete element.__ref.__frameHandler;
        }
    }
};
const $53eb18049026e4da$var$startFrameLoop = (frameListeners)=>{
    const raf = typeof window !== 'undefined' && window.requestAnimationFrame;
    if ($53eb18049026e4da$var$_frameRunning || !raf) return;
    $53eb18049026e4da$var$_frameRunning = true;
    function requestFrame() {
        if (frameListeners.size === 0) {
            $53eb18049026e4da$var$_frameRunning = false;
            return;
        }
        $53eb18049026e4da$var$processFrameListeners(frameListeners);
        raf(requestFrame);
    }
    raf(requestFrame);
};
const $53eb18049026e4da$export$cef3c08d5491509f = (element)=>{
    if (!element) throw new Error('Element is invalid');
    const { on: on, props: props, __ref: ref } = element;
    if (!ref.root || !ref.root.data) return;
    const { frameListeners: frameListeners } = ref.root.data;
    // Register if any of the frame handlers exists
    if (frameListeners && (on?.frame || element.onFrame || props?.onFrame)) {
        $53eb18049026e4da$export$a9e0446239e28a61(element);
        $53eb18049026e4da$var$startFrameLoop(frameListeners);
    }
};
let $53eb18049026e4da$var$_frameRunning = false;
const $53eb18049026e4da$export$e1d20e1514750bad = ()=>{
    const frameListeners = new Set();
    $53eb18049026e4da$var$startFrameLoop(frameListeners);
    return frameListeners;
};

parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
'use strict';
const $f8c3a5d1d51a80c4$export$13970129ca912f06 = (node, parentNode)=>{
    try {
        parentNode.appendChild(node);
        return node;
    } catch (e) {
        console.error('Does not support to append', parentNode, node);
    }
};
const $f8c3a5d1d51a80c4$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    if (!node) throw new Error('Node is required');
    const parent = parentNode || siblingNode?.parentNode;
    if (siblingNode?.nextSibling) parent?.insertBefore(node, siblingNode.nextSibling);
    else if (siblingNode?.insertAdjacentElement) siblingNode.insertAdjacentElement('afterend', node);
    else parent?.insertBefore(node, siblingNode);
};
const $f8c3a5d1d51a80c4$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    if (!node) throw new Error('Node is required');
    const parent = parentNode || siblingNode.parentNode;
    parent?.insertBefore(node, siblingNode);
};
const $f8c3a5d1d51a80c4$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    if (!element) throw new Error('Element is required');
    if (!parent) throw new Error('Parent is required');
    parent[key || element.key] = element;
    if (element.tag !== 'shadow') {
        if (attachOptions && attachOptions.position) (attachOptions.position === 'before' ? $f8c3a5d1d51a80c4$export$3a727f1d0007fe49 : $f8c3a5d1d51a80c4$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $f8c3a5d1d51a80c4$export$13970129ca912f06(element.node, parent.node, element);
    }
    return element;
};


parcelRequire("jgAqB");
var $lw6SS = parcelRequire("lw6SS");
var $e7Ezu = parcelRequire("e7Ezu");
var $b4h11 = parcelRequire("b4h11");
parcelRequire("jgAqB");
var $9RPo7 = parcelRequire("9RPo7");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $1jKby = parcelRequire("1jKby");

parcelRequire("jgAqB");
var $lw6SS = parcelRequire("lw6SS");
var $g1LU2 = parcelRequire("g1LU2");
var $b4h11 = parcelRequire("b4h11");
const $92849daa4e7aba12$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true,
    execStateFunction: true
};
const $92849daa4e7aba12$export$4971331372cec95a = function(obj, options = $92849daa4e7aba12$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (options.onEach) options.onEach(element, state, element.context, options);
    if (!options.updateByState) (0, $g1LU2.merge)(options, $92849daa4e7aba12$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $06908963bda72849$export$f18d5b0af29128b7)("ElementOnStateIsNotDefined");
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventBeforeStateUpdateListener) {
        const beforeStateUpdateReturns = (0, $b4h11.triggerEventOnUpdate)("beforeStateUpdate", obj, element, options);
        if (beforeStateUpdateReturns === false) return element;
    }
    (0, $lw6SS.overwriteState)(state, obj, options);
    const updateIsHoisted = $92849daa4e7aba12$export$f3d79b96f1f79ce2(state, obj, options);
    if (updateIsHoisted) return state;
    $92849daa4e7aba12$var$updateDependentState(state, obj, options);
    $92849daa4e7aba12$var$applyElementUpdate(state, obj, options);
    if (!options.preventStateUpdateListener) (0, $b4h11.triggerEventOnUpdate)("stateUpdate", obj, element, options);
    return state;
};
const $92849daa4e7aba12$export$f3d79b96f1f79ce2 = (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref?.__state;
    const stateType = ref?.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $lw6SS.checkIfInherits)(element);
    const inheritedState = (0, $lw6SS.findInheritedState)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === "string" || stateType === "number" || stateType === "boolean";
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findRootState = (0, $lw6SS.getRootStateInKey)(stateKey, parent.state);
    const findGrandParentState = (0, $lw6SS.getParentStateInKey)(stateKey, parent.state);
    const changesValue = (0, $lw6SS.createNestedObjectByKeyPath)(stateKey, passedValue);
    const targetParent = findRootState || findGrandParentState || parent.state;
    if (options.replace) (0, $g1LU2.overwriteDeep)(targetParent, changesValue || value);
    targetParent.update(changesValue, {
        execStateFunction: false,
        isHoisted: true,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace,
        ...options
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) (0, $b4h11.triggerEventOnUpdate)("stateUpdate", obj, element, options);
    return true;
};
const $92849daa4e7aba12$var$updateDependentState = (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        const cleanState = dependentState.clean();
        cleanState.update(state.parse(), options);
    }
};
const $92849daa4e7aba12$var$applyElementUpdate = (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === "recursive") element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};



const $9979ef578d36d980$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $e7Ezu.isObject)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $1jKby.STATE_METHODS).has(param)) obj[param] = state[param];
        return obj;
    } else if ((0, $e7Ezu.isArray)(state)) return state.filter((item)=>!(0, $1jKby.STATE_METHODS).has(item));
};
const $9979ef578d36d980$export$cf0b2a6c63f9e656 = function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $1jKby.STATE_METHODS).has(param) && Object.prototype.hasOwnProperty.call(state, param)) delete state[param];
    if (!options.preventStateUpdate) state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $9979ef578d36d980$export$b1fb4cac938035f7 = function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $e7Ezu.isString)(stateKey)) {
        element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $e7Ezu.isArray)(child.state)) Object.defineProperty(child.state, "parent", {
                value: state.parent,
                enumerable: false,
                // Set this to true if you want the method to appear in for...in loops
                configurable: true,
                // Set this to true if you want to allow redefining/removing the property later
                writable: true
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $9979ef578d36d980$export$e45af8832c6abf26 = function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $9979ef578d36d980$export$c2f300c8c094e900 = function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.root.state;
    return rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $9979ef578d36d980$export$e16d8520af44a096 = function(value, options = {}) {
    const state = this;
    if ((0, $e7Ezu.isArray)(state)) {
        state.push(value);
        state.update(state.parse(), {
            overwrite: true,
            ...options
        });
    } else if ((0, $e7Ezu.isObject)(state)) {
        const key = Object.keys(state).length;
        state.update({
            [key]: value
        }, options);
    }
};
const $9979ef578d36d980$export$e03c1c3201ee8bb7 = function(key, options = {}) {
    const state = this;
    state.update({
        [key]: !state[key]
    }, options);
};
const $9979ef578d36d980$export$cd7f480d6b8286c3 = function(key, options = {}) {
    const state = this;
    if ((0, $e7Ezu.isArray)(state)) (0, $9RPo7.removeFromArray)(state, key);
    else if ((0, $e7Ezu.isObject)(state)) (0, $g1LU2.removeFromObject)(state, key);
    if (options.applyReset) return state.set(state.parse(), {
        replace: true,
        ...options
    });
    return state.update({}, options);
};
const $9979ef578d36d980$export$adaa4cf7ef1b65be = function(val, options = {}) {
    const state = this;
    const value = (0, $g1LU2.deepClone)(val);
    const cleanState = state.clean({
        preventStateUpdate: true,
        ...options
    });
    return cleanState.update(value, {
        replace: true,
        ...options
    });
};
const $9979ef578d36d980$export$f65a19d15516795e = function(path, val, options = {}) {
    const state = this;
    const value = (0, $g1LU2.deepClone)(val);
    if (!options.preventReplace) (0, $g1LU2.setInObjectByPath)(state, path, val);
    const update = (0, $g1LU2.createNestedObject)(path, value);
    if (options.preventStateUpdate) return update;
    return state.update(update, options);
};
const $9979ef578d36d980$export$d340c517393b84c7 = function(changes, options = {}) {
    const state = this;
    const update = changes.reduce((acc, change)=>{
        if (change[0] === "update") {
            const result = $9979ef578d36d980$export$f65a19d15516795e.call(state, change[1], change[2], {
                preventStateUpdate: true
            });
            return (0, $g1LU2.overwriteDeep)(acc, result);
        } else if (change[0] === "delete") $9979ef578d36d980$export$ceab6855354994b2.call(state, change[1], {
            ...options,
            preventUpdate: true
        });
        return acc;
    }, {});
    return state.update(update, options);
};
const $9979ef578d36d980$export$ceab6855354994b2 = function(path, options = {}) {
    const state = this;
    (0, $g1LU2.removeNestedKeyByPath)(state, path);
    if (options.preventUpdate) return path;
    return state.update({}, options);
};
const $9979ef578d36d980$export$20d12daede3a0bb7 = function(changes, options = {}) {
    const state = this;
    for(let i = 0; i < changes.length; i++)$9979ef578d36d980$export$ceab6855354994b2(changes[i], {
        preventUpdate: true
    });
    return state.update({}, options);
};
const $9979ef578d36d980$export$44b5bed83342a92f = function(path, options = {}) {
    const state = this;
    return (0, $g1LU2.getInObjectByPath)(state, path);
};
const $9979ef578d36d980$export$aad8462122ac592b = function(options = {}) {
    const state = this;
    const value = (0, $g1LU2.deepClone)(state.parse());
    return state.set(value, {
        replace: true,
        ...options
    });
};
const $9979ef578d36d980$export$5635d7ef4b8fee1c = function(func, options = {}) {
    const state = this;
    if ((0, $e7Ezu.isFunction)(func)) {
        const value = func(state);
        return state.update(value, {
            replace: true,
            ...options
        });
    }
};
const $9979ef578d36d980$export$a820c59bcfe11369 = function(func, options = {}) {
    const state = this;
    if ((0, $e7Ezu.isFunction)(func)) {
        const value = func(state);
        return state.replace(value, options);
    }
};
const $9979ef578d36d980$export$bd130d4161841808 = function(func, options = {}) {
    const state = this;
    if ((0, $e7Ezu.isFunction)(func)) {
        func(state);
        return state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};
const $9979ef578d36d980$export$8e1d54bd5cf63ec5 = function(obj, options = {}) {
    const state = this;
    return state.update(obj, {
        preventUpdate: true,
        ...options
    });
};
const $9979ef578d36d980$export$77ad94ebf1c2b9ed = function(obj, options = {}) {
    const state = this;
    for(const param in obj)state[param] = obj[param];
    return state.update(obj, options);
};
const $9979ef578d36d980$export$b2ed1c8afe947b7d = function(obj, options = {}) {
    const state = this;
    return state.replace(obj, {
        preventUpdate: true,
        ...options
    });
};
const $9979ef578d36d980$export$ed97f33186d4b816 = function(obj, options = {}) {
    const state = this;
    return Object.keys(state);
};
const $9979ef578d36d980$export$68c286be0e7e55b7 = function(obj, options = {}) {
    const state = this;
    return Object.values(state);
};
const $9979ef578d36d980$export$4100ab4dd77a48b9 = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: $9979ef578d36d980$export$cf0b2a6c63f9e656.bind(state),
        parse: $9979ef578d36d980$export$98e6a39c04603d36.bind(state),
        destroy: $9979ef578d36d980$export$b1fb4cac938035f7.bind(state),
        update: (0, $92849daa4e7aba12$export$4971331372cec95a).bind(state),
        rootUpdate: $9979ef578d36d980$export$c2f300c8c094e900.bind(state),
        parentUpdate: $9979ef578d36d980$export$e45af8832c6abf26.bind(state),
        create: (0, $d49b8d9eb136c53a$export$e6a0daad8304de).bind(state),
        add: $9979ef578d36d980$export$e16d8520af44a096.bind(state),
        toggle: $9979ef578d36d980$export$e03c1c3201ee8bb7.bind(state),
        remove: $9979ef578d36d980$export$cd7f480d6b8286c3.bind(state),
        apply: $9979ef578d36d980$export$5635d7ef4b8fee1c.bind(state),
        applyReplace: $9979ef578d36d980$export$a820c59bcfe11369.bind(state),
        applyFunction: $9979ef578d36d980$export$bd130d4161841808.bind(state),
        set: $9979ef578d36d980$export$adaa4cf7ef1b65be.bind(state),
        quietUpdate: $9979ef578d36d980$export$8e1d54bd5cf63ec5.bind(state),
        replace: $9979ef578d36d980$export$77ad94ebf1c2b9ed.bind(state),
        quietReplace: $9979ef578d36d980$export$b2ed1c8afe947b7d.bind(state),
        reset: $9979ef578d36d980$export$aad8462122ac592b.bind(state),
        parent: element.parent?.state || state,
        setByPath: $9979ef578d36d980$export$f65a19d15516795e.bind(state),
        setPathCollection: $9979ef578d36d980$export$d340c517393b84c7.bind(state),
        removeByPath: $9979ef578d36d980$export$ceab6855354994b2.bind(state),
        removePathCollection: $9979ef578d36d980$export$20d12daede3a0bb7.bind(state),
        getByPath: $9979ef578d36d980$export$44b5bed83342a92f.bind(state),
        keys: $9979ef578d36d980$export$ed97f33186d4b816.bind(state),
        values: $9979ef578d36d980$export$68c286be0e7e55b7.bind(state),
        __element: element,
        __children: {},
        root: ref?.root ? ref.root.state : state
    };
    if ((0, $e7Ezu.isArray)(state)) (0, $9RPo7.addProtoToArray)(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};


const $d49b8d9eb136c53a$export$e6a0daad8304de = function(element, parent, options) {
    element.state = $d49b8d9eb136c53a$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $d49b8d9eb136c53a$export$6e8a0938c76079c7 = function(element, parent, options) {
    const objectizeState = (0, $lw6SS.checkForStateTypes)(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = objectizeState;
    const whatInitReturns = (0, $b4h11.triggerEventOn)("stateInit", element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $lw6SS.checkIfInherits)(element)) {
        const inheritedState = (0, $lw6SS.createInheritedState)(element, parent);
        element.state = (0, $e7Ezu.isUndefined)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = (0, $lw6SS.applyDependentState)(element, element.state || parent.state || {});
    if (dependentState) element.state = dependentState;
    (0, $9979ef578d36d980$export$4100ab4dd77a48b9)(element);
    (0, $b4h11.triggerEventOn)("stateCreated", element);
    return element.state;
};



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");

parcelRequire("jgAqB");
var $dWAIU = parcelRequire("dWAIU");
var $g1LU2 = parcelRequire("g1LU2");
var $lw6SS = parcelRequire("lw6SS");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");
var $5zx8x = parcelRequire("5zx8x");
var $bD06b = parcelRequire("bD06b");
var $j7W2w = parcelRequire("j7W2w");
parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");






'use strict';
const $4ebf83ec0d12b44f$export$7f0c3d30e5984c9d = [] // this is needed because of unit tests
;




'use strict';
const $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    exclude: (0, $4ebf83ec0d12b44f$export$7f0c3d30e5984c9d)
};
const $196ad7400dcaf39e$export$722fbec263ad908a = function(params = {}, opts) {
    // Shallow copy is sufficient - all values are primitives/references that shouldn't be cloned
    const options = (0, $e7Ezu.isObject)(opts) ? {
        ...$196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS,
        ...opts
    } : {
        ...$196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    };
    const element = this;
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = (0, $dWAIU.captureSnapshot)(element, options);
    if (snapshotHasUpdated) return;
    if (!options.preventListeners) (0, $b4h11.triggerEventOnUpdate)('startUpdate', params, element, options);
    const { parent: parent, node: node, key: key } = element;
    const { exclude: exclude, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!exclude) (0, $g1LU2.merge)(options, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS);
    if ((0, $e7Ezu.isString)(params) || (0, $e7Ezu.isNumber)(params)) params = {
        text: params
    };
    // apply new updates
    params = (0, $5zx8x.propertizeUpdate).call(element, params);
    const inheritState = $196ad7400dcaf39e$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $196ad7400dcaf39e$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__propsStack.some((0, $e7Ezu.isFunction));
        const props = params.props || hasParentProps || hasFunctionInProps;
        if (props) (0, $5zx8x.updateProps)(props, element, parent);
    }
    if (!options.preventBeforeUpdateListener && !options.preventListeners) {
        const hasBeforeUpdate = element.on?.beforeUpdate || element.props?.onBeforeUpdate;
        if (hasBeforeUpdate) {
            const simulate = {
                ...params,
                ...element
            };
            Object.setPrototypeOf(simulate, Object.getPrototypeOf(element));
            const beforeUpdateReturns = (0, $b4h11.triggerEventOnUpdate)('beforeUpdate', params, simulate, options);
            if (beforeUpdateReturns === false) return element;
        }
    }
    // apply new updates
    (0, $g1LU2.overwriteDeep)(element, params);
    // exec updates
    (0, $0513b3ed7d5404ec$export$23077649cd9ebd4b)(element);
    (0, $0513b3ed7d5404ec$export$2ad800d85590910f)(element, {
        ignore: $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    });
    (0, $0513b3ed7d5404ec$export$88eda8a7eb5c5eff)(element);
    if (!options.isForced && !options.preventListeners) (0, $b4h11.triggerEventOn)('beforeClassAssign', element, options);
    if (!ref.__if) return false;
    if (!node) return;
    const { preventUpdate: preventUpdate, preventDefineUpdate: preventDefineUpdate, preventContentUpdate: preventContentUpdate, preventStateUpdate: preventStateUpdate, preventRecursive: preventRecursive, preventUpdateListener: preventUpdateListener, preventUpdateAfter: preventUpdateAfter, preventUpdateAfterCount: preventUpdateAfterCount } = options;
    if (preventUpdateAfter) {
        if ((0, $e7Ezu.isNumber)(preventUpdateAfterCount) && preventUpdateAfter <= preventUpdateAfterCount) return;
        else if (options.preventUpdateAfterCount === undefined) options.preventUpdateAfterCount = 1;
        else options.preventUpdateAfterCount++;
    }
    // Convert arrays to Sets once for O(1) lookups during iteration
    const preventUpdateSet = (0, $e7Ezu.isArray)(preventUpdate) ? new Set(preventUpdate) : null;
    const preventDefineUpdateSet = (0, $e7Ezu.isArray)(preventDefineUpdate) ? new Set(preventDefineUpdate) : null;
    for(const param in element){
        const prop = element[param];
        if (!Object.prototype.hasOwnProperty.call(element, param)) continue;
        const isInPreventUpdate = preventUpdateSet && preventUpdateSet.has(param);
        const isInPreventDefineUpdate = preventDefineUpdateSet && preventDefineUpdateSet.has(param);
        // Skip onXxx event handler functions (e.g. onClick) that may remain at root level
        const isRootEventHandler = (0, $e7Ezu.isFunction)(prop) && param.length > 2 && param.charCodeAt(0) === 111 && param.charCodeAt(1) === 110 && // 'on'
        param.charCodeAt(2) >= 65 && param.charCodeAt(2) <= 90 // A-Z
        ;
        if ((0, $e7Ezu.isUndefined)(prop) || isInPreventUpdate || isInPreventDefineUpdate || preventDefineUpdate === true || preventDefineUpdate === param || preventStateUpdate && param === 'state' || (0, $j7W2w.isMethod)(param, element) || isRootEventHandler || (0, $e7Ezu.isObject)((0, $782cf63e523d0885$export$21cc2ed387caee94)[param])) continue;
        if (preventStateUpdate === 'once') options.preventStateUpdate = false;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $e7Ezu.isObject)(prop) && !hasDefine && !hasContextDefine && !preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            if (options.onEachUpdate) options.onEachUpdate(param, element, element.state, element.context);
            const childParams = params[param];
            if (childParams === undefined && !options.isForced) {
                if (options.onlyUpdate) {
                    if (param !== options.onlyUpdate) continue;
                } else if (!options.updateByState) continue;
            }
            // Once we reach the onlyUpdate target, clear it so its children update normally
            const childOptions = options.onlyUpdate && param === options.onlyUpdate ? {
                ...options,
                onlyUpdate: undefined,
                currentSnapshot: snapshotOnCallee,
                calleeElement: calleeElement
            } : {
                ...options,
                currentSnapshot: snapshotOnCallee,
                calleeElement: calleeElement
            };
            const childUpdateCall = ()=>$196ad7400dcaf39e$export$722fbec263ad908a.call(prop, childParams, childOptions);
            if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                // eslint-disable-line
                childUpdateCall();
                // handle lazy load
                if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)('lazyLoad', element, options);
            });
            else childUpdateCall();
        }
    }
    if (!preventContentUpdate) {
        const contentKey = ref.contentElementKey || 'content';
        const existingContent = element[contentKey];
        // During state-triggered cascading updates (updateByState), skip static
        // children but still re-process dynamic children (originally functions, already
        // re-evaluated by throughUpdatedExec). Check ref.__exec.children to detect these.
        const childrenProp = options.updateByState ? params.children || (ref.__exec?.children ? element.children : undefined) : params.children || element.children;
        if (childrenProp) {
            const content = (0, $98828bcde53bce97$export$2e2bcd8739ae039)(childrenProp, element, opts);
            if (content && !ref.__noChildrenDifference) (0, $bf937aebc888d68f$export$431313f2afd011e2)(content, element, options);
            else if (existingContent?.__ref && (0, $e7Ezu.isFunction)(existingContent.update)) {
                const lazyLoad = element.props?.lazyLoad || options.lazyLoad;
                const contentUpdateCall = ()=>$196ad7400dcaf39e$export$722fbec263ad908a.call(existingContent, params[contentKey], {
                        ...options,
                        currentSnapshot: snapshotOnCallee,
                        calleeElement: calleeElement
                    });
                if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                    contentUpdateCall();
                    if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)('lazyLoad', element, options);
                });
                else contentUpdateCall();
            }
        } else if (existingContent?.__ref && (0, $e7Ezu.isFunction)(existingContent.update)) {
            const lazyLoad = element.props?.lazyLoad || options.lazyLoad;
            const contentUpdateCall = ()=>$196ad7400dcaf39e$export$722fbec263ad908a.call(existingContent, params[contentKey], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                contentUpdateCall();
                if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)('lazyLoad', element, options);
            });
            else contentUpdateCall();
        } else {
            const content = element.children || params.content;
            if (content && !options.updateByState) (0, $bf937aebc888d68f$export$431313f2afd011e2)(content, element, options);
        }
    }
    if (!preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)('update', element, options);
};
const $196ad7400dcaf39e$var$findSiblingAttachOptions = (element, parent)=>{
    const { __children: __children } = parent.__ref || {};
    if (!__children) return false;
    const currentIndex = __children.indexOf(element.key);
    // Walk backwards to find nearest previous sibling with a DOM node
    let previousNode;
    for(let i = currentIndex - 1; i >= 0; i--){
        const sibling = parent[__children[i]];
        if (sibling?.node?.parentNode) {
            previousNode = sibling.node;
            break;
        }
    }
    if (previousNode) return {
        position: 'after',
        node: previousNode
    };
    // Walk forwards to find nearest next sibling with a DOM node
    let nextNode;
    for(let i = currentIndex + 1; i < __children.length; i++){
        const sibling = parent[__children[i]];
        if (sibling?.node?.parentNode) {
            nextNode = sibling.node;
            break;
        }
    }
    if (nextNode) return {
        position: 'before',
        node: nextNode
    };
    return false;
};
const $196ad7400dcaf39e$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $e7Ezu.isFunction)(element.if) && !(0, $e7Ezu.isFunction)(element.props?.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = (element.if || element.props?.if)(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.__text;
            delete element.extends;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            if (element.node) {
                element.node.remove();
                delete element.node;
            }
            const contentKey = ref.contentElementKey;
            if (element.children) element.removeContent();
            else if (element[contentKey]?.parseDeep) element[contentKey] = element[contentKey].parseDeep();
            const attachOptions = $196ad7400dcaf39e$var$findSiblingAttachOptions(element, parent);
            delete element.__ref;
            delete element.parent;
            const createdElement = (0, $947d5c063e68e91c$export$185802fd694ee1f5)(element, parent, element.key, (0, $dzojf.OPTIONS).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $e7Ezu.isFunction)(element.on.update)) (0, $b4h11.applyEvent)(element.on.update, createdElement, createdElement.state);
            return createdElement;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element when state is inherited.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.execStateFunction] - Execute the state functions.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventBeforeStateUpdateListener] - If true, prevent the 'beforeStateUpdate' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdate' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $196ad7400dcaf39e$var$inheritStateUpdates = (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent?.state || {};
        return;
    }
    // If state is function, decide execution and apply setting a current state
    const shouldForceFunctionState = (0, $e7Ezu.isFunction)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $g1LU2.exec)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            preventStateUpdateListener: false,
            updatedByStateFunction: true
        });
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $lw6SS.findInheritedState)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.beforeStateUpdate event
    if (!options.preventBeforeStateUpdateListener && !options.preventListeners) {
        const initStateReturns = (0, $b4h11.triggerEventOnUpdate)('beforeStateUpdate', keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = $196ad7400dcaf39e$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdate event
    if (!options.preventStateUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOnUpdate)('stateUpdate', newState.parse(), element, options);
};
const $196ad7400dcaf39e$var$createStateUpdate = (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        // __stateChildren[child].parent = newState
        Object.getPrototypeOf(__stateChildren[child]).parent = newState;
    }
    return newState;
};
var $196ad7400dcaf39e$export$2e2bcd8739ae039 = $196ad7400dcaf39e$export$722fbec263ad908a;



var $fUAoP = parcelRequire("fUAoP");
'use strict';
const $6587d89a5cc3b917$export$626ce79af72fc3d3 = (element, parent, options = {})=>{
    const proto = {
        set: $bf937aebc888d68f$export$adaa4cf7ef1b65be,
        reset: $bf937aebc888d68f$export$aad8462122ac592b,
        update: $196ad7400dcaf39e$export$722fbec263ad908a,
        variables: $fUAoP.variables,
        remove: $fUAoP.remove,
        updateContent: $bf937aebc888d68f$export$5143cc956eb9d8f6,
        removeContent: $bf937aebc888d68f$export$6e1d9b0d0e1e1def,
        setProps: $fUAoP.setProps,
        lookup: $fUAoP.lookup,
        lookdown: $fUAoP.lookdown,
        lookdownAll: $fUAoP.lookdownAll,
        getRef: $fUAoP.getRef,
        getPath: $fUAoP.getPath,
        getRootState: $fUAoP.getRootState,
        getRoot: $fUAoP.getRoot,
        getRootData: $fUAoP.getRootData,
        getRootContext: $fUAoP.getRootContext,
        getContext: $fUAoP.getContext,
        setNodeStyles: $fUAoP.setNodeStyles,
        spotByPath: $fUAoP.spotByPath,
        parse: $fUAoP.parse,
        parseDeep: $fUAoP.parseDeep,
        keys: $fUAoP.keys,
        nextElement: $fUAoP.nextElement,
        previousElement: $fUAoP.previousElement,
        log: $fUAoP.log,
        verbose: $fUAoP.verbose,
        warn: $fUAoP.warn,
        error: $fUAoP.error,
        call: $fUAoP.call
    };
    if (element.context.methods) (options.strict ? (0, $g1LU2.merge) : (0, $g1LU2.overwrite))(proto, element.context.methods);
    Object.setPrototypeOf(element, proto);
};





'use strict';
const $947d5c063e68e91c$var$EXCLUDED_ATTRS = new Set([
    'class',
    'style'
]);
const $947d5c063e68e91c$var$applyPropsAsAttrs = (element)=>{
    const { tag: tag, props: props, context: context } = element;
    if (!tag || !props) return;
    const autoAttrs = (0, $235425de3553395f$export$a3d5d5e1a17535c6)(tag, props, context?.cssPropsRegistry);
    const filtered = {};
    for(const key in autoAttrs)if (!$947d5c063e68e91c$var$EXCLUDED_ATTRS.has(key)) filtered[key] = autoAttrs[key];
    let hasFiltered = false;
    for(const _k in filtered){
        hasFiltered = true;
        break;
    } // eslint-disable-line
    if (!hasFiltered) return;
    if (!element.attr) element.attr = filtered;
    else if (typeof element.attr === 'object') element.attr = {
        ...filtered,
        ...element.attr
    };
};
const $947d5c063e68e91c$var$ENV = "production";
const $947d5c063e68e91c$export$185802fd694ee1f5 = (props, parentEl, passedKey, options = (0, $dzojf.OPTIONS).create || {}, attachOptions)=>{
    $947d5c063e68e91c$var$cacheOptions(options);
    const element = (0, $81M4S.createElement)(props, parentEl, passedKey, options, (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4));
    if (!element) return;
    const { key: key, parent: parent, __ref: ref } = element;
    (0, $81M4S.createRoot)(element, parent) // Call createRoot after addCaching
    ;
    (0, $7gXxj.applyExtends)(element, parent, options);
    if (options.onlyResolveExtends) return $947d5c063e68e91c$var$onlyResolveExtends(element, parent, key, options);
    (0, $5zx8x.propertizeElement).call(element, element);
    (0, $b4h11.triggerEventOn)('start', element, options);
    $947d5c063e68e91c$var$resetOptions(element, parent, options);
    (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent, options);
    (0, $5ORwk.createScope)(element, parent);
    (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    if (element.scope === 'state') element.scope = element.state;
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    // apply props settings
    (0, $5zx8x.initProps)(element, parent, options);
    // Re-pickup component-named properties that entered props via childProps/inheritParentProps
    (0, $5zx8x.pickupElementFromProps).call(element, element, {
        cachedKeys: []
    });
    // Populate element.attr from props matching the tag's HTML spec
    $947d5c063e68e91c$var$applyPropsAsAttrs(element);
    if (element.scope === 'props' || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    // if it already HAS a NODE
    if (element.node) {
        if (ref.__if) return (0, $f8c3a5d1d51a80c4$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    }
    // apply variants
    // applyVariant(element, parent)
    const onInit = (0, $b4h11.triggerEventOn)('init', element, options);
    if (onInit === false) return element;
    (0, $b4h11.triggerEventOn)('beforeClassAssign', element, options);
    // generate a CLASS name
    (0, $6a43953e96d89b45$export$d559e9a3b71405f6)(element);
    $947d5c063e68e91c$var$renderElement(element, parent, options, attachOptions);
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent);
    (0, $b4h11.triggerEventOn)('complete', element, options);
    return element;
};
const $947d5c063e68e91c$var$cacheOptions = (options)=>{
    if (options && !(0, $dzojf.OPTIONS).create) {
        (0, $dzojf.OPTIONS).create = options;
        (0, $dzojf.OPTIONS).create.context = options.context;
    }
};
const $947d5c063e68e91c$var$resetOptions = (element, parent, options)=>{
    let hasKeys = false;
    for(const _k in options){
        hasKeys = true;
        break;
    } // eslint-disable-line
    if (hasKeys) {
        (0, $dzojf.OPTIONS).defaultOptions = options;
        if (options.ignoreChildExtends) delete options.ignoreChildExtends;
    }
};
const $947d5c063e68e91c$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) {
        if (!parent.__ref.__children.includes(element.key)) parent.__ref.__children.push(element.key);
    }
};
let $947d5c063e68e91c$var$_uniqIdCounter = 1;
const $947d5c063e68e91c$var$visitedElements = new WeakMap();
const $947d5c063e68e91c$var$renderElement = (element, parent, options, attachOptions)=>{
    if ($947d5c063e68e91c$var$visitedElements.has(element)) {
        if ($947d5c063e68e91c$var$ENV === 'test' || $947d5c063e68e91c$var$ENV === 'development') console.warn('Cyclic rendering detected:', element.__ref.path);
    }
    $947d5c063e68e91c$var$visitedElements.set(element, true);
    const { __ref: ref, key: key } = element;
    const createNestedChild = ()=>{
        const isInfiniteLoopDetected = (0, $g1LU2.detectInfiniteLoop)(ref.path);
        if (ref.__uniqId || isInfiniteLoopDetected) return;
        (0, $4e214d02be0ddce7$export$270e7ba5936d3c48)(element, options);
        ref.__uniqId = $947d5c063e68e91c$var$_uniqIdCounter++;
    };
    // CREATE a real NODE
    if ($947d5c063e68e91c$var$ENV === 'test' || $947d5c063e68e91c$var$ENV === 'development' || element.context?.strictMode) createNestedChild();
    else try {
        createNestedChild();
    } catch (e) {
        element.error = e;
        const path = ref.path;
        if (path.includes('ComponentsGrid')) path.splice(0, path.indexOf('ComponentsGrid') + 2);
        if (path.includes('demoComponent')) path.splice(0, path.indexOf('demoComponent') + 1);
        const isDemoComponent = element.lookup((el)=>el.state.key)?.state?.key;
        element.warn('Error happened in:', isDemoComponent ? isDemoComponent + ' ' : '' + path.join('.'));
        element.verbose();
        console.error('[DomQL] Render error:', e);
        if (element.on?.error) element.on.error(e, element, element.state, element.context, options);
    }
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $f8c3a5d1d51a80c4$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // apply events
    (0, $53eb18049026e4da$export$cef3c08d5491509f)(element, options);
    // run `on.render`
    (0, $b4h11.triggerEventOn)('render', element, options);
    // triggerEventOn('render', element, options).then(() => {})
    // run `on.renderRouter`
    (0, $b4h11.triggerEventOn)('renderRouter', element, options);
    // run `on.done`
    (0, $b4h11.triggerEventOn)('done', element, options);
    // run `on.done`
    (0, $b4h11.triggerEventOn)('create', element, options);
};
const $947d5c063e68e91c$var$onlyResolveExtends = (element, parent, key, options)=>{
    const { __ref: ref } = element;
    (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent, options);
    (0, $5ORwk.createScope)(element, parent);
    (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    if (element.scope === 'state') element.scope = element.state;
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    // apply props settings
    (0, $5zx8x.initProps)(element, parent, options);
    // Re-pickup component-named properties that entered props via childProps/inheritParentProps
    (0, $5zx8x.pickupElementFromProps).call(element, element, {
        cachedKeys: []
    });
    if (element.scope === 'props' || element.scope === true) element.scope = element.props;
    if (element.node && ref.__if) parent[key || element.key] = element;
     // Borrowed from assignNode()
    if (!element.props) element.props = {};
    // applyVariant(element, parent)
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent);
    if (element.tag !== 'string' && element.tag !== 'fragment') {
        (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
        (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
        for(const k in element){
            if ((0, $e7Ezu.isUndefined)(element[k]) || (0, $j7W2w.isMethod)(k, element) || (0, $e7Ezu.isObject)((0, $782cf63e523d0885$export$21cc2ed387caee94)[k])) continue;
            const hasDefine = element.define?.[k];
            const contextHasDefine = element.context?.define?.[k];
            const optionsHasDefine = options.define?.[k];
            if (!ref.__skipCreate && (0, $782cf63e523d0885$export$21cc2ed387caee94)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $947d5c063e68e91c$export$185802fd694ee1f5((0, $g1LU2.exec)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by initProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
var $947d5c063e68e91c$export$2e2bcd8739ae039 = $947d5c063e68e91c$export$185802fd694ee1f5;


parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
'use strict';
const $bf937aebc888d68f$export$c99c504ad1135f20 = (element, opts = {})=>{
    const { __ref: ref } = element;
    const contentElementKey = opts.contentElementKey;
    if (!ref.contentElementKey || contentElementKey !== ref.contentElementKey) ref.contentElementKey = contentElementKey || 'content';
    return ref.contentElementKey;
};
function $bf937aebc888d68f$export$aad8462122ac592b(options) {
    const element = this;
    (0, $947d5c063e68e91c$export$185802fd694ee1f5)(element, element.parent, undefined, {
        ignoreChildExtends: true,
        ...(0, $dzojf.OPTIONS).defaultOptions,
        ...(0, $dzojf.OPTIONS).create,
        ...options
    });
}
const $bf937aebc888d68f$export$92dab91de9230702 = (params, element, opts)=>{
    const contentElementKey = $bf937aebc888d68f$export$c99c504ad1135f20(element, opts);
    if (element[contentElementKey]?.node) $bf937aebc888d68f$export$6e1d9b0d0e1e1def(element, opts);
    const contentElem = (0, $947d5c063e68e91c$export$185802fd694ee1f5)(params, element, contentElementKey || 'content', {
        ignoreChildExtends: true,
        ...(0, $dzojf.OPTIONS).defaultOptions,
        ...(0, $dzojf.OPTIONS).create,
        ...opts
    });
    if (contentElementKey !== 'content') opts.contentElementKey = 'content' // reset to default
    ;
    return contentElem;
};
const $bf937aebc888d68f$export$5143cc956eb9d8f6 = function(params, opts) {
    const element = this;
    const contentElementKey = $bf937aebc888d68f$export$c99c504ad1135f20(element, opts);
    if (!element[contentElementKey]) return;
    if (element[contentElementKey].update) element[contentElementKey].update(params, opts);
};
function $bf937aebc888d68f$export$431313f2afd011e2(param, element, opts) {
    const content = (0, $g1LU2.exec)(param, element);
    if (content && element) $bf937aebc888d68f$export$adaa4cf7ef1b65be.call(element, content, opts);
}
const $bf937aebc888d68f$export$6e1d9b0d0e1e1def = function(el, opts = {}) {
    const element = el || this;
    const contentElementKey = $bf937aebc888d68f$export$c99c504ad1135f20(element, opts);
    if (opts.contentElementKey !== 'content') opts.contentElementKey = 'content';
    const content = element[contentElementKey];
    if (!content) return;
    // Handle fragment removal
    if (content.tag === 'fragment' && content.__ref?.__children) {
        // Remove all child nodes
        const __children = content.__ref.__children;
        for(let i = 0; i < __children.length; i++){
            const child = content[__children[i]];
            if (child.node && child.node.parentNode) child.node.parentNode.removeChild(child.node);
            if ((0, $e7Ezu.isFunction)(child.remove)) child.remove();
        }
    } else {
        // Handle regular element removal
        if (content.node && content.node.parentNode) content.node.parentNode.removeChild(content.node);
        if ((0, $e7Ezu.isFunction)(content.remove)) content.remove();
    }
    delete element[contentElementKey];
};
const $bf937aebc888d68f$export$adaa4cf7ef1b65be = function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref } = element;
    // Guard against infinite set loops
    if (ref.__settingContent) return element;
    ref.__settingContent = true;
    try {
        return $bf937aebc888d68f$var$_setInner(params, options, element);
    } finally{
        ref.__settingContent = false;
    }
};
const $bf937aebc888d68f$var$_setInner = function(params, options, element) {
    const { __ref: ref } = element;
    const contentElementKey = $bf937aebc888d68f$export$c99c504ad1135f20(element, options);
    const content = element[contentElementKey];
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    const hasChildren = element.children;
    if (options.preventContentUpdate === true && !hasChildren) return;
    const childHasChanged = !ref.__noChildrenDifference;
    const childrenIsDifferentFromCache = childHasChanged && __contentRef && Object.keys(params).length === Object.keys(content).length && (0, $g1LU2.deepContains)(params, content);
    if (content?.update && !childHasChanged && !childrenIsDifferentFromCache) {
        if (!options.preventBeforeUpdateListener && !options.preventListeners) {
            const beforeUpdateReturns = (0, $b4h11.triggerEventOnUpdate)('beforeUpdate', params, element, options);
            if (beforeUpdateReturns === false) return element;
        }
        content.update(params);
        if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)('update', element, options);
        return;
    }
    if (!params || typeof params !== 'object') return element;
    let { childExtends: childExtends, props: props, tag: tag } = params;
    if (!props) props = params.props = {};
    if (tag === 'fragment') {
        const elementChildExtends = element.childExtends || element.childExtend;
        if (!childExtends && elementChildExtends) {
            params.childExtends = elementChildExtends;
            props.ignoreChildExtends = true;
        }
        const elementChildProps = element.childProps || element.props?.childProps;
        if (!props?.childProps && elementChildProps) props.childProps = elementChildProps;
        // Prevent the fragment from inheriting parent's childProps via inheritParentProps
        // (childProps is already forwarded explicitly above for the fragment's children)
        props.ignoreChildProps = true;
    }
    if (lazyLoad) window.requestAnimationFrame(()=>{
        $bf937aebc888d68f$export$92dab91de9230702(params, element, options);
        // handle lazy load
        if (!options.preventUpdateListener) (0, $b4h11.triggerEventOn)('lazyLoad', element, options);
    });
    else $bf937aebc888d68f$export$92dab91de9230702(params, element, options);
};
var $bf937aebc888d68f$export$2e2bcd8739ae039 = $bf937aebc888d68f$export$adaa4cf7ef1b65be;


const $32a808518113ee1c$var$paramPattern = /^:(.+)/;
const $32a808518113ee1c$var$wildcardPattern = /^\*$/;
const $32a808518113ee1c$var$routeCache = /* @__PURE__ */ new Map();
const $32a808518113ee1c$export$c1d2f753e345bfd = (pattern)=>{
    const cached = $32a808518113ee1c$var$routeCache.get(pattern);
    if (cached) return cached;
    const segments = pattern.replace(/^\//, "").split("/");
    const params = [];
    let hasWildcard = false;
    for(let i = 0; i < segments.length; i++){
        const match = segments[i].match($32a808518113ee1c$var$paramPattern);
        if (match) params.push({
            index: i,
            name: match[1]
        });
        else if ($32a808518113ee1c$var$wildcardPattern.test(segments[i])) hasWildcard = true;
    }
    const result = {
        segments: segments,
        params: params,
        hasWildcard: hasWildcard,
        pattern: pattern
    };
    $32a808518113ee1c$var$routeCache.set(pattern, result);
    return result;
};
const $32a808518113ee1c$export$b4ee0d6794375c82 = (pathname, routes, level = 0)=>{
    const pathSegments = pathname.replace(/^\//, "").split("/").filter(Boolean);
    const relevantSegments = pathSegments.slice(level);
    const routePath = "/" + (relevantSegments[0] || "");
    let bestMatch = null;
    let bestScore = -1;
    let matchedParams = {};
    for(const key in routes){
        if (key === "/*") continue;
        const parsed = $32a808518113ee1c$export$c1d2f753e345bfd(key);
        const score = $32a808518113ee1c$var$scoreMatch(relevantSegments, parsed);
        if (score > bestScore) {
            bestScore = score;
            bestMatch = key;
            matchedParams = $32a808518113ee1c$var$extractParams(relevantSegments, parsed);
        }
    }
    if (!bestMatch && routes["/*"]) bestMatch = "/*";
    return {
        key: bestMatch,
        content: bestMatch ? routes[bestMatch] : null,
        params: matchedParams,
        routePath: routePath
    };
};
const $32a808518113ee1c$var$scoreMatch = (pathSegments, parsed)=>{
    const { segments: segments, hasWildcard: hasWildcard } = parsed;
    if (!hasWildcard && segments.length !== pathSegments.length && segments.length !== 1) {
        if (segments.length > pathSegments.length) return -1;
    }
    let score = 0;
    const len = Math.min(segments.length, pathSegments.length);
    for(let i = 0; i < len; i++){
        if (segments[i] === pathSegments[i]) score += 3;
        else if ($32a808518113ee1c$var$paramPattern.test(segments[i])) score += 1;
        else if ($32a808518113ee1c$var$wildcardPattern.test(segments[i])) score += 0.5;
        else return -1;
    }
    return score;
};
const $32a808518113ee1c$var$extractParams = (pathSegments, parsed)=>{
    const params = {};
    for (const { index: index, name: name } of parsed.params)if (pathSegments[index]) params[name] = decodeURIComponent(pathSegments[index]);
    return params;
};
const $32a808518113ee1c$export$1e8473eaf75b0d10 = (search)=>{
    if (!search || search === "?") return {};
    const params = {};
    const searchParams = new URLSearchParams(search);
    searchParams.forEach((value, key)=>{
        if (params[key] !== void 0) {
            if (!Array.isArray(params[key])) params[key] = [
                params[key]
            ];
            params[key].push(value);
        } else params[key] = value;
    });
    return params;
};
const $32a808518113ee1c$export$6b398ed5c45e580b = async (guards, context)=>{
    if (!guards || !guards.length) return true;
    for (const guard of guards){
        const result = await guard(context);
        if (result === false) return false;
        if (typeof result === "string") return result;
    }
    return true;
};
const $32a808518113ee1c$export$e7a685f330e7752 = (level = 0, route = (0, $bD06b.window).location.pathname)=>{
    const routeArray = route.split("/");
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $32a808518113ee1c$export$7a9e7a91cdf4fce1;
let $32a808518113ee1c$export$ed098f724085d263 = 0;
const $32a808518113ee1c$var$defaultOptions = {
    level: $32a808518113ee1c$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $bD06b.document) && (0, $bD06b.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    },
    useParamsMatching: false
};
const $32a808518113ee1c$export$5375cda95f0b0eb4 = (path, el, state = {}, options = {})=>{
    const element = el || void 0;
    const win = element.context.window || (0, $bD06b.window);
    const doc = element.context.document || (0, $bD06b.document);
    const opts = {
        ...$32a808518113ee1c$var$defaultOptions,
        ...element.context.routerOptions,
        ...options
    };
    $32a808518113ee1c$export$ed098f724085d263 = opts.lastLevel;
    const ref = element.__ref;
    if (opts.contentElementKey !== "content" && opts.contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = opts.contentElementKey || "content";
    const contentElementKey = (0, $bf937aebc888d68f$export$c99c504ad1135f20)(element, opts);
    const urlObj = new win.URL(win.location.origin + path);
    const { pathname: pathname, search: search, hash: hash } = urlObj;
    const query = $32a808518113ee1c$export$1e8473eaf75b0d10(search);
    const rootNode = element.node;
    const hashChanged = hash && hash !== win.location.hash.slice(1);
    const pathChanged = pathname !== $32a808518113ee1c$export$7a9e7a91cdf4fce1;
    $32a808518113ee1c$export$7a9e7a91cdf4fce1 = pathname;
    let route, content, params;
    if (opts.useParamsMatching) {
        const match = $32a808518113ee1c$export$b4ee0d6794375c82(pathname, element.routes, opts.level);
        route = match.routePath;
        content = match.content;
        params = match.params;
    } else {
        route = $32a808518113ee1c$export$e7a685f330e7752(opts.level, pathname);
        content = element.routes[route || "/"] || element.routes["/*"];
        params = {};
    }
    const scrollNode = opts.scrollToNode ? rootNode : opts.scrollNode;
    if (!content || element.state.root.debugging) {
        element.state.root.debugging = false;
        if (opts.onNotFound) opts.onNotFound({
            pathname: pathname,
            route: route,
            element: element
        });
        return;
    }
    if (opts.guards && opts.guards.length) {
        const guardContext = {
            pathname: pathname,
            route: route,
            params: params,
            query: query,
            hash: hash,
            element: element,
            state: state
        };
        const guardResult = $32a808518113ee1c$export$6b398ed5c45e580b(opts.guards, guardContext);
        if (guardResult === false) return;
        if (typeof guardResult === "string") return $32a808518113ee1c$export$5375cda95f0b0eb4(guardResult, el, state, {
            ...options,
            guards: []
        });
    }
    if (opts.pushState) win.history.pushState(state, null, pathname + (search || "") + (hash || ""));
    if (pathChanged || !hashChanged) {
        const stateUpdate = {
            route: route,
            hash: hash,
            debugging: false
        };
        if (Object.keys(params).length) stateUpdate.params = params;
        if (Object.keys(query).length) stateUpdate.query = query;
        if (opts.updateState) element.state.update(stateUpdate, {
            preventContentUpdate: true
        });
        if (contentElementKey && opts.removeOldElement) element[contentElementKey].remove();
        element.set({
            tag: opts.useFragment && "fragment",
            extends: content
        }, {
            contentElementKey: contentElementKey
        });
    }
    if (opts.scrollToTop) scrollNode.scrollTo({
        ...opts.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (opts.scrollToNode) content[contentElementKey].node.scrollTo({
        ...opts.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (hash) {
        const activeNode = doc.getElementById(hash);
        if (activeNode) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - (opts.scrollToOffset || 0);
            scrollNode.scrollTo({
                ...opts.scrollToOptions || {},
                top: top,
                left: 0
            });
        }
    }
    (0, $b4h11.triggerEventOn)("routeChanged", element, opts);
};
var $32a808518113ee1c$export$2e2bcd8739ae039 = $32a808518113ee1c$export$5375cda95f0b0eb4;



'use strict';
const $59e9b7f5a8955db9$export$a6c7ac8248d6e38a = {
    extends: 'Focusable',
    tag: 'a',
    aria: {},
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'currentColor',
    draggable: false,
    attr: {
        href: (el)=>{
            const props = el.props;
            return (0, $235425de3553395f$export$ba06f8f07b4aa3a7)(el, props.href) || (0, $235425de3553395f$export$ba06f8f07b4aa3a7)(el, el.call('exec', props, el).href);
        },
        'aria-label': ({ props: props })=>props.aria ? props.aria.label : props.text
    }
};
const $59e9b7f5a8955db9$export$ebd11618f299a286 = {
    extends: 'Link'
};
const $59e9b7f5a8955db9$export$fce709ebdac448ed = {
    onClick: (event, el, s)=>{
        const { props: props, context: ctx } = el;
        const { href: h, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = props;
        let href = el.call('exec', h, el);
        if (el.call('isString', href) && href.includes('{{')) href = el.call('replaceLiteralsWithObjectFields', href);
        if (stopPropagation) event.stopPropagation();
        if (!href) return;
        const { utils: utils, snippets: snippets, functions: functions, routerOptions: routerOptions } = ctx;
        const root = el.__ref.root;
        const linkIsExternal = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sketch:') || href.startsWith('whatsapp:') || href.startsWith('sms:') || href.startsWith('skype:') || href.startsWith('viber:') || href.startsWith('callto:') || href.startsWith('facetime:') || href.startsWith('facetime-audio:') || href.startsWith('geo:') || href.startsWith('maps:');
        if (href && !linkIsExternal) {
            event.preventDefault();
            try {
                (functions.router || snippets.router || utils.router || (0, $32a808518113ee1c$export$5375cda95f0b0eb4))(href, root, {}, {
                    scrollToOptions: {
                        behaviour: 'instant'
                    },
                    scrollToTop: el.call('isDefined', scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...props.routerOptions
                });
            } catch (e) {
                console.warn(e);
            }
        }
    }
};
const $59e9b7f5a8955db9$export$9a6dc2d0fce7da79 = {
    extends: [
        $59e9b7f5a8955db9$export$a6c7ac8248d6e38a,
        $59e9b7f5a8955db9$export$fce709ebdac448ed
    ]
};


var $7f02b9e3018c9249$exports = {};
var $d4fa7f19f335d32f$exports = {};

$parcel$export($d4fa7f19f335d32f$exports, "Input", () => $d4fa7f19f335d32f$export$f5b8910cec6cf069);
'use strict';
const $d4fa7f19f335d32f$export$f5b8910cec6cf069 = {
    extends: [
        'Focusable'
    ],
    tag: 'input',
    border: 'none',
    type: 'input',
    theme: 'field',
    fontSize: 'A',
    round: 'C',
    lineHeight: '1',
    padding: 'Z2 B',
    attr: {
        pattern: ({ props: props })=>props.pattern,
        minLength: ({ props: props })=>props.minlength,
        maxLength: ({ props: props })=>props.maxlength,
        name: ({ props: props })=>props.name,
        autocomplete: ({ props: props })=>props.autocomplete,
        placeholder: ({ props: props })=>props.placeholder,
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        },
        checked: (el)=>el.call('exec', el.props.checked, el),
        disabled: ({ props: props })=>props.disabled || null,
        readonly: ({ props: props })=>props.readonly,
        required: ({ props: props })=>props.required,
        type: ({ props: props })=>props.type
    }
};


var $213c0d90580abffb$exports = {};

$parcel$export($213c0d90580abffb$exports, "NumberInput", () => $213c0d90580abffb$export$6bf0cd3a219bbade);
'use strict';
const $213c0d90580abffb$export$6bf0cd3a219bbade = {
    extends: [
        'Flex',
        'Input'
    ],
    type: 'number',
    boxSize: 'C+X',
    align: 'center center',
    textAlign: 'center',
    round: 'Y1',
    theme: 'transparent',
    border: 'solid gray3',
    borderWidth: '1px',
    placeholder: '0',
    fontWeight: '400',
    '::-webkit-inner-spin-button': {
        appearance: 'none'
    },
    attr: {
        step: ({ props: props })=>props.step,
        min: ({ props: props })=>props.min,
        max: ({ props: props })=>props.max
    }
};


var $59b438ee4e9b846d$exports = {};

$parcel$export($59b438ee4e9b846d$exports, "Checkbox", () => $59b438ee4e9b846d$export$48513f6b9f8ce62d);
$parcel$export($59b438ee4e9b846d$exports, "CheckboxHgroup", () => $59b438ee4e9b846d$export$8d7a3c6c6de62e1f);
'use strict';
const $59b438ee4e9b846d$export$48513f6b9f8ce62d = {
    extends: 'Focusable',
    tag: 'label',
    boxSize: 'fit-content fit-content',
    cursor: 'pointer',
    round: 'Y',
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked + div': {
            theme: 'primary'
        },
        ':checked + div > svg': {
            transform: 'none',
            opacity: '1'
        },
        attr: {
            checked: (el)=>el.call('exec', el.parent.props.checked)
        }
    },
    Flex: {
        align: 'center center',
        fontSize: 'B1',
        padding: 'V',
        theme: 'field',
        round: 'X2',
        transition: 'background A defaultBezier',
        Icon: {
            icon: 'check',
            opacity: '0',
            transform: 'scale(0.9) rotate(-15deg)',
            transition: 'opacity B defaultBezier'
        }
    }
};
const $59b438ee4e9b846d$export$8d7a3c6c6de62e1f = {
    display: 'flex',
    tag: 'label',
    boxSize: 'fit-content',
    align: 'flex-start flex-start',
    gap: 'A',
    Checkbox: {
        tag: 'div'
    },
    HgroupRows: {
        gap: 'Z1',
        margin: 'Y - - -'
    }
};


var $36ec4dd7c97e9ba6$exports = {};

$parcel$export($36ec4dd7c97e9ba6$exports, "Radio", () => $36ec4dd7c97e9ba6$export$d7b12c4107be0d61);
$parcel$export($36ec4dd7c97e9ba6$exports, "RadioHgroup", () => $36ec4dd7c97e9ba6$export$4a51391209c6c8b9);
'use strict';
const $36ec4dd7c97e9ba6$export$d7b12c4107be0d61 = {
    extends: 'Checkbox',
    Input: {
        type: 'radio',
        ':checked + div:after': {
            opacity: '1'
        }
    },
    Flex: {
        round: '100%',
        padding: 'Y',
        ':after': {
            content: '""',
            display: 'block',
            boxSize: 'X+W1',
            round: '100%',
            background: 'white',
            opacity: '0',
            transition: 'opacity .15s ease-in-out'
        },
        Icon: null
    }
};
const $36ec4dd7c97e9ba6$export$4a51391209c6c8b9 = {
    extends: 'CheckboxHgroup',
    Checkbox: null,
    Radio: {}
};


var $d0c993a5e2b7f197$exports = {};

$parcel$export($d0c993a5e2b7f197$exports, "Toggle", () => $d0c993a5e2b7f197$export$bea8ebba691c5813);
$parcel$export($d0c993a5e2b7f197$exports, "ToggleHgroup", () => $d0c993a5e2b7f197$export$9c397544fb27ca65);
'use strict';
const $d0c993a5e2b7f197$export$bea8ebba691c5813 = {
    extends: 'Checkbox',
    Input: {
        ':checked + div': {
            background: 'green2 +8',
            justifyContent: 'flex-end'
        }
    },
    Flex: {
        boxSize: 'A1 B1',
        padding: '- W_default',
        round: 'D',
        align: 'center flex-start',
        theme: 'field',
        border: 'none',
        transition: 'opacity .15s ease',
        ':after': {
            content: '""',
            boxSize: 'A A',
            round: '100%',
            background: 'white',
            boxShadow: '1px, 1px, Z, gray .2'
        },
        Icon: null
    }
};
const $d0c993a5e2b7f197$export$9c397544fb27ca65 = {
    extends: 'CheckboxHgroup',
    Checkbox: null,
    Toggle: {}
};


var $20f1327918487e94$exports = {};

$parcel$export($20f1327918487e94$exports, "Textarea", () => $20f1327918487e94$export$379139ebc1c2b235);
$parcel$export($20f1327918487e94$exports, "TextareaWithButton", () => $20f1327918487e94$export$b70f05b5c6092f02);
'use strict';
const $20f1327918487e94$export$379139ebc1c2b235 = {
    tag: 'textarea',
    extends: [
        'Input',
        'Flex'
    ],
    variant: 'outlined',
    fontfamily: 'Avenir',
    round: 'Z1',
    placeholder: 'Leave us a message...',
    padding: 'A',
    theme: 'field',
    border: 'none',
    maxWidth: 'G1_default',
    minHeight: 'E_default',
    width: '100%',
    height: 'E1_default',
    fontFamily: 'inherit',
    style: {
        resize: 'none'
    },
    '.simple': {
        theme: 'field',
        round: 'Z2',
        lineHeight: 1.4
    },
    '.outlined': {
        theme: 'field',
        borderWidth: '1px',
        borderStyle: 'solid',
        lineHeight: 1.4,
        placeholder: 'Leave us a message...',
        resize: 'none'
    },
    html: (el, s)=>el.props.value
};
const $20f1327918487e94$export$b70f05b5c6092f02 = {
    display: 'flex',
    gap: 'Y2',
    Textarea: {
        height: 'C2+W',
        minWidth: 'H',
        padding: 'A',
        fontSize: 'Z1',
        round: 'Z2',
        minHeight: 'fit-content'
    },
    SquareButton: {
        background: 'blue',
        Icon: {
            name: 'send'
        }
    }
};


'use strict';
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d4fa7f19f335d32f$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $213c0d90580abffb$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $59b438ee4e9b846d$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $36ec4dd7c97e9ba6$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d0c993a5e2b7f197$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $20f1327918487e94$exports);


var $c038997f2687863c$exports = {};

$parcel$export($c038997f2687863c$exports, "Select", () => $c038997f2687863c$export$ef9b1a59e592288f);
'use strict';
const $c038997f2687863c$export$ef9b1a59e592288f = {
    extends: 'Focusable',
    tag: 'select',
    fontSize: 'A',
    border: 'none',
    boxSizing: 'border-box',
    theme: 'field',
    cursor: 'pointer',
    childProps: {
        tag: 'option',
        attr: {
            value: ({ props: props })=>props.value,
            selected: ({ props: props })=>props.selected,
            disabled: ({ props: props })=>props.disabled
        }
    },
    attr: {
        name: ({ props: props })=>props.name,
        disabled: ({ props: props })=>props.disabled,
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        }
    }
};


var $ca26469f43255c37$exports = {};

$parcel$export($ca26469f43255c37$exports, "Button", () => $ca26469f43255c37$export$353f5b6fc5456de1);
$parcel$export($ca26469f43255c37$exports, "SquareButton", () => $ca26469f43255c37$export$51cd5c72b5e560c6);
$parcel$export($ca26469f43255c37$exports, "CircleButton", () => $ca26469f43255c37$export$235c11ae4b685dbd);
$parcel$export($ca26469f43255c37$exports, "KangorooButton", () => $ca26469f43255c37$export$6fbe98cd572b6a70);
$parcel$export($ca26469f43255c37$exports, "ButtonSet", () => $ca26469f43255c37$export$87e672a75327e04b);
$parcel$export($ca26469f43255c37$exports, "IconButton", () => $ca26469f43255c37$export$c25acd513dcc8062);
'use strict';
const $ca26469f43255c37$export$353f5b6fc5456de1 = {
    extends: [
        'IconText',
        'FocusableComponent'
    ],
    tag: 'button',
    fontSize: 'A',
    type: 'button',
    borderStyle: 'none',
    display: 'inline-flex',
    align: 'center center',
    textDecoration: 'none',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    padding: 'Z B2',
    fontWeight: '500',
    fontFamily: 'inherit',
    round: 'C2',
    disabled: (el)=>el.call('exec', el.props.disabled)
};
const $ca26469f43255c37$export$51cd5c72b5e560c6 = {
    extends: 'Button',
    fontSize: 'A',
    width: 'A',
    padding: 'Z',
    aspectRatio: '1 / 1',
    icon: 'smile',
    boxSize: 'fit-content fit-content',
    justifyContent: 'center',
    round: 'Z',
    boxSizing: 'content-box'
};
const $ca26469f43255c37$export$235c11ae4b685dbd = {
    extends: 'SquareButton',
    round: 'C'
};
const $ca26469f43255c37$export$6fbe98cd572b6a70 = {
    extends: 'Button',
    childExtends: 'IconText'
};
const $ca26469f43255c37$export$87e672a75327e04b = {
    tag: 'nav',
    display: 'flex',
    childExtends: 'SquareButton'
};
const $ca26469f43255c37$export$c25acd513dcc8062 = {
    extends: [
        'SquareButton',
        'ClickableItem'
    ],
    round: 'Z'
};


var $14b0ee601310f298$exports = {};

$parcel$export($14b0ee601310f298$exports, "Dialog", () => $14b0ee601310f298$export$3ddf2d174ce01153);
$parcel$export($14b0ee601310f298$exports, "DialogHeader", () => $14b0ee601310f298$export$742513523b177e3b);
$parcel$export($14b0ee601310f298$exports, "DialogFooter", () => $14b0ee601310f298$export$7bbfb2d443473050);
'use strict';
const $14b0ee601310f298$export$3ddf2d174ce01153 = {
    display: 'flex',
    tag: 'dialog',
    flow: 'column',
    border: '0',
    theme: 'dialog',
    round: 'Z2'
};
const $14b0ee601310f298$export$742513523b177e3b = {
    extends: 'Hgroup',
    minWidth: '100%',
    gap: 'A',
    Title: {
        align: 'center space-between',
        Text: {
            text: 'Title'
        },
        SquareButton: {
            icon: 'x',
            theme: 'transparent'
        }
    },
    Paragraph: {
        color: 'caption'
    }
};
const $14b0ee601310f298$export$7bbfb2d443473050 = {
    display: 'flex',
    align: 'center flex-end',
    gap: 'X2',
    margin: 'auto - -',
    padding: 'Y2 X2',
    childExtends: {
        extends: 'Button',
        textTransform: 'uppercase',
        background: 'transparent',
        '@dark': {
            theme: 'primary @dark .color-only'
        },
        '@light': {
            theme: 'primary @light .color-only'
        },
        '&': {
            padding: 'Z A'
        },
        ':hover': {
            theme: 'tertiary'
        },
        ':active': {
            background: 'white.1'
        }
    },
    Cancel: {
        text: 'cancel'
    },
    Ok: {
        text: 'ok'
    }
};


var $5789735af6bd85de$exports = {};

$parcel$export($5789735af6bd85de$exports, "Tooltip", () => $5789735af6bd85de$export$28c660c63b792dea);
$parcel$export($5789735af6bd85de$exports, "TooltipHidden", () => $5789735af6bd85de$export$92ba62bde414cbb2);
$parcel$export($5789735af6bd85de$exports, "TooltipParent", () => $5789735af6bd85de$export$1d54d90a050b9c15);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
const $5789735af6bd85de$export$28c660c63b792dea = {
    display: 'flex',
    theme: 'dialog',
    background: 'black',
    flow: 'column',
    shape: 'tooltip',
    shapeDirection: 'left',
    padding: 'Z1 A',
    round: 'Y2',
    width: 'fit-content',
    minWidth: 'D2',
    maxWidth: 'F2',
    gap: 'X',
    textAlign: 'center',
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent, props: props })=>(0, $e7Ezu.isDefined)(parent.props.title) || props.text,
        width: 'fit-content',
        fontWeight: 500,
        color: 'gray12',
        text: ({ parent: parent })=>parent.props.title
    },
    P: {
        if: (el, s)=>el.call('isDefined', el.call('exec', el.parent.props.description, el)) || el.props.text,
        width: 'fit-content',
        fontSize: 'Z2',
        margin: '0',
        color: 'gray6',
        fontWeight: '400',
        text: (el, s)=>el.call('exec', el.parent.props.description, el)
    }
};
const $5789735af6bd85de$export$92ba62bde414cbb2 = {
    extends: 'Tooltip',
    position: 'absolute',
    pointerEvents: 'none',
    opacity: '0',
    visibility: 'hidden',
    transition: 'C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform',
    props: ({ props: props })=>({
            ...!props.shapeDirection || props.shapeDirection === 'top' ? {
                top: '112%',
                left: '50%',
                transform: 'translate3d(-50%,10%,0)',
                '.isActive': {
                    transform: 'translate3d(-50%,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : props.shapeDirection === 'right' ? {
                transform: 'translate3d(10%,-50%,0)',
                left: '112%',
                top: '50%',
                '.isActive': {
                    transform: 'translate3d(0%,-50%,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : ({ props: props })=>props.shapeDirection === 'bottom' ? {
                    transform: 'translate3d(-50%,-10%,0)',
                    bottom: '112%',
                    left: '50%',
                    '.isActive': {
                        transform: 'translate3d(-50%,0,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : props.shapeDirection === 'left' ? {
                    transform: 'translate3d(10%,-50%,0)',
                    right: '112%',
                    top: '50%',
                    '.isActive': {
                        transform: 'translate3d(0%,-50%,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : {}
        })
};
const $5789735af6bd85de$export$1d54d90a050b9c15 = {
    position: 'relative',
    zIndex: 999,
    props: (el)=>{
        const { Tooltip: Tooltip, TooltipHidden: TooltipHidden } = el;
        const TooltipElem = Tooltip || TooltipHidden;
        if (!TooltipElem) return;
        const TooltipActive = TooltipElem && TooltipElem.props && TooltipElem.props['.isActive'];
        return {
            ':hover, &:focus-visible': {
                zIndex: 1000,
                '& [tooltip]': TooltipActive || {
                    transform: 'translate3d(-50%, 0, 0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        };
    }
};


var $d0fd1386e51a3c49$exports = {};

$parcel$export($d0fd1386e51a3c49$exports, "Avatar", () => $d0fd1386e51a3c49$export$e2255cf6045e8d47);
'use strict';
const $d0fd1386e51a3c49$export$e2255cf6045e8d47 = {
    extends: 'Img',
    display: 'block',
    avatarType: 'adventurer-neutral',
    borderRadius: '100%',
    boxSize: 'C+X C+X',
    src: (el)=>`https://api.dicebear.com/7.x/${el.props.avatarType || 'initials'}/svg?seed=${el.props.key || el.key || 'no-avatar'}`
};


var $781e0e9576e3e707$exports = {};

$parcel$export($781e0e9576e3e707$exports, "Range", () => $781e0e9576e3e707$export$9a58ef0d7ad3278c);

'use strict';
const $781e0e9576e3e707$export$9a58ef0d7ad3278c = {
    tag: 'input',
    appearance: 'none',
    width: '100%',
    height: '2px',
    outline: 'none',
    flex: 1,
    onInput: (ev, el, s)=>{
        const props = el.props;
        if (el.call('isFunction', props.onInput)) props.onInput(ev, el, s);
        else s.update({
            value: parseFloat(el.node.value)
        });
    },
    onChange: (ev, el, s)=>{
        const props = el.props;
        if (el.call('isFunction', props.onChange)) props.onChange(ev, el, s);
        else s.update({
            value: parseFloat(el.node.value)
        });
    },
    '::-webkit-slider-thumb': {
        boxSizing: 'content-box',
        width: '8px',
        height: '8px',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderRadius: '100%',
        opacity: '.8',
        appearance: 'none'
    },
    '::-webkit-slider-runnable-track': {},
    '@dark': {
        background: 'white.2',
        '::-webkit-slider-thumb': {
            background: '#232526',
            borderColor: (0, $d49bd28b97ddb649$export$f4f50e3877dd0530)('#454646', 0.75)
        },
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: (0, $d49bd28b97ddb649$export$f4f50e3877dd0530)('#fff', 0.35)
            }
        },
        ':focus': {
            '::-webkit-slider-thumb': {
                borderColor: '#3C6AC0'
            }
        }
    },
    '@light': {
        background: 'gray9',
        '::-webkit-slider-thumb': {
            background: 'white',
            borderColor: 'gray9'
        },
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: 'gray7'
            }
        },
        ':focus': {
            '::-webkit-slider-thumb': {
                borderColor: 'blue'
            }
        }
    },
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el.props && el.call('exec', el.props[property], el);
            const r = el.call('isFunction', val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
            return r + '';
        }
    },
    attr: {
        type: 'range',
        value: (el, s)=>el.call('exec', s.value || el.props.value || el.props.defaultValue, el),
        min: (el, s)=>el.deps.returnPropertyValue(el, 'min', 0),
        max: (el, s)=>el.deps.returnPropertyValue(el, 'max', 100),
        step: (el, s)=>el.deps.returnPropertyValue(el, 'step', 1)
    }
};


var $954e4cb4adbc0299$exports = {};

$parcel$export($954e4cb4adbc0299$exports, "DropdownList", () => $954e4cb4adbc0299$export$e40cc1c58d22b809);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParent", () => $954e4cb4adbc0299$export$b162207c9836937);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParentFocus", () => $954e4cb4adbc0299$export$89c2e92edc22fd8f);
$parcel$export($954e4cb4adbc0299$exports, "DropdownSiblingFocus", () => $954e4cb4adbc0299$export$60701cc380f56748);
'use strict';
const $954e4cb4adbc0299$export$e40cc1c58d22b809 = {
    display: 'flex',
    attr: {
        dropdown: true
    },
    padding: '0 Y',
    maxHeight: 'G',
    flow: 'column',
    theme: 'quaternary',
    overflow: 'hidden auto',
    style: {
        listStyleType: 'none'
    },
    transition: 'B defaultBezier',
    transitionProperty: 'transform, opacity, visibility',
    children: ({ props: props })=>props.options || [],
    childrenAs: 'props',
    '.hidden': {
        transform: 'translate3d(0,10%,0)',
        opacity: 0,
        visibility: 'hidden'
    },
    childExtends: {
        extends: 'Button',
        state: {},
        isActive: ({ key: key, state: state })=>state.active === key,
        position: 'relative',
        round: '0',
        align: 'center flex-end',
        flow: 'row-reverse',
        padding: 'Z2 C Z2 Y2',
        margin: '0',
        gap: 'Y2',
        theme: 'quaternary .child',
        ':hover': {
            style: {
                svg: {
                    opacity: '0.5'
                }
            }
        },
        Icon: {
            isActive: ({ key: key, state: state })=>state.active === key,
            name: 'checkmark',
            opacity: '0.1',
            '.active': {
                opacity: '1'
            }
        },
        ':not(:first-child)': {
            '@dark': {
                border: 'solid gray4.65'
            },
            '@light': {
                border: 'solid gray11'
            },
            borderWidth: '1px 0 0'
        }
    }
};
const $954e4cb4adbc0299$export$b162207c9836937 = {
    position: 'relative',
    zIndex: 999,
    style: {
        '&:hover': {
            zIndex: 1000,
            '& [dropdown]': {
                transform: 'translate3d(0,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        }
    }
};
const $954e4cb4adbc0299$export$89c2e92edc22fd8f = {
    position: 'relative',
    tabindex: '0',
    style: {
        '&:focus-within': {
            zIndex: 1000,
            '& [dropdown]': {
                transform: 'translate3d(0,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        visibility: 'hidden',
        position: 'absolute',
        inset: '0',
        onUpdate: (el)=>el.node.blur()
    },
    Dropdown: {
        // onClick: (ev, el) => el.parent.Input_trigger.node.blur()
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
};
const $954e4cb4adbc0299$export$60701cc380f56748 = {
    props: {
        position: 'relative',
        tabindex: '0',
        style: {
            '&:focus-within': {
                zIndex: 1000,
                '& ~ [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        visibility: 'hidden',
        position: 'absolute',
        inset: '0',
        onUpdate: (el)=>el.node.blur()
    }
};


var $e39e4f558cd2a095$exports = {};

$parcel$export($e39e4f558cd2a095$exports, "Notification", () => $e39e4f558cd2a095$export$14834abbfce3b8cd);
'use strict';
const $e39e4f558cd2a095$export$14834abbfce3b8cd = {
    display: 'flex',
    theme: 'alert',
    padding: 'Z1 B Z A',
    round: 'A A A Y2',
    gap: 'X2',
    cursor: 'pointer',
    align: 'flex-start center',
    IconText: {
        Icon: {
            name: 'info outline'
        },
        Text: {
            ':empty': {
                hide: true
            }
        }
    },
    Hgroup: {
        extends: [
            'Flex',
            'Hgroup'
        ],
        flow: 'y',
        align: 'flex-start',
        gap: 'X2',
        H: {
            tag: 'h6',
            margin: '0',
            fontWeight: '600',
            lineHeight: '1em',
            text: 'Notification',
            ':empty': {
                hide: true
            }
        },
        P: {
            fontSize: 'Z',
            margin: '0',
            text: 'is not always a distraction',
            ':empty': {
                hide: true
            }
        }
    }
};


'use strict';
$parcel$exportWildcard($be006f1a0fabd945$exports, $73d59c6c3fce378b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f8a17223267b0208$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $59e9b7f5a8955db9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7f02b9e3018c9249$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c038997f2687863c$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ca26469f43255c37$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $14b0ee601310f298$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5789735af6bd85de$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d0fd1386e51a3c49$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $781e0e9576e3e707$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $954e4cb4adbc0299$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $e39e4f558cd2a095$exports);



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $0daf8c2ff7816ad9$exports = {};

$parcel$export($0daf8c2ff7816ad9$exports, "applyCSS", () => $7d124ec5af804dac$export$3a26aa64e59aeaff);
$parcel$export($0daf8c2ff7816ad9$exports, "init", () => $7d124ec5af804dac$export$2cd8252107eb640b);
$parcel$export($0daf8c2ff7816ad9$exports, "reinit", () => $7d124ec5af804dac$export$b545ad0f2df0be16);
$parcel$export($0daf8c2ff7816ad9$exports, "scratchSystem", () => $0d39b47118642cb9$exports);
$parcel$export($0daf8c2ff7816ad9$exports, "scratchUtils", () => $fe979a89f55fc528$exports);
$parcel$export($0daf8c2ff7816ad9$exports, "set", () => $94f11aa15e4fc75e$export$adaa4cf7ef1b65be);
var $0d39b47118642cb9$exports = {};







var $7a2206a9182ab531$exports = {};

$parcel$export($7a2206a9182ab531$exports, "applyDocument", () => $7a2206a9182ab531$export$25b333cdc54cc186);
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");


const $7a2206a9182ab531$export$25b333cdc54cc186 = ()=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { DOCUMENT: DOCUMENT, FONT_FAMILY: FONT_FAMILY, THEME: THEME, TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $g1LU2.merge)(DOCUMENT, {
        theme: THEME.document,
        fontFamily: (0, $69026df1e768b48e$export$73aa7d12a2d2fb83)(FONT_FAMILY),
        fontSize: TYPOGRAPHY.base,
        lineHeight: TYPOGRAPHY.lineHeight
    });
};


var $ea2a29e9da15b058$exports = {};

$parcel$export($ea2a29e9da15b058$exports, "setSVG", () => $ea2a29e9da15b058$export$694c6c574069ebf2);
$parcel$export($ea2a29e9da15b058$exports, "appendSVGSprite", () => $ea2a29e9da15b058$export$2c4662f4a995c568);
$parcel$export($ea2a29e9da15b058$exports, "setSvgIcon", () => $ea2a29e9da15b058$export$46739718ff556447);
$parcel$export($ea2a29e9da15b058$exports, "appendSvgIconsSprite", () => $ea2a29e9da15b058$export$6892263c3fbefa8c);
parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");
var $9bcfa99ed38fca9d$exports = {};

$parcel$export($9bcfa99ed38fca9d$exports, "generateSprite", () => $9bcfa99ed38fca9d$export$121b8d85aca89bf6);
$parcel$export($9bcfa99ed38fca9d$exports, "convertSvgToSymbol", () => $9bcfa99ed38fca9d$export$510fb280711ea968);
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $eo3lV = parcelRequire("eo3lV");

const $9bcfa99ed38fca9d$var$isDev = (0, $eo3lV.isNotProduction)();
const $9bcfa99ed38fca9d$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    let sprite = "";
    for(const key in icons){
        if (CONFIG.__svg_cache[key]) continue;
        else CONFIG.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $9bcfa99ed38fca9d$var$parseRootAttributes = (htmlString)=>{
    const val = htmlString.default || htmlString;
    if (!(0, $e7Ezu.isString)(val)) {
        if ($9bcfa99ed38fca9d$var$isDev) console.warn("parseRootAttributes:", val, "is not a string");
        return;
    }
    const match = val.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split("=");
        acc[key] = value.replace(/['"]/g, "");
        return acc;
    }, {});
};
const $9bcfa99ed38fca9d$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $e7Ezu.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 1e5);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $9bcfa99ed38fca9d$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $9bcfa99ed38fca9d$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = "http://www.w3.org/2000/svg";
    const replacedCode = $9bcfa99ed38fca9d$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace("<svg", `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, "");
    symbol = symbol.replace(/height="[^"]*"/, "");
    symbol = symbol.replace("</svg", "</symbol");
    return symbol;
};



const $ea2a29e9da15b058$var$DEF_OPTIONS = {
    document: $bD06b.document
};
const $ea2a29e9da15b058$export$694c6c574069ebf2 = (val, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (!val) {
        if (CONFIG.verbose) console.warn("setSVG: val is not defined", key);
        return;
    }
    if (CONFIG.useSvgSprite) return (0, $9bcfa99ed38fca9d$export$510fb280711ea968)(key, val);
    return val;
};
const $ea2a29e9da15b058$export$2c4662f4a995c568 = (LIBRARY, options = $ea2a29e9da15b058$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.SVG;
    for(const key in LIBRARY)lib[key] = CONFIG.SVG[key];
    $ea2a29e9da15b058$var$appendSVG(lib, options);
};
const $ea2a29e9da15b058$export$46739718ff556447 = (val, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    if (CONFIG.useIconSprite && !CONFIG.SEMANTIC_ICONS?.[key]) return $ea2a29e9da15b058$export$694c6c574069ebf2(val, key);
    return val;
};
const $ea2a29e9da15b058$export$6892263c3fbefa8c = (LIBRARY, options = $ea2a29e9da15b058$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.ICONS;
    for(const key in LIBRARY)lib[key] = CONFIG.ICONS[key];
    $ea2a29e9da15b058$var$appendSVG(lib, options);
};
const $ea2a29e9da15b058$var$createSVGSpriteElement = (options = {
    isRoot: true
})=>{
    if (!(0, $bD06b.document) || !(0, $bD06b.document).createElementNS) return;
    const svgElem = (0, $bD06b.document).createElementNS("http://www.w3.org/2000/svg", "svg");
    if (options.isRoot) {
        svgElem.setAttribute("aria-hidden", "true");
        svgElem.setAttribute("width", "0");
        svgElem.setAttribute("height", "0");
        svgElem.setAttribute("style", "position:absolute");
        svgElem.setAttribute("id", "svgSprite");
    }
    return svgElem;
};
const $ea2a29e9da15b058$var$appendSVG = (lib, options = $ea2a29e9da15b058$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const doc = options.document || (0, $bD06b.document);
    if (!doc || !doc.documentElement) {
        if (CONFIG.verbose) console.warn("To append SVG sprites it should be run in browser environment");
        return (0, $9bcfa99ed38fca9d$export$121b8d85aca89bf6)(lib);
    }
    const exists = doc.querySelector("#svgSprite");
    const SVGsprite = (0, $9bcfa99ed38fca9d$export$121b8d85aca89bf6)(lib);
    if (exists) {
        const tempSVG = $ea2a29e9da15b058$var$createSVGSpriteElement({
            isRoot: false
        });
        tempSVG.innerHTML = SVGsprite;
        exists.append(...tempSVG.children);
    } else {
        const svgSpriteDOM = $ea2a29e9da15b058$var$createSVGSpriteElement();
        if (svgSpriteDOM && svgSpriteDOM.nodeType) {
            svgSpriteDOM.innerHTML = SVGsprite;
            doc.body.prepend(svgSpriteDOM);
        }
    }
};


var $2d6d0ec39ad07fce$exports = {};

$parcel$export($2d6d0ec39ad07fce$exports, "applyReset", () => $2d6d0ec39ad07fce$export$984fb5f73961424e);
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");


const $2d6d0ec39ad07fce$export$984fb5f73961424e = (reset = {})=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { RESET: RESET, TYPOGRAPHY: TYPOGRAPHY, DOCUMENT: DOCUMENT } = CONFIG;
    if (RESET) {
        if (RESET[":root"]) {
            const configReset = RESET;
            const configTemplates = TYPOGRAPHY.templates;
            configReset.body = {
                ...CONFIG.useDocumentTheme ? (0, $faa3e5b310b9cc9c$export$b3cf7317de2f2233)("document") : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY.templates;
        const globalTheme = CONFIG.useDocumentTheme ? (0, $faa3e5b310b9cc9c$export$b3cf7317de2f2233)("document") : {};
        if (RESET.html) (0, $g1LU2.overwriteDeep)(RESET.html, globalTheme);
        return (0, $g1LU2.deepMerge)((0, $g1LU2.merge)(RESET, reset), {
            html: {
                position: "absolute",
                // overflow: 'hidden',
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...globalTheme,
                fontSize: TYPOGRAPHY.browserDefault + "px",
                fontFamily: DOCUMENT.fontFamily,
                lineHeight: DOCUMENT.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: DOCUMENT.fontFamily,
                fontSize: TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + CONFIG.UNIT.default,
                ...templates,
                ...body
            },
            a: {
                color: "currentColor"
            },
            // form elements
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: DOCUMENT.fontFamily
            }
        });
    }
};


$parcel$exportWildcard($0d39b47118642cb9$exports, $232c9281a8f7b24b$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $faa3e5b310b9cc9c$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $6c2784ef9a7b4251$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $c0cda698d68ed165$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $82d690e9f70ef2c9$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $964ba5cf20bdbfc1$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $ad7739c5bf717870$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $7a2206a9182ab531$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $ea2a29e9da15b058$exports);
$parcel$exportWildcard($0d39b47118642cb9$exports, $2d6d0ec39ad07fce$exports);

var $fe979a89f55fc528$exports = {};


var $84bffcedfeddb162$exports = {};

$parcel$export($84bffcedfeddb162$exports, "returnSubThemeOrDefault", () => $84bffcedfeddb162$export$b653d4648867fe18);
const $84bffcedfeddb162$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};






$parcel$exportWildcard($fe979a89f55fc528$exports, $a1be1bae5b4015a7$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $d49bd28b97ddb649$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $84bffcedfeddb162$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $69026df1e768b48e$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $48a67b64ca668600$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $4e7bc1998c817803$exports);
$parcel$exportWildcard($fe979a89f55fc528$exports, $9bcfa99ed38fca9d$exports);



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
const $94f11aa15e4fc75e$var$setCases = (val, key)=>{
    if ((0, $e7Ezu.isFunction)(val)) return val();
    return val;
};
const $94f11aa15e4fc75e$var$setSameValue = (val, key)=>val;
const $94f11aa15e4fc75e$export$9ae1d0dd64d4a382 = {
    color: (0, $232c9281a8f7b24b$export$130a5dc1bc9cd8e1),
    gradient: (0, $232c9281a8f7b24b$export$afaa8352c6a43a44),
    font: (0, $6c2784ef9a7b4251$export$69e9bdef456a9c46),
    font_family: (0, $6c2784ef9a7b4251$export$5fae120d779aafec),
    theme: (0, $faa3e5b310b9cc9c$export$2e49b867b7a0847c),
    icons: (0, $ea2a29e9da15b058$export$46739718ff556447),
    semantic_icons: $94f11aa15e4fc75e$var$setSameValue,
    svg: (0, $ea2a29e9da15b058$export$694c6c574069ebf2),
    svg_data: $94f11aa15e4fc75e$var$setSameValue,
    typography: $94f11aa15e4fc75e$var$setSameValue,
    cases: $94f11aa15e4fc75e$var$setCases,
    shadow: (0, $964ba5cf20bdbfc1$export$9cd3672191b5a46f),
    spacing: $94f11aa15e4fc75e$var$setSameValue,
    media: $94f11aa15e4fc75e$var$setSameValue,
    grid: $94f11aa15e4fc75e$var$setSameValue,
    class: $94f11aa15e4fc75e$var$setSameValue,
    timing: $94f11aa15e4fc75e$var$setSameValue,
    reset: $94f11aa15e4fc75e$var$setSameValue,
    unit: $94f11aa15e4fc75e$var$setSameValue,
    animation: $94f11aa15e4fc75e$var$setSameValue
};
const $94f11aa15e4fc75e$export$80746c6bc6142fc8 = (factoryName, value, key)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const lowerName = factoryName.toLowerCase();
    const FACTORY2 = CONFIG[lowerName] || CONFIG[factoryName];
    if ($94f11aa15e4fc75e$export$9ae1d0dd64d4a382[lowerName]) try {
        const result = $94f11aa15e4fc75e$export$9ae1d0dd64d4a382[lowerName](value, key);
        FACTORY2[key] = result;
        return FACTORY2;
    } catch (error) {
        if (CONFIG.verbose) console.warn("Error setting", lowerName, "value", value, key, error);
    }
    if (CONFIG.verbose) console.warn("Can not find", lowerName, "method in scratch");
};
const $94f11aa15e4fc75e$export$943920cf7e6d5f23 = (factoryName, props)=>{
    const CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const lowerName = factoryName.toLowerCase();
    const keys = Object.keys(props);
    keys.forEach((key)=>{
        try {
            return $94f11aa15e4fc75e$export$80746c6bc6142fc8(lowerName, props[key], key);
        } catch (error) {
            if (CONFIG.verbose) console.warn("Error setting", lowerName, "value", props[key], key, error);
        }
    });
    return CONFIG[lowerName] || CONFIG[factoryName];
};
const $94f11aa15e4fc75e$var$SET_OPTIONS = {};
const $94f11aa15e4fc75e$export$adaa4cf7ef1b65be = (recivedConfig, options = $94f11aa15e4fc75e$var$SET_OPTIONS)=>{
    let CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, SEMANTIC_ICONS: SEMANTIC_ICONS, semantic_icons: semantic_icons, files: files, ...config } = recivedConfig;
    if (options.newConfig) CONFIG = (0, $e2cb0be23d169790$export$5e61d1b6fff0c794)(options.newConfig);
    if (files !== void 0) CONFIG.files = files;
    if (verbose !== void 0) CONFIG.verbose = verbose;
    if (useVariable !== void 0) CONFIG.useVariable = useVariable;
    if (useReset !== void 0) CONFIG.useReset = useReset;
    if (useFontImport !== void 0) CONFIG.useFontImport = useFontImport;
    if (useSvgSprite !== void 0) CONFIG.useSvgSprite = useSvgSprite;
    if (useIconSprite !== void 0) CONFIG.useIconSprite = useIconSprite;
    if (useDocumentTheme !== void 0) CONFIG.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== void 0) CONFIG.globalTheme = globalTheme;
    if (recivedConfig.useThemeSuffixedVars !== void 0) CONFIG.useThemeSuffixedVars = recivedConfig.useThemeSuffixedVars;
    if (useDefaultConfig !== void 0) CONFIG.useDefaultConfig = useDefaultConfig;
    const _semanticIcons = SEMANTIC_ICONS || semantic_icons;
    if (_semanticIcons !== void 0) {
        CONFIG.semantic_icons = _semanticIcons;
        CONFIG.SEMANTIC_ICONS = CONFIG.semantic_icons;
    }
    if (CONFIG.verbose) console.log(CONFIG);
    if (!CONFIG.__svg_cache) CONFIG.__svg_cache = {};
    const keys = Object.keys(config);
    const keySet = new Set(keys);
    keys.forEach((key)=>{
        const lower = key.toLowerCase();
        if (lower !== key && keySet.has(lower)) (0, $g1LU2.deepMerge)(config[lower], config[key]);
    });
    keys.map((key)=>{
        const lower = key.toLowerCase();
        if (lower !== key && keySet.has(lower)) return;
        return $94f11aa15e4fc75e$export$943920cf7e6d5f23(key, config[key]);
    });
    if (config.TYPOGRAPHY || config.typography) try {
        (0, $c0cda698d68ed165$export$7c7d7b0d076fe8b5)();
    } catch (e) {
        if (CONFIG.verbose) console.warn("Error applying typography sequence", e);
    }
    if (config.SPACING || config.spacing) try {
        (0, $82d690e9f70ef2c9$export$9bfe8384addafa7c)();
    } catch (e) {
        if (CONFIG.verbose) console.warn("Error applying spacing sequence", e);
    }
    if (config.TIMING || config.timing) try {
        (0, $ad7739c5bf717870$export$a5be618f63a441ac)();
    } catch (e) {
        if (CONFIG.verbose) console.warn("Error applying timing sequence", e);
    }
    (0, $7a2206a9182ab531$export$25b333cdc54cc186)();
    (0, $2d6d0ec39ad07fce$export$984fb5f73961424e)();
    return CONFIG;
};



var $jgAqB = parcelRequire("jgAqB");


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

var $eca075ad100d834d$exports = {};
"use strict";


var $7d124ec5af804dac$var$__filename = "node_modules/smbls/dist/esm/src/init.js";
let $7d124ec5af804dac$export$1370ffb96395fc6c = {};
try {
    const _url = typeof $7d124ec5af804dac$var$__filename !== "undefined" ? $7d124ec5af804dac$var$__filename : "file:///node_modules/smbls/dist/esm/src/init.js";
    const require2 = (0, $eca075ad100d834d$exports.createRequire)(_url);
    $7d124ec5af804dac$export$1370ffb96395fc6c = require2("../dynamic.json");
} catch  {}
const $7d124ec5af804dac$var$CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
const $7d124ec5af804dac$var$mergeWithLocalFile = (config = $7d124ec5af804dac$var$CONFIG, options)=>{
    const rcfile = (0, $e7Ezu.isObject)(options.localFile) ? options.localFile : $7d124ec5af804dac$export$1370ffb96395fc6c || {};
    const clonedFile = (0, $g1LU2.deepClone)(rcfile.designSystem || {});
    return (0, $g1LU2.deepMerge)(config, clonedFile);
};
const $7d124ec5af804dac$var$SET_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $7d124ec5af804dac$export$2cd8252107eb640b = (config, options = $7d124ec5af804dac$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $7d124ec5af804dac$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $94f11aa15e4fc75e$export$adaa4cf7ef1b65be)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        globalTheme: options.globalTheme,
        files: options.files,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $69026df1e768b48e$export$8b73d71a1d936bc)(conf.font || conf.FONT, conf.files);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) {
        emotion.injectGlobal({
            ":root": conf.CSS_VARS
        });
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith("@media")) themeStyles[key] = {
                ":root:not([data-theme])": conf.CSS_MEDIA_VARS[key]
            };
            else themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            emotion.injectGlobal(themeStyles);
        }
    }
    if (useReset) emotion.injectGlobal(conf.reset || conf.RESET);
    const animations = conf.animation || conf.ANIMATION;
    if (animations) {
        const keyframesCSS = {};
        for(const name in animations)keyframesCSS[`@keyframes ${name}`] = animations[name];
        emotion.injectGlobal(keyframesCSS);
    }
    if (hasSvgs || useSvgSprite) (0, $ea2a29e9da15b058$export$2c4662f4a995c568)(conf.svg || conf.SVG, {
        document: options.document
    });
    if (hasIcons || useIconSprite) (0, $ea2a29e9da15b058$export$6892263c3fbefa8c)(conf.icons || conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $7d124ec5af804dac$var$UPDATE_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90)
};
const $7d124ec5af804dac$export$b545ad0f2df0be16 = (config, options = $7d124ec5af804dac$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $7d124ec5af804dac$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $94f11aa15e4fc75e$export$adaa4cf7ef1b65be)({
        verbose: false,
        ...resultConfig
    });
    if (!options.preventInject) {
        emotion.injectGlobal({
            ":root": conf.CSS_VARS
        });
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith("@media")) themeStyles[key] = {
                ":root:not([data-theme])": conf.CSS_MEDIA_VARS[key]
            };
            else themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            emotion.injectGlobal(themeStyles);
        }
        emotion.injectGlobal(conf.RESET);
    }
    return conf;
};
const $7d124ec5af804dac$export$3a26aa64e59aeaff = (styles, options = $7d124ec5af804dac$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $7d124ec5af804dac$export$ed2c61d2d8a098be = (config, options = $7d124ec5af804dac$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ":root": config.CSS_VARS
    });
    if (config.CSS_MEDIA_VARS) {
        const themeStyles = {};
        for(const key in config.CSS_MEDIA_VARS)if (key.startsWith("@media")) themeStyles[key] = {
            ":root:not([data-theme])": config.CSS_MEDIA_VARS[key]
        };
        else themeStyles[key] = config.CSS_MEDIA_VARS[key];
        emotion.injectGlobal(themeStyles);
    }
};
const $7d124ec5af804dac$export$2796c4ce44e61efa = (props, options = $7d124ec5af804dac$var$UPDATE_OPTIONS)=>{};




$parcel$exportWildcard($0daf8c2ff7816ad9$exports, $jgAqB);
$parcel$exportWildcard($0daf8c2ff7816ad9$exports, $18086de584b972dd$exports);
$parcel$exportWildcard($0daf8c2ff7816ad9$exports, $06908963bda72849$exports);
$parcel$exportWildcard($0daf8c2ff7816ad9$exports, $32a808518113ee1c$exports);


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $bD06b = parcelRequire("bD06b");


const $2a3f98c527233ec8$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $2a3f98c527233ec8$export$cf7ee87ede64229c = (element, context)=>{
    if (context.router === false) return;
    else if (context.router === true) context.router = $2a3f98c527233ec8$var$DEFAULT_ROUTING_OPTIONS;
    else context.router = (0, $g1LU2.merge)(context.router || {}, $2a3f98c527233ec8$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = context.router;
    const onRouterRenderDefault = async (el, s)=>{
        if (!(0, $bD06b.window).location) return;
        const { pathname: pathname, search: search, hash: hash } = (0, $bD06b.window).location;
        const url = pathname + search + hash;
        if (el.routes) await (0, $32a808518113ee1c$export$5375cda95f0b0eb4)(url, el, {}, {
            initialRender: true
        });
    };
    const hasRenderRouter = element.on && !(0, $e7Ezu.isUndefined)(element.on.renderRouter) || !(0, $e7Ezu.isUndefined)(element.onRenderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) {
        if (element.on) element.on.renderRouter = onRouterRenderDefault;
        else element.on = {
            renderRouter: onRouterRenderDefault
        };
    }
    $2a3f98c527233ec8$export$54b760094ac80b64(context, routerOptions);
    return routerOptions;
};
let $2a3f98c527233ec8$var$popStateFired;
const $2a3f98c527233ec8$export$7fe20beff2421d2d = (element, context)=>{
    if ($2a3f98c527233ec8$var$popStateFired) return;
    $2a3f98c527233ec8$var$popStateFired = true;
    const routerOptions = context.router || $2a3f98c527233ec8$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    const router = context.utils && context.utils.router ? context.utils.router : (0, $32a808518113ee1c$export$5375cda95f0b0eb4);
    (0, $bD06b.window).onpopstate = async (e)=>{
        const { pathname: pathname, search: search, hash: hash } = (0, $bD06b.window).location;
        const url = pathname + search + hash;
        await element.call("router", url, element, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0,
            event: e
        });
    };
};
const $2a3f98c527233ec8$export$54b760094ac80b64 = (context, routerOptions)=>{
    const { components: components } = context;
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $g1LU2.deepMerge)(components["Link"] || components["smbls.Link"], components["RouterLink"] || components["smbls.RouterLink"]);
};


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");

var $jgAqB = parcelRequire("jgAqB");
const { window: $2550e36c47c35765$var$window, overwriteDeep: $2550e36c47c35765$var$overwriteDeep, deepDestringifyFunctions: $2550e36c47c35765$var$deepDestringifyFunctions } = $jgAqB;
const $2550e36c47c35765$var$IS_DEVELOPMENT = $2550e36c47c35765$var$window && $2550e36c47c35765$var$window.location ? $2550e36c47c35765$var$window.location.host.includes("dev.") : $jgAqB.isDevelopment();
const $2550e36c47c35765$var$SERVER_URL = $2550e36c47c35765$var$IS_DEVELOPMENT ? "http://localhost:8080/get" : "https://api.symbols.app/get";
const $2550e36c47c35765$var$defaultOptions = {
    endpoint: $2550e36c47c35765$var$SERVER_URL
};
const $2550e36c47c35765$export$e7aa7bc5c1b3cfb3 = globalThis.fetch;
const $2550e36c47c35765$export$db36d2f1649120da = async (key, options = $2550e36c47c35765$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $2550e36c47c35765$var$SERVER_URL;
    const route = options.serviceRoute ? $jgAqB.isArray(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase() + "=true").join("&") : options.serviceRoute : "";
    let response;
    try {
        response = await $2550e36c47c35765$export$e7aa7bc5c1b3cfb3(baseUrl + "/?" + route, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": key,
                "X-Metadata": options.metadata
            }
        });
        return await response.json();
    } catch (e) {
        if ($jgAqB.isFunction(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $2550e36c47c35765$export$525bc467aeb111d5 = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $2550e36c47c35765$export$db36d2f1649120da(key, editor);
        const evalData = $2550e36c47c35765$var$IS_DEVELOPMENT || options.isDevelopment ? $2550e36c47c35765$var$deepDestringifyFunctions(data) : $2550e36c47c35765$var$deepDestringifyFunctions(data.releases[0]);
        if (editor.serviceRoute) {
            if ($jgAqB.isArray(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                $2550e36c47c35765$var$overwriteDeep(options[route], evalData[route.toLowerCase()]);
            });
            else $2550e36c47c35765$var$overwriteDeep(options[editor.serviceRoute], evalData);
        } else [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages",
            "utils",
            "files",
            "packages",
            "functions"
        ].forEach((key2)=>{
            $2550e36c47c35765$var$overwriteDeep(options[key2], evalData[key2.toLowerCase()]);
        });
    }
    return options;
};
const $2550e36c47c35765$export$571411efd7718583 = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $2550e36c47c35765$export$db36d2f1649120da(key, editor);
        const evalData = $2550e36c47c35765$var$IS_DEVELOPMENT || options.isDevelopment ? $2550e36c47c35765$var$deepDestringifyFunctions(data) : $2550e36c47c35765$var$deepDestringifyFunctions(data.releases[0]);
        callback(evalData);
    }
};


const $e8b5c76650b7dedc$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await (0, $2550e36c47c35765$export$525bc467aeb111d5)(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $e8b5c76650b7dedc$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        if (options.editor.async) (0, $2550e36c47c35765$export$571411efd7718583)(key, options, callback || ((data)=>{
            const designSystem = data.designSystem;
            if ((0, $e7Ezu.isObject)(designSystem)) options.utils.init(designSystem);
            if ((0, $e7Ezu.isObject)(data.state)) app.state.set(data.state);
        }));
    } catch (e) {
        console.error(e);
    }
};


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
'use strict';
// ── Meta tag registry ──────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$META_TAGS = {
    title: {
        tag: 'title'
    },
    description: {
        tag: 'meta',
        attr: 'name',
        key: 'description'
    },
    keywords: {
        tag: 'meta',
        attr: 'name',
        key: 'keywords'
    },
    robots: {
        tag: 'meta',
        attr: 'name',
        key: 'robots'
    },
    author: {
        tag: 'meta',
        attr: 'name',
        key: 'author'
    },
    canonical: {
        tag: 'link',
        attr: 'rel',
        key: 'canonical',
        valueAttr: 'href'
    },
    image: {
        tag: 'meta',
        attr: 'property',
        key: 'og:image'
    },
    url: {
        tag: 'meta',
        attr: 'property',
        key: 'og:url'
    },
    siteName: {
        tag: 'meta',
        attr: 'property',
        key: 'og:site_name'
    },
    type: {
        tag: 'meta',
        attr: 'property',
        key: 'og:type'
    },
    locale: {
        tag: 'meta',
        attr: 'property',
        key: 'og:locale'
    },
    'og:title': {
        tag: 'meta',
        attr: 'property',
        key: 'og:title'
    },
    'og:description': {
        tag: 'meta',
        attr: 'property',
        key: 'og:description'
    },
    'og:image': {
        tag: 'meta',
        attr: 'property',
        key: 'og:image'
    },
    'og:url': {
        tag: 'meta',
        attr: 'property',
        key: 'og:url'
    },
    'og:type': {
        tag: 'meta',
        attr: 'property',
        key: 'og:type'
    },
    'og:site_name': {
        tag: 'meta',
        attr: 'property',
        key: 'og:site_name'
    },
    'og:locale': {
        tag: 'meta',
        attr: 'property',
        key: 'og:locale'
    },
    'twitter:card': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:card'
    },
    'twitter:title': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:title'
    },
    'twitter:description': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:description'
    },
    'twitter:image': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:image'
    },
    'twitter:site': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:site'
    },
    'theme-color': {
        tag: 'meta',
        attr: 'name',
        key: 'theme-color'
    }
};
// ── Shared utilities ────────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$createQuery = (obj)=>{
    if (obj.tag === 'link') return `link[${obj.attr}="${obj.key}"]`;
    if (obj.tag && !obj.attr && !obj.key) return obj.tag;
    if (obj.tag && obj.attr && obj.key) return `${obj.tag}[${obj.attr}="${obj.key}"]`;
};
const $84f66b9cc4cc43c7$export$d2032d3864484f3 = (metadata, element, state)=>{
    if (!metadata) return {};
    const resolved = (0, $e7Ezu.isFunction)(metadata) ? (0, $g1LU2.exec)(metadata, element, state) : {
        ...metadata
    };
    if (!(0, $e7Ezu.isObject)(resolved)) return {};
    for(const key in resolved)if ((0, $e7Ezu.isFunction)(resolved[key])) resolved[key] = (0, $g1LU2.exec)(resolved[key], element, state);
    return resolved;
};
const $84f66b9cc4cc43c7$export$ff8c3ec904fd95bb = (data, route = '/', element, state)=>{
    const pages = data.pages || {};
    const page = pages[route];
    let metadata = {};
    if (data.integrations?.seo) metadata = {
        ...data.integrations.seo
    };
    if (data.app?.metadata) {
        const appMeta = $84f66b9cc4cc43c7$export$d2032d3864484f3(data.app.metadata, element, state);
        metadata = {
            ...metadata,
            ...appMeta
        };
    }
    if (page) {
        const pageMeta = page.metadata || page.helmet || {};
        const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(pageMeta, element, state);
        metadata = {
            ...metadata,
            ...resolved
        };
        if (!metadata.title && page.state?.title) metadata.title = page.state.title;
        if (!metadata.description && page.state?.description) metadata.description = page.state.description;
    }
    if (!metadata.title) metadata.title = data.name || 'Symbols';
    // Resolve bare filenames
    if (data.files) for(const key in metadata){
        const val = metadata[key];
        if (typeof val === 'string' && val.length > 0 && !val.startsWith('/') && !val.startsWith('http')) {
            const fileEntry = data.files[val];
            if (fileEntry?.src) metadata[key] = fileEntry.src;
        }
    }
    return metadata;
};
// ── DOM runtime (browser) ───────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$createMetaElement = (metaObj, doc)=>{
    const domElement = doc.createElement(metaObj.tag);
    if (metaObj.attr) domElement.setAttribute(metaObj.attr, metaObj.key);
    const head = doc.head || doc.querySelector('head');
    head.appendChild(domElement);
    return domElement;
};
const $84f66b9cc4cc43c7$export$961d8bb4ed050676 = (metadata, doc)=>{
    if (!(0, $e7Ezu.isObject)(metadata) || !doc) return;
    for(const key in metadata){
        const value = metadata[key];
        if (value === undefined || value === null) continue;
        const metaObj = $84f66b9cc4cc43c7$var$META_TAGS[key];
        if (!metaObj) continue;
        const query = $84f66b9cc4cc43c7$var$createQuery(metaObj);
        const domElement = doc.querySelector(query) || $84f66b9cc4cc43c7$var$createMetaElement(metaObj, doc);
        if (!domElement) continue;
        if (key === 'title') domElement.textContent = value;
        else if (metaObj.valueAttr) domElement.setAttribute(metaObj.valueAttr, value);
        else domElement.setAttribute('content', value);
    }
};
// ── SSR (brender) ───────────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$esc = (text)=>{
    if (text === null || text === undefined) return '';
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.toString().replace(/[&<>"']/g, (m)=>map[m]);
};
const $84f66b9cc4cc43c7$export$ebea745cf9b6b083 = (metadata)=>{
    const tags = [
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">'
    ];
    for (const [key, value] of Object.entries(metadata)){
        if (!value && value !== 0 && value !== false) continue;
        if (key === 'title') {
            tags.push(`<title>${$84f66b9cc4cc43c7$var$esc(value)}</title>`);
            continue;
        }
        if (key === 'canonical') {
            tags.push(`<link rel="canonical" href="${$84f66b9cc4cc43c7$var$esc(value)}">`);
            continue;
        }
        if (key === 'alternate' && Array.isArray(value)) {
            value.forEach((alt)=>{
                if (typeof alt === 'object') {
                    const attrs = Object.entries(alt).map(([k, v])=>`${k}="${$84f66b9cc4cc43c7$var$esc(v)}"`).join(' ');
                    tags.push(`<link rel="alternate" ${attrs}>`);
                }
            });
            continue;
        }
        const propertyPrefixes = [
            'og:',
            'article:',
            'product:',
            'fb:',
            'profile:',
            'book:',
            'business:',
            'music:',
            'video:'
        ];
        const namePrefixes = [
            'twitter:',
            'DC:',
            'DCTERMS:'
        ];
        const isProperty = propertyPrefixes.some((p)=>key.startsWith(p));
        const isName = namePrefixes.some((p)=>key.startsWith(p));
        if (key.startsWith('http-equiv:')) {
            const httpKey = key.replace('http-equiv:', '');
            tags.push(`<meta http-equiv="${$84f66b9cc4cc43c7$var$esc(httpKey)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (key.startsWith('itemprop:')) {
            const itemKey = key.replace('itemprop:', '');
            tags.push(`<meta itemprop="${$84f66b9cc4cc43c7$var$esc(itemKey)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (isProperty) {
            if (Array.isArray(value)) value.forEach((v)=>tags.push(`<meta property="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(v)}">`));
            else tags.push(`<meta property="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (isName) tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        else if (key !== 'favicon' && key !== 'favicons') {
            if (Array.isArray(value)) value.forEach((v)=>tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(v)}">`));
            else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        }
    }
    return tags.join('\n');
};
const $84f66b9cc4cc43c7$export$dcef8f9bb9a41431 = {
    define: {
        metadata: (param, el, state)=>{
            const doc = el.context?.document || typeof document !== 'undefined' && document;
            if (!doc) return;
            const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(param, el, state);
            $84f66b9cc4cc43c7$export$961d8bb4ed050676(resolved, doc);
            // Store on root state for interop
            const rootState = el.state?.root;
            if ((0, $e7Ezu.isObject)(rootState)) rootState.$helmet = resolved;
        }
    }
};
var $84f66b9cc4cc43c7$export$2e2bcd8739ae039 = $84f66b9cc4cc43c7$export$dcef8f9bb9a41431;


const $63f946251218a7c2$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    metadata: (param, el, state)=>{
        if (!param) return;
        const doc = el.context?.document || typeof document !== "undefined" && document;
        if (!doc) return;
        const resolved = (0, $84f66b9cc4cc43c7$export$d2032d3864484f3)(param, el, state);
        (0, $84f66b9cc4cc43c7$export$961d8bb4ed050676)(resolved, doc);
    },
    $router: async (param, el)=>{
        if (!param) return;
        const obj = {
            tag: "fragment",
            ...param
        };
        const set = async ()=>{
            await el.set(obj, {
                preventDefineUpdate: "$router"
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else await set();
        return obj;
    }
};



var $56136d4e5c63987d$var$__filename = "node_modules/smbls/dist/esm/src/options.js";
let $56136d4e5c63987d$var$version = "0.0.0";
try {
    const _url = typeof $56136d4e5c63987d$var$__filename !== "undefined" ? $56136d4e5c63987d$var$__filename : "file:///node_modules/smbls/dist/esm/src/options.js";
    const require2 = (0, $eca075ad100d834d$exports.createRequire)(_url);
    const pkg = require2("../package.json");
    $56136d4e5c63987d$var$version = pkg.version;
} catch  {}
const $56136d4e5c63987d$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useDefaultIcons: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $56136d4e5c63987d$export$47bde86d5ec3fc9c = {
    initRouter: true,
    popState: true,
    injectRouterInLinkComponent: true
};
const $56136d4e5c63987d$export$9c542858adf7dcd0 = {
    ...$56136d4e5c63987d$export$882cd4124a942c79,
    router: $56136d4e5c63987d$export$47bde86d5ec3fc9c,
    version: $56136d4e5c63987d$var$version
};
const $56136d4e5c63987d$export$7f202753e6a32b2b = {
    state: {},
    pages: {},
    components: {},
    router: $56136d4e5c63987d$export$47bde86d5ec3fc9c,
    define: (0, $63f946251218a7c2$export$6588fc50c67b09a2)
};
var $56136d4e5c63987d$export$2e2bcd8739ae039 = $56136d4e5c63987d$export$7f202753e6a32b2b;



parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $j7W2w = parcelRequire("j7W2w");
parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
var $1jKby = parcelRequire("1jKby");
var $e7Ezu = parcelRequire("e7Ezu");
const $6df09ec4a8d4e1c2$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    if (onEvent) return onEvent;
    const props = element.props;
    if (!props) return;
    const propKey = "on" + param.charAt(0).toUpperCase() + param.slice(1);
    return props[propKey];
};
const $6df09ec4a8d4e1c2$var$registerNodeEvent = (param, element, node, options)=>{
    const appliedFunction = $6df09ec4a8d4e1c2$var$getOnOrPropsEvent(param, element);
    if ((0, $e7Ezu.isFunction)(appliedFunction)) {
        const { __ref: ref } = element;
        if (!ref.__eventListeners) ref.__eventListeners = {};
        if (ref.__eventListeners[param]) node.removeEventListener(param, ref.__eventListeners[param]);
        const handler = (event)=>{
            const { state: state, context: context } = element;
            try {
                const result = appliedFunction.call(element, event, element, state, context, options);
                if (result && typeof result.then === "function") result.catch((err)=>{
                    element.error = err;
                    console.error("[DomQL] Async DOM event error:", err);
                });
            } catch (err) {
                element.error = err;
                console.error("[DomQL] DOM event error:", err);
                if (context?.strictMode) throw err;
            }
        };
        ref.__eventListeners[param] = handler;
        node.addEventListener(param, handler);
    }
};
const $6df09ec4a8d4e1c2$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on, props: props } = element;
    const handled = /* @__PURE__ */ new Set();
    for(const param in on){
        if ((0, $1jKby.DOMQL_EVENTS).has(param)) continue;
        handled.add(param);
        $6df09ec4a8d4e1c2$var$registerNodeEvent(param, element, node, options);
    }
    if (props) {
        for(const key in props)if (key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && (0, $e7Ezu.isFunction)(props[key])) {
            const thirdChar = key[2];
            if (thirdChar !== thirdChar.toUpperCase()) continue;
            const eventName = thirdChar.toLowerCase() + key.slice(3);
            if (handled.has(eventName) || (0, $1jKby.DOMQL_EVENTS).has(eventName)) continue;
            $6df09ec4a8d4e1c2$var$registerNodeEvent(eventName, element, node, options);
        }
    }
};

parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $3GLOu = parcelRequire("3GLOu");
const $49f2c888e21fa10b$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    for(const v in props){
        if (v.charCodeAt(0) !== 111 || v.charCodeAt(1) !== 110) continue;
        const eventName = (0, $3GLOu.lowercaseFirstLetter)(v.slice(2));
        const origEvent = on[eventName];
        const funcFromProps = props[v];
        if ((0, $e7Ezu.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const originalEventRetunrs = origEvent(...args);
            if (originalEventRetunrs !== false) return funcFromProps(...args);
        };
        else on[eventName] = funcFromProps;
    }
};
const $49f2c888e21fa10b$export$703a2b3ea711c09d = (element)=>{
    const { on: on } = element;
    for(const param in element){
        if (param.charCodeAt(0) !== 111 || param.charCodeAt(1) !== 110 || !Object.prototype.hasOwnProperty.call(element, param)) continue;
        const fn = element[param];
        if (!(0, $e7Ezu.isFunction)(fn)) continue;
        const eventName = (0, $3GLOu.lowercaseFirstLetter)(param.slice(2));
        const origEvent = on[eventName];
        if ((0, $e7Ezu.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const ret = origEvent(...args);
            if (ret !== false) return fn(...args);
        };
        else on[eventName] = fn;
    }
};




parcelRequire("jgAqB");
var $03PwY = parcelRequire("03PwY");
const $22fe990a22a68071$export$342a7615681b7118 = (tag)=>{
    return (0, $03PwY.isValidHtmlTag)(tag || "div") || (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag");
};


parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $03PwY = parcelRequire("03PwY");
const $45aee2d1be86c49c$var$SVG_NS = "http://www.w3.org/2000/svg";
const $45aee2d1be86c49c$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag, context: context } = element;
    const doc = context.document || (0, $bD06b.document);
    if (tag) {
        if (tag === "string") return doc.createTextNode(element.text);
        else if (tag === "fragment") return doc.createDocumentFragment();
        else if ((0, $03PwY.SVG_TAGS).has(tag)) {
            if (tag === "svg" || element.parent?.node?.namespaceURI === $45aee2d1be86c49c$var$SVG_NS) return doc.createElementNS($45aee2d1be86c49c$var$SVG_NS, tag);
            return doc.createElement(tag);
        } else return doc.createElement(tag);
    } else return doc.createElement("div");
};
const $45aee2d1be86c49c$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $g1LU2.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $e7Ezu.isObject)(props) && (0, $e7Ezu.isString)(props.tag)) {
        const tagExists = (0, $03PwY.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $e7Ezu.isString)(tag)) {
        if ((0, $03PwY.isValidHtmlTag)(tag)) return tag;
    } else {
        let keyAsTag = key.toLowerCase();
        if (keyAsTag.includes(".")) keyAsTag = keyAsTag.split(".")[0];
        if (keyAsTag.includes("_")) keyAsTag = keyAsTag.split("_")[0];
        if ((0, $03PwY.isValidHtmlTag)(keyAsTag)) return keyAsTag;
    }
    return "div";
};
const $45aee2d1be86c49c$export$257247f9c0329159 = (element)=>{
    const { context: context } = element;
    const win = context.window || window;
    const tag = element.tag = $45aee2d1be86c49c$export$5075bd4eae016d2c(element);
    if (!(0, $22fe990a22a68071$export$342a7615681b7118)(tag)) return (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag", element.tag, element);
    if (!win.nodeCaches) win.nodeCaches = {};
    const isSvgContext = (0, $03PwY.SVG_TAGS).has(tag) && (tag === "svg" || element.parent?.node?.namespaceURI === $45aee2d1be86c49c$var$SVG_NS);
    const cacheKey = isSvgContext ? "svg:" + tag : tag;
    let cachedTag = win.nodeCaches[cacheKey];
    if (!cachedTag) cachedTag = win.nodeCaches[cacheKey] = $45aee2d1be86c49c$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === "string") clonedNode.nodeValue = element.text;
    return clonedNode;
};



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $iPYI6 = parcelRequire("iPYI6");
var $e7Ezu = parcelRequire("e7Ezu");
var $j7W2w = parcelRequire("j7W2w");
const $f25442b4c3be55c5$export$3223a9877c540db8 = (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $e7Ezu.isFunction)(prop) && !(0, $j7W2w.isMethod)(param, element)) {
            ref.__exec[param] = prop;
            const result = prop(element, element.state, element.context);
            if (result && typeof result.then === "function") result.then((resolved)=>{
                element[param] = resolved;
            });
            else element[param] = result;
        }
    }
};
const $f25442b4c3be55c5$export$2ad800d85590910f = (element, options = {})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = ref.__exec[param](element, element.state, element.context);
        if (newExec && typeof newExec.then === "function") {
            newExec.then((resolved)=>{
                element[param] = resolved;
            });
            continue;
        }
        const execReturnsString = (0, $e7Ezu.isString)(newExec) || (0, $e7Ezu.isNumber)(newExec);
        if (prop?.node && execReturnsString) (0, $g1LU2.overwrite)(prop, {
            text: newExec
        });
        else if (newExec !== prop) {
            if ((0, $iPYI6.matchesComponentNaming)(param)) {
                const { extends: extend, ...newElem } = (0, $iPYI6.isContextComponent)(newExec, element, param);
                (0, $g1LU2.overwrite)(prop, newElem);
            } else {
                changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $f25442b4c3be55c5$export$23077649cd9ebd4b = (element)=>{
    const { __ref: ref } = element;
    const { props: props } = element;
    for(const k in props){
        const c0 = k.charCodeAt(0);
        const c1 = k.charCodeAt(1);
        const isDefine = c0 === 105 && c1 === 115 || // 'is'
        c0 === 104 && c1 === 97 && k.charCodeAt(2) === 115 || // 'has'
        c0 === 117 && c1 === 115 && k.charCodeAt(2) === 101;
        const cachedExecProp = ref.__execProps[k];
        if ((0, $e7Ezu.isFunction)(cachedExecProp)) {
            const result = (0, $g1LU2.exec)(cachedExecProp, element);
            if (result && typeof result.then === "function") result.then((resolved)=>{
                props[k] = resolved;
            });
            else props[k] = result;
        } else if (isDefine && (0, $e7Ezu.isFunction)(props[k])) {
            ref.__execProps[k] = props[k];
            const result = (0, $g1LU2.exec)(props[k], element);
            if (result && typeof result.then === "function") result.then((resolved)=>{
                props[k] = resolved;
            });
            else props[k] = result;
        }
    }
};
const $f25442b4c3be55c5$export$b4c781127351659b = (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    const hasLocalDefine = (0, $e7Ezu.isObject)(define);
    const hasGlobalDefine = context && (0, $e7Ezu.isObject)(context.define);
    if (!hasLocalDefine && !hasGlobalDefine) return element;
    const defineObj = hasLocalDefine && hasGlobalDefine ? {
        ...define,
        ...context.define
    } : hasLocalDefine ? define : context.define;
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $e7Ezu.isFunction)(elementProp) && !(0, $j7W2w.isMethod)(param, element)) {
            ref.__exec[param] = elementProp;
            let execParam2 = (0, $g1LU2.exec)(elementProp, element);
            if (execParam2 && typeof execParam2.then === "function") execParam2.then((resolved)=>{
                elementProp = element[param] = resolved && resolved.parse ? resolved.parse() : resolved;
                if (resolved) ref.__defineCache[param] = elementProp;
            });
            else {
                elementProp = element[param] = execParam2 && execParam2.parse ? execParam2.parse() : execParam2;
                if (execParam2) ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = defineObj[param](elementProp, element, element.state, element.context);
        if (execParam && typeof execParam.then === "function") execParam.then((resolved)=>{
            if (resolved) element[param] = resolved;
        });
        else if (execParam) element[param] = execParam;
    }
    return element;
};
const $f25442b4c3be55c5$export$88eda8a7eb5c5eff = (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const hasLocalDefine = (0, $e7Ezu.isObject)(define);
    const hasGlobalDefine = (0, $e7Ezu.isObject)(context?.define);
    if (!hasLocalDefine && !hasGlobalDefine) return;
    const obj = hasLocalDefine && hasGlobalDefine ? {
        ...define,
        ...context.define
    } : hasLocalDefine ? define : context.define;
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) {
            const result = execParam(element, element.state, element.context);
            if (result && typeof result.then === "function") result.then((resolved)=>{
                ref.__defineCache[param] = resolved;
            });
            else ref.__defineCache[param] = result;
        }
        const cached = (0, $g1LU2.exec)(ref.__defineCache[param], element);
        if (cached && typeof cached.then === "function") {
            cached.then((resolved)=>{});
            continue;
        }
        const newExecParam = typeof obj[param] === "function" ? obj[param](cached, element, element.state, element.context) : void 0;
        if (newExecParam && typeof newExecParam.then === "function") newExecParam.then((resolved)=>{
            element[param] = resolved;
        });
        else if (newExecParam) element[param] = newExecParam;
    }
};


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

function $4de88835407a4c4f$export$7aabe8b3a840d2fd(params, element, node) {
    const { __ref: ref, props: props } = element;
    const { __attr: __attr } = ref;
    if ((0, $e7Ezu.isNot)(params)("object")) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidAttr", params);
    if (params) {
        const attrs = (0, $g1LU2.exec)(params, element);
        if (props.attr) (0, $g1LU2.deepMerge)(attrs, props.attr);
        for(const attr2 in attrs){
            const val = (0, $g1LU2.exec)(attrs[attr2], element);
            if (val === __attr[attr2]) continue;
            if (val !== false && val !== void 0 && val !== null && node.setAttribute) node.setAttribute(attr2, val);
            else if (node.removeAttribute) node.removeAttribute(attr2);
            __attr[attr2] = val;
        }
    }
}
var $4de88835407a4c4f$export$2e2bcd8739ae039 = $4de88835407a4c4f$export$7aabe8b3a840d2fd;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
const $e443d57a8c733245$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.classlist === true) element.classlist = key;
    else if (!element.classlist && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.classlist = key.slice(1);
};
const $e443d57a8c733245$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $g1LU2.exec)(param, element)}`;
    }
    return className;
};
const $e443d57a8c733245$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.classlist = {
        key: key
    };
    if ((0, $e7Ezu.isString)(params)) params = element.classlist = {
        default: params
    };
    if ((0, $e7Ezu.isObject)(params)) params = $e443d57a8c733245$export$b04d9b8d414ba5e8(params, element);
    const className = params.replace(/\s+/g, " ").trim();
    return className;
};
const $e443d57a8c733245$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $e443d57a8c733245$export$11c615ce16f87241(params, element);
    const { __ref: __ref } = element;
    if (className === __ref.__className) return className;
    __ref.__className = className;
    if (node && typeof node.setAttribute === "function") node.setAttribute("class", className);
    else if (node) try {
        node.className = className;
    } catch (e) {}
    return className;
};
function $e443d57a8c733245$export$f1a8a7f322d4587c(params, element, node) {
    $e443d57a8c733245$export$e8f750c9f10c0a7b(params, element, node);
}
var $e443d57a8c733245$export$2e2bcd8739ae039 = $e443d57a8c733245$export$f1a8a7f322d4587c;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

function $c46e237ff994c9a0$export$4051a07651545597(params, element, node) {
    if (params) {
        if (element.props.data) (0, $g1LU2.deepMerge)(params, element.props.data);
        if (params.showOnNode) {
            if (!(0, $e7Ezu.isObject)(params)) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidData", params);
            for(const dataset in params)if (dataset !== "showOnNode") node.dataset[dataset] = (0, $g1LU2.exec)(params[dataset], element);
        }
    }
}
var $c46e237ff994c9a0$export$2e2bcd8739ae039 = $c46e237ff994c9a0$export$4051a07651545597;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
function $5ea299b0173b28f7$export$c0bb0b647f701bb5(param, element, node) {
    const prop = (0, $g1LU2.exec)(param ?? element?.props?.html, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        if (node.nodeName === "SVG") node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
}
var $5ea299b0173b28f7$export$2e2bcd8739ae039 = $5ea299b0173b28f7$export$c0bb0b647f701bb5;


parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
function $7e4ce4be70defae9$export$5cff813ca8e50db9(params, element, node) {
    if (!(0, $e7Ezu.isObject)(params)) return;
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $e7Ezu.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
}
var $7e4ce4be70defae9$export$2e2bcd8739ae039 = $7e4ce4be70defae9$export$5cff813ca8e50db9;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $1jKby = parcelRequire("1jKby");
function $8ee411585e3eafe0$export$ca000e230c0caa3e(params, element, node) {
    const state2 = (0, $g1LU2.exec)(params, element);
    if ((0, $e7Ezu.isObject)(state2)) for(const param in state2){
        if ((0, $1jKby.STATE_METHODS).has(param)) continue;
        if (!Object.prototype.hasOwnProperty.call(state2, param)) continue;
    }
    return element;
}
var $8ee411585e3eafe0$export$2e2bcd8739ae039 = $8ee411585e3eafe0$export$ca000e230c0caa3e;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

function $ec1fb09c82269acc$export$1d567c320f4763bc(params, element, node) {
    if (params) {
        if ((0, $e7Ezu.isObject)(params)) {
            const { __ref: __ref } = element;
            if (!__ref.__style) __ref.__style = {};
            const cache = __ref.__style;
            for(const prop in params){
                const val = (0, $g1LU2.exec)(params[prop], element);
                if (val === cache[prop]) continue;
                cache[prop] = val;
                node.style[prop] = val;
            }
        } else (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidStyles", params);
    }
}
var $ec1fb09c82269acc$export$2e2bcd8739ae039 = $ec1fb09c82269acc$export$1d567c320f4763bc;



parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $03PwY = parcelRequire("03PwY");
function $5f1f5309d20a2dcc$export$6f093cfa640b7166(param, element, node) {
    let prop = (0, $g1LU2.exec)(element.props.text || param, element);
    if ((0, $e7Ezu.isString)(prop) && prop.includes("{{")) prop = element.call("replaceLiteralsWithObjectFields", prop, element.state);
    if (element.tag === "string") node.nodeValue = prop;
    else if (param !== void 0 && param !== null) {
        if ((0, $03PwY.SVG_TAGS).has(element.tag)) {
            if (node) node.textContent = prop;
            return;
        }
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $7dd430f018926e40$export$185802fd694ee1f5)({
            tag: "string",
            text: prop
        }, element, "__text");
    }
}
var $5f1f5309d20a2dcc$export$2e2bcd8739ae039 = $5f1f5309d20a2dcc$export$6f093cfa640b7166;


const $e8b271fd11ec61f3$export$21cc2ed387caee94 = {
    attr: $4de88835407a4c4f$export$7aabe8b3a840d2fd,
    style: $ec1fb09c82269acc$export$2e2bcd8739ae039,
    text: $5f1f5309d20a2dcc$export$2e2bcd8739ae039,
    html: $5ea299b0173b28f7$export$2e2bcd8739ae039,
    data: $c46e237ff994c9a0$export$2e2bcd8739ae039,
    classlist: (0, $e443d57a8c733245$export$11c615ce16f87241),
    state: $8ee411585e3eafe0$export$2e2bcd8739ae039,
    scope: $7e4ce4be70defae9$export$2e2bcd8739ae039,
    deps: (param, el)=>param || el.parent.deps,
    extends: {},
    children: {},
    content: {},
    childExtend: {},
    childExtends: {},
    childExtendRecursive: {},
    childExtendsRecursive: {},
    props: {},
    if: {},
    define: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    variables: {},
    on: {},
    component: {},
    context: {}
};
var $e8b271fd11ec61f3$export$2e2bcd8739ae039 = $e8b271fd11ec61f3$export$21cc2ed387caee94;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");

const $84df86e91acef76b$export$535107f3c159da5d = (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = (0, $g1LU2.exec)(element[param], element);
    const { onlyUpdate: onlyUpdate } = options;
    const DOMQLProperty = (0, $e8b271fd11ec61f3$export$21cc2ed387caee94)[param];
    const DOMQLPropertyFromContext = context?.registry?.[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define?.[param];
    const hasContextDefine = context?.define?.[param];
    if (!ref.__if) return;
    const hasOnlyUpdate = onlyUpdate ? onlyUpdate === param || element.lookup(onlyUpdate) : true;
    if (isGlobalTransformer && !hasContextDefine && hasOnlyUpdate) {
        if ((0, $e7Ezu.isFunction)(isGlobalTransformer)) isGlobalTransformer(prop, element, node, options);
        return;
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};


parcelRequire("jgAqB");
var $7gXxj = parcelRequire("7gXxj");
var $g1LU2 = parcelRequire("g1LU2");
var $lw6SS = parcelRequire("lw6SS");
var $e7Ezu = parcelRequire("e7Ezu");
var $iPYI6 = parcelRequire("iPYI6");
const $4d2f5ab9b9d9b529$var$deepChildrenEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const typeA = typeof a;
    const typeB = typeof b;
    if (typeA === "function" && typeB === "function") return true;
    if (typeA !== typeB) return false;
    if ((0, $e7Ezu.isArray)(a) && (0, $e7Ezu.isArray)(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$4d2f5ab9b9d9b529$var$deepChildrenEqual(a[i], b[i])) return false;
        }
        return true;
    }
    if ((0, $e7Ezu.isObject)(a) && (0, $e7Ezu.isObject)(b)) {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        for(let i = 0; i < keysA.length; i++){
            const key = keysA[i];
            if (!$4d2f5ab9b9d9b529$var$deepChildrenEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
};
function $4d2f5ab9b9d9b529$export$d4cb3dfdb7a8fc7d(param, element, opts) {
    let { children: children, __ref: ref, state: state } = element;
    let { childrenAs: childrenAs } = element.props || {};
    let execParam = (0, $g1LU2.exec)(param, element, state);
    let execChildren = (0, $g1LU2.exec)(children, element, state);
    children = execParam || execChildren;
    if (children) {
        if ((0, $lw6SS.isState)(children)) children = children.parse();
        if ((0, $e7Ezu.isString)(children) || (0, $e7Ezu.isNumber)(children)) {
            if (children === "state") children = state.parse();
            else {
                const pathInState = (0, $lw6SS.getChildStateInKey)(children, state);
                if (pathInState) {
                    childrenAs = "state";
                    children = (0, $lw6SS.getChildStateInKey)(children, state) || {
                        value: children
                    };
                } else children = {
                    text: children
                };
            }
        }
        if ((0, $e7Ezu.isObject)(children)) {
            if (children.$$typeof) return element.call("renderReact", children, element);
            children = Object.keys(children).map((v)=>{
                const val = children[v];
                if ((0, $iPYI6.matchesComponentNaming)(v)) return (0, $7gXxj.concatAddExtends)(v, val);
                return val;
            });
        }
    }
    if (!children || (0, $e7Ezu.isNot)(children)("array", "object")) return;
    if ((0, $e7Ezu.isArray)(children) && children.some((v)=>v?.$$typeof)) {
        const filterReact = [];
        const reactComponents = [];
        for(let i = 0; i < children.length; i++)if (children[i]?.$$typeof) reactComponents.push(children[i]);
        else filterReact.push(children[i]);
        if (reactComponents.length) element.call("renderReact", reactComponents, element);
        children = filterReact;
    }
    let cloned;
    if (ref.__childrenCache) {
        if ($4d2f5ab9b9d9b529$var$deepChildrenEqual(children, ref.__childrenCache)) ref.__noChildrenDifference = true;
        else {
            cloned = (0, $g1LU2.deepClone)(children);
            ref.__childrenCache = cloned;
            delete ref.__noChildrenDifference;
        }
    } else {
        cloned = (0, $g1LU2.deepClone)(children);
        ref.__childrenCache = cloned;
    }
    if ((0, $e7Ezu.isObject)(children) || (0, $e7Ezu.isArray)(children)) children = cloned || (0, $g1LU2.deepClone)(children);
    const content = {
        tag: "fragment"
    };
    for(const key in children){
        const value = Object.prototype.hasOwnProperty.call(children, key) && children[key];
        if ((0, $e7Ezu.isDefined)(value) && value !== null && value !== false) content[key] = (0, $e7Ezu.isObjectLike)(value) ? childrenAs ? {
            [childrenAs]: value
        } : value : childrenAs ? {
            [childrenAs]: childrenAs === "state" ? {
                value: value
            } : {
                text: value
            }
        } : {
            text: value
        };
    }
    return content;
}
var $4d2f5ab9b9d9b529$export$2e2bcd8739ae039 = $4d2f5ab9b9d9b529$export$d4cb3dfdb7a8fc7d;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");

parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
const $b06ad0032e72e12d$export$c99c504ad1135f20 = (element, opts = {})=>{
    const { __ref: ref } = element;
    const contentElementKey = opts.contentElementKey;
    if (!ref.contentElementKey || contentElementKey !== ref.contentElementKey) ref.contentElementKey = contentElementKey || "content";
    return ref.contentElementKey;
};
function $b06ad0032e72e12d$export$aad8462122ac592b(options) {
    const element = this;
    (0, $7dd430f018926e40$export$185802fd694ee1f5)(element, element.parent, void 0, {
        ignoreChildExtends: true,
        ...(0, $dzojf.OPTIONS).defaultOptions,
        ...(0, $dzojf.OPTIONS).create,
        ...options
    });
}
const $b06ad0032e72e12d$export$92dab91de9230702 = (params, element, opts)=>{
    const contentElementKey = $b06ad0032e72e12d$export$c99c504ad1135f20(element, opts);
    if (element[contentElementKey]?.node) $b06ad0032e72e12d$export$6e1d9b0d0e1e1def(element, opts);
    const contentElem = (0, $7dd430f018926e40$export$185802fd694ee1f5)(params, element, contentElementKey || "content", {
        ignoreChildExtends: true,
        ...(0, $dzojf.OPTIONS).defaultOptions,
        ...(0, $dzojf.OPTIONS).create,
        ...opts
    });
    if (contentElementKey !== "content") opts.contentElementKey = "content";
    return contentElem;
};
const $b06ad0032e72e12d$export$5143cc956eb9d8f6 = function(params, opts) {
    const element = this;
    const contentElementKey = $b06ad0032e72e12d$export$c99c504ad1135f20(element, opts);
    if (!element[contentElementKey]) return;
    if (element[contentElementKey].update) element[contentElementKey].update(params, opts);
};
function $b06ad0032e72e12d$export$431313f2afd011e2(param, element, opts) {
    const content = (0, $g1LU2.exec)(param, element);
    if (content && element) $b06ad0032e72e12d$export$adaa4cf7ef1b65be.call(element, content, opts);
}
const $b06ad0032e72e12d$export$6e1d9b0d0e1e1def = function(el, opts = {}) {
    const element = el || this;
    const contentElementKey = $b06ad0032e72e12d$export$c99c504ad1135f20(element, opts);
    if (opts.contentElementKey !== "content") opts.contentElementKey = "content";
    const content = element[contentElementKey];
    if (!content) return;
    if (content.tag === "fragment" && content.__ref?.__children) {
        const __children = content.__ref.__children;
        for(let i = 0; i < __children.length; i++){
            const child = content[__children[i]];
            if (child.node && child.node.parentNode) child.node.parentNode.removeChild(child.node);
            if ((0, $e7Ezu.isFunction)(child.remove)) child.remove();
        }
    } else {
        if (content.node && content.node.parentNode) content.node.parentNode.removeChild(content.node);
        if ((0, $e7Ezu.isFunction)(content.remove)) content.remove();
    }
    delete element[contentElementKey];
};
const $b06ad0032e72e12d$export$adaa4cf7ef1b65be = function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref } = element;
    if (ref.__settingContent) return element;
    ref.__settingContent = true;
    try {
        return $b06ad0032e72e12d$var$_setInner(params, options, element);
    } finally{
        ref.__settingContent = false;
    }
};
const $b06ad0032e72e12d$var$_setInner = function(params, options, element) {
    const { __ref: ref } = element;
    const contentElementKey = $b06ad0032e72e12d$export$c99c504ad1135f20(element, options);
    const content = element[contentElementKey];
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    const hasChildren = element.children;
    if (options.preventContentUpdate === true && !hasChildren) return;
    const childHasChanged = !ref.__noChildrenDifference;
    const childrenIsDifferentFromCache = childHasChanged && __contentRef && Object.keys(params).length === Object.keys(content).length && (0, $g1LU2.deepContains)(params, content);
    if (content?.update && !childHasChanged && !childrenIsDifferentFromCache) {
        if (!options.preventBeforeUpdateListener && !options.preventListeners) {
            const beforeUpdateReturns = (0, $b4h11.triggerEventOnUpdate)("beforeUpdate", params, element, options);
            if (beforeUpdateReturns === false) return element;
        }
        content.update(params);
        if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)("update", element, options);
        return;
    }
    if (!params || typeof params !== "object") return element;
    let { childExtends: childExtends, props: props, tag: tag } = params;
    if (!props) props = params.props = {};
    if (tag === "fragment") {
        const elementChildExtends = element.childExtends || element.childExtend;
        if (!childExtends && elementChildExtends) {
            params.childExtends = elementChildExtends;
            props.ignoreChildExtends = true;
        }
        const elementChildProps = element.childProps || element.props?.childProps;
        if (!props?.childProps && elementChildProps) props.childProps = elementChildProps;
        props.ignoreChildProps = true;
    }
    if (lazyLoad) window.requestAnimationFrame(()=>{
        $b06ad0032e72e12d$export$92dab91de9230702(params, element, options);
        if (!options.preventUpdateListener) (0, $b4h11.triggerEventOn)("lazyLoad", element, options);
    });
    else $b06ad0032e72e12d$export$92dab91de9230702(params, element, options);
};
var $b06ad0032e72e12d$export$2e2bcd8739ae039 = $b06ad0032e72e12d$export$adaa4cf7ef1b65be;


const $55f529c16bdd65a1$var$ENV = "production";
const $55f529c16bdd65a1$export$270e7ba5936d3c48 = (element, opts)=>{
    let { node: node, tag: tag, __ref: ref } = element;
    if (!ref.__if) return element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (tag === "shadow") node = element.node = element.parent.node.attachShadow({
            mode: "open"
        });
        else node = element.node = (0, $45aee2d1be86c49c$export$257247f9c0329159)(element);
        (0, $b4h11.triggerEventOn)("attachNode", element, opts);
    }
    if ($55f529c16bdd65a1$var$ENV === "test" || $55f529c16bdd65a1$var$ENV === "development" || opts.alowRefReference) {
        node.ref = element;
        if ((0, $e7Ezu.isFunction)(node.setAttribute)) node.setAttribute("key", element.key);
    }
    (0, $f25442b4c3be55c5$export$23077649cd9ebd4b)(element);
    (0, $f25442b4c3be55c5$export$b4c781127351659b)(element);
    (0, $f25442b4c3be55c5$export$3223a9877c540db8)(element);
    (0, $49f2c888e21fa10b$export$e43138af17da316d)(element);
    (0, $49f2c888e21fa10b$export$703a2b3ea711c09d)(element);
    (0, $6df09ec4a8d4e1c2$export$1f7cb486ba1f8a10)(element, {
        isNewNode: isNewNode,
        ...opts
    });
    for(const param in element){
        const value = element[param];
        if (!Object.prototype.hasOwnProperty.call(element, param) || value === void 0 || (0, $j7W2w.isMethod)(param, element) || (0, $e7Ezu.isObject)((0, $e8b271fd11ec61f3$export$21cc2ed387caee94)[param]) || param.length > 2 && param.charCodeAt(0) === 111 && param.charCodeAt(1) === 110 && param.charCodeAt(2) >= 65 && param.charCodeAt(2) <= 90) continue;
        const isElement = (0, $84df86e91acef76b$export$535107f3c159da5d)(param, element, opts);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            if (element[param] && !hasDefine && !hasContextDefine) {
                const createAsync = ()=>{
                    (0, $7dd430f018926e40$export$185802fd694ee1f5)(value, element, param, opts);
                };
                if (element.props && element.props.lazyLoad || opts.lazyLoad) window.requestAnimationFrame(()=>{
                    createAsync();
                    if (!opts.preventUpdateListener) (0, $b4h11.triggerEventOn)("lazyLoad", element, opts);
                });
                else createAsync();
            }
        }
    }
    const content = element.children ? (0, $4d2f5ab9b9d9b529$export$2e2bcd8739ae039)(element.children, element, opts) : element.children || element.content;
    if (content) (0, $b06ad0032e72e12d$export$431313f2afd011e2)(content, element, opts);
    return element;
};
var $55f529c16bdd65a1$export$2e2bcd8739ae039 = $55f529c16bdd65a1$export$270e7ba5936d3c48;


parcelRequire("jgAqB");
var $bD06b = parcelRequire("bD06b");

const $a86760b483a583a2$export$fbea82a1c0574ef4 = {
    key: ":root",
    node: (0, $bD06b.document) ? (0, $bD06b.document).body : (0, $06908963bda72849$export$f18d5b0af29128b7)("DocumentNotDefined", (0, $bD06b.document))
};
const $a86760b483a583a2$export$33ecaa422889cd80 = $a86760b483a583a2$export$fbea82a1c0574ef4;


parcelRequire("jgAqB");
var $7gXxj = parcelRequire("7gXxj");
var $81M4S = parcelRequire("81M4S");
var $bvmdI = parcelRequire("bvmdI");
var $5ORwk = parcelRequire("5ORwk");
var $g1LU2 = parcelRequire("g1LU2");
var $5zx8x = parcelRequire("5zx8x");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");
var $j7W2w = parcelRequire("j7W2w");
const $339eb5798b6c1bb7$export$a9e0446239e28a61 = (el)=>{
    if (!el || !el.__ref) throw new Error("Element reference is invalid");
    const { __ref: ref } = el;
    if (!ref.root) throw new Error("Root reference is invalid");
    if (!ref.root.data) throw new Error("Data are undefined");
    const { frameListeners: frameListeners } = ref.root.data;
    if (frameListeners && !frameListeners.has(el)) frameListeners.add(el);
};
const $339eb5798b6c1bb7$var$processFrameListeners = (frameListeners)=>{
    for (const element of frameListeners){
        if (!element.__ref.__frameHandler) {
            const handler = element.on?.frame || element.onFrame || element.props?.onFrame;
            if (handler) element.__ref.__frameHandler = handler;
            else {
                frameListeners.delete(element);
                continue;
            }
        }
        if (!element.node?.parentNode) {
            frameListeners.delete(element);
            delete element.__ref.__frameHandler;
        } else try {
            element.__ref.__frameHandler(element, element.state, element.context);
        } catch (e) {
            console.warn(e);
            frameListeners.delete(element);
            delete element.__ref.__frameHandler;
        }
    }
};
const $339eb5798b6c1bb7$var$startFrameLoop = (frameListeners)=>{
    const raf = typeof window !== "undefined" && window.requestAnimationFrame;
    if ($339eb5798b6c1bb7$var$_frameRunning || !raf) return;
    $339eb5798b6c1bb7$var$_frameRunning = true;
    function requestFrame() {
        if (frameListeners.size === 0) {
            $339eb5798b6c1bb7$var$_frameRunning = false;
            return;
        }
        $339eb5798b6c1bb7$var$processFrameListeners(frameListeners);
        raf(requestFrame);
    }
    raf(requestFrame);
};
const $339eb5798b6c1bb7$export$cef3c08d5491509f = (element)=>{
    if (!element) throw new Error("Element is invalid");
    const { on: on, props: props, __ref: ref } = element;
    if (!ref.root || !ref.root.data) return;
    const { frameListeners: frameListeners } = ref.root.data;
    if (frameListeners && (on?.frame || element.onFrame || props?.onFrame)) {
        $339eb5798b6c1bb7$export$a9e0446239e28a61(element);
        $339eb5798b6c1bb7$var$startFrameLoop(frameListeners);
    }
};
let $339eb5798b6c1bb7$var$_frameRunning = false;
const $339eb5798b6c1bb7$export$e1d20e1514750bad = ()=>{
    const frameListeners = /* @__PURE__ */ new Set();
    $339eb5798b6c1bb7$var$startFrameLoop(frameListeners);
    return frameListeners;
};

parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");
const $ba03b8b173117516$export$13970129ca912f06 = (node, parentNode)=>{
    try {
        parentNode.appendChild(node);
        return node;
    } catch (e) {
        console.error("Does not support to append", parentNode, node);
    }
};
const $ba03b8b173117516$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    if (!node) throw new Error("Node is required");
    const parent = parentNode || siblingNode?.parentNode;
    if (siblingNode?.nextSibling) parent?.insertBefore(node, siblingNode.nextSibling);
    else if (siblingNode?.insertAdjacentElement) siblingNode.insertAdjacentElement("afterend", node);
    else parent?.insertBefore(node, siblingNode);
};
const $ba03b8b173117516$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    if (!node) throw new Error("Node is required");
    const parent = parentNode || siblingNode.parentNode;
    parent?.insertBefore(node, siblingNode);
};
const $ba03b8b173117516$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    if (!element) throw new Error("Element is required");
    if (!parent) throw new Error("Parent is required");
    parent[key || element.key] = element;
    if (element.tag !== "shadow") {
        if (attachOptions && attachOptions.position) (attachOptions.position === "before" ? $ba03b8b173117516$export$3a727f1d0007fe49 : $ba03b8b173117516$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $ba03b8b173117516$export$13970129ca912f06(element.node, parent.node, element);
    }
    return element;
};




parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");

parcelRequire("jgAqB");
var $dWAIU = parcelRequire("dWAIU");
var $g1LU2 = parcelRequire("g1LU2");
var $lw6SS = parcelRequire("lw6SS");
var $e7Ezu = parcelRequire("e7Ezu");
var $dzojf = parcelRequire("dzojf");
var $5zx8x = parcelRequire("5zx8x");
var $bD06b = parcelRequire("bD06b");
var $j7W2w = parcelRequire("j7W2w");
parcelRequire("jgAqB");
var $b4h11 = parcelRequire("b4h11");






const $bfd71f30488a9c1b$export$7f0c3d30e5984c9d = [];




const $1274d677f59cb752$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    exclude: (0, $bfd71f30488a9c1b$export$7f0c3d30e5984c9d)
};
const $1274d677f59cb752$export$722fbec263ad908a = function(params = {}, opts) {
    const options = (0, $e7Ezu.isObject)(opts) ? {
        ...$1274d677f59cb752$var$UPDATE_DEFAULT_OPTIONS,
        ...opts
    } : {
        ...$1274d677f59cb752$var$UPDATE_DEFAULT_OPTIONS
    };
    const element = this;
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = (0, $dWAIU.captureSnapshot)(element, options);
    if (snapshotHasUpdated) return;
    if (!options.preventListeners) (0, $b4h11.triggerEventOnUpdate)("startUpdate", params, element, options);
    const { parent: parent, node: node, key: key } = element;
    const { exclude: exclude, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!exclude) (0, $g1LU2.merge)(options, $1274d677f59cb752$var$UPDATE_DEFAULT_OPTIONS);
    if ((0, $e7Ezu.isString)(params) || (0, $e7Ezu.isNumber)(params)) params = {
        text: params
    };
    params = (0, $5zx8x.propertizeUpdate).call(element, params);
    const inheritState = $1274d677f59cb752$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $1274d677f59cb752$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__propsStack.some((0, $e7Ezu.isFunction));
        const props = params.props || hasParentProps || hasFunctionInProps;
        if (props) (0, $5zx8x.updateProps)(props, element, parent);
    }
    if (!options.preventBeforeUpdateListener && !options.preventListeners) {
        const hasBeforeUpdate = element.on?.beforeUpdate || element.props?.onBeforeUpdate;
        if (hasBeforeUpdate) {
            const simulate = {
                ...params,
                ...element
            };
            Object.setPrototypeOf(simulate, Object.getPrototypeOf(element));
            const beforeUpdateReturns = (0, $b4h11.triggerEventOnUpdate)("beforeUpdate", params, simulate, options);
            if (beforeUpdateReturns === false) return element;
        }
    }
    (0, $g1LU2.overwriteDeep)(element, params);
    (0, $f25442b4c3be55c5$export$23077649cd9ebd4b)(element);
    (0, $f25442b4c3be55c5$export$2ad800d85590910f)(element, {
        ignore: $1274d677f59cb752$var$UPDATE_DEFAULT_OPTIONS
    });
    (0, $f25442b4c3be55c5$export$88eda8a7eb5c5eff)(element);
    if (!options.isForced && !options.preventListeners) (0, $b4h11.triggerEventOn)("beforeClassAssign", element, options);
    if (!ref.__if) return false;
    if (!node) return;
    const { preventUpdate: preventUpdate, preventDefineUpdate: preventDefineUpdate, preventContentUpdate: preventContentUpdate, preventStateUpdate: preventStateUpdate, preventRecursive: preventRecursive, preventUpdateListener: preventUpdateListener, preventUpdateAfter: preventUpdateAfter, preventUpdateAfterCount: preventUpdateAfterCount } = options;
    if (preventUpdateAfter) {
        if ((0, $e7Ezu.isNumber)(preventUpdateAfterCount) && preventUpdateAfter <= preventUpdateAfterCount) return;
        else if (options.preventUpdateAfterCount === void 0) options.preventUpdateAfterCount = 1;
        else options.preventUpdateAfterCount++;
    }
    const preventUpdateSet = (0, $e7Ezu.isArray)(preventUpdate) ? new Set(preventUpdate) : null;
    const preventDefineUpdateSet = (0, $e7Ezu.isArray)(preventDefineUpdate) ? new Set(preventDefineUpdate) : null;
    for(const param in element){
        const prop = element[param];
        if (!Object.prototype.hasOwnProperty.call(element, param)) continue;
        const isInPreventUpdate = preventUpdateSet && preventUpdateSet.has(param);
        const isInPreventDefineUpdate = preventDefineUpdateSet && preventDefineUpdateSet.has(param);
        const isRootEventHandler = (0, $e7Ezu.isFunction)(prop) && param.length > 2 && param.charCodeAt(0) === 111 && param.charCodeAt(1) === 110 && // 'on'
        param.charCodeAt(2) >= 65 && param.charCodeAt(2) <= 90;
        if ((0, $e7Ezu.isUndefined)(prop) || isInPreventUpdate || isInPreventDefineUpdate || preventDefineUpdate === true || preventDefineUpdate === param || preventStateUpdate && param === "state" || (0, $j7W2w.isMethod)(param, element) || isRootEventHandler || (0, $e7Ezu.isObject)((0, $e8b271fd11ec61f3$export$21cc2ed387caee94)[param])) continue;
        if (preventStateUpdate === "once") options.preventStateUpdate = false;
        const isElement = (0, $84df86e91acef76b$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $e7Ezu.isObject)(prop) && !hasDefine && !hasContextDefine && !preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            if (options.onEachUpdate) options.onEachUpdate(param, element, element.state, element.context);
            const childParams = params[param];
            if (childParams === void 0 && !options.isForced) {
                if (options.onlyUpdate) {
                    if (param !== options.onlyUpdate) continue;
                } else if (!options.updateByState) continue;
            }
            const childOptions = options.onlyUpdate && param === options.onlyUpdate ? {
                ...options,
                onlyUpdate: void 0,
                currentSnapshot: snapshotOnCallee,
                calleeElement: calleeElement
            } : {
                ...options,
                currentSnapshot: snapshotOnCallee,
                calleeElement: calleeElement
            };
            const childUpdateCall = ()=>$1274d677f59cb752$export$722fbec263ad908a.call(prop, childParams, childOptions);
            if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                childUpdateCall();
                if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)("lazyLoad", element, options);
            });
            else childUpdateCall();
        }
    }
    if (!preventContentUpdate) {
        const contentKey = ref.contentElementKey || "content";
        const existingContent = element[contentKey];
        const childrenProp = options.updateByState ? params.children || (ref.__exec?.children ? element.children : void 0) : params.children || element.children;
        if (childrenProp) {
            const content = (0, $4d2f5ab9b9d9b529$export$2e2bcd8739ae039)(childrenProp, element, opts);
            if (content && !ref.__noChildrenDifference) (0, $b06ad0032e72e12d$export$431313f2afd011e2)(content, element, options);
            else if (existingContent?.__ref && (0, $e7Ezu.isFunction)(existingContent.update)) {
                const lazyLoad = element.props?.lazyLoad || options.lazyLoad;
                const contentUpdateCall = ()=>$1274d677f59cb752$export$722fbec263ad908a.call(existingContent, params[contentKey], {
                        ...options,
                        currentSnapshot: snapshotOnCallee,
                        calleeElement: calleeElement
                    });
                if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                    contentUpdateCall();
                    if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)("lazyLoad", element, options);
                });
                else contentUpdateCall();
            }
        } else if (existingContent?.__ref && (0, $e7Ezu.isFunction)(existingContent.update)) {
            const lazyLoad = element.props?.lazyLoad || options.lazyLoad;
            const contentUpdateCall = ()=>$1274d677f59cb752$export$722fbec263ad908a.call(existingContent, params[contentKey], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            if (lazyLoad) (0, $bD06b.window).requestAnimationFrame(()=>{
                contentUpdateCall();
                if (!options.preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)("lazyLoad", element, options);
            });
            else contentUpdateCall();
        } else {
            const content = element.children || params.content;
            if (content && !options.updateByState) (0, $b06ad0032e72e12d$export$431313f2afd011e2)(content, element, options);
        }
    }
    if (!preventUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOn)("update", element, options);
};
const $1274d677f59cb752$var$findSiblingAttachOptions = (element, parent)=>{
    const { __children: __children } = parent.__ref || {};
    if (!__children) return false;
    const currentIndex = __children.indexOf(element.key);
    let previousNode;
    for(let i = currentIndex - 1; i >= 0; i--){
        const sibling = parent[__children[i]];
        if (sibling?.node?.parentNode) {
            previousNode = sibling.node;
            break;
        }
    }
    if (previousNode) return {
        position: "after",
        node: previousNode
    };
    let nextNode;
    for(let i = currentIndex + 1; i < __children.length; i++){
        const sibling = parent[__children[i]];
        if (sibling?.node?.parentNode) {
            nextNode = sibling.node;
            break;
        }
    }
    if (nextNode) return {
        position: "before",
        node: nextNode
    };
    return false;
};
const $1274d677f59cb752$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $e7Ezu.isFunction)(element.if) && !(0, $e7Ezu.isFunction)(element.props?.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = (element.if || element.props?.if)(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.__text;
            delete element.extends;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            if (element.node) {
                element.node.remove();
                delete element.node;
            }
            const contentKey = ref.contentElementKey;
            if (element.children) element.removeContent();
            else if (element[contentKey]?.parseDeep) element[contentKey] = element[contentKey].parseDeep();
            const attachOptions = $1274d677f59cb752$var$findSiblingAttachOptions(element, parent);
            delete element.__ref;
            delete element.parent;
            const createdElement = (0, $7dd430f018926e40$export$185802fd694ee1f5)(element, parent, element.key, (0, $dzojf.OPTIONS).create, attachOptions);
            if (options.preventUpdate !== true && element.on && (0, $e7Ezu.isFunction)(element.on.update)) (0, $b4h11.applyEvent)(element.on.update, createdElement, createdElement.state);
            return createdElement;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
const $1274d677f59cb752$var$inheritStateUpdates = (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent?.state || {};
        return;
    }
    const shouldForceFunctionState = (0, $e7Ezu.isFunction)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $g1LU2.exec)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            preventStateUpdateListener: false,
            updatedByStateFunction: true
        });
        return;
    }
    const keyInParentState = (0, $lw6SS.findInheritedState)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    if (!options.preventBeforeStateUpdateListener && !options.preventListeners) {
        const initStateReturns = (0, $b4h11.triggerEventOnUpdate)("beforeStateUpdate", keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    const newState = $1274d677f59cb752$var$createStateUpdate(element, parent, options);
    if (!options.preventStateUpdateListener && !options.preventListeners) (0, $b4h11.triggerEventOnUpdate)("stateUpdate", newState.parse(), element, options);
};
const $1274d677f59cb752$var$createStateUpdate = (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        Object.getPrototypeOf(__stateChildren[child]).parent = newState;
    }
    return newState;
};
var $1274d677f59cb752$export$2e2bcd8739ae039 = $1274d677f59cb752$export$722fbec263ad908a;



var $fUAoP = parcelRequire("fUAoP");
const $5ed71877cb172ff8$export$626ce79af72fc3d3 = (element, parent, options = {})=>{
    const proto = {
        set: $b06ad0032e72e12d$export$adaa4cf7ef1b65be,
        reset: $b06ad0032e72e12d$export$aad8462122ac592b,
        update: $1274d677f59cb752$export$722fbec263ad908a,
        variables: $fUAoP.variables,
        remove: $fUAoP.remove,
        updateContent: $b06ad0032e72e12d$export$5143cc956eb9d8f6,
        removeContent: $b06ad0032e72e12d$export$6e1d9b0d0e1e1def,
        setProps: $fUAoP.setProps,
        lookup: $fUAoP.lookup,
        lookdown: $fUAoP.lookdown,
        lookdownAll: $fUAoP.lookdownAll,
        getRef: $fUAoP.getRef,
        getPath: $fUAoP.getPath,
        getRootState: $fUAoP.getRootState,
        getRoot: $fUAoP.getRoot,
        getRootData: $fUAoP.getRootData,
        getRootContext: $fUAoP.getRootContext,
        getContext: $fUAoP.getContext,
        setNodeStyles: $fUAoP.setNodeStyles,
        spotByPath: $fUAoP.spotByPath,
        parse: $fUAoP.parse,
        parseDeep: $fUAoP.parseDeep,
        keys: $fUAoP.keys,
        nextElement: $fUAoP.nextElement,
        previousElement: $fUAoP.previousElement,
        log: $fUAoP.log,
        verbose: $fUAoP.verbose,
        warn: $fUAoP.warn,
        error: $fUAoP.error,
        call: $fUAoP.call
    };
    if (element.context.methods) (options.strict ? (0, $g1LU2.merge) : (0, $g1LU2.overwrite))(proto, element.context.methods);
    Object.setPrototypeOf(element, proto);
};





const $7dd430f018926e40$var$EXCLUDED_ATTRS = /* @__PURE__ */ new Set([
    "class",
    "style"
]);
const $7dd430f018926e40$var$applyPropsAsAttrs = (element)=>{
    const { tag: tag, props: props, context: context } = element;
    if (!tag || !props) return;
    const autoAttrs = (0, $235425de3553395f$export$a3d5d5e1a17535c6)(tag, props, context?.cssPropsRegistry);
    const filtered = {};
    for(const key in autoAttrs)if (!$7dd430f018926e40$var$EXCLUDED_ATTRS.has(key)) filtered[key] = autoAttrs[key];
    let hasFiltered = false;
    for(const _k in filtered){
        hasFiltered = true;
        break;
    }
    if (!hasFiltered) return;
    if (!element.attr) element.attr = filtered;
    else if (typeof element.attr === "object") element.attr = {
        ...filtered,
        ...element.attr
    };
};
const $7dd430f018926e40$var$ENV = "production";
const $7dd430f018926e40$export$185802fd694ee1f5 = (props, parentEl, passedKey, options = (0, $dzojf.OPTIONS).create || {}, attachOptions)=>{
    $7dd430f018926e40$var$cacheOptions(options);
    const element = (0, $81M4S.createElement)(props, parentEl, passedKey, options, (0, $a86760b483a583a2$export$fbea82a1c0574ef4));
    if (!element) return;
    const { key: key, parent: parent, __ref: ref } = element;
    (0, $81M4S.createRoot)(element, parent);
    (0, $7gXxj.applyExtends)(element, parent, options);
    if (options.onlyResolveExtends) return $7dd430f018926e40$var$onlyResolveExtends(element, parent, key, options);
    (0, $5zx8x.propertizeElement).call(element, element);
    (0, $b4h11.triggerEventOn)("start", element, options);
    $7dd430f018926e40$var$resetOptions(element, parent, options);
    (0, $5ed71877cb172ff8$export$626ce79af72fc3d3)(element, parent, options);
    (0, $5ORwk.createScope)(element, parent);
    (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    if (element.scope === "state") element.scope = element.state;
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    (0, $5zx8x.initProps)(element, parent, options);
    (0, $5zx8x.pickupElementFromProps).call(element, element, {
        cachedKeys: []
    });
    $7dd430f018926e40$var$applyPropsAsAttrs(element);
    if (element.scope === "props" || element.scope === true) element.scope = element.props;
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    if (element.node) {
        if (ref.__if) return (0, $ba03b8b173117516$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    }
    const onInit = (0, $b4h11.triggerEventOn)("init", element, options);
    if (onInit === false) return element;
    (0, $b4h11.triggerEventOn)("beforeClassAssign", element, options);
    (0, $e443d57a8c733245$export$d559e9a3b71405f6)(element);
    $7dd430f018926e40$var$renderElement(element, parent, options, attachOptions);
    $7dd430f018926e40$var$addElementIntoParentChildren(element, parent);
    (0, $b4h11.triggerEventOn)("complete", element, options);
    return element;
};
const $7dd430f018926e40$var$cacheOptions = (options)=>{
    if (options && !(0, $dzojf.OPTIONS).create) {
        (0, $dzojf.OPTIONS).create = options;
        (0, $dzojf.OPTIONS).create.context = options.context;
    }
};
const $7dd430f018926e40$var$resetOptions = (element, parent, options)=>{
    let hasKeys = false;
    for(const _k in options){
        hasKeys = true;
        break;
    }
    if (hasKeys) {
        (0, $dzojf.OPTIONS).defaultOptions = options;
        if (options.ignoreChildExtends) delete options.ignoreChildExtends;
    }
};
const $7dd430f018926e40$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) {
        if (!parent.__ref.__children.includes(element.key)) parent.__ref.__children.push(element.key);
    }
};
let $7dd430f018926e40$var$_uniqIdCounter = 1;
const $7dd430f018926e40$var$visitedElements = /* @__PURE__ */ new WeakMap();
const $7dd430f018926e40$var$renderElement = (element, parent, options, attachOptions)=>{
    if ($7dd430f018926e40$var$visitedElements.has(element)) {
        if ($7dd430f018926e40$var$ENV === "test" || $7dd430f018926e40$var$ENV === "development") console.warn("Cyclic rendering detected:", element.__ref.path);
    }
    $7dd430f018926e40$var$visitedElements.set(element, true);
    const { __ref: ref, key: key } = element;
    const createNestedChild = ()=>{
        const isInfiniteLoopDetected = (0, $g1LU2.detectInfiniteLoop)(ref.path);
        if (ref.__uniqId || isInfiniteLoopDetected) return;
        (0, $55f529c16bdd65a1$export$270e7ba5936d3c48)(element, options);
        ref.__uniqId = $7dd430f018926e40$var$_uniqIdCounter++;
    };
    if ($7dd430f018926e40$var$ENV === "test" || $7dd430f018926e40$var$ENV === "development" || element.context?.strictMode) createNestedChild();
    else try {
        createNestedChild();
    } catch (e) {
        element.error = e;
        const path = ref.path;
        if (path.includes("ComponentsGrid")) path.splice(0, path.indexOf("ComponentsGrid") + 2);
        if (path.includes("demoComponent")) path.splice(0, path.indexOf("demoComponent") + 1);
        const isDemoComponent = element.lookup((el)=>el.state.key)?.state?.key;
        element.warn("Error happened in:", isDemoComponent ? isDemoComponent + " " : "" + path.join("."));
        element.verbose();
        console.error("[DomQL] Render error:", e);
        if (element.on?.error) element.on.error(e, element, element.state, element.context, options);
    }
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    (0, $ba03b8b173117516$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    (0, $339eb5798b6c1bb7$export$cef3c08d5491509f)(element, options);
    (0, $b4h11.triggerEventOn)("render", element, options);
    (0, $b4h11.triggerEventOn)("renderRouter", element, options);
    (0, $b4h11.triggerEventOn)("done", element, options);
    (0, $b4h11.triggerEventOn)("create", element, options);
};
const $7dd430f018926e40$var$onlyResolveExtends = (element, parent, key, options)=>{
    const { __ref: ref } = element;
    (0, $5ed71877cb172ff8$export$626ce79af72fc3d3)(element, parent, options);
    (0, $5ORwk.createScope)(element, parent);
    (0, $d49b8d9eb136c53a$export$e6a0daad8304de)(element, parent);
    if (element.scope === "state") element.scope = element.state;
    (0, $bvmdI.createIfConditionFlag)(element, parent);
    (0, $5zx8x.initProps)(element, parent, options);
    (0, $5zx8x.pickupElementFromProps).call(element, element, {
        cachedKeys: []
    });
    if (element.scope === "props" || element.scope === true) element.scope = element.props;
    if (element.node && ref.__if) parent[key || element.key] = element;
    if (!element.props) element.props = {};
    $7dd430f018926e40$var$addElementIntoParentChildren(element, parent);
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $f25442b4c3be55c5$export$b4c781127351659b)(element);
        (0, $f25442b4c3be55c5$export$3223a9877c540db8)(element);
        for(const k in element){
            if ((0, $e7Ezu.isUndefined)(element[k]) || (0, $j7W2w.isMethod)(k, element) || (0, $e7Ezu.isObject)((0, $e8b271fd11ec61f3$export$21cc2ed387caee94)[k])) continue;
            const hasDefine = element.define?.[k];
            const contextHasDefine = element.context?.define?.[k];
            const optionsHasDefine = options.define?.[k];
            if (!ref.__skipCreate && (0, $e8b271fd11ec61f3$export$21cc2ed387caee94)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $7dd430f018926e40$export$185802fd694ee1f5((0, $g1LU2.exec)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element;
    delete element.update;
    delete element.__element;
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
var $7dd430f018926e40$export$2e2bcd8739ae039 = $7dd430f018926e40$export$185802fd694ee1f5;


const $4d3a6b1761d4d13f$var$create = (element, parent, key, options)=>{
    const domqlElement = ((0, $7dd430f018926e40$export$2e2bcd8739ae039).default || (0, $7dd430f018926e40$export$2e2bcd8739ae039))(element, parent, key, options);
    const complete = domqlElement.on?.complete;
    if (complete) domqlElement.on.complete(element, element.state, element.context, options);
    const onComplete = domqlElement.props?.onComplete;
    if (onComplete) domqlElement.props?.onComplete(element, element.state, element.context, options);
    const initInspect = domqlElement.on?.initInspect;
    if (initInspect) domqlElement.on.initInspect(element, element.state, element.context, options);
    const initSync = domqlElement.on?.initSync;
    if (initSync) domqlElement.on.initSync(element, element.state, element.context, options);
    return domqlElement;
};
var $4d3a6b1761d4d13f$export$2e2bcd8739ae039 = {
    TREE: $a86760b483a583a2$export$33ecaa422889cd80,
    create: $4d3a6b1761d4d13f$var$create
};




parcelRequire("jgAqB");
var $fhYuv = parcelRequire("fhYuv");
var $e7Ezu = parcelRequire("e7Ezu");



parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");
var $eo3lV = parcelRequire("eo3lV");



var $73MNt = parcelRequire("73MNt");
parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $bD06b = parcelRequire("bD06b");
const $f115c1a4e068c423$var$NOTIF_COLORS = {
    success: "green",
    error: "red",
    warning: "yellow"
};
const $f115c1a4e068c423$export$f34bb2007ac88e4d = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.setProps({
                    animation: "fadeOutDown"
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3e3);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: "Disconnected",
            type: "error"
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            if (element.notifications.content.connected) element.notifications.content.connected.setProps({
                animation: "fadeOutDown"
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3e3);
    }
};
const $f115c1a4e068c423$export$36ba2f559d49a8f6 = {
    state: {
        notifications: []
    },
    Notifications: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999",
        childExtends: "Notification",
        childProps: ({ state: state })=>({
                animationDuration: "C",
                background: $f115c1a4e068c423$var$NOTIF_COLORS[state.type || "success"],
                icon: null,
                Flex: {
                    Title: {
                        text: "{{ title }}"
                    },
                    P: {
                        text: "{{ title }}"
                    }
                },
                onRender: (e, el, s)=>{
                    el.setProps({
                        animation: "fadeInUp"
                    });
                },
                onClick: (e, el, s)=>{
                    delete s.notifications[el.key];
                    el.setProps({
                        animation: "fadeOutDown"
                    });
                    if (s.onClose) s.onClose(e, el, s);
                }
            }),
        IconText: null,
        childrenAs: "state",
        children: ({ state: state })=>state.notifications
    }
};



parcelRequire("jgAqB");
var $e7Ezu = parcelRequire("e7Ezu");

var $Lswg4 = parcelRequire("Lswg4");
function $16ceb1f9d93b5773$var$returnStringExtend(_extends) {
    return (0, $e7Ezu.isString)(_extends) ? _extends : (0, $e7Ezu.isArray)(_extends) ? _extends.find((extItem)=>(0, $e7Ezu.isString)(extItem)) : "";
}
function $16ceb1f9d93b5773$var$getComponentKey(el) {
    if (!el) return;
    const __componentKey = el.__ref.__componentKey;
    const extendsStr = el.extends && $16ceb1f9d93b5773$var$returnStringExtend(el.extends);
    const parentChildExtendStr = el.parent && el.parent.childExtends && $16ceb1f9d93b5773$var$returnStringExtend(el.parent.childExtends);
    return (__componentKey || extendsStr || parentChildExtendStr || "").split("_")[0].split(".")[0].split("+")[0];
}
function $16ceb1f9d93b5773$var$findComponent(el) {
    if (!el || !el.__ref) return;
    const { components: components, pages: pages, editor: editor } = el.context;
    const componentKey = $16ceb1f9d93b5773$var$getComponentKey(el);
    if (editor && editor.onInitInspect) {
        const initInspectReturns = editor.onInitInspect(componentKey, el, el.state);
        if (!initInspectReturns) return $16ceb1f9d93b5773$var$findComponent(el.parent);
    }
    if (componentKey && (components[componentKey] || pages[componentKey])) return el;
    return $16ceb1f9d93b5773$var$findComponent(el.parent);
}
const $16ceb1f9d93b5773$var$onInspect = (app, state, ctx)=>{
    const windowOpts = ctx.window || window;
    windowOpts.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventUpdate: true,
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    windowOpts.onkeyup = (ev)=>{
        if (app.state.preventSelect && (!ev.altKey || !ev.shiftKey)) {
            app.state.replace({
                debugging: false,
                preventSelect: false
            }, {
                preventUpdate: true,
                preventContentUpdate: true,
                preventRecursive: true
            });
            app.Inspector.state.update({
                area: false
            });
        }
    };
};
const $16ceb1f9d93b5773$export$d1a121333e17a5bb = {
    ".preventSelect": {
        userSelect: "none"
    },
    "!preventSelect": {
        userSelect: "auto"
    },
    onInspect: $16ceb1f9d93b5773$var$onInspect,
    onMousemove: (ev, e, state)=>{
        const el = ev.target.ref;
        const component = $16ceb1f9d93b5773$var$findComponent(el);
        const focusState = e.Inspector.state;
        if (!component || !state.debugging || !component.__ref) return focusState.update({
            area: false
        });
        const componentKey = $16ceb1f9d93b5773$var$getComponentKey(component);
        const updateValue = (area)=>{
            focusState.update({
                area: area,
                focusKey: componentKey
            });
        };
        const update = ()=>{
            if (ev.altKey && ev.shiftKey) {
                const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                const area = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
                if (!focusState.area) return updateValue(area);
                if (focusState.area.x !== area.x) updateValue(area);
            } else if (focusState.area) focusState.update({
                area: false
            });
        };
        window.requestAnimationFrame(()=>{
            update();
            window.requestAnimationFrame(update);
        });
    },
    onMousedown: (ev, elem, state)=>{
        if (!state.debugging) return;
        const el = ev.target.ref;
        const component = $16ceb1f9d93b5773$var$findComponent(el);
        if (!component) return;
        const componentKey = $16ceb1f9d93b5773$var$getComponentKey(component);
        if (!componentKey) return;
        const editor = el.context.editor;
        if (editor && editor.onInspect) return editor.onInspect(componentKey, el, el.state, {
            allowRouterWhileInspect: true
        });
        const data = JSON.stringify({
            componentKey: `${componentKey}`
        });
        (0, $Lswg4.send).call(el.context.socket, "route", data);
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    },
    Inspector: {
        state: {},
        transition: "all, defaultBezier, X",
        position: "fixed",
        hide: (el, s)=>!(s.area && s.parent.debugging),
        style: {
            boxShadow: "0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A",
            zIndex: "9999999",
            borderRadius: "10px",
            pointerEvents: "none"
        },
        Span: {
            position: "absolute",
            margin: "A2 0",
            fontSize: "Z",
            color: "text",
            // color: 'blue',
            zIndex: "99999999",
            transition: "all, defaultBezier, X",
            textDecoration: "underline",
            fontWeight: "500",
            top: "100%",
            style: {
                boxShadow: "0 25px 10px 35px black",
                textShadow: "0 0 10px black"
            },
            text: "{{ focusKey }}"
        },
        onInit: ({ context: context })=>{
            const { components: components } = context;
            if ((0, $e7Ezu.isObject)(components)) {
                const { Content: Content, ...rest } = components;
                for(const key in rest){
                    if ($be006f1a0fabd945$exports[key]) continue;
                    if (!rest[key].__ref) rest[key].__ref = {};
                    if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                }
            }
        },
        onBeforeUpdate: (ch, el, s)=>{
            const { area: area } = s;
            const isDebugging = s.area && s.parent.debugging;
            let style;
            if (!isDebugging) style = "display: none !important";
            else if (area) {
                const { x: x, y: y, width: width, height: height } = area;
                style = `
            display: block !important;
            top: ${y - 6}px;
            left: ${x - 6}px;
            width: ${width + 12}px;
            height: ${height + 12}px;
          `;
            }
            el.node.style = style;
            el.Span.node.innerText = s.focusKey;
            return false;
        }
    }
};


const $079a62f37cff6b3e$var$isLocal = false;
const $079a62f37cff6b3e$var$deletePath = (obj, path)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (acc && v in acc) {
            if (i !== arr.length - 1) return acc[v];
            delete acc[v];
        }
        return void 0;
    }, obj);
};
const $079a62f37cff6b3e$var$setPath = (obj, path, value, createNestedObjects = false)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (!acc) return void 0;
        if (i !== arr.length - 1) {
            if (!acc[v] && createNestedObjects) acc[v] = {};
            return acc[v];
        }
        acc[v] = value;
        return void 0;
    }, obj);
};
const $079a62f37cff6b3e$var$applyOpsToCtx = (ctx, changes)=>{
    const topLevelChanged = /* @__PURE__ */ new Set();
    if (!Array.isArray(changes)) return topLevelChanged;
    for (const [action, path, change] of changes){
        if (!Array.isArray(path) || !path.length) continue;
        topLevelChanged.add(path[0]);
        switch(action){
            case "delete":
                $079a62f37cff6b3e$var$deletePath(ctx, path);
                break;
            case "update":
            case "set":
                $079a62f37cff6b3e$var$setPath(ctx, path, change, true);
                break;
            default:
                break;
        }
    }
    return topLevelChanged;
};
const $079a62f37cff6b3e$var$fetchServiceToken = async ()=>{
    try {
        const urlBase = $079a62f37cff6b3e$var$isLocal ? "http://localhost:8080" : "https://api.symbols.app";
        const res = await (0, $bD06b.window).fetch(`${urlBase}/service-token`, {
            method: "GET"
        });
        let txt;
        try {
            const json = await res.clone().json();
            if (json && typeof json.token === "string") return json.token.trim();
            txt = await res.text();
        } catch  {
            txt = await res.text();
        }
        return (txt || "").replace(/\s+/gu, "") || void 0;
    } catch (e) {
        console.error("[sync] Failed to fetch service-token", e);
    }
};
const $079a62f37cff6b3e$var$onSnapshot = (el, s, ctx)=>(payload = {})=>{
        let { data: data } = payload;
        const { schema: schema } = payload;
        if (!data) return;
        data = el.call("deepDestringifyFunctions", data, Array.isArray(data) ? [] : {});
        Object.entries(data).forEach(([key, val])=>{
            if (ctx[key] && typeof ctx[key] === "object") {
                if (key === "designSystem") (0, $7d124ec5af804dac$export$2cd8252107eb640b)(val);
                else (0, $g1LU2.overwriteShallow)(ctx[key], val);
            } else ctx[key] = val;
        });
        if (schema) ctx.schema = schema;
    };
const $079a62f37cff6b3e$var$onOps = (el, s, ctx)=>(payload = {})=>{
        let { changes: changes } = payload;
        if (!changes || !Array.isArray(changes) || !changes.length) return;
        changes = el.call("deepDestringifyFunctions", changes, Array.isArray(changes) ? [] : {});
        const changed = $079a62f37cff6b3e$var$applyOpsToCtx(ctx, changes);
        if (changed.has("state")) {
            const route = ctx.state?.route;
            if (route) el.call("router", route.replace("/state", "") || "/", el.__ref.root, {}, {
                scrollToTop: false
            });
            else s.update(ctx.state);
        }
        if ([
            "pages",
            "components",
            "snippets",
            "functions"
        ].some((k)=>changed.has(k))) {
            const { pathname: pathname, search: search, hash: hash } = ctx.window.location;
            el.call("router", pathname + search + hash, el.__ref.root, {}, {
                scrollToTop: false
            });
        }
        if (changed.has("designSystem")) (0, $7d124ec5af804dac$export$2cd8252107eb640b)(ctx.designSystem);
    };
const $079a62f37cff6b3e$export$c57211ae658b2a31 = async (el, s, ctx)=>{
    const token = await $079a62f37cff6b3e$var$fetchServiceToken();
    if (!token) {
        console.warn("[sync] No service token \u2013 live collaboration disabled");
        return null;
    }
    const projectKey = ctx.key;
    if (!projectKey) {
        console.warn("[sync] ctx.key missing \u2013 cannot establish collaborative connection");
        return null;
    }
    const socketBaseUrl = $079a62f37cff6b3e$var$isLocal ? "http://localhost:8080" : "https://api.symbols.app";
    const socket = (0, $73MNt.io)(socketBaseUrl, {
        path: "/collab-socket",
        transports: [
            "websocket"
        ],
        auth: {
            token: token,
            projectKey: projectKey,
            branch: "main",
            live: true,
            clientType: "platform"
        },
        reconnectionAttempts: Infinity,
        reconnectionDelayMax: 4e3
    });
    socket.on("connect", ()=>{
        if (ctx.editor?.verbose) console.info("[sync] Connected to collab socket");
    });
    socket.on("snapshot", $079a62f37cff6b3e$var$onSnapshot(el, s, ctx));
    socket.on("ops", $079a62f37cff6b3e$var$onOps(el, s, ctx));
    socket.on("clients", (data)=>{
        if (ctx.editor?.verbose) (0, $f115c1a4e068c423$export$f34bb2007ac88e4d)(data, el, s);
    });
    socket.on("disconnect", (reason)=>{
        if (ctx.editor?.verbose) console.info("[sync] Disconnected from collab socket", reason);
    });
    return socket;
};
const $079a62f37cff6b3e$export$a8792fa004fc1e59 = {
    onInitSync: $079a62f37cff6b3e$export$c57211ae658b2a31
};
const $079a62f37cff6b3e$export$d05f3dc416482df7 = {
    extends: [
        $079a62f37cff6b3e$export$a8792fa004fc1e59,
        (0, $16ceb1f9d93b5773$export$d1a121333e17a5bb),
        (0, $f115c1a4e068c423$export$36ba2f559d49a8f6)
    ]
};


const $cbd4ab0ffc89cd76$export$c8d1988b2aeaf8a9 = (app, ctx)=>{
    return (0, $e7Ezu.isObjectLike)(app.extends) ? app.extends : [];
};
const $cbd4ab0ffc89cd76$export$f04cca198b6322f4 = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const liveSync = (0, $e7Ezu.isUndefined)(editor.liveSync) ? (0, $eo3lV.isDevelopment)() : editor.liveSync;
    if (liveSync) {
        if ((0, $e7Ezu.isArray)(app.extends)) app.extends.push((0, $079a62f37cff6b3e$export$a8792fa004fc1e59));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $079a62f37cff6b3e$export$a8792fa004fc1e59)
        ];
        else app.extends = [
            (0, $079a62f37cff6b3e$export$a8792fa004fc1e59)
        ];
    }
};
const $cbd4ab0ffc89cd76$export$6919748479ac6c4f = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const inspect = (0, $e7Ezu.isUndefined)(editor.inspect) ? (0, $eo3lV.isDevelopment)() : editor.inspect;
    if (inspect) {
        if ((0, $e7Ezu.isArray)(app.extends)) app.extends.push((0, $16ceb1f9d93b5773$export$d1a121333e17a5bb));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $16ceb1f9d93b5773$export$d1a121333e17a5bb)
        ];
        else app.extends = [
            (0, $16ceb1f9d93b5773$export$d1a121333e17a5bb)
        ];
    }
};
const $cbd4ab0ffc89cd76$export$cf84b69175b2f78a = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const verbose = (0, $e7Ezu.isUndefined)(editor.verbose) ? (0, $eo3lV.isDevelopment)() || ctx.verbose : editor.verbose;
    if (verbose) {
        if ((0, $e7Ezu.isArray)(app.extends)) app.extends.push((0, $f115c1a4e068c423$export$36ba2f559d49a8f6));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $f115c1a4e068c423$export$36ba2f559d49a8f6)
        ];
        else app.extends = [
            (0, $f115c1a4e068c423$export$36ba2f559d49a8f6)
        ];
    }
};


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $eo3lV = parcelRequire("eo3lV");
var $e7Ezu = parcelRequire("e7Ezu");
var $iPYI6 = parcelRequire("iPYI6");


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");
var $e7Ezu = parcelRequire("e7Ezu");


var $44846c222685cb73$var$__filename = "node_modules/smbls/src/init.js";
'use strict';
let $44846c222685cb73$export$1370ffb96395fc6c = {};
try {
    const _url = typeof $44846c222685cb73$var$__filename !== 'undefined' ? $44846c222685cb73$var$__filename : "file:///node_modules/smbls/src/init.js";
    const require = (0, $eca075ad100d834d$exports.createRequire)(_url);
    $44846c222685cb73$export$1370ffb96395fc6c = require('../dynamic.json');
} catch  {}
const $44846c222685cb73$var$CONFIG = (0, $e2cb0be23d169790$export$e23c3d522afb24cd)();
const $44846c222685cb73$var$mergeWithLocalFile = (config = $44846c222685cb73$var$CONFIG, options)=>{
    const rcfile = (0, $e7Ezu.isObject)(options.localFile) ? options.localFile : $44846c222685cb73$export$1370ffb96395fc6c || {};
    const clonedFile = (0, $g1LU2.deepClone)(rcfile.designSystem || {});
    return (0, $g1LU2.deepMerge)(config, clonedFile);
};
const $44846c222685cb73$var$SET_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $44846c222685cb73$export$2cd8252107eb640b = (config, options = $44846c222685cb73$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $44846c222685cb73$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $94f11aa15e4fc75e$export$adaa4cf7ef1b65be)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        globalTheme: options.globalTheme,
        files: options.files,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $69026df1e768b48e$export$8b73d71a1d936bc)(conf.font || conf.FONT, conf.files);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) {
        emotion.injectGlobal({
            ':root': conf.CSS_VARS
        });
        // Inject theme-switching CSS vars (media queries + data-theme selectors)
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith('@media')) // Media query — only apply when no data-theme forces a theme
            themeStyles[key] = {
                ':root:not([data-theme])': conf.CSS_MEDIA_VARS[key]
            };
            else // Selector ([data-theme="..."]) — apply directly
            themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            emotion.injectGlobal(themeStyles);
        }
    }
    if (useReset) emotion.injectGlobal(conf.reset || conf.RESET);
    // Register all ANIMATION entries as global @keyframes
    const animations = conf.animation || conf.ANIMATION;
    if (animations) {
        const keyframesCSS = {};
        for(const name in animations)keyframesCSS[`@keyframes ${name}`] = animations[name];
        emotion.injectGlobal(keyframesCSS);
    }
    if (hasSvgs || useSvgSprite) (0, $ea2a29e9da15b058$export$2c4662f4a995c568)(conf.svg || conf.SVG, {
        document: options.document
    });
    if (hasIcons || useIconSprite) (0, $ea2a29e9da15b058$export$6892263c3fbefa8c)(conf.icons || conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $44846c222685cb73$var$UPDATE_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90)
};
const $44846c222685cb73$export$b545ad0f2df0be16 = (config, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $44846c222685cb73$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $94f11aa15e4fc75e$export$adaa4cf7ef1b65be)({
        verbose: false,
        ...resultConfig
    });
    if (!options.preventInject) {
        emotion.injectGlobal({
            ':root': conf.CSS_VARS
        });
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith('@media')) themeStyles[key] = {
                ':root:not([data-theme])': conf.CSS_MEDIA_VARS[key]
            };
            else themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            emotion.injectGlobal(themeStyles);
        }
        emotion.injectGlobal(conf.RESET);
    }
    return conf;
};
const $44846c222685cb73$export$3a26aa64e59aeaff = (styles, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $44846c222685cb73$export$ed2c61d2d8a098be = (config, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ':root': config.CSS_VARS
    });
    if (config.CSS_MEDIA_VARS) {
        const themeStyles = {};
        for(const key in config.CSS_MEDIA_VARS)if (key.startsWith('@media')) themeStyles[key] = {
            ':root:not([data-theme])': config.CSS_MEDIA_VARS[key]
        };
        else themeStyles[key] = config.CSS_MEDIA_VARS[key];
        emotion.injectGlobal(themeStyles);
    }
};
const $44846c222685cb73$export$2796c4ce44e61efa = (props, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{} // setClassname(props, options.emotion.css)
;



'use strict';
const $efa68247d5355cfe$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    metadata: (param, el, state)=>{
        if (!param) return;
        const doc = el.context?.document || typeof document !== 'undefined' && document;
        if (!doc) return;
        const resolved = (0, $84f66b9cc4cc43c7$export$d2032d3864484f3)(param, el, state);
        (0, $84f66b9cc4cc43c7$export$961d8bb4ed050676)(resolved, doc);
    },
    $router: async (param, el)=>{
        if (!param) return;
        const obj = {
            tag: 'fragment',
            ...param
        };
        const set = async ()=>{
            await el.set(obj, {
                preventDefineUpdate: '$router'
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else await set();
        return obj;
    }
};



var $07b489c9a6cbc9d4$var$__filename = "node_modules/smbls/src/options.js";
'use strict';
let $07b489c9a6cbc9d4$var$version = '0.0.0';
try {
    const _url = typeof $07b489c9a6cbc9d4$var$__filename !== 'undefined' ? $07b489c9a6cbc9d4$var$__filename : "file:///node_modules/smbls/src/options.js";
    const require = (0, $eca075ad100d834d$exports.createRequire)(_url);
    const pkg = require('../package.json');
    $07b489c9a6cbc9d4$var$version = pkg.version;
} catch  {}
const $07b489c9a6cbc9d4$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useDefaultIcons: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c = {
    initRouter: true,
    popState: true,
    injectRouterInLinkComponent: true
};
const $07b489c9a6cbc9d4$export$9c542858adf7dcd0 = {
    ...$07b489c9a6cbc9d4$export$882cd4124a942c79,
    router: $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c,
    version: $07b489c9a6cbc9d4$var$version
};
const $07b489c9a6cbc9d4$export$7f202753e6a32b2b = {
    state: {},
    pages: {},
    components: {},
    router: $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c,
    define: (0, $efa68247d5355cfe$export$6588fc50c67b09a2)
};
var $07b489c9a6cbc9d4$export$2e2bcd8739ae039 = $07b489c9a6cbc9d4$export$7f202753e6a32b2b;


parcelRequire("jgAqB");
var $g1LU2 = parcelRequire("g1LU2");

'use strict';
const $dcc242eddee725a1$var$OPTION_KEYS = [
    'useReset',
    'useVariable',
    'useFontImport',
    'useIconSprite',
    'useSvgSprite',
    'useDocumentTheme',
    'useDefaultIcons',
    'useDefaultConfig',
    'verbose',
    'globalTheme'
];
const $dcc242eddee725a1$export$e567b959eb9cc2cc = (key, options = {})=>{
    const doc = options.parent || options.document || document;
    const initOptions = options.initOptions || {};
    const emotion = initOptions.emotion;
    if (!initOptions.emotion) initOptions.emotion = (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const registry = options.registry || (0, $b3468425a35a59c8$export$23627aa597d6e60c)(initOptions.emotion, options);
    const designSystem = initOptions.useDefaultConfig || options.useDefaultConfig || options.designSystem?.useDefaultConfig ? (0, $g1LU2.deepMerge)(options.designSystem, (0, $g1LU2.deepClone)((0, $72d70d264f1ca449$export$c2f8e0cc249a8d8f))) : options.designSystem || (0, $g1LU2.deepClone)((0, $72d70d264f1ca449$export$c2f8e0cc249a8d8f));
    // Pick context-level overrides (from user's config.js spread into context)
    const contextOverrides = {};
    for (const k of $dcc242eddee725a1$var$OPTION_KEYS)if (options[k] !== undefined) contextOverrides[k] = options[k];
    const scratchSystem = (0, $44846c222685cb73$export$2cd8252107eb640b)(designSystem, {
        key: key,
        emotion: emotion,
        document: doc,
        files: options.files,
        ...(0, $07b489c9a6cbc9d4$export$9c542858adf7dcd0),
        ...contextOverrides,
        ...initOptions
    });
    return [
        scratchSystem,
        emotion,
        registry
    ];
};






// @preserve-env
const $e53004b52dee5ec6$export$c3727843bfb8bb3b = (context)=>{
    const win = typeof window !== "undefined" ? window : globalThis || {};
    if (!win.document) win.document = {
        body: {}
    };
    const doc = typeof document !== "undefined" ? document : win.document;
    context.document = context.document || doc;
    context.window = context.window || win;
    return context.window;
};
const $e53004b52dee5ec6$var$UIkitWithPrefix = (prefix = "smbls")=>{
    const newObj = {};
    for(const key in $be006f1a0fabd945$exports)if (Object.prototype.hasOwnProperty.call($be006f1a0fabd945$exports, key)) {
        if ((0, $iPYI6.matchesComponentNaming)(key)) newObj[`smbls.${key}`] = $be006f1a0fabd945$exports[key];
        else newObj[key] = $be006f1a0fabd945$exports[key];
    }
    return newObj;
};
const $e53004b52dee5ec6$export$4f2633f1ff10978c = (context)=>{
    return context.components ? {
        ...$e53004b52dee5ec6$var$UIkitWithPrefix(),
        ...context.components
    } : $e53004b52dee5ec6$var$UIkitWithPrefix();
};
const $e53004b52dee5ec6$export$348dc3ccba7d17b1 = (context)=>{
    return {
        ...$0daf8c2ff7816ad9$exports,
        ...$32a808518113ee1c$exports,
        ...$0daf8c2ff7816ad9$exports.scratchUtils,
        ...context.utils,
        ...context.snippets,
        ...context.functions
    };
};
const $e53004b52dee5ec6$export$bb03004b651040c = (context)=>{
    return {
        ...context.methods || {},
        require: context.utils.require,
        requireOnDemand: context.utils.requireOnDemand,
        router: context.utils.router
    };
};
const $e53004b52dee5ec6$var$cachedDeps = {};
const $e53004b52dee5ec6$export$c40391394e7726ed = async ({ dependencies: dependencies, dependenciesOnDemand: dependenciesOnDemand, document: document2, preventCaching: preventCaching = false, cdnProvider: cdnProvider, packageManager: packageManager, symbolsConfig: symbolsConfig })=>{
    if (!cdnProvider) cdnProvider = (0, $6aceb777da373426$export$1a8b9f70f9282ea1)[packageManager] || (0, $6aceb777da373426$export$b5e67ffeac229970)(symbolsConfig) || "esmsh";
    if (!dependencies) return null;
    let hasAny = false;
    for(const _k in dependencies){
        hasAny = true;
        break;
    }
    if (!hasAny) return null;
    for(const dependency in dependencies){
        const version = dependencies[dependency];
        if (dependenciesOnDemand && dependenciesOnDemand[dependency]) continue;
        const random = (0, $eo3lV.isDevelopment)() && preventCaching ? `?${Math.random()}` : "";
        const url = (0, $6aceb777da373426$export$8407093f131dcef1)(dependency, version, cdnProvider) + random;
        try {
            if ($e53004b52dee5ec6$var$cachedDeps[dependency]) return;
            $e53004b52dee5ec6$var$cachedDeps[dependency] = true;
            await $0daf8c2ff7816ad9$exports.loadRemoteScript(url, {
                document: document2,
                type: "module"
            });
        } catch (e) {
            console.error(`Failed to load ${dependency} from ${cdnProvider}:`, e);
            if (cdnProvider !== "symbols") try {
                const fallbackUrl = (0, $6aceb777da373426$export$8407093f131dcef1)(dependency, version, "symbols") + random;
                await $0daf8c2ff7816ad9$exports.loadRemoteScript(fallbackUrl, {
                    document: document2
                });
                console.log(`Successfully loaded ${dependency} from fallback (symbols.ls)`);
            } catch (fallbackError) {
                console.error(`Failed to load ${dependency} from fallback:`, fallbackError);
            }
        }
    }
    return dependencies;
};
const $e53004b52dee5ec6$export$52302ef84805a6f8 = async (packages, ctx)=>{
    const windowOpts = ctx.window || window;
    const defaultProvider = ctx.cdnProvider || (0, $6aceb777da373426$export$b5e67ffeac229970)(ctx.symbolsConfig) || "esmsh";
    const initRequire = async (ctx2)=>async (key, provider)=>{
            const windowOpts2 = ctx2.window || window;
            const pkg = windowOpts2.packages[key];
            if (typeof pkg === "function") return pkg();
            return pkg;
        };
    const initRequireOnDemand = async (ctx2)=>async (key, provider = defaultProvider)=>{
            const { dependenciesOnDemand: dependenciesOnDemand } = ctx2;
            const documentOpts = ctx2.document || document;
            const windowOpts2 = ctx2.window || window;
            if (!windowOpts2.packages[key]) {
                const random = (0, $eo3lV.isDevelopment)() ? `?${Math.random()}` : "";
                if (dependenciesOnDemand && dependenciesOnDemand[key]) {
                    const version = dependenciesOnDemand[key];
                    const url = (0, $6aceb777da373426$export$8407093f131dcef1)(key, version, provider) + random;
                    try {
                        await ctx2.utils.loadRemoteScript(url, {
                            window: windowOpts2,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        if (provider !== "symbols") {
                            const fallbackUrl = (0, $6aceb777da373426$export$8407093f131dcef1)(key, version, "symbols") + random;
                            await ctx2.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts2,
                                document: documentOpts
                            });
                        }
                    }
                } else {
                    const url = (0, $6aceb777da373426$export$8407093f131dcef1)(key, "latest", provider) + random;
                    try {
                        await ctx2.utils.loadRemoteScript(url, {
                            window: windowOpts2,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        if (provider !== "symbols") {
                            const fallbackUrl = (0, $6aceb777da373426$export$8407093f131dcef1)(key, "latest", "symbols") + random;
                            await ctx2.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts2,
                                document: documentOpts
                            });
                        }
                    }
                    windowOpts2.packages[key] = "loadedOnDeman";
                }
            }
            return await windowOpts2.require(key, provider);
        };
    if (windowOpts.packages) windowOpts.packages = (0, $g1LU2.merge)(windowOpts.packages, packages);
    else windowOpts.packages = packages;
    if (!windowOpts.require) {
        ctx.utils.require = await initRequire(ctx);
        windowOpts.require = ctx.utils.require;
    }
    if (!windowOpts.requireOnDemand) {
        ctx.utils.requireOnDemand = await initRequireOnDemand(ctx);
        windowOpts.requireOnDemand = ctx.utils.requireOnDemand;
    }
};
const $e53004b52dee5ec6$export$d54de307475be07a = (key, context)=>{
    const [scratcDesignhSystem, emotion, registry] = (0, $dcc242eddee725a1$export$e567b959eb9cc2cc)(key, context);
    return [
        scratcDesignhSystem,
        emotion,
        registry
    ];
};
const $e53004b52dee5ec6$export$beb986ec1c64324 = (app, context)=>{
    const state = {};
    if (context.state) $0daf8c2ff7816ad9$exports.deepMerge(state, context.state);
    if (app && app.state) (0, $g1LU2.deepMerge)(state, app.state);
    state.isRootState = true;
    return (0, $g1LU2.deepClone)(state);
};
const $e53004b52dee5ec6$export$b2f7e94520d001d1 = (app, context)=>{
    if ((0, $e7Ezu.isObject)(app.routes) && (0, $e7Ezu.isObject)(context.pages)) (0, $g1LU2.merge)(app.routes, context.pages);
    const pages = app.routes || context.pages || {};
    for(const v in pages){
        if (v.charCodeAt(0) === 47) continue;
        const index = v === "index" ? "" : v;
        pages["/" + index] = pages[v];
        delete pages[v];
    }
    return pages;
};
const $e53004b52dee5ec6$export$2068a53156b77a95 = (context)=>{
    const sharedLibraries = context.sharedLibraries;
    for(let i = 0; i < sharedLibraries.length; i++){
        const sharedLib = sharedLibraries[i];
        if (context.type === "template") {
            overwriteShallow(context.designSystem, sharedLib.designSystem);
            (0, $g1LU2.deepMerge)(context, sharedLib, [
                "designSystem"
            ], 1);
        } else (0, $g1LU2.deepMerge)(context, sharedLib, [], 1);
    }
};


const $82f1c59da0b975f7$export$9c634076e0a91d1f = async (app, context = {})=>{
    const key = context.key = context.key || ((0, $e7Ezu.isString)(app) ? app : "smblsapp");
    context.define = context.define || (0, $63f946251218a7c2$export$6588fc50c67b09a2);
    context.cssPropsRegistry = (0, $ba2ea636a01886dc$export$b474245a861fc144);
    context.window = (0, $e53004b52dee5ec6$export$c3727843bfb8bb3b)(context);
    if (context.sharedLibraries && context.sharedLibraries.length) (0, $e53004b52dee5ec6$export$2068a53156b77a95)(context);
    const [scratcDesignSystem, emotion, registry] = (0, $e53004b52dee5ec6$export$d54de307475be07a)(key, context);
    context.designSystem = scratcDesignSystem;
    context.registry = registry;
    context.emotion = emotion;
    const state = (0, $e53004b52dee5ec6$export$beb986ec1c64324)(app, context);
    context.state = state;
    context.pages = (0, $e53004b52dee5ec6$export$b2f7e94520d001d1)(app, context);
    context.components = (0, $e53004b52dee5ec6$export$4f2633f1ff10978c)(context);
    context.utils = (0, $e53004b52dee5ec6$export$348dc3ccba7d17b1)(context);
    if ((0, $6aceb777da373426$export$1a8b9f70f9282ea1)[context.packageManager]) context.dependencies = await (0, $e53004b52dee5ec6$export$c40391394e7726ed)(context);
    context.methods = (0, $e53004b52dee5ec6$export$bb03004b651040c)(context);
    context.routerOptions = (0, $2a3f98c527233ec8$export$cf7ee87ede64229c)(app, context);
    context.defaultExtends = [
        $c4098057d78edae9$export$e71c4d32a2263218
    ];
    context.snippets = context.snippets || {};
    context.functions = context.functions || {};
    return context;
};
const $82f1c59da0b975f7$export$b5b313bfdabf2fb4 = async (app, ctx)=>{
    if (!(0, $e7Ezu.isObject)(ctx)) ctx = {};
    if ((0, $fhYuv.isNode)(app)) {
        app = {};
        ctx.parent = app;
    } else if ((0, $e7Ezu.isString)(app)) {
        app = {};
        ctx.key = app;
    } else if (!(0, $e7Ezu.isObject)(app)) app = {};
    await $82f1c59da0b975f7$export$9c634076e0a91d1f(app, ctx);
    app.extends = (0, $cbd4ab0ffc89cd76$export$c8d1988b2aeaf8a9)(app, ctx);
    app.routes = ctx.pages;
    app.state = ctx.state;
    app.context = ctx;
    app.data = app.data || {};
    app.data.frameListeners = (0, $339eb5798b6c1bb7$export$e1d20e1514750bad)(ctx);
    await (0, $e53004b52dee5ec6$export$52302ef84805a6f8)({
        functions: ctx.functions,
        utils: ctx.utils,
        snippets: ctx.snippets,
        ...ctx.files
    }, ctx);
    (0, $cbd4ab0ffc89cd76$export$f04cca198b6322f4)(app, ctx);
    (0, $cbd4ab0ffc89cd76$export$cf84b69175b2f78a)(app, ctx);
    const doc = ctx.document;
    if (!doc || !doc.createElement) return app;
    const parentNode = ctx.parent || doc.body;
    const domqlCreate = (0, $4d3a6b1761d4d13f$export$2e2bcd8739ae039).default && (0, $4d3a6b1761d4d13f$export$2e2bcd8739ae039).default.create || (0, $4d3a6b1761d4d13f$export$2e2bcd8739ae039).create;
    const smblsApp = await domqlCreate(app, parentNode, ctx.key, {
        verbose: ctx.verbose,
        ...ctx.domqlOptions
    });
    return smblsApp;
};


const $d34fff7d4687ff54$var$mergeWithLocalFile = (options, optionsExternalFile)=>(0, $g1LU2.deepMerge)(options, (0, $e7Ezu.isObject)(optionsExternalFile) ? optionsExternalFile : (0, $7d124ec5af804dac$export$1370ffb96395fc6c) || {});
const $d34fff7d4687ff54$export$185802fd694ee1f5 = (App, options = (0, $56136d4e5c63987d$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $56136d4e5c63987d$export$2e2bcd8739ae039),
        ...$d34fff7d4687ff54$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $82f1c59da0b975f7$export$b5b313bfdabf2fb4)(App, redefinedOptions).then((App2)=>{
        (0, $2a3f98c527233ec8$export$7fe20beff2421d2d)(App2, redefinedOptions);
        if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    });
    return domqlApp;
};
const $d34fff7d4687ff54$export$fa0abf86dcc47d66 = (App, options = (0, $56136d4e5c63987d$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const domqlApp = $d34fff7d4687ff54$export$185802fd694ee1f5(App, options, optionsExternalFile);
    const redefinedOptions = {
        ...(0, $56136d4e5c63987d$export$2e2bcd8739ae039),
        ...$d34fff7d4687ff54$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const key = redefinedOptions.key;
    (0, $e8b5c76650b7dedc$export$beca342e15b450be)(domqlApp, key, {
        utils: $0daf8c2ff7816ad9$exports,
        ...redefinedOptions
    });
    return domqlApp;
};
const $d34fff7d4687ff54$export$df2a74307fafca3b = async (App, options = (0, $56136d4e5c63987d$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $56136d4e5c63987d$export$2e2bcd8739ae039),
        ...$d34fff7d4687ff54$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const key = options.key;
    await (0, $e8b5c76650b7dedc$export$8946d631417d8ced)(key, redefinedOptions);
    const domqlApp = await (0, $82f1c59da0b975f7$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) await redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    return domqlApp;
};
const $d34fff7d4687ff54$export$9cb2e3fca5d0556e = (App = {}, options = (0, $56136d4e5c63987d$export$2e2bcd8739ae039), optionsExternalFile)=>{
    return $d34fff7d4687ff54$export$185802fd694ee1f5({
        deps: {
            isUndefined: $e7Ezu.isUndefined
        },
        ...App
    }, (0, $g1LU2.deepMerge)({
        domqlOptions: {
            onlyResolveExtends: true
        }
    }, options), optionsExternalFile);
};
var $d34fff7d4687ff54$export$2e2bcd8739ae039 = $d34fff7d4687ff54$export$185802fd694ee1f5;


$parcel$exportWildcard($92955cf4caddf682$exports, $j7W2w);
$parcel$exportWildcard($92955cf4caddf682$exports, $be006f1a0fabd945$exports);


var $85274e1cff99deb2$export$2e2bcd8739ae039 = {};


var $583e5c65243bf299$export$2e2bcd8739ae039 = {};


var $ffee29e35474451f$export$2e2bcd8739ae039 = {};


var $b940b823876787d8$exports = {};
var $b35c86137e587395$exports = {};

$parcel$export($b35c86137e587395$exports, "Eyebrow", () => $b35c86137e587395$export$71f050e2efa708bb);
$parcel$export($b35c86137e587395$exports, "H2", () => $b35c86137e587395$export$cb94397127ac9363);
$parcel$export($b35c86137e587395$exports, "Lead", () => $b35c86137e587395$export$ba4d7ae5fb67789e);
// ─── Typography primitives ──────────────────────────────────────────────────
const $b35c86137e587395$export$71f050e2efa708bb = {
    fontFamily: "'DM Mono', monospace",
    fontSize: '11px',
    fontWeight: '400',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'accent',
    marginBottom: '16px',
    display: 'block'
};
const $b35c86137e587395$export$cb94397127ac9363 = {
    tag: 'h2',
    fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
    fontSize: 'clamp(32px, 4.2vw, 56px)',
    fontWeight: '700',
    lineHeight: '1.04',
    letterSpacing: '-0.036em',
    color: 'dark'
};
const $b35c86137e587395$export$ba4d7ae5fb67789e = {
    tag: 'p',
    fontSize: '16px',
    color: 'textSecondary',
    lineHeight: '1.72',
    maxWidth: '500px',
    marginTop: '18px',
    fontWeight: '400'
};


var $454e1f1e91e540ff$exports = {};

$parcel$export($454e1f1e91e540ff$exports, "Btn", () => $454e1f1e91e540ff$export$37f54d0b7407611f);
$parcel$export($454e1f1e91e540ff$exports, "BtnPrimary", () => $454e1f1e91e540ff$export$e573772e40771efe);
$parcel$export($454e1f1e91e540ff$exports, "BtnAccent", () => $454e1f1e91e540ff$export$baea1e2c601a46ad);
$parcel$export($454e1f1e91e540ff$exports, "BtnGhost", () => $454e1f1e91e540ff$export$3c5bae6bc7136c67);
$parcel$export($454e1f1e91e540ff$exports, "BtnOutline", () => $454e1f1e91e540ff$export$6977f058b0ed42a4);
// ─── Button primitives ──────────────────────────────────────────────────────
const $454e1f1e91e540ff$export$37f54d0b7407611f = {
    extends: 'Flex',
    tag: 'button',
    display: 'inline-flex',
    flexAlign: 'center center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '500',
    padding: '11px 24px',
    borderRadius: '6px',
    borderWidth: '0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    cursor: 'pointer',
    letterSpacing: '-0.005em',
    transition: 'background 180ms cubic-bezier(0.16, 1, 0.3, 1), color 180ms cubic-bezier(0.16, 1, 0.3, 1), border-color 180ms cubic-bezier(0.16, 1, 0.3, 1), transform 180ms cubic-bezier(0.16, 1, 0.3, 1)',
    ':active': {
        transform: 'scale(0.97)'
    }
};
const $454e1f1e91e540ff$export$e573772e40771efe = {
    extends: 'Btn',
    background: 'dark',
    color: 'cream',
    ':hover': {
        background: 'dark3'
    }
};
const $454e1f1e91e540ff$export$baea1e2c601a46ad = {
    extends: 'Btn',
    background: 'accent',
    color: 'white',
    ':hover': {
        background: 'accentHover'
    }
};
const $454e1f1e91e540ff$export$3c5bae6bc7136c67 = {
    extends: 'Btn',
    background: 'transparent',
    color: 'textSecondary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'borderStrong',
    ':hover': {
        background: 'bgSubtle',
        color: 'dark',
        borderColor: 'borderMedium'
    }
};
const $454e1f1e91e540ff$export$6977f058b0ed42a4 = {
    extends: 'Btn',
    background: 'transparent',
    color: 'dark',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'borderStrong',
    borderRadius: '6px',
    ':hover': {
        background: 'dark',
        color: 'cream'
    }
};


var $a30183713abdd208$exports = {};

$parcel$export($a30183713abdd208$exports, "Nav", () => $a30183713abdd208$export$39140c7d8b0ba7b3);
$parcel$export($a30183713abdd208$exports, "MobileNavLink", () => $a30183713abdd208$export$99526554844bced1);
// ─── Nav ────────────────────────────────────────────────────────────────────
const $a30183713abdd208$export$39140c7d8b0ba7b3 = {
    extends: 'Flex',
    tag: 'nav',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    zIndex: '1000',
    height: '60px',
    background: 'navBg',
    style: {
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)'
    },
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'borderLight',
    transition: 'border-color 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
    Inner: {
        extends: 'Flex',
        maxWidth: '1200px',
        margin: '0 auto',
        height: '100%',
        flexAlign: 'center space-between',
        padding: '0 48px',
        width: '100%',
        '@tablet': {
            padding: '0 24px'
        },
        Logo: {
            extends: 'Link',
            href: '/',
            fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
            fontSize: '15px',
            fontWeight: '600',
            letterSpacing: '-0.02em',
            color: 'dark',
            transition: 'opacity 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
            ':hover': {
                opacity: '0.4'
            },
            text: "Hi, I'm Rita Katona"
        },
        Links: {
            extends: 'Flex',
            flexAlign: 'center center',
            gap: '32px',
            '@mobile': {
                display: 'none'
            },
            About: {
                extends: 'Link',
                href: '/about',
                fontSize: '13px',
                fontWeight: '400',
                color: 'textTertiary',
                transition: 'color 120ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    color: 'dark'
                },
                text: 'About'
            },
            Coaching: {
                extends: 'Link',
                href: '/from-workshops-to-1-on-1s',
                fontSize: '13px',
                fontWeight: '400',
                color: 'textTertiary',
                transition: 'color 120ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    color: 'dark'
                },
                text: 'Coaching'
            },
            Freelance: {
                extends: 'Link',
                href: '/hire-me-as-a-freelancer',
                fontSize: '13px',
                fontWeight: '400',
                color: 'textTertiary',
                transition: 'color 120ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    color: 'dark'
                },
                text: 'Freelance'
            },
            Angel: {
                extends: 'Link',
                href: '/angel-investment',
                fontSize: '13px',
                fontWeight: '400',
                color: 'textTertiary',
                transition: 'color 120ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    color: 'dark'
                },
                text: 'Angel'
            },
            CTA: {
                extends: 'Link',
                href: '#contact',
                fontSize: '12px',
                fontWeight: '500',
                color: 'white',
                padding: '7px 18px',
                background: 'accent',
                borderRadius: '6px',
                transition: 'background 200ms cubic-bezier(0.16, 1, 0.3, 1), transform 200ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 200ms cubic-bezier(0.16, 1, 0.3, 1)',
                ':hover': {
                    background: 'accentHover',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 16px rgba(85,127,177,0.3)'
                },
                ':active': {
                    transform: 'scale(0.96) translateY(0)',
                    boxShadow: 'none'
                },
                text: 'Get in touch'
            }
        },
        Hamburger: {
            tag: 'button',
            display: 'none',
            '@mobile': {
                display: 'flex'
            },
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px',
            width: '40px',
            height: '40px',
            background: 'transparent',
            borderWidth: '0',
            borderStyle: 'solid',
            borderColor: 'transparent',
            cursor: 'pointer',
            padding: '0',
            attr: {
                id: 'nav-hamburger',
                onclick: 'toggleMobileMenu()',
                'aria-label': 'Toggle navigation'
            },
            L1: {
                width: '22px',
                height: '2px',
                background: 'dark',
                borderRadius: '1px',
                transition: 'transform 240ms cubic-bezier(0.16, 1, 0.3, 1)',
                attr: {
                    id: 'hb-l1'
                }
            },
            L2: {
                width: '22px',
                height: '2px',
                background: 'dark',
                borderRadius: '1px',
                transition: 'opacity 200ms ease',
                attr: {
                    id: 'hb-l2'
                }
            },
            L3: {
                width: '22px',
                height: '2px',
                background: 'dark',
                borderRadius: '1px',
                transition: 'transform 240ms cubic-bezier(0.16, 1, 0.3, 1)',
                attr: {
                    id: 'hb-l3'
                }
            }
        }
    },
    MobileMenu: {
        attr: {
            id: 'nav-mobile-menu'
        },
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        background: 'cream',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'borderLight',
        display: 'none',
        flexDirection: 'column',
        padding: '4px 24px 24px',
        style: {
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)'
        },
        MAbout: {
            extends: 'MobileNavLink',
            href: '/about',
            text: 'About'
        },
        MCoaching: {
            extends: 'MobileNavLink',
            href: '/from-workshops-to-1-on-1s',
            text: 'Coaching'
        },
        MFreelance: {
            extends: 'MobileNavLink',
            href: '/hire-me-as-a-freelancer',
            text: 'Freelance'
        },
        MAngel: {
            extends: 'MobileNavLink',
            href: '/angel-investment',
            text: 'Angel'
        },
        MRefs: {
            extends: 'MobileNavLink',
            href: '/references-and-partners',
            text: 'References'
        },
        MDivider: {
            height: '1px',
            background: 'borderLight',
            margin: '8px 0 12px'
        },
        MCTA: {
            extends: 'Link',
            href: '#contact',
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: 'white',
            padding: '13px 20px',
            background: 'accent',
            borderRadius: '8px',
            textAlign: 'center',
            transition: 'background 200ms ease',
            ':hover': {
                background: 'accentHover'
            },
            text: 'Get in touch',
            attr: {
                onclick: 'closeMobileMenu()'
            }
        }
    },
    NavScript: {
        tag: 'script',
        text: `(function(){var _o=false;function _show(){var m=document.getElementById('nav-mobile-menu');if(!m)return;m.style.display='flex';document.getElementById('hb-l1').style.transform='translateY(7px) rotate(45deg)';document.getElementById('hb-l2').style.opacity='0';document.getElementById('hb-l3').style.transform='translateY(-7px) rotate(-45deg)';_o=true;}function _hide(){var m=document.getElementById('nav-mobile-menu');if(!m)return;m.style.display='none';document.getElementById('hb-l1').style.transform='';document.getElementById('hb-l2').style.opacity='';document.getElementById('hb-l3').style.transform='';_o=false;}window.toggleMobileMenu=function(){_o?_hide():_show();};window.closeMobileMenu=function(){_hide();};document.addEventListener('click',function(e){if(!_o)return;var m=document.getElementById('nav-mobile-menu');var b=document.getElementById('nav-hamburger');if(m&&b&&!m.contains(e.target)&&!b.contains(e.target))_hide();});})();`
    }
};
const $a30183713abdd208$export$99526554844bced1 = {
    extends: 'Link',
    display: 'block',
    padding: '13px 0',
    fontSize: '15px',
    fontWeight: '400',
    letterSpacing: '-0.01em',
    color: 'dark',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'borderLight',
    transition: 'opacity 120ms ease',
    ':hover': {
        opacity: '0.5'
    },
    attr: {
        onclick: 'closeMobileMenu()'
    }
};


var $a2a8ed032b49c171$exports = {};

$parcel$export($a2a8ed032b49c171$exports, "HeroSection", () => $a2a8ed032b49c171$export$4489c2ed11909944);
const $a2a8ed032b49c171$var$IMG_BASE = '//img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6';
const $a2a8ed032b49c171$export$4489c2ed11909944 = {
    tag: 'section',
    minHeight: '100vh',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'flex-end',
    attr: {
        'data-hero': ''
    },
    Background: {
        position: 'absolute',
        inset: '0',
        zIndex: '0',
        Photo: {
            tag: 'img',
            attr: {
                src: `https:${$a2a8ed032b49c171$var$IMG_BASE}/EP_130.jpg`,
                alt: 'Rita Katona',
                loading: 'eager'
            },
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: '65% 20%',
            animation: 'heroImageZoom 1800ms cubic-bezier(0.16, 1, 0.3, 1)',
            animationFillMode: 'both'
        },
        Overlay: {
            position: 'absolute',
            inset: '0',
            background: 'linear-gradient(to top, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.85) 30%, rgba(10,10,10,0.6) 55%, rgba(10,10,10,0.2) 75%, transparent 100%)'
        }
    },
    Content: {
        position: 'relative',
        zIndex: '1',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px 80px',
        width: '100%',
        '@tablet': {
            padding: '0 24px 60px'
        },
        Eyebrow: {
            fontFamily: "'DM Mono', monospace",
            fontSize: '11px',
            fontWeight: '400',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: 'white65',
            marginBottom: '24px',
            display: 'block',
            opacity: '0',
            animation: 'fadeInUp 700ms cubic-bezier(0.16, 1, 0.3, 1) 400ms',
            animationFillMode: 'both',
            text: 'Growth Marketing & Sales'
        },
        Headline: {
            tag: 'h1',
            fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
            fontSize: 'clamp(40px, 5.6vw, 72px)',
            fontWeight: '700',
            lineHeight: '1.0',
            letterSpacing: '-0.042em',
            color: 'white',
            maxWidth: '720px',
            opacity: '0',
            animation: 'fadeInUp 800ms cubic-bezier(0.16, 1, 0.3, 1) 550ms',
            animationFillMode: 'both',
            '@mobile': {
                fontSize: '36px'
            },
            text: 'Are you looking for help to grow your tech startup?'
        },
        Divider: {
            width: '48px',
            height: '2px',
            background: 'accent',
            margin: '32px 0',
            borderRadius: '1px',
            opacity: '0',
            animation: 'widthExpand 600ms cubic-bezier(0.16, 1, 0.3, 1) 800ms',
            animationFillMode: 'both'
        },
        Sub: {
            tag: 'p',
            fontSize: '17px',
            color: 'white65',
            lineHeight: '1.7',
            maxWidth: '480px',
            margin: '0 0 36px',
            fontWeight: '400',
            opacity: '0',
            animation: 'fadeInUp 700ms cubic-bezier(0.16, 1, 0.3, 1) 900ms',
            animationFillMode: 'both',
            text: 'With 12+ years in the tech startup ecosystem, I help founders scale through coaching, hands-on freelance support, and angel investment.'
        },
        Actions: {
            extends: 'Flex',
            gap: '12px',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            opacity: '0',
            animation: 'fadeInUp 700ms cubic-bezier(0.16, 1, 0.3, 1) 1100ms',
            animationFillMode: 'both',
            Primary: {
                tag: 'a',
                attr: {
                    href: '#contact'
                },
                extends: 'BtnAccent',
                text: 'Get in touch'
            },
            Ghost: {
                extends: 'Link',
                href: '/about',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 28px',
                fontSize: '13px',
                fontWeight: '500',
                letterSpacing: '-0.01em',
                borderRadius: '6px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'white25',
                color: 'white88',
                background: 'transparent',
                transition: 'all 160ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    background: 'rgba(255,255,255,0.08)',
                    borderColor: 'rgba(255,255,255,0.4)'
                },
                text: 'About me'
            }
        }
    },
    ScrollHint: {
        position: 'absolute',
        bottom: '24px',
        left: '50%',
        style: {
            transform: 'translateX(-50%)'
        },
        zIndex: '1',
        opacity: '0',
        animation: 'fadeIn 600ms cubic-bezier(0.16, 1, 0.3, 1) 1600ms',
        animationFillMode: 'both',
        Dot: {
            width: '1px',
            height: '32px',
            background: 'rgba(255,255,255,0.25)',
            margin: '0 auto',
            position: 'relative',
            overflow: 'hidden',
            Inner: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                background: 'rgba(255,255,255,0.6)',
                animation: 'bounce 1800ms cubic-bezier(0.4, 0.0, 0.6, 1) infinite'
            }
        }
    }
};


var $b8c6ba537dfdb858$exports = {};

$parcel$export($b8c6ba537dfdb858$exports, "AboutPreview", () => $b8c6ba537dfdb858$export$26b8a5d858bdbc7a);
const $b8c6ba537dfdb858$var$IMG_BASE = '//img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6';
const $b8c6ba537dfdb858$export$26b8a5d858bdbc7a = {
    tag: 'section',
    id: 'about',
    background: 'warmWhite',
    padding: '80px 0',
    '@mobile': {
        padding: '60px 0'
    },
    Inner: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        '@tablet': {
            padding: '0 24px'
        },
        Grid: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '56px',
            alignItems: 'center',
            '@tablet': {
                gap: '32px'
            },
            '@mobile': {
                gridTemplateColumns: '1fr',
                gap: '32px'
            },
            ImageCol: {
                overflow: 'hidden',
                aspectRatio: '4/5',
                background: 'bgSubtle',
                borderRadius: '12px',
                transition: 'transform 600ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 600ms cubic-bezier(0.16, 1, 0.3, 1)',
                ':hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 24px 64px rgba(0,0,0,0.1)'
                },
                '@mobile': {
                    aspectRatio: '3/2'
                },
                Photo: {
                    tag: 'img',
                    attr: {
                        src: `https:${$b8c6ba537dfdb858$var$IMG_BASE}/RitaWS.jpeg`,
                        alt: 'Rita Katona at a workshop',
                        loading: 'lazy'
                    },
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 800ms cubic-bezier(0.16, 1, 0.3, 1)'
                },
                ':hover img': {
                    transform: 'scale(1.04)'
                }
            },
            TextCol: {
                Eyebrow: {
                    extends: 'Eyebrow',
                    text: 'About Rita'
                },
                Title: {
                    tag: 'h2',
                    extends: 'H2',
                    marginBottom: '24px',
                    text: 'Founder at Heart'
                },
                Body: {
                    tag: 'p',
                    color: 'medGray',
                    fontSize: '15px',
                    lineHeight: '1.78',
                    fontWeight: '400',
                    text: "I'm a 2x founder with 12+ years in the tech startup ecosystem. Some years ago, I transitioned from my entrepreneurial journey to key roles at various startup supporting organisations, including ZOLLHOF and BCG X."
                },
                Stats: {
                    extends: 'StatsRow'
                },
                ReadMore: {
                    extends: 'CardLink',
                    href: '/about',
                    text: 'Read my story \u2192'
                }
            }
        }
    }
};


var $d567b0d63dd6a3b3$exports = {};

$parcel$export($d567b0d63dd6a3b3$exports, "CardLink", () => $d567b0d63dd6a3b3$export$94b4c87f5c7de894);
$parcel$export($d567b0d63dd6a3b3$exports, "ServiceCard", () => $d567b0d63dd6a3b3$export$47e19cb482b7c646);
$parcel$export($d567b0d63dd6a3b3$exports, "CoachingCard", () => $d567b0d63dd6a3b3$export$62b29e43a14e433b);
$parcel$export($d567b0d63dd6a3b3$exports, "FreelanceCard", () => $d567b0d63dd6a3b3$export$a521d583e9ef9653);
$parcel$export($d567b0d63dd6a3b3$exports, "ReferencesCard", () => $d567b0d63dd6a3b3$export$2ff883669e648fc4);
$parcel$export($d567b0d63dd6a3b3$exports, "AngelCard", () => $d567b0d63dd6a3b3$export$46914f5630bd2d8f);
$parcel$export($d567b0d63dd6a3b3$exports, "DarkCardLink", () => $d567b0d63dd6a3b3$export$4ab961d47fa73817);
// ─── Card Link (shared) ─────────────────────────────────────────────────────
const $d567b0d63dd6a3b3$export$94b4c87f5c7de894 = {
    extends: 'Link',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: "'DM Mono', monospace",
    color: 'accent',
    marginTop: '24px',
    opacity: '0.7',
    transition: 'opacity 160ms cubic-bezier(0.0, 0.0, 0.2, 1), gap 160ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        opacity: '1',
        gap: '9px'
    }
};
const $d567b0d63dd6a3b3$export$47e19cb482b7c646 = {
    tag: 'article',
    background: 'warmWhite',
    padding: '40px',
    borderRadius: '8px',
    transition: 'background 200ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        background: 'bgSubtle'
    },
    Icon: {
        fontSize: '18px',
        marginBottom: '24px',
        display: 'block',
        lineHeight: '1',
        opacity: '0.6'
    },
    Title: {
        tag: 'h3',
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        fontSize: '17px',
        fontWeight: '600',
        letterSpacing: '-0.02em',
        color: 'dark',
        marginBottom: '10px'
    },
    Text: {
        tag: 'p',
        fontSize: '14px',
        color: 'textSecondary',
        lineHeight: '1.72',
        fontWeight: '400'
    },
    Link: {
        extends: 'CardLink'
    }
};
const $d567b0d63dd6a3b3$export$62b29e43a14e433b = {
    extends: 'ServiceCard',
    Icon: {
        extends: 'ServiceCard.Icon',
        text: '\uD83C\uDFAF'
    },
    Title: {
        extends: 'ServiceCard.Title',
        text: 'Coaching & Workshops'
    },
    Text: {
        extends: 'ServiceCard.Text',
        text: "Nurturing your startup's journey: Deep-dive conversations, practical workshops, and personalised coaching for business growth."
    },
    Link: {
        extends: 'ServiceCard.Link',
        href: '/from-workshops-to-1-on-1s',
        text: 'Learn more \u2192'
    }
};
const $d567b0d63dd6a3b3$export$a521d583e9ef9653 = {
    extends: 'ServiceCard',
    Icon: {
        extends: 'ServiceCard.Icon',
        text: '\uD83D\uDE80'
    },
    Title: {
        extends: 'ServiceCard.Title',
        text: 'Freelance Services'
    },
    Text: {
        extends: 'ServiceCard.Text',
        text: 'Hands-on, operative help with sales and marketing. Impactful strategies and hands-on execution to level up your digital presence.'
    },
    Link: {
        extends: 'ServiceCard.Link',
        href: '/hire-me-as-a-freelancer',
        text: 'Learn more \u2192'
    }
};
const $d567b0d63dd6a3b3$export$2ff883669e648fc4 = {
    extends: 'ServiceCard',
    Icon: {
        extends: 'ServiceCard.Icon',
        text: '\u2b50'
    },
    Title: {
        extends: 'ServiceCard.Title',
        text: 'References & Partners'
    },
    Text: {
        extends: 'ServiceCard.Text',
        text: 'Read about my previous engagements, success stories and references and what partners say about our joint successes.'
    },
    Link: {
        extends: 'ServiceCard.Link',
        href: '/references-and-partners',
        text: 'Learn more \u2192'
    }
};
const $d567b0d63dd6a3b3$export$46914f5630bd2d8f = {
    extends: 'ServiceCard',
    Icon: {
        extends: 'ServiceCard.Icon',
        text: '\uD83D\uDCA1'
    },
    Title: {
        extends: 'ServiceCard.Title',
        text: 'Angel Investment'
    },
    Text: {
        extends: 'ServiceCard.Text',
        text: "As part of the Wise Angels Network, I'm always on the lookout for tech startups to invest in as well as offer my support on growth-related topics."
    },
    Link: {
        extends: 'ServiceCard.Link',
        href: '/angel-investment',
        text: 'Learn more \u2192'
    }
};
const $d567b0d63dd6a3b3$export$4ab961d47fa73817 = {
    extends: 'Link',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: "'DM Mono', monospace",
    color: 'darkWhite68',
    marginTop: '24px',
    transition: 'color 160ms cubic-bezier(0.0, 0.0, 0.2, 1), gap 160ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        color: 'cream92',
        gap: '9px'
    }
};


var $47fce3a9994fbb94$exports = {};

$parcel$export($47fce3a9994fbb94$exports, "ServicesSection", () => $47fce3a9994fbb94$export$f97f39279e5bb398);
$parcel$export($47fce3a9994fbb94$exports, "DarkServiceCard", () => $47fce3a9994fbb94$export$ff792866140e2866);
// ─── Services Section (dark) ────────────────────────────────────────────────
const $47fce3a9994fbb94$export$f97f39279e5bb398 = {
    tag: 'section',
    id: 'services',
    background: 'dark',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    },
    Inner: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        '@tablet': {
            padding: '0 24px'
        },
        Header: {
            marginBottom: '72px',
            Eyebrow: {
                extends: 'Eyebrow',
                color: 'cream48',
                text: 'Services'
            },
            Title: {
                tag: 'h2',
                extends: 'H2',
                color: 'cream92',
                text: 'How I can help you grow'
            },
            Lead: {
                extends: 'Lead',
                color: 'cream65',
                fontWeight: '400',
                text: 'From coaching and workshops to hands-on freelance support and angel investment.'
            }
        },
        Grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '1px',
            background: 'cream12',
            borderRadius: '12px',
            overflow: 'hidden',
            counterReset: 'service-card',
            '@tablet': {
                gridTemplateColumns: '1fr'
            }
        }
    }
};
const $47fce3a9994fbb94$export$ff792866140e2866 = {
    tag: 'article',
    background: 'darkCard',
    padding: '48px',
    position: 'relative',
    transition: 'background 350ms cubic-bezier(0.16, 1, 0.3, 1), transform 400ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 400ms cubic-bezier(0.16, 1, 0.3, 1)',
    ':hover': {
        background: 'dark2',
        transform: 'translateY(-4px)',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    ':before': {
        counterIncrement: 'service-card',
        style: {
            content: '"0" counter(service-card)'
        },
        display: 'block',
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        fontWeight: '400',
        letterSpacing: '0.06em',
        color: 'accent',
        opacity: '0.6',
        marginBottom: '40px'
    },
    Icon: {
        marginBottom: '16px',
        fontSize: '16px',
        opacity: '0.5'
    },
    Title: {
        tag: 'h3',
        color: 'cream92',
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        fontSize: '17px',
        fontWeight: '600',
        letterSpacing: '-0.02em',
        marginBottom: '10px'
    },
    Text: {
        tag: 'p',
        color: 'cream48',
        fontSize: '14px',
        lineHeight: '1.72',
        fontWeight: '400'
    },
    Link: {
        extends: 'Link',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '12px',
        fontWeight: '500',
        fontFamily: "'DM Mono', monospace",
        color: 'darkWhite68',
        marginTop: '24px',
        transition: 'color 160ms cubic-bezier(0.0, 0.0, 0.2, 1), gap 160ms cubic-bezier(0.0, 0.0, 0.2, 1)',
        ':hover': {
            color: 'darkWhite84',
            gap: '9px'
        }
    }
};


var $ead2558298e676a9$exports = {};

$parcel$export($ead2558298e676a9$exports, "TestimonialCard", () => $ead2558298e676a9$export$a34a40ba0fc7f13f);
$parcel$export($ead2558298e676a9$exports, "TestimonialsPreview", () => $ead2558298e676a9$export$92acdbcd84098ff9);
// ─── Testimonial Card ───────────────────────────────────────────────────────
const $ead2558298e676a9$export$a34a40ba0fc7f13f = {
    background: 'warmWhite',
    padding: '36px',
    transition: 'background 300ms cubic-bezier(0.16, 1, 0.3, 1)',
    ':hover': {
        background: 'bgSubtle'
    },
    Stars: {
        color: 'accent',
        fontSize: '9px',
        marginBottom: '16px',
        letterSpacing: '4px',
        opacity: '0.6',
        text: '\u2605\u2605\u2605\u2605\u2605'
    },
    Quote: {
        tag: 'p',
        fontSize: '13px',
        color: 'textSecondary',
        lineHeight: '1.80',
        fontStyle: 'italic',
        marginBottom: '24px',
        fontWeight: '400'
    },
    Photo: {
        tag: 'img',
        display: 'none',
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: '12px'
    },
    AuthorName: {
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        fontSize: '13px',
        fontWeight: '600',
        letterSpacing: '-0.01em',
        color: 'dark'
    },
    AuthorRole: {
        fontSize: '11px',
        fontFamily: "'DM Mono', monospace",
        color: 'textTertiary',
        marginTop: '4px',
        letterSpacing: '0.01em'
    }
};
const $ead2558298e676a9$export$92acdbcd84098ff9 = {
    tag: 'section',
    id: 'testimonials',
    background: 'cream',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    },
    Inner: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        '@tablet': {
            padding: '0 24px'
        },
        Header: {
            marginBottom: '72px',
            '@mobile': {
                marginBottom: '48px'
            },
            Eyebrow: {
                extends: 'Eyebrow',
                text: 'Kind words'
            },
            Title: {
                tag: 'h2',
                extends: 'H2',
                text: 'What people say'
            }
        },
        Grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1px',
            background: 'borderLight',
            borderRadius: '12px',
            overflow: 'hidden',
            '@tablet': {
                gridTemplateColumns: '1fr 1fr'
            },
            '@mobile': {
                gridTemplateColumns: '1fr'
            }
        },
        ViewAll: {
            textAlign: 'center',
            marginTop: '40px',
            Link: {
                extends: 'CardLink',
                href: '/references-and-partners',
                text: 'View all references \u2192'
            }
        }
    }
};


var $cbacb18557cd8141$exports = {};

$parcel$export($cbacb18557cd8141$exports, "ContactSection", () => $cbacb18557cd8141$export$66e1d1242c696f84);
$parcel$export($cbacb18557cd8141$exports, "Field", () => $cbacb18557cd8141$export$a455218a85c89869);
// ─── Contact Section ────────────────────────────────────────────────────────
const $cbacb18557cd8141$export$66e1d1242c696f84 = {
    tag: 'section',
    id: 'contact',
    background: 'warmWhite',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    },
    Inner: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        '@tablet': {
            padding: '0 24px'
        },
        Grid: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '100px',
            alignItems: 'start',
            '@tablet': {
                gap: '48px'
            },
            '@mobile': {
                gridTemplateColumns: '1fr',
                gap: '40px'
            },
            Info: {
                Eyebrow: {
                    extends: 'Eyebrow',
                    text: 'Get in Touch'
                },
                Title: {
                    tag: 'h2',
                    extends: 'H2',
                    marginBottom: '18px',
                    text: "Let's talk about your growth"
                },
                Lead: {
                    extends: 'Lead',
                    text: "Whether you need coaching, freelance support, or are looking for an angel investor \u2014 I'd love to hear from you."
                },
                Details: {
                    extends: 'Flex',
                    tag: 'div',
                    flexFlow: 'column',
                    marginTop: '40px',
                    gap: '26px',
                    EmailDetail: {
                        Label: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: '10px',
                            fontWeight: '400',
                            letterSpacing: '0.06em',
                            textTransform: 'uppercase',
                            color: 'textTertiary',
                            marginBottom: '4px',
                            display: 'block',
                            text: 'Email'
                        },
                        Value: {
                            fontSize: '15px',
                            color: 'dark',
                            Link: {
                                tag: 'a',
                                attr: {
                                    href: 'mailto:rk@rita-katona.com'
                                },
                                color: 'dark',
                                transition: 'color 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    color: 'accent'
                                },
                                text: 'rk@rita-katona.com'
                            }
                        }
                    },
                    LocationDetail: {
                        Label: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: '10px',
                            fontWeight: '400',
                            letterSpacing: '0.06em',
                            textTransform: 'uppercase',
                            color: 'textTertiary',
                            marginBottom: '4px',
                            display: 'block',
                            text: 'Location'
                        },
                        Value: {
                            fontSize: '15px',
                            color: 'dark',
                            text: 'Berlin, Germany'
                        }
                    },
                    LinkedInDetail: {
                        Label: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: '10px',
                            fontWeight: '400',
                            letterSpacing: '0.06em',
                            textTransform: 'uppercase',
                            color: 'textTertiary',
                            marginBottom: '4px',
                            display: 'block',
                            text: 'LinkedIn'
                        },
                        Value: {
                            fontSize: '15px',
                            color: 'dark',
                            Link: {
                                tag: 'a',
                                attr: {
                                    href: 'https://www.linkedin.com/in/rita-kato-growth/',
                                    target: '_blank',
                                    rel: 'noopener'
                                },
                                color: 'dark',
                                transition: 'color 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    color: 'accent'
                                },
                                whiteSpace: 'nowrap',
                                text: 'rita-katona-growth \u2197'
                            }
                        }
                    }
                }
            },
            FormWrap: {
                paddingTop: '168px',
                '@tablet': {
                    paddingTop: '0'
                },
                '@mobile': {
                    paddingTop: '0'
                },
                Form: {
                    tag: 'form',
                    extends: 'Flex',
                    flexFlow: 'column',
                    gap: '8px',
                    Row: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '8px',
                        '@mobile': {
                            gridTemplateColumns: '1fr'
                        },
                        NameField: {
                            extends: 'Field',
                            tag: 'input',
                            attr: {
                                type: 'text',
                                placeholder: 'Your name',
                                name: 'name'
                            }
                        },
                        EmailField: {
                            extends: 'Field',
                            tag: 'input',
                            attr: {
                                type: 'email',
                                placeholder: 'Email address',
                                name: 'email'
                            }
                        }
                    },
                    MessageField: {
                        extends: 'Field',
                        tag: 'textarea',
                        attr: {
                            placeholder: 'Tell me about your project\u2026',
                            name: 'message',
                            rows: '5'
                        },
                        resize: 'vertical',
                        minHeight: '128px'
                    },
                    Submit: {
                        extends: 'BtnAccent',
                        tag: 'button',
                        attr: {
                            type: 'submit'
                        },
                        width: '100%',
                        justifyContent: 'center',
                        text: 'Send Message'
                    }
                }
            }
        }
    }
};
const $cbacb18557cd8141$export$a455218a85c89869 = {
    width: '100%',
    padding: '13px 16px',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'borderMedium',
    borderRadius: '6px',
    fontSize: '14px',
    color: 'dark',
    outline: 'none',
    transition: 'border-color 140ms cubic-bezier(0.0, 0.0, 0.2, 1), box-shadow 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':focus': {
        borderColor: 'accent',
        boxShadow: '0 0 0 3px rgba(85,127,177,0.08)'
    },
    '::placeholder': {
        color: 'textQuaternary'
    }
};


var $7686e5faed3049c9$exports = {};

$parcel$export($7686e5faed3049c9$exports, "Footer", () => $7686e5faed3049c9$export$a06f1c675e846f6f);
$parcel$export($7686e5faed3049c9$exports, "FooterLink", () => $7686e5faed3049c9$export$e0513c91be1318ca);
// ─── Footer ─────────────────────────────────────────────────────────────────
const $7686e5faed3049c9$export$a06f1c675e846f6f = {
    tag: 'footer',
    background: 'dark',
    padding: '40px 0',
    Inner: {
        extends: 'Flex',
        flexFlow: 'column',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        gap: '20px',
        '@tablet': {
            padding: '0 24px'
        },
        Links: {
            extends: 'Flex',
            gap: '24px',
            style: {
                flexWrap: 'wrap'
            },
            justifyContent: 'center',
            width: '100%',
            '@mobile': {
                flexDirection: 'column',
                gap: '0',
                alignItems: 'stretch'
            },
            childExtends: 'FooterLink',
            AboutL: {
                href: '/about',
                text: 'About'
            },
            CoachingL: {
                href: '/from-workshops-to-1-on-1s',
                text: 'Coaching'
            },
            FreelanceL: {
                href: '/hire-me-as-a-freelancer',
                text: 'Freelance'
            },
            AngelL: {
                href: '/angel-investment',
                text: 'Angel'
            },
            ReferencesL: {
                href: '/references-and-partners',
                text: 'References'
            },
            LinkedInL: {
                tag: 'a',
                attr: {
                    href: 'https://www.linkedin.com/in/rita-kato-growth/',
                    target: '_blank',
                    rel: 'noopener'
                },
                whiteSpace: 'nowrap',
                text: 'LinkedIn\u00a0\u2197',
                '@mobile': {
                    borderBottomWidth: '0'
                }
            }
        },
        Copyright: {
            width: '100%',
            fontSize: '11px',
            fontFamily: "'DM Mono', monospace",
            color: 'cream35',
            paddingTop: '20px',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'cream15',
            textAlign: 'center',
            letterSpacing: '0.02em',
            text: '\u00a9 2024 Rita Katona. All rights reserved.'
        }
    }
};
const $7686e5faed3049c9$export$e0513c91be1318ca = {
    extends: 'Link',
    fontSize: '12px',
    color: 'cream65',
    transition: 'color 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        color: 'cream92'
    },
    '@mobile': {
        display: 'block',
        padding: '14px 0',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'cream15'
    }
};


var $d19de07849ee64c2$exports = {};

$parcel$export($d19de07849ee64c2$exports, "PageLayout", () => $d19de07849ee64c2$export$6d1402fb58384e4f);
$parcel$export($d19de07849ee64c2$exports, "PageHeader", () => $d19de07849ee64c2$export$53f1cd6809577fc5);
$parcel$export($d19de07849ee64c2$exports, "PageHeaderBack", () => $d19de07849ee64c2$export$fb50ffd7fda59a42);
$parcel$export($d19de07849ee64c2$exports, "PageHeaderCenter", () => $d19de07849ee64c2$export$83a71564e98dfee8);
$parcel$export($d19de07849ee64c2$exports, "BackLink", () => $d19de07849ee64c2$export$a4b666110a3a853f);
$parcel$export($d19de07849ee64c2$exports, "Section", () => $d19de07849ee64c2$export$6e2c8f0811a474ce);
$parcel$export($d19de07849ee64c2$exports, "SectionAlt", () => $d19de07849ee64c2$export$de8dd087962babab);
$parcel$export($d19de07849ee64c2$exports, "SectionDark", () => $d19de07849ee64c2$export$72afa684c7663140);
$parcel$export($d19de07849ee64c2$exports, "Inner", () => $d19de07849ee64c2$export$f63ba74aa66682be);
$parcel$export($d19de07849ee64c2$exports, "SectionHeader", () => $d19de07849ee64c2$export$8adb256d999cd5a0);
$parcel$export($d19de07849ee64c2$exports, "Chip", () => $d19de07849ee64c2$export$5a7f9a6004988d01);
$parcel$export($d19de07849ee64c2$exports, "PartnerChip", () => $d19de07849ee64c2$export$8c13455349042a69);
// ─── Page Layout ────────────────────────────────────────────────────────────
const $d19de07849ee64c2$export$6d1402fb58384e4f = {
    extends: 'Flex',
    flexFlow: 'column',
    minHeight: '100vh',
    background: 'cream'
};
const $d19de07849ee64c2$export$53f1cd6809577fc5 = {
    tag: 'section',
    padding: '148px 0 88px',
    position: 'relative',
    overflow: 'hidden',
    '@tablet': {
        padding: '120px 0 64px'
    },
    Bg: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        background: 'dark'
    },
    Inner: {
        position: 'relative',
        zIndex: '1',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 48px',
        textAlign: 'center',
        '@tablet': {
            padding: '0 24px'
        }
    }
};
const $d19de07849ee64c2$export$fb50ffd7fda59a42 = {
    position: 'absolute',
    top: '76px',
    left: '0',
    right: '0',
    zIndex: '2',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 48px',
    '@tablet': {
        padding: '0 24px',
        top: '68px'
    }
};
const $d19de07849ee64c2$export$83a71564e98dfee8 = {
    maxWidth: '700px',
    margin: '0 auto'
};
const $d19de07849ee64c2$export$a4b666110a3a853f = {
    extends: 'Link',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '7px',
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    color: 'cream48',
    letterSpacing: '0.04em',
    transition: 'color 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        color: 'cream80'
    }
};
const $d19de07849ee64c2$export$6e2c8f0811a474ce = {
    tag: 'section',
    background: 'warmWhite',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    }
};
const $d19de07849ee64c2$export$de8dd087962babab = {
    tag: 'section',
    background: 'cream',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    }
};
const $d19de07849ee64c2$export$72afa684c7663140 = {
    tag: 'section',
    background: 'dark',
    padding: '104px 0',
    '@tablet': {
        padding: '80px 0'
    },
    '@mobile': {
        padding: '60px 0'
    }
};
const $d19de07849ee64c2$export$f63ba74aa66682be = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 48px',
    '@tablet': {
        padding: '0 24px'
    }
};
const $d19de07849ee64c2$export$8adb256d999cd5a0 = {
    marginBottom: '72px',
    '@mobile': {
        marginBottom: '48px'
    }
};
const $d19de07849ee64c2$export$5a7f9a6004988d01 = {
    padding: '6px 14px',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'borderMedium',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '500',
    color: 'textSecondary',
    whiteSpace: 'nowrap',
    transition: 'border-color 140ms cubic-bezier(0.0, 0.0, 0.2, 1), color 140ms cubic-bezier(0.0, 0.0, 0.2, 1), background 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        borderColor: 'borderStrong',
        color: 'dark',
        background: 'accentLight'
    }
};
const $d19de07849ee64c2$export$8c13455349042a69 = {
    extends: 'Flex',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '7px 13px',
    whiteSpace: 'nowrap',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'borderMedium',
    borderRadius: '8px',
    transition: 'border-color 140ms cubic-bezier(0.0, 0.0, 0.2, 1), background 140ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        borderColor: 'borderStrong',
        background: 'bgSubtle'
    },
    Logo: {
        tag: 'img',
        width: '24px',
        height: '24px',
        objectFit: 'contain',
        flexShrink: '0',
        borderRadius: '4px'
    },
    Name: {
        fontSize: '12px',
        fontWeight: '500',
        letterSpacing: '-0.01em',
        color: 'dark'
    }
};


var $96bcb8d9f7d75917$exports = {};

$parcel$export($96bcb8d9f7d75917$exports, "Stat", () => $96bcb8d9f7d75917$export$cbbc350c1dfc80cb);
$parcel$export($96bcb8d9f7d75917$exports, "StatsRow", () => $96bcb8d9f7d75917$export$ec098db2733c7492);
// ─── Stats ──────────────────────────────────────────────────────────────────
const $96bcb8d9f7d75917$export$cbbc350c1dfc80cb = {
    padding: '24px 20px',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: 'borderLight',
    ':first-child': {
        paddingLeft: '0'
    },
    Num: {
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        fontSize: '48px',
        fontWeight: '700',
        letterSpacing: '-0.05em',
        color: 'dark',
        lineHeight: '1',
        fontVariantNumeric: 'tabular-nums',
        '@mobile': {
            fontSize: '38px'
        }
    },
    Lbl: {
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        color: 'textTertiary',
        marginTop: '8px',
        letterSpacing: '0.02em',
        fontWeight: '400'
    }
};
const $96bcb8d9f7d75917$export$ec098db2733c7492 = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'borderLight',
    margin: '32px 0',
    '@mobile': {
        gridTemplateColumns: '1fr 1fr'
    },
    S1: {
        extends: 'Stat',
        Num: {
            extends: 'Stat.Num',
            text: '12+'
        },
        Lbl: {
            extends: 'Stat.Lbl',
            text: 'Years Experience'
        }
    },
    S2: {
        extends: 'Stat',
        Num: {
            extends: 'Stat.Num',
            text: '150+'
        },
        Lbl: {
            extends: 'Stat.Lbl',
            text: 'Startups Helped'
        },
        '@mobile': {
            borderRightWidth: '0'
        }
    },
    S3: {
        extends: 'Stat',
        borderRightWidth: '0',
        Num: {
            extends: 'Stat.Num',
            text: '2\u00d7'
        },
        Lbl: {
            extends: 'Stat.Lbl',
            text: 'Founder'
        },
        '@mobile': {
            gridColumn: 'span 2',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'borderLight'
        }
    }
};


var $ddc892d3854866ac$exports = {};

$parcel$export($ddc892d3854866ac$exports, "ServiceItemCard", () => $ddc892d3854866ac$export$2fa32384cf41bf78);
$parcel$export($ddc892d3854866ac$exports, "ItemsGrid", () => $ddc892d3854866ac$export$8a2402bda6a6fb9f);
$parcel$export($ddc892d3854866ac$exports, "Criterion", () => $ddc892d3854866ac$export$38dd0ff231338092);
// ─── Service Item Card (for sub-pages grid items) ───────────────────────────
const $ddc892d3854866ac$export$2fa32384cf41bf78 = {
    background: 'warmWhite',
    padding: '36px',
    transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
    ':hover': {
        background: 'bgSubtle'
    },
    Number: {
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        fontWeight: '400',
        color: 'accent',
        letterSpacing: '0.06em',
        marginBottom: '20px',
        fontVariantNumeric: 'tabular-nums',
        opacity: '0.7'
    },
    Title: {
        tag: 'h3',
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        fontSize: '15px',
        fontWeight: '600',
        letterSpacing: '-0.018em',
        color: 'dark',
        marginBottom: '10px'
    },
    Text: {
        tag: 'p',
        fontSize: '13px',
        color: 'textSecondary',
        lineHeight: '1.72',
        fontWeight: '400'
    }
};
const $ddc892d3854866ac$export$8a2402bda6a6fb9f = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '1px',
    background: 'borderLight',
    borderRadius: '12px',
    overflow: 'hidden',
    '@tablet': {
        gridTemplateColumns: '1fr 1fr'
    },
    '@mobile': {
        gridTemplateColumns: '1fr'
    }
};
const $ddc892d3854866ac$export$38dd0ff231338092 = {
    extends: 'Flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '22px 0',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'borderLight',
    Check: {
        width: '20px',
        height: '20px',
        flexShrink: '0',
        marginTop: '2px',
        fontSize: '12px',
        color: 'accent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600'
    },
    Text: {
        fontSize: '14px',
        color: 'textSecondary',
        lineHeight: '1.68',
        fontWeight: '400'
    }
};


$parcel$exportWildcard($b940b823876787d8$exports, $b35c86137e587395$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $454e1f1e91e540ff$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a30183713abdd208$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a2a8ed032b49c171$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b8c6ba537dfdb858$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d567b0d63dd6a3b3$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $47fce3a9994fbb94$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ead2558298e676a9$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $cbacb18557cd8141$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $7686e5faed3049c9$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d19de07849ee64c2$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $96bcb8d9f7d75917$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ddc892d3854866ac$exports);


var $5006d5ef181f83de$exports = {};


const $45001c780dea3812$var$IMG_BASE = '//img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6';
var $45001c780dea3812$export$2e2bcd8739ae039 = {
    // ─── Home ──────────────────────────────────────────────────────────────────
    '/': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Hero: {
            extends: 'HeroSection'
        },
        About: {
            extends: 'AboutPreview'
        },
        Services: {
            extends: 'ServicesSection',
            Inner: {
                extends: 'ServicesSection.Inner',
                Header: {
                    extends: 'ServicesSection.Inner.Header'
                },
                Grid: {
                    extends: 'ServicesSection.Inner.Grid',
                    Coaching: {
                        extends: 'DarkServiceCard',
                        Icon: {
                            extends: 'DarkServiceCard.Icon',
                            text: '\uD83C\uDFAF'
                        },
                        Title: {
                            extends: 'DarkServiceCard.Title',
                            text: 'Coaching & Workshops'
                        },
                        Text: {
                            extends: 'DarkServiceCard.Text',
                            text: "Nurturing your startup's journey: Deep-dive conversations, practical workshops, and personalised coaching for business growth."
                        },
                        Link: {
                            extends: 'DarkServiceCard.Link',
                            href: '/from-workshops-to-1-on-1s',
                            text: 'Learn more \u2192'
                        }
                    },
                    Freelance: {
                        extends: 'DarkServiceCard',
                        Icon: {
                            extends: 'DarkServiceCard.Icon',
                            text: '\uD83D\uDE80'
                        },
                        Title: {
                            extends: 'DarkServiceCard.Title',
                            text: 'Freelance Services'
                        },
                        Text: {
                            extends: 'DarkServiceCard.Text',
                            text: 'Hands-on, operative help with sales and marketing. Impactful strategies and hands-on execution to level up your digital presence.'
                        },
                        Link: {
                            extends: 'DarkServiceCard.Link',
                            href: '/hire-me-as-a-freelancer',
                            text: 'Learn more \u2192'
                        }
                    },
                    References: {
                        extends: 'DarkServiceCard',
                        Icon: {
                            extends: 'DarkServiceCard.Icon',
                            text: '\u2b50'
                        },
                        Title: {
                            extends: 'DarkServiceCard.Title',
                            text: 'References & Partners'
                        },
                        Text: {
                            extends: 'DarkServiceCard.Text',
                            text: 'Read about my previous engagements, success stories and references and what partners say about our joint successes.'
                        },
                        Link: {
                            extends: 'DarkServiceCard.Link',
                            href: '/references-and-partners',
                            text: 'Learn more \u2192'
                        }
                    },
                    Angel: {
                        extends: 'DarkServiceCard',
                        Icon: {
                            extends: 'DarkServiceCard.Icon',
                            text: '\uD83D\uDCA1'
                        },
                        Title: {
                            extends: 'DarkServiceCard.Title',
                            text: 'Angel Investment'
                        },
                        Text: {
                            extends: 'DarkServiceCard.Text',
                            text: "As part of the Wise Angels Network, I'm always on the lookout for tech startups to invest in as well as offer my support on growth-related topics."
                        },
                        Link: {
                            extends: 'DarkServiceCard.Link',
                            href: '/angel-investment',
                            text: 'Learn more \u2192'
                        }
                    }
                }
            }
        },
        Testimonials: {
            extends: 'TestimonialsPreview',
            Inner: {
                extends: 'TestimonialsPreview.Inner',
                Header: {
                    extends: 'TestimonialsPreview.Inner.Header'
                },
                Grid: {
                    extends: 'TestimonialsPreview.Inner.Grid',
                    T1: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Rita\'s three-year journey with our incubator has seen her guide many startups through their market introductions successfully. Her adept use of performance marketing has also remarkably supported our corporate innovation projects."'
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Benjamin Bauer'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'CEO, ZOLLHOF Tech Incubator'
                        }
                    },
                    T2: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"In the 4 years of working with Rita as a coach at Berlin Startup School, she has consistently delivered valuable workshops and 1on1 sessions on Digital Marketing, Go-to-Market & Sales strategies."'
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Constantin Schmutzler'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Founder & CEO, Berlin Startup School'
                        }
                    },
                    T3: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Sessions with Rita are often described as \'mind-opening\', \'insightful\', and \'direct and realistic\'. She is definitely a mentor to keep close when it comes to tech startups."'
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Sergio Borasino'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'MD Founders Club, Startup Wise Guys'
                        }
                    }
                },
                ViewAll: {
                    extends: 'TestimonialsPreview.Inner.ViewAll'
                }
            }
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    },
    // ─── About ─────────────────────────────────────────────────────────────────
    '/about': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Header: {
            extends: 'PageHeader',
            Back: {
                extends: 'PageHeaderBack',
                BackLink: {
                    extends: 'BackLink',
                    href: '/',
                    text: '\u2190 Back'
                }
            },
            Inner: {
                extends: 'PageHeader.Inner',
                Center: {
                    extends: 'PageHeaderCenter',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        color: 'cream48',
                        text: 'My Story'
                    },
                    Title: {
                        tag: 'h1',
                        extends: 'H2',
                        color: 'cream92',
                        text: 'Founder at Heart & Startup Nurturer'
                    },
                    Lead: {
                        extends: 'Lead',
                        color: 'cream65',
                        maxWidth: 'none',
                        margin: '20px auto 0',
                        fontWeight: '400',
                        text: 'Growth Marketing & Sales Expert with 12+ years in the tech startup ecosystem'
                    }
                }
            }
        },
        MainContent: {
            tag: 'section',
            background: 'warmWhite',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                Grid: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '80px',
                    alignItems: 'center',
                    '@tablet': {
                        gap: '40px'
                    },
                    '@mobile': {
                        gridTemplateColumns: '1fr',
                        gap: '32px'
                    },
                    TextCol: {
                        Eyebrow: {
                            extends: 'Eyebrow',
                            text: 'About Me'
                        },
                        Title: {
                            tag: 'h2',
                            extends: 'H2',
                            text: 'Founder at Heart'
                        },
                        Intro: {
                            tag: 'p',
                            color: 'dark',
                            fontSize: '16px',
                            fontWeight: '500',
                            lineHeight: '1.65',
                            marginBottom: '16px',
                            text: "I'm a 2x founder with 12+ years in the tech startup ecosystem. Some years ago, I transitioned from my entrepreneurial journey to key roles at various startup supporting organisations."
                        },
                        Body1: {
                            tag: 'p',
                            color: 'medGray',
                            fontSize: '15px',
                            lineHeight: '1.75',
                            fontWeight: '400',
                            text: "My core focus is on practical growth strategies, Go-to-Market and business model development. I've held positions at ZOLLHOF (Germany's fastest growing tech incubator) and BCG X, connecting startups with corporate innovation."
                        },
                        Body2: {
                            tag: 'p',
                            color: 'medGray',
                            fontSize: '15px',
                            lineHeight: '1.75',
                            fontWeight: '400',
                            marginTop: '16px',
                            text: 'I mentor at Techstars, Startup Wise Guys, and Berlin Startup School, drawing from my personal founder experience and work with 150+ startups. My teaching covers multi-channel strategies, smart sales tactics, and data-driven growth approaches.'
                        },
                        CTAs: {
                            extends: 'Flex',
                            gap: '10px',
                            flexWrap: 'wrap',
                            marginTop: '32px',
                            justifyContent: 'flex-start',
                            ContactBtn: {
                                tag: 'a',
                                extends: 'BtnPrimary',
                                attr: {
                                    href: '#contact'
                                },
                                text: 'Get in touch'
                            },
                            LinkedInBtn: {
                                tag: 'a',
                                extends: 'BtnOutline',
                                attr: {
                                    href: 'https://www.linkedin.com/in/rita-kato-growth/',
                                    target: '_blank'
                                },
                                whiteSpace: 'nowrap',
                                text: 'LinkedIn\u00a0\u2197'
                            }
                        }
                    },
                    ImageCol: {
                        overflow: 'hidden',
                        aspectRatio: '4/5',
                        background: 'bgSubtle',
                        borderRadius: '12px',
                        '@mobile': {
                            aspectRatio: '3/2'
                        },
                        Photo: {
                            tag: 'img',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/blob-90ae2e3.png`,
                                alt: 'Rita Katona',
                                loading: 'lazy'
                            },
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center top'
                        }
                    }
                },
                Partners: {
                    marginTop: '48px',
                    OrgLabel: {
                        extends: 'Eyebrow',
                        marginBottom: '16px',
                        display: 'block',
                        text: 'Organisations & Partners'
                    },
                    Chips: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(6, 1fr)',
                        '@tablet': {
                            gridTemplateColumns: 'repeat(3, 1fr)'
                        },
                        '@mobile': {
                            gridTemplateColumns: 'repeat(2, 1fr)'
                        },
                        gap: '1px',
                        background: 'borderLight',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'borderLight',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        C1: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://zollhof.de/assets/zollhof-logo-rgb_black.svg',
                                    alt: 'ZOLLHOF',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '28px',
                                width: 'auto',
                                maxWidth: '110px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'ZOLLHOF'
                            }
                        },
                        C2: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://cap.csail.mit.edu/sites/default/files/organization-logos/01-bcgx-logo-black-RGB-small.png',
                                    alt: 'BCG X',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '28px',
                                width: 'auto',
                                maxWidth: '110px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'BCG X'
                            }
                        },
                        C3: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://cdn.worldvectorlogo.com/logos/techstars-logo-vector-1.svg',
                                    alt: 'Techstars',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '28px',
                                width: 'auto',
                                maxWidth: '110px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'Techstars'
                            }
                        },
                        C4: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://startupwiseguys.com/wp-content/uploads/2023/01/startupwiseguys-logo-red.svg',
                                    alt: 'Startup Wise Guys',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '32px',
                                width: 'auto',
                                maxWidth: '110px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'Startup Wise Guys'
                            }
                        },
                        C5: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://static.wixstatic.com/media/a35252_8020b31fa8354d62b22b6bfa8924df05~mv2.png/v1/fill/w_242,h_218,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BSS%20Logo%202022.png',
                                    alt: 'Berlin Startup School',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '36px',
                                width: 'auto',
                                maxWidth: '100px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'Berlin Startup School'
                            }
                        },
                        C6: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '24px 16px',
                            background: 'warmWhite',
                            transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                background: 'white'
                            },
                            Logo: {
                                tag: 'img',
                                attr: {
                                    src: 'https://swissep.org/assets/static/images/swiss-ep-logo.svg',
                                    alt: 'Swiss EP',
                                    onerror: "this.style.display='none'"
                                },
                                filter: 'grayscale(1)',
                                transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                                ':hover': {
                                    filter: 'grayscale(0)'
                                },
                                height: '32px',
                                width: 'auto',
                                maxWidth: '110px',
                                objectFit: 'contain'
                            },
                            Name: {
                                fontSize: '10px',
                                fontFamily: "'DM Mono', monospace",
                                color: 'textTertiary',
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                text: 'Swiss EP'
                            }
                        }
                    }
                }
            }
        },
        StatsSection: {
            tag: 'section',
            background: 'cream',
            padding: '48px 0',
            Inner: {
                extends: 'Inner',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                '@mobile': {
                    gridTemplateColumns: '1fr 1fr'
                },
                S1: {
                    textAlign: 'center',
                    padding: '24px 32px',
                    borderRightWidth: '1px',
                    borderRightStyle: 'solid',
                    borderRightColor: 'borderLight',
                    Num: {
                        extends: 'Stat.Num',
                        textAlign: 'center',
                        fontSize: '58px',
                        '@mobile': {
                            fontSize: '42px'
                        },
                        text: '12+'
                    },
                    Lbl: {
                        extends: 'Stat.Lbl',
                        textAlign: 'center',
                        text: 'Years Experience'
                    }
                },
                S2: {
                    textAlign: 'center',
                    padding: '24px 32px',
                    borderRightWidth: '1px',
                    borderRightStyle: 'solid',
                    borderRightColor: 'borderLight',
                    '@mobile': {
                        borderRightWidth: '0'
                    },
                    Num: {
                        extends: 'Stat.Num',
                        textAlign: 'center',
                        fontSize: '58px',
                        '@mobile': {
                            fontSize: '42px'
                        },
                        text: '150+'
                    },
                    Lbl: {
                        extends: 'Stat.Lbl',
                        textAlign: 'center',
                        text: 'Startups Helped'
                    }
                },
                S3: {
                    textAlign: 'center',
                    padding: '24px 32px',
                    '@mobile': {
                        gridColumn: 'span 2',
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: 'borderLight'
                    },
                    Num: {
                        extends: 'Stat.Num',
                        textAlign: 'center',
                        fontSize: '58px',
                        '@mobile': {
                            fontSize: '42px'
                        },
                        text: '2\u00d7'
                    },
                    Lbl: {
                        extends: 'Stat.Lbl',
                        textAlign: 'center',
                        text: 'Founder'
                    }
                }
            }
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    },
    // ─── Coaching ──────────────────────────────────────────────────────────────
    '/from-workshops-to-1-on-1s': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Header: {
            extends: 'PageHeader',
            Back: {
                extends: 'PageHeaderBack',
                BackLink: {
                    extends: 'BackLink',
                    href: '/',
                    text: '\u2190 Back'
                }
            },
            Inner: {
                extends: 'PageHeader.Inner',
                Center: {
                    extends: 'PageHeaderCenter',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        color: 'cream48',
                        text: 'Services'
                    },
                    Title: {
                        tag: 'h1',
                        extends: 'H2',
                        color: 'cream92',
                        text: 'From Workshops to 1-on-1 Coaching'
                    },
                    Lead: {
                        extends: 'Lead',
                        color: 'cream65',
                        maxWidth: 'none',
                        margin: '20px auto 0',
                        fontWeight: '400',
                        text: "Let's elevate your startup's journey: I offer deep-dive sessions, practical workshops, and personalised coaching for business growth."
                    }
                }
            }
        },
        Gallery: {
            tag: 'section',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            height: '380px',
            overflow: 'hidden',
            '@tablet': {
                height: '260px'
            },
            '@mobile': {
                height: '180px'
            },
            P1: {
                tag: 'img',
                attr: {
                    src: `https:${$45001c780dea3812$var$IMG_BASE}/RitaWS.jpeg`,
                    alt: 'Rita Katona workshop',
                    loading: 'lazy',
                    onclick: 'openGallery(0)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            },
            P2: {
                tag: 'img',
                attr: {
                    src: `https:${$45001c780dea3812$var$IMG_BASE}/EP_320.jpg`,
                    alt: 'Coaching session',
                    loading: 'lazy',
                    onclick: 'openGallery(1)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            },
            P3: {
                tag: 'img',
                attr: {
                    src: `https:${$45001c780dea3812$var$IMG_BASE}/EP_319.jpg`,
                    alt: 'Startup event',
                    loading: 'lazy',
                    onclick: 'openGallery(2)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            }
        },
        Lightbox: {
            attr: {
                id: 'gallery-lb'
            },
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'rgba(0,0,0,0.96)',
            display: 'none',
            zIndex: '9999',
            alignItems: 'center',
            justifyContent: 'center',
            BgClose: {
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                attr: {
                    onclick: 'closeGallery()'
                }
            },
            Img: {
                tag: 'img',
                attr: {
                    id: 'gallery-lb-img',
                    alt: ''
                },
                position: 'relative',
                maxHeight: '90vh',
                maxWidth: '90vw',
                objectFit: 'contain',
                zIndex: '1'
            },
            Prev: {
                tag: 'button',
                text: '\u2039',
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '32px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'prevGallery()'
                }
            },
            Next: {
                tag: 'button',
                text: '\u203A',
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '32px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'nextGallery()'
                }
            },
            Close: {
                tag: 'button',
                text: '\u00D7',
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '22px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'closeGallery()'
                }
            }
        },
        GalleryScript: {
            tag: 'script',
            text: `(function(){var _gi=0,_gs=['https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/RitaWS.jpeg','https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/EP_320.jpg','https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/EP_319.jpg'];window.openGallery=function(i){_gi=i;var lb=document.getElementById('gallery-lb');document.getElementById('gallery-lb-img').src=_gs[i];lb.style.display='flex';document.body.style.overflow='hidden';};window.closeGallery=function(){document.getElementById('gallery-lb').style.display='none';document.body.style.overflow='';};window.prevGallery=function(){_gi=(_gi-1+_gs.length)%_gs.length;document.getElementById('gallery-lb-img').src=_gs[_gi];};window.nextGallery=function(){_gi=(_gi+1)%_gs.length;document.getElementById('gallery-lb-img').src=_gs[_gi];};document.addEventListener('keydown',function(e){var lb=document.getElementById('gallery-lb');if(lb&&lb.style.display==='flex'){if(e.key==='ArrowLeft')prevGallery();if(e.key==='ArrowRight')nextGallery();if(e.key==='Escape')closeGallery();}});})();`
        },
        Workshops: {
            tag: 'section',
            background: 'warmWhite',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                SectionHead: {
                    extends: 'SectionHeader',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        text: 'Option 1'
                    },
                    Title: {
                        tag: 'h2',
                        extends: 'H2',
                        text: 'Workshops (1.5 \u2013 5 hours)'
                    },
                    Lead: {
                        extends: 'Lead',
                        text: 'Interactive workshops and lectures that provide practical, skill-building experiences. These sessions, taking place online or offline, are designed to impart knowledge and strategies in specific areas.'
                    }
                },
                Grid: {
                    extends: 'ItemsGrid',
                    W1: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '01'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Business Model & Revenue Streams'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Interactive sessions on deep-diving into business modelling as well as exploring diverse and sustainable revenue streams for tech businesses, based on Business Model Canvas.'
                        }
                    },
                    W2: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '02'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Go-to-Market Strategy'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Workshops focusing on developing structured, effective go-to-market strategies tailored to your target market and competitive landscape.'
                        }
                    },
                    W3: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '03'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Customer Analysis & Positioning'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Sessions on understanding and analysing target audiences for better business positioning and growth strategy development.'
                        }
                    },
                    W4: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '04'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Startup Marketing'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Comprehensive lectures on marketing fundamentals, strategic planning, and performance marketing for early-stage startups.'
                        }
                    },
                    W5: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '05'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Growth Channel Exploration'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Practical sessions on testing and identifying the most effective growth strategies using the Bullseye Framework.'
                        }
                    },
                    W6: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '06'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Web Optimization'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Workshops dedicated to teaching effective website optimization techniques including SEO, content strategy, and conversion rate optimization.'
                        }
                    }
                }
            }
        },
        Coaching: {
            tag: 'section',
            background: 'cream',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                SectionHead: {
                    extends: 'SectionHeader',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        text: 'Option 2'
                    },
                    Title: {
                        tag: 'h2',
                        extends: 'H2',
                        text: '1-on-1 Coaching'
                    },
                    Lead: {
                        extends: 'Lead',
                        text: 'Personalized coaching sessions designed to serve the unique needs of startups. These sessions focus on individual strategies, offering tailored guidance and actionable insights for startup growth.'
                    }
                },
                Grid: {
                    extends: 'ItemsGrid',
                    background: 'transparent',
                    childExtends: {
                        background: 'transparent'
                    },
                    C1: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '01'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Go-to-Market & Growth Strategy'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Personalized strategies for structuring market entry, focusing on individual goals, target audiences and best channels to consider.'
                        }
                    },
                    C2: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '02'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'User Discovery & Testing'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Guidance on product/service testing methods and user discovery to gain valuable insights and improve your offerings.'
                        }
                    },
                    C3: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '03'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Audience Testing'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Tailored coaching on identifying and engaging the right customer segments for startup success.'
                        }
                    },
                    C4: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '04'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Data-Driven Strategy'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Advice on establishing a data-centric approach, including setting up KPIs and measurement tactics.'
                        }
                    },
                    C5: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '05'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Website Optimization'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Personalized recommendations for enhancing your business website for better user experience and marketing efficiency.'
                        }
                    }
                }
            }
        },
        Partners: {
            tag: 'section',
            background: 'warmWhite',
            padding: '64px 0',
            '@mobile': {
                padding: '48px 0'
            },
            Inner: {
                extends: 'Inner',
                textAlign: 'center',
                Label: {
                    extends: 'Eyebrow',
                    marginBottom: '24px',
                    display: 'block',
                    text: 'Often in cooperation with'
                },
                Chips: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    '@tablet': {
                        gridTemplateColumns: 'repeat(2, 1fr)'
                    },
                    gap: '1px',
                    background: 'borderLight',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'borderLight',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    C1: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://static.wixstatic.com/media/a35252_8020b31fa8354d62b22b6bfa8924df05~mv2.png/v1/fill/w_242,h_218,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BSS%20Logo%202022.png',
                                alt: 'Berlin Startup School',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '36px',
                            width: 'auto',
                            maxWidth: '100px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Berlin Startup School'
                        }
                    },
                    C2: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://startupwiseguys.com/wp-content/uploads/2023/01/startupwiseguys-logo-red.svg',
                                alt: 'Startup Wise Guys',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Startup Wise Guys'
                        }
                    },
                    C3: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://cdn.prod.website-files.com/65b8cc282d03ffce99110be9/65ba5b3d50103d8529e0873a_XS_BIA-Logo-Full%20Colour-reverse-RGB.png',
                                alt: 'Berlin Innovation Agency',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1) invert(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0) invert(1)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Berlin Innovation Agency'
                        }
                    },
                    C4: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://swissep.org/assets/static/images/swiss-ep-logo.svg',
                                alt: 'Swiss EP',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Swiss EP'
                        }
                    }
                }
            }
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    },
    // ─── Freelance ─────────────────────────────────────────────────────────────
    '/hire-me-as-a-freelancer': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Header: {
            extends: 'PageHeader',
            Back: {
                extends: 'PageHeaderBack',
                BackLink: {
                    extends: 'BackLink',
                    href: '/',
                    text: '\u2190 Back'
                }
            },
            Inner: {
                extends: 'PageHeader.Inner',
                Center: {
                    extends: 'PageHeaderCenter',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        color: 'cream48',
                        text: 'Freelance Services'
                    },
                    Title: {
                        tag: 'h1',
                        extends: 'H2',
                        color: 'cream92',
                        text: 'Hire me as a Freelancer'
                    },
                    Lead: {
                        extends: 'Lead',
                        color: 'cream65',
                        maxWidth: 'none',
                        margin: '20px auto 0',
                        fontWeight: '400',
                        text: 'Need hands-on, operative help with sales and marketing? I deliver impactful strategies and hands-on execution to level up your digital presence and drive meaningful engagement.'
                    }
                }
            }
        },
        Services: {
            tag: 'section',
            background: 'warmWhite',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                Intro: {
                    tag: 'p',
                    color: 'medGray',
                    fontSize: '15px',
                    lineHeight: '1.75',
                    maxWidth: '680px',
                    margin: '0 auto 48px auto',
                    textAlign: 'center',
                    fontWeight: '400',
                    text: "I bring 12+ years of hands-on startup experience to every engagement. Whether you're looking to build your marketing foundation or scale existing efforts, I work as a true partner in your growth journey."
                },
                Grid: {
                    extends: 'ItemsGrid',
                    S1: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '01'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Digital Advertising & Social Media'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Selecting and setting up the most effective channels for your brand. Implementing overarching ad campaigns tailored to your objectives (Google, META, LinkedIn and more).'
                        }
                    },
                    S2: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '02'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Content Strategy & Creation'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Crafting content plans informed by market trends and SEO research. Planning and overseeing content such as blogs, videos, and case studies. Managing and collaborating with third-party freelancers.'
                        }
                    },
                    S3: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '03'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'SEO Optimization'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Conducting comprehensive website and content reviews for SEO enhancement. Integrating targeted keywords and on-site optimization for better Google ranking. Improving technical SEO including page load speed and mobile optimization.'
                        }
                    },
                    S4: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '04'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Sales & Marketing Strategy'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Developing full-scale sales and marketing strategies. Customising messaging and positioning for various target groups and use cases. Fostering lead generation, outreach, and communication tactics to drive growth.'
                        }
                    },
                    S5: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '05'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Interim CMO'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Planning, leading and executing all growth-related initiatives. Strategizing and testing various marketing channels for optimal reach. Hiring and mentoring team members to enhance capabilities. Push sales and marketing operations to accelerate business growth.'
                        }
                    },
                    S6: {
                        extends: 'ServiceItemCard',
                        Number: {
                            extends: 'ServiceItemCard.Number',
                            text: '06'
                        },
                        Title: {
                            extends: 'ServiceItemCard.Title',
                            text: 'Analytics & Tracking'
                        },
                        Text: {
                            extends: 'ServiceItemCard.Text',
                            text: 'Setting up and optimizing analytics infrastructure across your digital channels. Defining KPIs, building dashboards, and implementing tracking to ensure every marketing decision is backed by data.'
                        }
                    }
                }
            }
        },
        CTA: {
            tag: 'section',
            background: 'cream',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                textAlign: 'center',
                Title: {
                    tag: 'h2',
                    extends: 'H2',
                    text: 'Ready to grow together?'
                },
                Lead: {
                    extends: 'Lead',
                    margin: '16px auto 32px auto',
                    text: "Let's discuss your specific needs and how I can help accelerate your growth."
                },
                Btn: {
                    tag: 'a',
                    extends: 'BtnPrimary',
                    attr: {
                        href: '#contact'
                    },
                    text: 'Get in touch'
                }
            }
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    },
    // ─── References ────────────────────────────────────────────────────────────
    '/references-and-partners': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Header: {
            extends: 'PageHeader',
            Back: {
                extends: 'PageHeaderBack',
                BackLink: {
                    extends: 'BackLink',
                    href: '/',
                    text: '\u2190 Back'
                }
            },
            Inner: {
                extends: 'PageHeader.Inner',
                Center: {
                    extends: 'PageHeaderCenter',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        color: 'cream48',
                        text: 'Social Proof'
                    },
                    Title: {
                        tag: 'h1',
                        extends: 'H2',
                        color: 'cream92',
                        text: 'References & Partners'
                    },
                    Lead: {
                        extends: 'Lead',
                        color: 'cream65',
                        maxWidth: 'none',
                        margin: '20px auto 0',
                        fontWeight: '400',
                        text: 'See what partners say about our joint successes. These testimonials reflect the nature and great results of our collaborations.'
                    }
                }
            }
        },
        Testimonials: {
            tag: 'section',
            background: 'cream',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            Inner: {
                extends: 'Inner',
                Grid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '1px',
                    background: 'transparent',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    '@tablet': {
                        gridTemplateColumns: '1fr 1fr'
                    },
                    '@mobile': {
                        gridTemplateColumns: '1fr'
                    },
                    T1: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Our startup, Heynanny, has greatly benefited from Rita\'s expertise, especially in refining our go-to-market strategy. Her guidance on data analysis and tracking has been also pivotal in making more informed decisions. 100% recommended to startups looking into these areas!"'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/%C2%A9%20Tribunalova%20_%20Julia%20Kahle.jpeg`,
                                alt: 'Julia Kahle'
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Julia Kahle'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Co-Founder & CEO, Heynanny'
                        }
                    },
                    T2: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"In the 4 years of working with Rita as a coach at Berlin Startup School, she has consistently delivered valuable workshops and 1on1 sessions on Digital Marketing, Go-to-Market & Sales strategies. Her insights and personalized coaching have greatly impacted our startup community, driving its growth."'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/Tino2.jpeg`,
                                alt: 'Constantin Schmutzler'
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Constantin Schmutzler'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Founder & CEO, Berlin Startup School'
                        }
                    },
                    T3: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Rita\'s guidance was pivotal for refining our digital campaigns on Google and Meta platforms. She also helped precise tracking setup, and gave actionable insights on email and content strategies that boosted our engagement."'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/Tobi.jpeg`,
                                alt: "Tobias B\xe4umler"
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Tobias B\u00e4umler'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Co-Founder & COO, VITAS.ai'
                        }
                    },
                    T4: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"At Swiss EP, we value the authenticity and insights of entrepreneurs who have forged their own paths. Rita brought this to life at our latest Founders Retreat, where her expertise in sales was a great contribution to the advancement of our 14 participating teams."'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/EP_64.jpg`,
                                alt: "Jakob Mod\xe9er"
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Jakob Mod\u00e9er'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Program Manager, Swiss Entrepreneurship Programme'
                        }
                    },
                    T5: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Her valuable insights in biz.dev, marketing, and sales have proven to be a great support for our startups\' growth, leading them to successfully test and prioritise growth channels. Her positive hands-on approach is well appreciated by our teams, putting her as one of our highest NPS-ranked coaches!"'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/blob-6e8428f.png`,
                                alt: 'Lou Kest'
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Lou Kest'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'Project Manager, Berlin Innovation Agency'
                        }
                    },
                    T6: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Rita\'s three-year journey with our incubator has seen her guide many startups through their market introductions successfully. Her adept use of performance marketing on platforms like Google, LinkedIn, and META has also remarkably supported our corporate innovation projects."'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/MB231103_ZoHo_517-lowres.jpg`,
                                alt: 'Benjamin Bauer'
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Benjamin Bauer'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'CEO, ZOLLHOF Tech Incubator'
                        }
                    },
                    T7: {
                        extends: 'TestimonialCard',
                        Quote: {
                            extends: 'TestimonialCard.Quote',
                            text: '"Sessions with Rita are often described as \'mind-opening\', \'insightful\', and \'direct and realistic\'. Her in-depth knowledge of the sector allows her to bring value to the table in no more than few minutes. She is definitely a mentor to keep close to you when it comes to tech startups."'
                        },
                        Photo: {
                            extends: 'TestimonialCard.Photo',
                            display: 'block',
                            attr: {
                                src: `https:${$45001c780dea3812$var$IMG_BASE}/20220525_202701.jpg`,
                                alt: 'Sergio Borasino'
                            }
                        },
                        AuthorName: {
                            extends: 'TestimonialCard.AuthorName',
                            text: 'Sergio Borasino'
                        },
                        AuthorRole: {
                            extends: 'TestimonialCard.AuthorRole',
                            text: 'MD Founders Club, Startup Wise Guys'
                        }
                    }
                }
            }
        },
        Partners: {
            tag: 'section',
            background: 'warmWhite',
            padding: '64px 0',
            '@mobile': {
                padding: '48px 0'
            },
            Inner: {
                extends: 'Inner',
                textAlign: 'center',
                Label: {
                    extends: 'Eyebrow',
                    marginBottom: '24px',
                    display: 'block',
                    text: 'Organisations I worked with'
                },
                Chips: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    '@tablet': {
                        gridTemplateColumns: 'repeat(3, 1fr)'
                    },
                    '@mobile': {
                        gridTemplateColumns: 'repeat(2, 1fr)'
                    },
                    gap: '1px',
                    background: 'borderLight',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'borderLight',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    C1: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://zollhof.de/assets/zollhof-logo-rgb_black.svg',
                                alt: 'ZOLLHOF',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '28px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'ZOLLHOF'
                        }
                    },
                    C2: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://static.wixstatic.com/media/a35252_8020b31fa8354d62b22b6bfa8924df05~mv2.png/v1/fill/w_242,h_218,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BSS%20Logo%202022.png',
                                alt: 'Berlin Startup School',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '36px',
                            width: 'auto',
                            maxWidth: '100px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Berlin Startup School'
                        }
                    },
                    C3: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://startupwiseguys.com/wp-content/uploads/2023/01/startupwiseguys-logo-red.svg',
                                alt: 'Startup Wise Guys',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Startup Wise Guys'
                        }
                    },
                    C4: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://cdn.prod.website-files.com/65b8cc282d03ffce99110be9/65ba5b3d50103d8529e0873a_XS_BIA-Logo-Full%20Colour-reverse-RGB.png',
                                alt: 'Berlin Innovation Agency',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1) invert(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0) invert(1)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Berlin Innovation Agency'
                        }
                    },
                    C5: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '24px 16px',
                        background: 'warmWhite',
                        transition: 'background 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                        ':hover': {
                            background: 'white'
                        },
                        Logo: {
                            tag: 'img',
                            attr: {
                                src: 'https://swissep.org/assets/static/images/swiss-ep-logo.svg',
                                alt: 'Swiss EP',
                                onerror: "this.style.display='none'"
                            },
                            filter: 'grayscale(1)',
                            transition: 'filter 180ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                            ':hover': {
                                filter: 'grayscale(0)'
                            },
                            height: '32px',
                            width: 'auto',
                            maxWidth: '110px',
                            objectFit: 'contain'
                        },
                        Name: {
                            fontSize: '10px',
                            fontFamily: "'DM Mono', monospace",
                            color: 'textTertiary',
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            text: 'Swiss EP'
                        }
                    }
                }
            }
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    },
    // ─── Angel Investment ──────────────────────────────────────────────────────
    '/angel-investment': {
        tag: 'main',
        extends: 'PageLayout',
        Nav: {
            extends: 'Nav'
        },
        Header: {
            extends: 'PageHeader',
            Back: {
                extends: 'PageHeaderBack',
                BackLink: {
                    extends: 'BackLink',
                    href: '/',
                    text: '\u2190 Back'
                }
            },
            Inner: {
                extends: 'PageHeader.Inner',
                Center: {
                    extends: 'PageHeaderCenter',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        color: 'cream48',
                        text: 'Investment'
                    },
                    Title: {
                        tag: 'h1',
                        extends: 'H2',
                        color: 'cream92',
                        text: 'Looking for Angel Investment?'
                    },
                    Lead: {
                        extends: 'Lead',
                        color: 'cream65',
                        maxWidth: 'none',
                        margin: '20px auto 0',
                        fontWeight: '400',
                        text: "As a proud member of the Wise Angels Network, I'm always on the lookout for tech startups to invest in."
                    }
                }
            }
        },
        WANInfo: {
            tag: 'section',
            background: 'cream',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'borderLight',
            Inner: {
                extends: 'Inner',
                Eyebrow: {
                    extends: 'Eyebrow',
                    text: 'About WAN'
                },
                Title: {
                    tag: 'h2',
                    extends: 'H2',
                    marginTop: '8px',
                    text: 'Wise Angels Network'
                },
                Lead: {
                    extends: 'Lead',
                    text: 'Wise Angels Network is an angel investor community headquartered in Europe, passionately committed to supporting startups during their critical early stages.'
                },
                Body: {
                    tag: 'p',
                    color: 'medGray',
                    fontSize: '15px',
                    lineHeight: '1.75',
                    maxWidth: '640px',
                    marginTop: '8px',
                    fontWeight: '400',
                    text: 'Our mission goes beyond just financial backing; we aim to empower startup founders by offering invaluable guidance in areas such as marketing, sales, operations, and more.'
                },
                WANLink: {
                    extends: 'CardLink',
                    tag: 'a',
                    display: 'inline-flex',
                    marginTop: '16px',
                    attr: {
                        href: 'https://wiseangels.network',
                        target: '_blank',
                        rel: 'noopener'
                    },
                    text: 'Learn more about WAN \u2192'
                },
                WANBlock: {
                    extends: 'Flex',
                    background: 'warmWhite',
                    padding: '40px',
                    borderRadius: '12px',
                    alignItems: 'center',
                    gap: '32px',
                    marginTop: '48px',
                    '@mobile': {
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '28px'
                    },
                    Logo: {
                        tag: 'img',
                        attr: {
                            src: `https:${$45001c780dea3812$var$IMG_BASE}/WAN-logo.png`,
                            alt: 'Wise Angels Network',
                            loading: 'lazy'
                        },
                        width: '120px',
                        flexShrink: '0'
                    },
                    Info: {
                        Title: {
                            tag: 'h3',
                            fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
                            fontSize: '17px',
                            fontWeight: '600',
                            letterSpacing: '-0.02em',
                            color: 'dark',
                            marginBottom: '10px',
                            text: 'Wise Angels Network Member'
                        },
                        Text: {
                            tag: 'p',
                            fontSize: '14px',
                            color: 'textSecondary',
                            lineHeight: '1.72',
                            fontWeight: '400',
                            text: "As an individual, but also as proud member of the Wise Angels Network, I'm always on the lookout for tech startups to invest in as well as offer my support on growth-related topics and beyond!"
                        }
                    }
                }
            }
        },
        Main: {
            tag: 'section',
            background: 'warmWhite',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'borderLight',
            Inner: {
                extends: 'Inner',
                CriteriaHead: {
                    extends: 'SectionHeader',
                    marginBottom: '16px',
                    Eyebrow: {
                        extends: 'Eyebrow',
                        text: 'Investment Criteria'
                    },
                    Title: {
                        tag: 'h2',
                        extends: 'H2',
                        text: 'What I look for in startups'
                    }
                },
                Criteria: {
                    extends: 'Flex',
                    flexFlow: 'column',
                    Crit1: {
                        extends: 'Criterion',
                        Check: {
                            extends: 'Criterion.Check',
                            text: '\u2713'
                        },
                        Text: {
                            extends: 'Criterion.Text',
                            text: 'The product is required to be in, or beyond, the Minimum Viable Product (MVP) stage'
                        }
                    },
                    Crit2: {
                        extends: 'Criterion',
                        Check: {
                            extends: 'Criterion.Check',
                            text: '\u2713'
                        },
                        Text: {
                            extends: 'Criterion.Text',
                            text: 'Traction: Either paying beta testers/customers or a formal letter of intent'
                        }
                    },
                    Crit3: {
                        extends: 'Criterion',
                        Check: {
                            extends: 'Criterion.Check',
                            text: '\u2713'
                        },
                        Text: {
                            extends: 'Criterion.Text',
                            text: 'A minimum of one year of the strategic roadmap has been outlined'
                        }
                    }
                }
            }
        },
        CTA: {
            tag: 'section',
            background: 'warmWhite',
            padding: '104px 0',
            '@tablet': {
                padding: '80px 0'
            },
            '@mobile': {
                padding: '60px 0'
            },
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'borderLight',
            Inner: {
                extends: 'Inner',
                textAlign: 'center',
                Title: {
                    tag: 'h2',
                    extends: 'H2',
                    text: 'Ready to pitch your startup?'
                },
                Lead: {
                    extends: 'Lead',
                    margin: '16px auto 32px auto',
                    text: "If you think your startup meets the criteria, I'd love to hear from you."
                },
                Btn: {
                    tag: 'a',
                    extends: 'BtnPrimary',
                    attr: {
                        href: '#contact'
                    },
                    text: 'Get in touch'
                }
            }
        },
        AngelGallery: {
            tag: 'section',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            height: '380px',
            overflow: 'hidden',
            '@tablet': {
                height: '260px'
            },
            '@mobile': {
                height: '180px'
            },
            P1: {
                tag: 'img',
                attr: {
                    src: `https:${$45001c780dea3812$var$IMG_BASE}/EP_130.jpg`,
                    alt: 'Rita Katona presenting',
                    loading: 'lazy',
                    onclick: 'openAngelGallery(0)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            },
            P2: {
                tag: 'img',
                attr: {
                    src: `https:${$45001c780dea3812$var$IMG_BASE}/Screenshot%202024-01-25%20at%2008.38.48.png`,
                    alt: 'Rita Katona presenting',
                    loading: 'lazy',
                    onclick: 'openAngelGallery(1)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            },
            P3: {
                tag: 'img',
                attr: {
                    src: 'https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/Screenshot%202024-01-11%20at%2016.48.19.png/:/cr=t:35.92%25,l:0%25,w:100%25,h:63.53%25/rs=w:1200,h:600,cg:true',
                    alt: 'Rita Katona workshop session',
                    loading: 'lazy',
                    onclick: 'openAngelGallery(2)'
                },
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center center',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 400ms cubic-bezier(0.0, 0.0, 0.2, 1)',
                ':hover': {
                    transform: 'scale(1.04)'
                }
            }
        },
        AngelLightbox: {
            attr: {
                id: 'angel-gallery-lb'
            },
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'rgba(0,0,0,0.96)',
            display: 'none',
            zIndex: '9999',
            alignItems: 'center',
            justifyContent: 'center',
            BgClose: {
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                attr: {
                    onclick: 'closeAngelGallery()'
                }
            },
            Img: {
                tag: 'img',
                attr: {
                    id: 'angel-gallery-lb-img',
                    alt: ''
                },
                position: 'relative',
                maxHeight: '90vh',
                maxWidth: '90vw',
                objectFit: 'contain',
                zIndex: '1'
            },
            Prev: {
                tag: 'button',
                text: '\u2039',
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '32px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'prevAngelGallery()'
                }
            },
            Next: {
                tag: 'button',
                text: '\u203A',
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '32px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'nextAngelGallery()'
                }
            },
            Close: {
                tag: 'button',
                text: '\u00D7',
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'rgba(255,255,255,0.12)',
                border: 'none',
                color: 'rgba(255,255,255,0.9)',
                fontSize: '22px',
                lineHeight: '1',
                cursor: 'pointer',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: '2',
                transition: 'background 150ms ease',
                ':hover': {
                    background: 'rgba(255,255,255,0.22)'
                },
                attr: {
                    onclick: 'closeAngelGallery()'
                }
            }
        },
        AngelGalleryScript: {
            tag: 'script',
            text: `(function(){var _gi=0,_gs=['https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/EP_130.jpg','https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/Screenshot%202024-01-25%20at%2008.38.48.png','https://img1.wsimg.com/isteam/ip/15c18bf3-4ed7-4452-806f-cdd970bf3dd6/Screenshot%202024-01-11%20at%2016.48.19.png'];window.openAngelGallery=function(i){_gi=i;var lb=document.getElementById('angel-gallery-lb');document.getElementById('angel-gallery-lb-img').src=_gs[i];lb.style.display='flex';document.body.style.overflow='hidden';};window.closeAngelGallery=function(){document.getElementById('angel-gallery-lb').style.display='none';document.body.style.overflow='';};window.prevAngelGallery=function(){_gi=(_gi-1+_gs.length)%_gs.length;document.getElementById('angel-gallery-lb-img').src=_gs[_gi];};window.nextAngelGallery=function(){_gi=(_gi+1)%_gs.length;document.getElementById('angel-gallery-lb-img').src=_gs[_gi];};document.addEventListener('keydown',function(e){var lb=document.getElementById('angel-gallery-lb');if(lb&&lb.style.display==='flex'){if(e.key==='ArrowLeft')prevAngelGallery();if(e.key==='ArrowRight')nextAngelGallery();if(e.key==='Escape')closeAngelGallery();}});})();`
        },
        Contact: {
            extends: 'ContactSection'
        },
        SiteFooter: {
            extends: 'Footer'
        }
    }
};


var $b42a2ac40ecd9203$exports = {};


var $3bda623ffab03480$exports = {};


var $1f94fb7560370f21$export$2e2bcd8739ae039 = {
    // Base
    black: '#000000',
    white: '#ffffff',
    // Backgrounds
    cream: '#fafafa',
    warmWhite: '#ffffff',
    bgSubtle: '#f3f3f3',
    bgAlt: '#ebebeb',
    // Text
    dark: '#0a0a0a',
    textSecondary: '#6b6b6b',
    textTertiary: '#737373',
    textQuaternary: '#a0a0a0',
    // Dark surface
    dark2: '#141414',
    dark3: '#1c1c1c',
    darkCard: '#0a0a0a',
    // Borders
    borderLight: 'rgba(0,0,0,0.06)',
    borderMedium: 'rgba(0,0,0,0.10)',
    borderStrong: 'rgba(0,0,0,0.20)',
    // Grays
    lightGray: '#f0f0f0',
    altGray: '#f7f7f7',
    medGray: '#6b6b6b',
    // Accent
    accent: 'rgb(85,127,177)',
    accentHover: 'rgb(70,110,158)',
    accentLight: 'rgba(85,127,177,0.06)',
    accentMed: 'rgba(85,127,177,0.12)',
    // Nav
    navBg: 'rgba(250,250,250,0.88)',
    // Hero overlays
    heroOverlay97: 'rgba(10,10,10,0.97)',
    heroOverlay92: 'rgba(10,10,10,0.92)',
    heroOverlay68: 'rgba(10,10,10,0.68)',
    heroOverlay22: 'rgba(10,10,10,0.22)',
    heroOverlay08: 'rgba(10,10,10,0.08)',
    // White opacity variants
    white92: 'rgba(255,255,255,0.92)',
    white88: 'rgba(255,255,255,0.88)',
    white65: 'rgba(255,255,255,0.65)',
    white52: 'rgba(255,255,255,0.52)',
    white38: 'rgba(255,255,255,0.38)',
    white32: 'rgba(255,255,255,0.32)',
    white25: 'rgba(255,255,255,0.25)',
    white22: 'rgba(255,255,255,0.22)',
    white20: 'rgba(255,255,255,0.20)',
    white15: 'rgba(255,255,255,0.15)',
    white14: 'rgba(255,255,255,0.14)',
    white08: 'rgba(255,255,255,0.08)',
    white07: 'rgba(255,255,255,0.07)',
    white05: 'rgba(255,255,255,0.05)',
    // Cream opacity variants (now neutral white for dark sections)
    cream92: 'rgba(255,255,255,0.92)',
    cream80: 'rgba(255,255,255,0.80)',
    cream65: 'rgba(255,255,255,0.65)',
    cream48: 'rgba(255,255,255,0.48)',
    cream35: 'rgba(255,255,255,0.35)',
    cream30: 'rgba(255,255,255,0.30)',
    cream22: 'rgba(255,255,255,0.22)',
    cream15: 'rgba(255,255,255,0.15)',
    cream12: 'rgba(255,255,255,0.12)',
    cream08: 'rgba(255,255,255,0.08)',
    cream05: 'rgba(255,255,255,0.05)',
    // Dark-section text
    darkWhite84: 'rgba(255,255,255,0.88)',
    darkWhite68: 'rgba(255,255,255,0.68)',
    darkWhite48: 'rgba(255,255,255,0.48)',
    darkWhite35: 'rgba(255,255,255,0.35)',
    darkWhite30: 'rgba(255,255,255,0.30)'
};


var $311a5e5cb61c1a1b$export$2e2bcd8739ae039 = {};


var $3116e794b25d00ca$export$2e2bcd8739ae039 = {
    document: {
        '@light': {
            color: 'dark',
            background: 'cream'
        },
        '@dark': {
            color: 'cream92',
            background: 'dark'
        }
    },
    dark: {
        color: 'cream92',
        background: 'dark'
    },
    blue: {
        color: 'white',
        background: 'accent'
    },
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    }
};


var $d1e1c29584374e78$export$2e2bcd8739ae039 = {};


var $22b0a268f5e3c9c7$export$2e2bcd8739ae039 = {
    body: "'DM Sans', system-ui, -apple-system, sans-serif",
    display: "'Inter Tight', system-ui, -apple-system, sans-serif",
    mono: "'DM Mono', monospace"
};


var $427ce150ce5df318$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


var $af6c52f5e26a563e$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.618,
    subSequence: true
};


var $3c00d699b7463a5a$export$2e2bcd8739ae039 = {
    spring: 'cubic-bezier(0.16, 1, 0.3, 1)',
    easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
    easeStandard: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
};


var $90131e45aaa63902$export$2e2bcd8739ae039 = {};


var $6ede05c296bd9ec9$export$2e2bcd8739ae039 = {};


var $5d854b05544f3b96$export$2e2bcd8739ae039 = {};


var $78651d184c5325c2$export$2e2bcd8739ae039 = {
    none: '0',
    xs: '2px',
    sm: '6px',
    md: '8px',
    lg: '16px',
    xl: '24px',
    round: '99px'
};


var $92ec376187f7a4de$export$2e2bcd8739ae039 = {
    '*, *::before, *::after': {
        boxSizing: 'border-box',
        margin: '0',
        padding: '0'
    },
    html: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontFeatureSettings: '"ss01", "cv01", "cv03"'
    },
    body: {
        fontFamily: "'DM Sans', system-ui, -apple-system, sans-serif",
        lineHeight: '1.6',
        overflowX: 'hidden'
    },
    a: {
        color: 'inherit',
        textDecoration: 'none'
    },
    img: {
        display: 'block',
        maxWidth: '100%'
    },
    'button, input, textarea, select': {
        fontFamily: 'inherit'
    },
    '::-webkit-scrollbar': {
        width: '4px'
    },
    '::-webkit-scrollbar-track': {
        background: 'transparent'
    },
    '::-webkit-scrollbar-thumb': {
        background: 'rgba(29,27,22,0.10)',
        borderRadius: '99px'
    }
};


var $c4ca593693018207$export$2e2bcd8739ae039 = {
    fadeIn: {
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    fadeInUp: {
        from: {
            opacity: 0,
            transform: 'translateY(20px)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    },
    fadeInDown: {
        from: {
            opacity: 0,
            transform: 'translateY(-8px)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    },
    pageEnter: {
        from: {
            opacity: 0,
            transform: 'translateY(16px)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    },
    slideInRight: {
        from: {
            opacity: 0,
            transform: 'translateX(24px)'
        },
        to: {
            opacity: 1,
            transform: 'translateX(0)'
        }
    },
    slideInLeft: {
        from: {
            opacity: 0,
            transform: 'translateX(-24px)'
        },
        to: {
            opacity: 1,
            transform: 'translateX(0)'
        }
    },
    scaleIn: {
        from: {
            opacity: 0,
            transform: 'scale(0.97)'
        },
        to: {
            opacity: 1,
            transform: 'scale(1)'
        }
    },
    revealUp: {
        from: {
            opacity: 0,
            transform: 'translateY(40px)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    },
    revealScale: {
        from: {
            opacity: 0,
            transform: 'scale(0.92) translateY(20px)'
        },
        to: {
            opacity: 1,
            transform: 'scale(1) translateY(0)'
        }
    },
    heroImageZoom: {
        from: {
            transform: 'scale(1.08)'
        },
        to: {
            transform: 'scale(1)'
        }
    },
    shimmer: {
        '0%': {
            backgroundPosition: '-200% center'
        },
        '100%': {
            backgroundPosition: '200% center'
        }
    },
    bounce: {
        '0%': {
            transform: 'translateY(0)'
        },
        '55%': {
            transform: 'translateY(6px)'
        },
        '100%': {
            transform: 'translateY(0)'
        }
    },
    pulse: {
        '0%': {
            opacity: 1
        },
        '50%': {
            opacity: 0.6
        },
        '100%': {
            opacity: 1
        }
    },
    widthExpand: {
        from: {
            width: '0%',
            opacity: 0
        },
        to: {
            width: '48px',
            opacity: 1
        }
    }
};


var $372ac325ab0ab1d3$export$2e2bcd8739ae039 = {
    tablet: '(max-width: 900px)',
    mobile: '(max-width: 640px)'
};


var $8d37bf74fd7dee28$export$2e2bcd8739ae039 = {};


var $1a9a2097450ea0af$export$2e2bcd8739ae039 = {
    color: $1f94fb7560370f21$export$2e2bcd8739ae039,
    gradient: $311a5e5cb61c1a1b$export$2e2bcd8739ae039,
    theme: $3116e794b25d00ca$export$2e2bcd8739ae039,
    font: $d1e1c29584374e78$export$2e2bcd8739ae039,
    font_family: $22b0a268f5e3c9c7$export$2e2bcd8739ae039,
    typography: $427ce150ce5df318$export$2e2bcd8739ae039,
    spacing: $af6c52f5e26a563e$export$2e2bcd8739ae039,
    timing: $3c00d699b7463a5a$export$2e2bcd8739ae039,
    class: (0, $90131e45aaa63902$export$2e2bcd8739ae039),
    grid: $6ede05c296bd9ec9$export$2e2bcd8739ae039,
    icons: $5d854b05544f3b96$export$2e2bcd8739ae039,
    shape: $78651d184c5325c2$export$2e2bcd8739ae039,
    reset: $92ec376187f7a4de$export$2e2bcd8739ae039,
    animation: $c4ca593693018207$export$2e2bcd8739ae039,
    media: $372ac325ab0ab1d3$export$2e2bcd8739ae039,
    cases: $8d37bf74fd7dee28$export$2e2bcd8739ae039
};


var $f00b8cc44c2f4180$export$2e2bcd8739ae039 = {};


var $3e7bb68d55e4c07c$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    globalTheme: 'light',
    verbose: false
};


var $70676ed063e69c3c$export$2e2bcd8739ae039 = {
    ...(0, $3e7bb68d55e4c07c$export$2e2bcd8739ae039),
    state: $583e5c65243bf299$export$2e2bcd8739ae039,
    dependencies: $ffee29e35474451f$export$2e2bcd8739ae039,
    components: $b940b823876787d8$exports,
    snippets: $5006d5ef181f83de$exports,
    pages: $45001c780dea3812$export$2e2bcd8739ae039,
    functions: $b42a2ac40ecd9203$exports,
    methods: $3bda623ffab03480$exports,
    designSystem: $1a9a2097450ea0af$export$2e2bcd8739ae039,
    files: $f00b8cc44c2f4180$export$2e2bcd8739ae039
};


(0, $d34fff7d4687ff54$export$185802fd694ee1f5)((0, $85274e1cff99deb2$export$2e2bcd8739ae039), (0, $70676ed063e69c3c$export$2e2bcd8739ae039));
// ── Animations & Effects ────────────────────────────────────────
setTimeout(()=>{
    // Inject styles
    const style = document.createElement('style');
    style.textContent = `
    [data-reveal] {
      opacity: 0;
      transform: translateY(32px);
      transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
                  transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-reveal="left"] { transform: translateX(-32px); }
    [data-reveal="right"] { transform: translateX(32px); }
    [data-reveal="scale"] { transform: scale(0.94) translateY(16px); }
    [data-reveal].revealed {
      opacity: 1;
      transform: translateY(0) translateX(0) scale(1);
    }
    [data-stagger] > * {
      opacity: 0;
      transform: translateY(24px);
      transition: opacity 0.55s cubic-bezier(0.16, 1, 0.3, 1),
                  transform 0.55s cubic-bezier(0.16, 1, 0.3, 1);
    }
    [data-stagger].revealed > * {
      opacity: 1;
      transform: translateY(0);
    }
    nav[data-scrolled] {
      box-shadow: 0 1px 12px rgba(0,0,0,0.06) !important;
    }
    nav a[data-active] {
      color: #0a0a0a !important;
    }
    body > div > div > *:not(nav):not(footer) {
      opacity: 0;
      transform: translateY(32px);
      transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1),
                  transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    }
    body > div > div > *:not(nav):not(footer).revealed {
      opacity: 1;
      transform: translateY(0);
    }
  `;
    document.head.appendChild(style);
    // Active nav link
    const setActiveNav = ()=>{
        const path = window.location.pathname;
        document.querySelectorAll('nav a[href^="/"]').forEach((a)=>{
            const href = a.getAttribute('href');
            if (href === path || href !== '/' && path.startsWith(href)) a.setAttribute('data-active', '');
            else a.removeAttribute('data-active');
        });
    };
    setActiveNav();
    window.addEventListener('popstate', ()=>setTimeout(setActiveNav, 50));
    document.addEventListener('click', (e)=>{
        const a = e.target.closest('nav a[href^="/"]');
        if (a) setTimeout(setActiveNav, 50);
    });
    // ── Scroll Reveal Observer (persistent) ──────────────────────
    const revealObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                if (entry.target.hasAttribute('data-stagger')) Array.from(entry.target.children).forEach((child, i)=>{
                    child.style.transitionDelay = `${i * 90}ms`;
                });
                entry.target.classList.add('revealed');
                revealObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -60px 0px'
    });
    // ── Auto-tag & observe (runs on load + every navigation) ───
    const isGrid = (el)=>getComputedStyle(el).display === 'grid';
    const initPageAnimations = ()=>{
        const content = document.querySelector('body > div > div');
        if (!content) return;
        const vh = window.innerHeight;
        let sectionDelay = 0;
        // Observe each section with stagger for above-fold
        Array.from(content.children).forEach((el)=>{
            if (el.tagName === 'NAV' || el.tagName === 'FOOTER' || el.classList.contains('revealed')) return;
            const rect = el.getBoundingClientRect();
            if (rect.top < vh) {
                el.style.transitionDelay = `${sectionDelay}ms`;
                sectionDelay += 100;
            }
            revealObserver.observe(el);
        });
        // Tag inner elements for scroll reveal
        document.querySelectorAll('section').forEach((section)=>{
            if (section.hasAttribute('data-hero')) return;
            section.querySelectorAll('h2').forEach((h)=>{
                if (!h.closest('[data-reveal]')) h.setAttribute('data-reveal', '');
            });
            section.querySelectorAll('p').forEach((p)=>{
                if (!p.closest('[data-stagger]') && !p.closest('[data-reveal]') && !p.closest('article')) p.setAttribute('data-reveal', '');
            });
            section.querySelectorAll('img[loading="lazy"]').forEach((img)=>{
                const wrapper = img.parentElement;
                if (wrapper && wrapper.tagName !== 'SECTION') {
                    wrapper.setAttribute('data-reveal', 'scale');
                    wrapper.setAttribute('data-parallax', '');
                }
            });
            section.querySelectorAll('*').forEach((el)=>{
                if (isGrid(el) && el.children.length > 1 && !el.closest('[data-stagger]')) el.setAttribute('data-stagger', '');
            });
            section.querySelectorAll('form').forEach((f)=>f.setAttribute('data-reveal', 'right'));
        });
        document.querySelectorAll('[data-reveal]:not(.revealed), [data-stagger]:not(.revealed)').forEach((el)=>{
            revealObserver.observe(el);
        });
    };
    // Initial run
    initPageAnimations();
    // Re-init when framework swaps page content
    const appEl = document.querySelector('body > div');
    if (appEl) new MutationObserver(()=>{
        setTimeout(initPageAnimations, 60);
    }).observe(appEl, {
        childList: true,
        subtree: true
    });
    // ── Nav scroll shadow (dynamic query) ──────────────────────
    window.addEventListener('scroll', ()=>{
        const nav = document.querySelector('nav');
        if (nav) {
            if (window.scrollY > 40) nav.setAttribute('data-scrolled', '');
            else nav.removeAttribute('data-scrolled');
        }
    }, {
        passive: true
    });
    // ── Parallax (dynamic queries) ─────────────────────────────
    let pTicking = false;
    window.addEventListener('scroll', ()=>{
        if (pTicking) return;
        requestAnimationFrame(()=>{
            // Hero parallax
            const heroImg = document.querySelector('[data-hero] img[loading="eager"]');
            if (heroImg) {
                const y = window.scrollY;
                const h = heroImg.closest('section')?.offsetHeight || window.innerHeight;
                if (y < h) heroImg.style.transform = `scale(${1 + y * 0.0001}) translateY(${y * 0.25}px)`;
            }
            // Image parallax
            document.querySelectorAll('[data-parallax]').forEach((el)=>{
                const rect = el.getBoundingClientRect();
                const vh = window.innerHeight;
                if (rect.top < vh && rect.bottom > 0) {
                    const progress = (vh - rect.top) / (vh + rect.height);
                    const img = el.querySelector('img');
                    if (img) img.style.transform = `translateY(${(progress - 0.5) * 30}px) scale(1.04)`;
                }
            });
            pTicking = false;
        });
        pTicking = true;
    }, {
        passive: true
    });
    // ── Smooth scroll for anchors (delegated) ──────────────────
    document.addEventListener('click', (e)=>{
        const anchor = e.target.closest('a[href^="#"]');
        if (!anchor) return;
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
            e.preventDefault();
            window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - 60,
                behavior: 'smooth'
            });
        }
    });
    // ── Scroll to top on page switch ───────────────────────────
    document.addEventListener('click', (e)=>{
        const anchor = e.target.closest('a[href]');
        if (!anchor) return;
        const href = anchor.getAttribute('href');
        if (!href || !href.startsWith('/') || href.startsWith('//') || href.includes('#')) return;
        window.scrollTo(0, 0);
    });
    window.addEventListener('popstate', ()=>{
        window.scrollTo(0, 0);
    });
}, 150);


//# sourceMappingURL=symbols.9b58e8ff.js.map
